window.evertestAnimation1 = {
    "nm": "Animation",
    "ddd": 0,
    "h": 732,
    "w": 764,
    "meta": {
        "g": "@lottiefiles/toolkit-js 0.76.0"
    },
    "layers": [
        {
            "ty": 0,
            "nm": "Popup ",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "428",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "1",
            "ind": 1
        },
        {
            "ty": 0,
            "nm": "Dot Line",
            "sr": 1,
            "st": 94,
            "op": 18095,
            "ip": 94,
            "ln": "427",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "11",
            "ind": 2
        },
        {
            "ty": 0,
            "nm": "Text field",
            "sr": 1,
            "st": -47,
            "op": 17954,
            "ip": 0,
            "ln": "426",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "12",
            "ind": 3
        },
        {
            "ty": 0,
            "nm": "Register.svg",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "425",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        133.5,
                        158.5
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        110,
                        110
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        196
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 267,
            "h": 317,
            "refId": "13",
            "ind": 4
        },
        {
            "ty": 0,
            "nm": "isometric",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "424",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        358,
                        368
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "15",
            "ind": 5
        }
    ],
    "v": "5.7.0",
    "fr": 30,
    "op": 301,
    "ip": 0,
    "fonts": {
        "list": [
            {
                "ascent": null,
                "fClass": "",
                "fFamily": "BDO Grotesk",
                "fStyle": "Regular",
                "fName": "BDOGrotesk-Regular",
                "fPath": "",
                "fWeight": "",
                "origin": 0
            }
        ]
    },
    "chars": [
        {
            "ch": "U",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 76.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.6666666666666667,
                                                -2.7000000000000006
                                            ],
                                            [
                                                -3,
                                                -1.1999999999999993
                                            ],
                                            [
                                                -4,
                                                0
                                            ],
                                            [
                                                -2.900000000000001,
                                                1.5
                                            ],
                                            [
                                                -1.3666666666666647,
                                                2.733333333333333
                                            ],
                                            [
                                                0,
                                                3.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -4.033333333333332
                                            ],
                                            [
                                                4.5,
                                                -2.2666666666666666
                                            ],
                                            [
                                                6.666666666666667,
                                                0
                                            ],
                                            [
                                                5.4333333333333345,
                                                4.666666666666667
                                            ],
                                            [
                                                0,
                                                8.666666666666666
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.333333333333333
                                            ],
                                            [
                                                1.6666666666666667,
                                                2.7000000000000006
                                            ],
                                            [
                                                2.999999999999998,
                                                1.2000000000000004
                                            ],
                                            [
                                                4.733333333333334,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -1.5
                                            ],
                                            [
                                                1.3666666666666696,
                                                -2.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                5.400000000000001
                                            ],
                                            [
                                                -2.3333333333333286,
                                                4.033333333333333
                                            ],
                                            [
                                                -4.5,
                                                2.2666666666666666
                                            ],
                                            [
                                                -9.333333333333334,
                                                0
                                            ],
                                            [
                                                -5.433333333333333,
                                                -4.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                7.8,
                                                -26
                                            ],
                                            [
                                                7.8,
                                                -72.9
                                            ],
                                            [
                                                18.3,
                                                -72.9
                                            ],
                                            [
                                                18.3,
                                                -26.8
                                            ],
                                            [
                                                20.8,
                                                -16.25
                                            ],
                                            [
                                                27.8,
                                                -10.4
                                            ],
                                            [
                                                38.3,
                                                -8.6
                                            ],
                                            [
                                                49.75,
                                                -10.85
                                            ],
                                            [
                                                56.15,
                                                -17.2
                                            ],
                                            [
                                                58.2,
                                                -26.8
                                            ],
                                            [
                                                58.2,
                                                -72.9
                                            ],
                                            [
                                                68.6,
                                                -72.9
                                            ],
                                            [
                                                68.6,
                                                -26
                                            ],
                                            [
                                                65.1,
                                                -11.85
                                            ],
                                            [
                                                54.85,
                                                -2.4
                                            ],
                                            [
                                                38.1,
                                                1
                                            ],
                                            [
                                                15.95,
                                                -6
                                            ],
                                            [
                                                7.8,
                                                -26
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "s",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 54.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.266666666666668,
                                                3.266666666666667
                                            ],
                                            [
                                                0.19999999999999987,
                                                5.733333333333332
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.5333333333333337,
                                                -2.2000000000000006
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                1.3
                                            ],
                                            [
                                                0,
                                                3.0666666666666664
                                            ],
                                            [
                                                0.8666666666666695,
                                                1.0666666666666675
                                            ],
                                            [
                                                1.5666666666666675,
                                                0.6333333333333329
                                            ],
                                            [
                                                2.066666666666665,
                                                0.3999999999999986
                                            ],
                                            [
                                                2.3999999999999986,
                                                0.5333333333333338
                                            ],
                                            [
                                                2.4666666666666663,
                                                1.400000000000001
                                            ],
                                            [
                                                1.2,
                                                2.099999999999999
                                            ],
                                            [
                                                0,
                                                2.8666666666666694
                                            ],
                                            [
                                                -1.7333333333333332,
                                                2.400000000000001
                                            ],
                                            [
                                                -3.2000000000000006,
                                                1.3333333333333333
                                            ],
                                            [
                                                -4.333333333333333,
                                                0
                                            ],
                                            [
                                                -3.2666666666666657,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -1.900000000000001,
                                                -2.5333333333333314
                                            ],
                                            [
                                                -0.1999999999999981,
                                                -3.866666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                2
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                1.8333333333333333,
                                                -1.4333333333333371
                                            ],
                                            [
                                                0,
                                                -2.2666666666666657
                                            ],
                                            [
                                                -1.099999999999999,
                                                -1.1666666666666667
                                            ],
                                            [
                                                -2.3333333333333335,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -3.6666666666666665,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -2.2666666666666706,
                                                -0.7666666666666657
                                            ],
                                            [
                                                -1.5666666666666675,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -0.8333333333333334,
                                                -1.8999999999999986
                                            ],
                                            [
                                                0,
                                                -2.7999999999999994
                                            ],
                                            [
                                                3.7666666666666657,
                                                -3.033333333333333
                                            ],
                                            [
                                                7.866666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -7.0666666666666655,
                                                0
                                            ],
                                            [
                                                -4.266666666666667,
                                                -3.266666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.4666666666666663
                                            ],
                                            [
                                                2.5333333333333337,
                                                2.1999999999999997
                                            ],
                                            [
                                                3.6666666666666665,
                                                0
                                            ],
                                            [
                                                2.2333333333333343,
                                                -1.2999999999999996
                                            ],
                                            [
                                                0,
                                                -1.8666666666666671
                                            ],
                                            [
                                                -0.8666666666666648,
                                                -1.0666666666666653
                                            ],
                                            [
                                                -1.5666666666666675,
                                                -0.6333333333333352
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -0.40000000000000097
                                            ],
                                            [
                                                -3.800000000000002,
                                                -0.8666666666666648
                                            ],
                                            [
                                                -2.4666666666666663,
                                                -1.400000000000001
                                            ],
                                            [
                                                -1.2,
                                                -2.099999999999999
                                            ],
                                            [
                                                0,
                                                -3.2666666666666657
                                            ],
                                            [
                                                1.7333333333333332,
                                                -2.3999999999999964
                                            ],
                                            [
                                                3.1999999999999993,
                                                -1.3333333333333333
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.2666666666666657,
                                                1.2666666666666657
                                            ],
                                            [
                                                1.900000000000001,
                                                2.5333333333333363
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.2666666666666706
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -2
                                            ],
                                            [
                                                -3.3999999999999986,
                                                0
                                            ],
                                            [
                                                -1.8333333333333333,
                                                1.4333333333333325
                                            ],
                                            [
                                                0,
                                                1.9333333333333325
                                            ],
                                            [
                                                1.1000000000000014,
                                                1.1666666666666667
                                            ],
                                            [
                                                2.3333333333333335,
                                                0.7333333333333343
                                            ],
                                            [
                                                2.799999999999997,
                                                0.5333333333333314
                                            ],
                                            [
                                                2.2666666666666657,
                                                0.766666666666668
                                            ],
                                            [
                                                1.5666666666666629,
                                                1.2666666666666682
                                            ],
                                            [
                                                0.8333333333333334,
                                                1.900000000000001
                                            ],
                                            [
                                                0,
                                                4.933333333333334
                                            ],
                                            [
                                                -3.7666666666666657,
                                                3.033333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27.2,
                                                1
                                            ],
                                            [
                                                10.2,
                                                -3.9
                                            ],
                                            [
                                                3.5,
                                                -17.4
                                            ],
                                            [
                                                13.5,
                                                -18.5
                                            ],
                                            [
                                                17.3,
                                                -10
                                            ],
                                            [
                                                27.5,
                                                -6.7
                                            ],
                                            [
                                                36.35,
                                                -8.65
                                            ],
                                            [
                                                39.7,
                                                -15.2
                                            ],
                                            [
                                                38.4,
                                                -19.6
                                            ],
                                            [
                                                34.75,
                                                -22.15
                                            ],
                                            [
                                                29.3,
                                                -23.7
                                            ],
                                            [
                                                22.6,
                                                -25.1
                                            ],
                                            [
                                                13.2,
                                                -28.5
                                            ],
                                            [
                                                7.7,
                                                -33.75
                                            ],
                                            [
                                                5.9,
                                                -41.2
                                            ],
                                            [
                                                8.5,
                                                -49.7
                                            ],
                                            [
                                                15.9,
                                                -55.3
                                            ],
                                            [
                                                27.2,
                                                -57.3
                                            ],
                                            [
                                                38.6,
                                                -55.4
                                            ],
                                            [
                                                46.35,
                                                -49.7
                                            ],
                                            [
                                                49.5,
                                                -40.1
                                            ],
                                            [
                                                39.6,
                                                -38.8
                                            ],
                                            [
                                                36.5,
                                                -46.7
                                            ],
                                            [
                                                26.9,
                                                -49.7
                                            ],
                                            [
                                                19.05,
                                                -47.55
                                            ],
                                            [
                                                16.3,
                                                -42
                                            ],
                                            [
                                                17.95,
                                                -37.35
                                            ],
                                            [
                                                23.1,
                                                -34.5
                                            ],
                                            [
                                                32.1,
                                                -32.3
                                            ],
                                            [
                                                39.7,
                                                -30.35
                                            ],
                                            [
                                                45.45,
                                                -27.3
                                            ],
                                            [
                                                49.05,
                                                -22.55
                                            ],
                                            [
                                                50.3,
                                                -15.5
                                            ],
                                            [
                                                44.65,
                                                -3.55
                                            ],
                                            [
                                                27.2,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "e",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 58.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.033333333333331,
                                                2.3000000000000003
                                            ],
                                            [
                                                2.233333333333334,
                                                4.333333333333333
                                            ],
                                            [
                                                0,
                                                6.1333333333333355
                                            ],
                                            [
                                                -2.1,
                                                4.36666666666667
                                            ],
                                            [
                                                -3.9333333333333336,
                                                2.4333333333333322
                                            ],
                                            [
                                                -5.600000000000001,
                                                0
                                            ],
                                            [
                                                -3.900000000000001,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2,
                                                -4.699999999999998
                                            ],
                                            [
                                                0.46666666666666384,
                                                -7.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.5666666666666678,
                                                3.599999999999999
                                            ],
                                            [
                                                5.333333333333333,
                                                0
                                            ],
                                            [
                                                3.066666666666665,
                                                -3.2666666666666706
                                            ],
                                            [
                                                0,
                                                -7.399999999999999
                                            ],
                                            [
                                                -2.933333333333335,
                                                -3.4333333333333336
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.5333333333333363,
                                                1.8666666666666671
                                            ],
                                            [
                                                -0.5999999999999991,
                                                3.3333333333333344
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.1333333333333306,
                                                -2.5333333333333337
                                            ],
                                            [
                                                3.3333333333333335,
                                                -1.4333333333333333
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4.033333333333334,
                                                -2.3000000000000003
                                            ],
                                            [
                                                -2.233333333333334,
                                                -4.333333333333332
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                2.1,
                                                -4.3666666666666645
                                            ],
                                            [
                                                3.9333333333333322,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.333333333333333,
                                                0
                                            ],
                                            [
                                                3.8999999999999964,
                                                2.3333333333333335
                                            ],
                                            [
                                                2,
                                                4.699999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.8666666666666695,
                                                -5.8
                                            ],
                                            [
                                                -2.5666666666666678,
                                                -3.6000000000000036
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.0666666666666678,
                                                3.2666666666666657
                                            ],
                                            [
                                                0,
                                                7
                                            ],
                                            [
                                                2.9333333333333322,
                                                3.4333333333333336
                                            ],
                                            [
                                                4.13333333333333,
                                                0
                                            ],
                                            [
                                                2.5333333333333314,
                                                -1.866666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                3.4
                                            ],
                                            [
                                                -2.133333333333335,
                                                2.533333333333333
                                            ],
                                            [
                                                -3.3333333333333335,
                                                1.4333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31,
                                                1
                                            ],
                                            [
                                                16.85,
                                                -2.45
                                            ],
                                            [
                                                7.45,
                                                -12.4
                                            ],
                                            [
                                                4.1,
                                                -28.1
                                            ],
                                            [
                                                7.25,
                                                -43.45
                                            ],
                                            [
                                                16.3,
                                                -53.65
                                            ],
                                            [
                                                30.6,
                                                -57.3
                                            ],
                                            [
                                                44.45,
                                                -53.8
                                            ],
                                            [
                                                53.3,
                                                -43.25
                                            ],
                                            [
                                                55.6,
                                                -25.6
                                            ],
                                            [
                                                13,
                                                -25.6
                                            ],
                                            [
                                                13,
                                                -33.3
                                            ],
                                            [
                                                49.5,
                                                -33.3
                                            ],
                                            [
                                                44.8,
                                                -29.7
                                            ],
                                            [
                                                42.25,
                                                -43.8
                                            ],
                                            [
                                                30.4,
                                                -49.2
                                            ],
                                            [
                                                18.8,
                                                -44.3
                                            ],
                                            [
                                                14.2,
                                                -28.3
                                            ],
                                            [
                                                18.6,
                                                -12.65
                                            ],
                                            [
                                                31.1,
                                                -7.5
                                            ],
                                            [
                                                41.1,
                                                -10.3
                                            ],
                                            [
                                                45.8,
                                                -18.1
                                            ],
                                            [
                                                54.9,
                                                -16
                                            ],
                                            [
                                                50.7,
                                                -7.1
                                            ],
                                            [
                                                42.5,
                                                -1.15
                                            ],
                                            [
                                                31,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "r",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 35.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.2999999999999994,
                                                1.533333333333336
                                            ],
                                            [
                                                -3,
                                                0
                                            ],
                                            [
                                                -1,
                                                -0.40000000000000097
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7000000000000028,
                                                0.09999999999999905
                                            ],
                                            [
                                                0.6666666666666666,
                                                0
                                            ],
                                            [
                                                2.2999999999999994,
                                                -2.3333333333333335
                                            ],
                                            [
                                                0.3333333333333333,
                                                -3.933333333333337
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4666666666666686,
                                                -2.866666666666665
                                            ],
                                            [
                                                2.2999999999999994,
                                                -1.5333333333333314
                                            ],
                                            [
                                                2.0666666666666678,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333314,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.6999999999999981,
                                                -0.1000000000000038
                                            ],
                                            [
                                                -3.7999999999999994,
                                                0
                                            ],
                                            [
                                                -2.300000000000002,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.3,
                                                -56.3
                                            ],
                                            [
                                                16.9,
                                                -48
                                            ],
                                            [
                                                22.55,
                                                -54.6
                                            ],
                                            [
                                                30.5,
                                                -56.9
                                            ],
                                            [
                                                35.1,
                                                -56.3
                                            ],
                                            [
                                                35.1,
                                                -46.6
                                            ],
                                            [
                                                34.4,
                                                -46.6
                                            ],
                                            [
                                                32.55,
                                                -47.05
                                            ],
                                            [
                                                30.5,
                                                -47.2
                                            ],
                                            [
                                                21.35,
                                                -43.7
                                            ],
                                            [
                                                17.4,
                                                -34.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": " ",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 24,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": []
                    }
                ]
            }
        },
        {
            "ch": "R",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 73.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.4666666666666637,
                                                -1.6333333333333353
                                            ],
                                            [
                                                -1.7999999999999972,
                                                -2.900000000000001
                                            ],
                                            [
                                                0,
                                                -3.9333333333333322
                                            ],
                                            [
                                                2.5333333333333314,
                                                -3.2666666666666657
                                            ],
                                            [
                                                4.333333333333333,
                                                -0.9333333333333323
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7999999999999972,
                                                -1.2333333333333296
                                            ],
                                            [
                                                -0.5333333333333314,
                                                -1.8333333333333333
                                            ],
                                            [
                                                0,
                                                -2.5333333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2000000000000028,
                                                1.7666666666666657
                                            ],
                                            [
                                                3.7333333333333343,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.299999999999997,
                                                2
                                            ],
                                            [
                                                0,
                                                3.800000000000002
                                            ],
                                            [
                                                2.300000000000002,
                                                1.9333333333333325
                                            ],
                                            [
                                                4.200000000000003,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5,
                                                0
                                            ],
                                            [
                                                3.4666666666666686,
                                                1.6333333333333353
                                            ],
                                            [
                                                1.8000000000000018,
                                                2.900000000000001
                                            ],
                                            [
                                                0,
                                                4.533333333333331
                                            ],
                                            [
                                                -2.5333333333333363,
                                                3.2666666666666706
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.800000000000002,
                                                0.6000000000000038
                                            ],
                                            [
                                                1.8000000000000018,
                                                1.2333333333333343
                                            ],
                                            [
                                                0.5333333333333314,
                                                1.8333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -1.1999999999999982,
                                                -1.7666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.266666666666666,
                                                0
                                            ],
                                            [
                                                2.300000000000002,
                                                -2
                                            ],
                                            [
                                                0,
                                                -3.799999999999997
                                            ],
                                            [
                                                -2.299999999999997,
                                                -1.9333333333333371
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19,
                                                0
                                            ],
                                            [
                                                8.6,
                                                0
                                            ],
                                            [
                                                8.6,
                                                -72.9
                                            ],
                                            [
                                                43.2,
                                                -72.9
                                            ],
                                            [
                                                55.9,
                                                -70.45
                                            ],
                                            [
                                                63.8,
                                                -63.65
                                            ],
                                            [
                                                66.5,
                                                -53.4
                                            ],
                                            [
                                                62.7,
                                                -41.7
                                            ],
                                            [
                                                52.4,
                                                -35.4
                                            ],
                                            [
                                                52.4,
                                                -36.2
                                            ],
                                            [
                                                60.8,
                                                -33.45
                                            ],
                                            [
                                                64.3,
                                                -28.85
                                            ],
                                            [
                                                65.1,
                                                -22.3
                                            ],
                                            [
                                                65.1,
                                                0
                                            ],
                                            [
                                                54.7,
                                                0
                                            ],
                                            [
                                                54.7,
                                                -20.5
                                            ],
                                            [
                                                52.9,
                                                -28.75
                                            ],
                                            [
                                                45.5,
                                                -31.4
                                            ],
                                            [
                                                17.4,
                                                -31.4
                                            ],
                                            [
                                                17.4,
                                                -40.5
                                            ],
                                            [
                                                42.2,
                                                -40.5
                                            ],
                                            [
                                                52.05,
                                                -43.5
                                            ],
                                            [
                                                55.5,
                                                -52.2
                                            ],
                                            [
                                                52.05,
                                                -60.8
                                            ],
                                            [
                                                42.3,
                                                -63.7
                                            ],
                                            [
                                                17.4,
                                                -63.7
                                            ],
                                            [
                                                19,
                                                -65.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "q",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 64.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.9333333333333336,
                                                4.266666666666666
                                            ],
                                            [
                                                -3.633333333333333,
                                                2.366666666666665
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.299999999999997,
                                                -1.8666666666666647
                                            ],
                                            [
                                                -1.599999999999999,
                                                -3.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.0666666666666678,
                                                -1.7666666666666666
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                3.666666666666668,
                                                2.433333333333333
                                            ],
                                            [
                                                2,
                                                4.433333333333333
                                            ],
                                            [
                                                0,
                                                6
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                1.9333333333333336,
                                                -4.26666666666667
                                            ],
                                            [
                                                3.633333333333334,
                                                -2.366666666666665
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.300000000000002,
                                                1.8666666666666647
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.8666666666666647,
                                                3.266666666666666
                                            ],
                                            [
                                                -3.0666666666666678,
                                                1.7666666666666666
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.6666666666666665,
                                                -2.433333333333333
                                            ],
                                            [
                                                -2,
                                                -4.4333333333333345
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                4.1,
                                                -28.6
                                            ],
                                            [
                                                7,
                                                -43.8
                                            ],
                                            [
                                                15.35,
                                                -53.75
                                            ],
                                            [
                                                28.2,
                                                -57.3
                                            ],
                                            [
                                                39.65,
                                                -54.5
                                            ],
                                            [
                                                47,
                                                -46.7
                                            ],
                                            [
                                                47.7,
                                                -56.3
                                            ],
                                            [
                                                57.2,
                                                -56.3
                                            ],
                                            [
                                                57.2,
                                                16.7
                                            ],
                                            [
                                                47,
                                                16.7
                                            ],
                                            [
                                                47,
                                                -9.2
                                            ],
                                            [
                                                39.6,
                                                -1.65
                                            ],
                                            [
                                                28.5,
                                                1
                                            ],
                                            [
                                                15.6,
                                                -2.65
                                            ],
                                            [
                                                7.1,
                                                -12.95
                                            ],
                                            [
                                                4.1,
                                                -28.6
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.766666666666667,
                                                -3.5666666666666678
                                            ],
                                            [
                                                -5.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.4666666666666637,
                                                1.4333333333333336
                                            ],
                                            [
                                                -1.3333333333333333,
                                                2.633333333333333
                                            ],
                                            [
                                                0,
                                                3.5333333333333314
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3666666666666647,
                                                2.5666666666666678
                                            ],
                                            [
                                                2.5,
                                                1.400000000000001
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.7333333333333343,
                                                -3.4666666666666686
                                            ],
                                            [
                                                0,
                                                -6.333333333333333
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                6.666666666666667
                                            ],
                                            [
                                                2.7666666666666657,
                                                3.5666666666666664
                                            ],
                                            [
                                                3.400000000000001,
                                                0
                                            ],
                                            [
                                                2.4666666666666686,
                                                -1.4333333333333325
                                            ],
                                            [
                                                1.3333333333333333,
                                                -2.633333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.4666666666666686
                                            ],
                                            [
                                                -1.3666666666666696,
                                                -2.566666666666663
                                            ],
                                            [
                                                -2.5,
                                                -1.400000000000001
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -2.733333333333333,
                                                3.4666666666666637
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14.6,
                                                -28.6
                                            ],
                                            [
                                                18.75,
                                                -13.25
                                            ],
                                            [
                                                30.5,
                                                -7.9
                                            ],
                                            [
                                                39.3,
                                                -10.05
                                            ],
                                            [
                                                45,
                                                -16.15
                                            ],
                                            [
                                                47,
                                                -25.4
                                            ],
                                            [
                                                47,
                                                -31.4
                                            ],
                                            [
                                                44.95,
                                                -40.45
                                            ],
                                            [
                                                39.15,
                                                -46.4
                                            ],
                                            [
                                                30.4,
                                                -48.5
                                            ],
                                            [
                                                18.7,
                                                -43.3
                                            ],
                                            [
                                                14.6,
                                                -28.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "u",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 61.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.400000000000001,
                                                3.5
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.133333333333335,
                                                -1.8999999999999997
                                            ],
                                            [
                                                -3.5333333333333337,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                1.2000000000000004
                                            ],
                                            [
                                                -1.2333333333333343,
                                                2.099999999999999
                                            ],
                                            [
                                                0,
                                                2.7999999999999994
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.1000000000000036,
                                                -1.7
                                            ],
                                            [
                                                3.599999999999999,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.466666666666666,
                                                0
                                            ],
                                            [
                                                -3.4,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.4666666666666672
                                            ],
                                            [
                                                2.133333333333333,
                                                1.900000000000001
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                2.2333333333333294,
                                                -1.2000000000000004
                                            ],
                                            [
                                                1.2333333333333343,
                                                -2.1000000000000014
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7333333333333296,
                                                2.9333333333333336
                                            ],
                                            [
                                                -3.099999999999999,
                                                1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27,
                                                1
                                            ],
                                            [
                                                12.2,
                                                -4.25
                                            ],
                                            [
                                                7.1,
                                                -18.2
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -19.1
                                            ],
                                            [
                                                20.6,
                                                -11.05
                                            ],
                                            [
                                                29.1,
                                                -8.2
                                            ],
                                            [
                                                36.95,
                                                -10
                                            ],
                                            [
                                                42.15,
                                                -14.95
                                            ],
                                            [
                                                44,
                                                -22.3
                                            ],
                                            [
                                                44,
                                                -56.3
                                            ],
                                            [
                                                54.3,
                                                -56.3
                                            ],
                                            [
                                                54.3,
                                                0
                                            ],
                                            [
                                                44.8,
                                                0
                                            ],
                                            [
                                                44.3,
                                                -8.5
                                            ],
                                            [
                                                37.05,
                                                -1.55
                                            ],
                                            [
                                                27,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "t",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 31.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9666666666666661,
                                                1.6333333333333335
                                            ],
                                            [
                                                0,
                                                3.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333329,
                                                -0.6666666666666666
                                            ],
                                            [
                                                -1.8666666666666671,
                                                0
                                            ],
                                            [
                                                -0.7000000000000005,
                                                0.06666666666666643
                                            ],
                                            [
                                                -0.5333333333333314,
                                                0.13333333333333405
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2666666666666657,
                                                -0.13333333333333333
                                            ],
                                            [
                                                1.0666666666666653,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -3.7333333333333343,
                                                0
                                            ],
                                            [
                                                -1.9666666666666661,
                                                -1.6333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2.0666666666666664
                                            ],
                                            [
                                                0.6333333333333329,
                                                0.6666666666666666
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                0.7000000000000005,
                                                -0.06666666666666643
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.4666666666666661,
                                                0.26666666666666666
                                            ],
                                            [
                                                -1.2666666666666682,
                                                0.1333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.3,
                                                0.7
                                            ],
                                            [
                                                12.75,
                                                -1.75
                                            ],
                                            [
                                                9.8,
                                                -8.8
                                            ],
                                            [
                                                9.8,
                                                -72
                                            ],
                                            [
                                                19.8,
                                                -73
                                            ],
                                            [
                                                19.8,
                                                -13
                                            ],
                                            [
                                                20.75,
                                                -8.9
                                            ],
                                            [
                                                24.5,
                                                -7.9
                                            ],
                                            [
                                                27.05,
                                                -8
                                            ],
                                            [
                                                28.9,
                                                -8.3
                                            ],
                                            [
                                                28.9,
                                                -0.1
                                            ],
                                            [
                                                24.8,
                                                0.5
                                            ],
                                            [
                                                21.3,
                                                0.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14.8,
                                                -48.3
                                            ],
                                            [
                                                2.3,
                                                -48.3
                                            ],
                                            [
                                                2.3,
                                                -56.3
                                            ],
                                            [
                                                14.8,
                                                -56.3
                                            ],
                                            [
                                                14.8,
                                                -48.3
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                28.9,
                                                -56.3
                                            ],
                                            [
                                                28.9,
                                                -48.3
                                            ],
                                            [
                                                14.8,
                                                -48.3
                                            ],
                                            [
                                                14.8,
                                                -56.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "F",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 61.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19,
                                                0
                                            ],
                                            [
                                                8.6,
                                                0
                                            ],
                                            [
                                                8.6,
                                                -72.9
                                            ],
                                            [
                                                59.8,
                                                -72.9
                                            ],
                                            [
                                                59.8,
                                                -63.7
                                            ],
                                            [
                                                19,
                                                -63.7
                                            ],
                                            [
                                                19,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                55.1,
                                                -31.9
                                            ],
                                            [
                                                17.4,
                                                -31.9
                                            ],
                                            [
                                                17.4,
                                                -40.9
                                            ],
                                            [
                                                55.1,
                                                -40.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "o",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 61.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.033333333333334,
                                                2.433333333333333
                                            ],
                                            [
                                                2.1999999999999993,
                                                4.333333333333334
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                -2.233333333333334,
                                                4.36666666666667
                                            ],
                                            [
                                                -4.033333333333334,
                                                2.4333333333333322
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4,
                                                -2.4333333333333322
                                            ],
                                            [
                                                -2.199999999999998,
                                                -4.3666666666666645
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                2.200000000000003,
                                                -4.366666666666667
                                            ],
                                            [
                                                4,
                                                -2.4
                                            ],
                                            [
                                                5.400000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.466666666666666,
                                                0
                                            ],
                                            [
                                                -4.033333333333334,
                                                -2.433333333333333
                                            ],
                                            [
                                                -2.2000000000000006,
                                                -4.333333333333333
                                            ],
                                            [
                                                0,
                                                -5.933333333333333
                                            ],
                                            [
                                                2.233333333333334,
                                                -4.3666666666666645
                                            ],
                                            [
                                                4.033333333333331,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.400000000000001,
                                                0
                                            ],
                                            [
                                                4,
                                                2.4333333333333322
                                            ],
                                            [
                                                2.200000000000003,
                                                4.36666666666667
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ],
                                            [
                                                -2.199999999999998,
                                                4.366666666666666
                                            ],
                                            [
                                                -4,
                                                2.4
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31,
                                                1
                                            ],
                                            [
                                                16.75,
                                                -2.65
                                            ],
                                            [
                                                7.4,
                                                -12.8
                                            ],
                                            [
                                                4.1,
                                                -28
                                            ],
                                            [
                                                7.45,
                                                -43.45
                                            ],
                                            [
                                                16.85,
                                                -53.65
                                            ],
                                            [
                                                31,
                                                -57.3
                                            ],
                                            [
                                                45.1,
                                                -53.65
                                            ],
                                            [
                                                54.4,
                                                -43.45
                                            ],
                                            [
                                                57.7,
                                                -28.1
                                            ],
                                            [
                                                54.4,
                                                -12.75
                                            ],
                                            [
                                                45.1,
                                                -2.6
                                            ],
                                            [
                                                31,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8999999999999964,
                                                3.5999999999999996
                                            ],
                                            [
                                                0,
                                                6.399999999999999
                                            ],
                                            [
                                                2.900000000000001,
                                                3.5333333333333363
                                            ],
                                            [
                                                5.1333333333333355,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.633333333333335
                                            ],
                                            [
                                                0,
                                                -6.333333333333333
                                            ],
                                            [
                                                -2.9,
                                                -3.5666666666666664
                                            ],
                                            [
                                                -5.199999999999998,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                5.200000000000003,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.6000000000000014
                                            ],
                                            [
                                                0,
                                                -6.466666666666666
                                            ],
                                            [
                                                -2.8999999999999964,
                                                -3.5333333333333314
                                            ],
                                            [
                                                -5.266666666666666,
                                                0
                                            ],
                                            [
                                                -2.9,
                                                3.6333333333333306
                                            ],
                                            [
                                                0,
                                                6.400000000000001
                                            ],
                                            [
                                                2.900000000000001,
                                                3.566666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.9,
                                                -7.8
                                            ],
                                            [
                                                43.05,
                                                -13.2
                                            ],
                                            [
                                                47.4,
                                                -28.2
                                            ],
                                            [
                                                43.05,
                                                -43.2
                                            ],
                                            [
                                                31,
                                                -48.5
                                            ],
                                            [
                                                18.75,
                                                -43.05
                                            ],
                                            [
                                                14.4,
                                                -28.1
                                            ],
                                            [
                                                18.75,
                                                -13.15
                                            ],
                                            [
                                                30.9,
                                                -7.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "m",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 95.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3,
                                                1.6333333333333353
                                            ],
                                            [
                                                -3.4666666666666686,
                                                0
                                            ],
                                            [
                                                -3,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -1.400000000000001,
                                                -3.800000000000002
                                            ],
                                            [
                                                -3.299999999999997,
                                                1.9666666666666686
                                            ],
                                            [
                                                -3.933333333333337,
                                                0
                                            ],
                                            [
                                                -3.199999999999998,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                -5.799999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8000000000000018,
                                                2.0333333333333314
                                            ],
                                            [
                                                3.4666666666666686,
                                                0
                                            ],
                                            [
                                                2.199999999999998,
                                                -1.2666666666666657
                                            ],
                                            [
                                                1.2333333333333296,
                                                -2.366666666666665
                                            ],
                                            [
                                                0,
                                                -3.2666666666666706
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7333333333333343,
                                                2.3333333333333335
                                            ],
                                            [
                                                3.7333333333333343,
                                                0
                                            ],
                                            [
                                                2.133333333333333,
                                                -1.3333333333333333
                                            ],
                                            [
                                                1.2000000000000004,
                                                -2.300000000000002
                                            ],
                                            [
                                                0,
                                                -2.933333333333337
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666647,
                                                -3.400000000000001
                                            ],
                                            [
                                                3,
                                                -1.6333333333333304
                                            ],
                                            [
                                                3.866666666666665,
                                                0
                                            ],
                                            [
                                                3,
                                                1.9333333333333325
                                            ],
                                            [
                                                1.7333333333333343,
                                                -3.7333333333333343
                                            ],
                                            [
                                                3.300000000000002,
                                                -1.966666666666664
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                3.199999999999998,
                                                3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -1.8000000000000018,
                                                -2.0333333333333363
                                            ],
                                            [
                                                -2.799999999999997,
                                                0
                                            ],
                                            [
                                                -2.200000000000003,
                                                1.2666666666666704
                                            ],
                                            [
                                                -1.2333333333333343,
                                                2.366666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -1.7333333333333296,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2.800000000000002,
                                                0
                                            ],
                                            [
                                                -2.133333333333333,
                                                1.3333333333333333
                                            ],
                                            [
                                                -1.2000000000000004,
                                                2.299999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.4,
                                                -56.3
                                            ],
                                            [
                                                17.1,
                                                -47.3
                                            ],
                                            [
                                                24.4,
                                                -54.85
                                            ],
                                            [
                                                34.1,
                                                -57.3
                                            ],
                                            [
                                                44.4,
                                                -54.4
                                            ],
                                            [
                                                51,
                                                -45.8
                                            ],
                                            [
                                                58.55,
                                                -54.35
                                            ],
                                            [
                                                69.4,
                                                -57.3
                                            ],
                                            [
                                                83.2,
                                                -52.05
                                            ],
                                            [
                                                88,
                                                -38.1
                                            ],
                                            [
                                                88,
                                                0
                                            ],
                                            [
                                                77.7,
                                                0
                                            ],
                                            [
                                                77.7,
                                                -36.4
                                            ],
                                            [
                                                75,
                                                -45.05
                                            ],
                                            [
                                                67.1,
                                                -48.1
                                            ],
                                            [
                                                59.6,
                                                -46.2
                                            ],
                                            [
                                                54.45,
                                                -40.75
                                            ],
                                            [
                                                52.6,
                                                -32.3
                                            ],
                                            [
                                                52.6,
                                                0
                                            ],
                                            [
                                                42.4,
                                                0
                                            ],
                                            [
                                                42.4,
                                                -35.5
                                            ],
                                            [
                                                39.8,
                                                -44.6
                                            ],
                                            [
                                                31.6,
                                                -48.1
                                            ],
                                            [
                                                24.2,
                                                -46.1
                                            ],
                                            [
                                                19.2,
                                                -40.65
                                            ],
                                            [
                                                17.4,
                                                -32.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "i",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 24.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -78.6
                                            ],
                                            [
                                                17,
                                                -78.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "n",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3,
                                                1.5333333333333314
                                            ],
                                            [
                                                -3.866666666666667,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -3.2333333333333294
                                            ],
                                            [
                                                0,
                                                -6.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2,
                                                2.0666666666666678
                                            ],
                                            [
                                                4.066666666666667,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.3666666666666671,
                                                -2.200000000000003
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3999999999999986,
                                                -3.2666666666666706
                                            ],
                                            [
                                                3,
                                                -1.5333333333333314
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                3.6333333333333306,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.5333333333333314
                                            ],
                                            [
                                                -2,
                                                -2.0666666666666678
                                            ],
                                            [
                                                -2.7333333333333343,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                1.1666666666666667
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.5,
                                                -56.3
                                            ],
                                            [
                                                17.1,
                                                -47.8
                                            ],
                                            [
                                                25.2,
                                                -55
                                            ],
                                            [
                                                35.5,
                                                -57.3
                                            ],
                                            [
                                                49.45,
                                                -52.45
                                            ],
                                            [
                                                54.9,
                                                -37.6
                                            ],
                                            [
                                                54.9,
                                                0
                                            ],
                                            [
                                                44.7,
                                                0
                                            ],
                                            [
                                                44.7,
                                                -36.6
                                            ],
                                            [
                                                41.7,
                                                -45
                                            ],
                                            [
                                                32.6,
                                                -48.1
                                            ],
                                            [
                                                25,
                                                -46.35
                                            ],
                                            [
                                                19.45,
                                                -41.3
                                            ],
                                            [
                                                17.4,
                                                -33.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "p",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 64.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.3333333333333335,
                                                1.8666666666666647
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ],
                                            [
                                                -3.599999999999999,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -1.9666666666666686,
                                                -4.299999999999997
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                2,
                                                -4.4333333333333345
                                            ],
                                            [
                                                3.6666666666666665,
                                                -2.433333333333333
                                            ],
                                            [
                                                4.933333333333337,
                                                0
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.7
                                            ],
                                            [
                                                1.8666666666666671,
                                                3.4
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6000000000000014,
                                                -3.3333333333333335
                                            ],
                                            [
                                                3.3333333333333335,
                                                -1.8666666666666647
                                            ],
                                            [
                                                5,
                                                0
                                            ],
                                            [
                                                3.599999999999999,
                                                2.3333333333333335
                                            ],
                                            [
                                                1.9666666666666686,
                                                4.300000000000002
                                            ],
                                            [
                                                0,
                                                6
                                            ],
                                            [
                                                -2,
                                                4.433333333333333
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.433333333333333
                                            ],
                                            [
                                                -3.999999999999998,
                                                0
                                            ],
                                            [
                                                -3.233333333333332,
                                                -1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                16.7
                                            ],
                                            [
                                                7.1,
                                                16.7
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.5,
                                                -56.3
                                            ],
                                            [
                                                17.2,
                                                -46.7
                                            ],
                                            [
                                                24.6,
                                                -54.5
                                            ],
                                            [
                                                36,
                                                -57.3
                                            ],
                                            [
                                                48.9,
                                                -53.8
                                            ],
                                            [
                                                57.25,
                                                -43.85
                                            ],
                                            [
                                                60.2,
                                                -28.6
                                            ],
                                            [
                                                57.2,
                                                -12.95
                                            ],
                                            [
                                                48.7,
                                                -2.65
                                            ],
                                            [
                                                35.8,
                                                1
                                            ],
                                            [
                                                24.95,
                                                -1.55
                                            ],
                                            [
                                                17.3,
                                                -9.2
                                            ],
                                            [
                                                17.3,
                                                16.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2.633333333333335
                                            ],
                                            [
                                                -2.4666666666666663,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -3.3333333333333357,
                                                0
                                            ],
                                            [
                                                -2.7666666666666657,
                                                3.5666666666666664
                                            ],
                                            [
                                                0,
                                                6.666666666666667
                                            ],
                                            [
                                                2.7666666666666706,
                                                3.4666666666666637
                                            ],
                                            [
                                                5.066666666666667,
                                                0
                                            ],
                                            [
                                                2.5,
                                                -1.400000000000001
                                            ],
                                            [
                                                1.3666666666666647,
                                                -2.566666666666663
                                            ],
                                            [
                                                0,
                                                -3.4666666666666686
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.5333333333333314
                                            ],
                                            [
                                                1.3333333333333333,
                                                2.633333333333333
                                            ],
                                            [
                                                2.4666666666666663,
                                                1.4333333333333336
                                            ],
                                            [
                                                5.13333333333333,
                                                0
                                            ],
                                            [
                                                2.7666666666666706,
                                                -3.5666666666666678
                                            ],
                                            [
                                                0,
                                                -6.333333333333333
                                            ],
                                            [
                                                -2.7666666666666657,
                                                -3.4666666666666686
                                            ],
                                            [
                                                -3.2666666666666657,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                1.400000000000001
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                -31.4
                                            ],
                                            [
                                                17.3,
                                                -25.4
                                            ],
                                            [
                                                19.3,
                                                -16.15
                                            ],
                                            [
                                                25,
                                                -10.05
                                            ],
                                            [
                                                33.7,
                                                -7.9
                                            ],
                                            [
                                                45.55,
                                                -13.25
                                            ],
                                            [
                                                49.7,
                                                -28.6
                                            ],
                                            [
                                                45.55,
                                                -43.3
                                            ],
                                            [
                                                33.8,
                                                -48.5
                                            ],
                                            [
                                                25.15,
                                                -46.4
                                            ],
                                            [
                                                19.35,
                                                -40.45
                                            ],
                                            [
                                                17.3,
                                                -31.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "c",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 58.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4,
                                                2.433333333333333
                                            ],
                                            [
                                                2.1999999999999993,
                                                4.366666666666666
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                -2.233333333333334,
                                                4.3666666666666645
                                            ],
                                            [
                                                -4.033333333333334,
                                                2.400000000000001
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4.166666666666667,
                                                -3.566666666666663
                                            ],
                                            [
                                                -0.7333333333333295,
                                                -5.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.5333333333333363,
                                                1.9333333333333325
                                            ],
                                            [
                                                3.933333333333335,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.5666666666666678
                                            ],
                                            [
                                                0,
                                                -6.333333333333336
                                            ],
                                            [
                                                -2.866666666666666,
                                                -3.6
                                            ],
                                            [
                                                -5,
                                                0
                                            ],
                                            [
                                                -2.5333333333333314,
                                                2
                                            ],
                                            [
                                                -0.3999999999999962,
                                                3.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.1666666666666665,
                                                -2.866666666666666
                                            ],
                                            [
                                                3.400000000000001,
                                                -1.5
                                            ],
                                            [
                                                4.333333333333331,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4,
                                                -2.4333333333333336
                                            ],
                                            [
                                                -2.2000000000000006,
                                                -4.366666666666667
                                            ],
                                            [
                                                0,
                                                -5.866666666666667
                                            ],
                                            [
                                                2.233333333333334,
                                                -4.36666666666667
                                            ],
                                            [
                                                4.033333333333331,
                                                -2.3999999999999964
                                            ],
                                            [
                                                6.800000000000002,
                                                0
                                            ],
                                            [
                                                4.166666666666667,
                                                3.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.3999999999999962,
                                                -3.9333333333333322
                                            ],
                                            [
                                                -2.5333333333333314,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -2.9,
                                                3.566666666666663
                                            ],
                                            [
                                                0,
                                                6.266666666666666
                                            ],
                                            [
                                                2.866666666666667,
                                                3.6
                                            ],
                                            [
                                                3.933333333333335,
                                                0
                                            ],
                                            [
                                                2.5333333333333363,
                                                -2
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333314,
                                                4.066666666666667
                                            ],
                                            [
                                                -2.1666666666666665,
                                                2.866666666666667
                                            ],
                                            [
                                                -3.400000000000001,
                                                1.5
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.8,
                                                0.9
                                            ],
                                            [
                                                16.7,
                                                -2.75
                                            ],
                                            [
                                                7.4,
                                                -12.95
                                            ],
                                            [
                                                4.1,
                                                -28.2
                                            ],
                                            [
                                                7.45,
                                                -43.55
                                            ],
                                            [
                                                16.85,
                                                -53.7
                                            ],
                                            [
                                                31,
                                                -57.3
                                            ],
                                            [
                                                47.45,
                                                -51.95
                                            ],
                                            [
                                                54.8,
                                                -37.9
                                            ],
                                            [
                                                44.8,
                                                -36.7
                                            ],
                                            [
                                                40.4,
                                                -45.5
                                            ],
                                            [
                                                30.7,
                                                -48.4
                                            ],
                                            [
                                                18.95,
                                                -43.05
                                            ],
                                            [
                                                14.6,
                                                -28.2
                                            ],
                                            [
                                                18.9,
                                                -13.4
                                            ],
                                            [
                                                30.7,
                                                -8
                                            ],
                                            [
                                                40.4,
                                                -11
                                            ],
                                            [
                                                44.8,
                                                -19.5
                                            ],
                                            [
                                                54.8,
                                                -18.3
                                            ],
                                            [
                                                50.75,
                                                -7.9
                                            ],
                                            [
                                                42.4,
                                                -1.35
                                            ],
                                            [
                                                30.8,
                                                0.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "a",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 58,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.233333333333333,
                                                2.9
                                            ],
                                            [
                                                0,
                                                4.666666666666666
                                            ],
                                            [
                                                -1.7,
                                                2.3333333333333335
                                            ],
                                            [
                                                -2.733333333333333,
                                                1.2999999999999996
                                            ],
                                            [
                                                -3.2000000000000006,
                                                0.6000000000000014
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9333333333333323,
                                                1.099999999999999
                                            ],
                                            [
                                                0,
                                                1.8000000000000018
                                            ],
                                            [
                                                1.6666666666666667,
                                                1.5666666666666675
                                            ],
                                            [
                                                4.399999999999999,
                                                0
                                            ],
                                            [
                                                2.5333333333333314,
                                                -1.6666666666666667
                                            ],
                                            [
                                                -0.06666666666666643,
                                                -3.4666666666666637
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.3,
                                                2.9666666666666686
                                            ],
                                            [
                                                -7,
                                                0
                                            ],
                                            [
                                                -3.2333333333333343,
                                                -1.2333333333333296
                                            ],
                                            [
                                                -1.6999999999999982,
                                                -2.5333333333333363
                                            ],
                                            [
                                                0,
                                                -3.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -0.6000000000000002
                                            ],
                                            [
                                                -0.8666666666666695,
                                                0
                                            ],
                                            [
                                                -0.2666666666666657,
                                                0.033333333333333805
                                            ],
                                            [
                                                -0.06666666666666288,
                                                0.06666666666666643
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.099999999999999,
                                                -0.1333333333333333
                                            ],
                                            [
                                                0.5333333333333362,
                                                0
                                            ],
                                            [
                                                1.7666666666666657,
                                                1.4000000000000001
                                            ],
                                            [
                                                0,
                                                2.866666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.6666666666666665,
                                                -1.9333333333333333
                                            ],
                                            [
                                                4.600000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.866666666666666,
                                                0
                                            ],
                                            [
                                                -3.233333333333334,
                                                -2.9
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                1.7000000000000004,
                                                -2.3333333333333335
                                            ],
                                            [
                                                2.733333333333333,
                                                -1.2999999999999996
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3,
                                                -0.5333333333333362
                                            ],
                                            [
                                                0.9333333333333323,
                                                -1.099999999999999
                                            ],
                                            [
                                                0,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -1.6666666666666667,
                                                -1.5666666666666629
                                            ],
                                            [
                                                -4.266666666666668,
                                                0
                                            ],
                                            [
                                                -2.5333333333333337,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.13333333333333344,
                                                -5.533333333333331
                                            ],
                                            [
                                                4.300000000000001,
                                                -2.9666666666666637
                                            ],
                                            [
                                                4.666666666666664,
                                                0
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.2333333333333343
                                            ],
                                            [
                                                1.7000000000000028,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2
                                            ],
                                            [
                                                0.7333333333333295,
                                                0.6000000000000002
                                            ],
                                            [
                                                0.5333333333333314,
                                                0
                                            ],
                                            [
                                                0.26666666666667044,
                                                -0.033333333333333215
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0.26666666666666666
                                            ],
                                            [
                                                -1.099999999999999,
                                                0.1333333333333334
                                            ],
                                            [
                                                -2.866666666666665,
                                                0
                                            ],
                                            [
                                                -1.7666666666666657,
                                                -1.3999999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.400000000000001,
                                                3.1333333333333333
                                            ],
                                            [
                                                -3.6666666666666665,
                                                1.9333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                22.7,
                                                1
                                            ],
                                            [
                                                9.05,
                                                -3.35
                                            ],
                                            [
                                                4.2,
                                                -14.7
                                            ],
                                            [
                                                6.75,
                                                -23.8
                                            ],
                                            [
                                                13.4,
                                                -29.25
                                            ],
                                            [
                                                22.3,
                                                -32.1
                                            ],
                                            [
                                                34.1,
                                                -34.3
                                            ],
                                            [
                                                40,
                                                -36.75
                                            ],
                                            [
                                                41.4,
                                                -41.1
                                            ],
                                            [
                                                38.9,
                                                -46.95
                                            ],
                                            [
                                                29.8,
                                                -49.3
                                            ],
                                            [
                                                19.6,
                                                -46.8
                                            ],
                                            [
                                                15.9,
                                                -39.1
                                            ],
                                            [
                                                6.2,
                                                -40.1
                                            ],
                                            [
                                                12.85,
                                                -52.85
                                            ],
                                            [
                                                29.8,
                                                -57.3
                                            ],
                                            [
                                                41.65,
                                                -55.45
                                            ],
                                            [
                                                49.05,
                                                -49.8
                                            ],
                                            [
                                                51.6,
                                                -40.3
                                            ],
                                            [
                                                51.6,
                                                -11.9
                                            ],
                                            [
                                                52.7,
                                                -8
                                            ],
                                            [
                                                55.1,
                                                -7.1
                                            ],
                                            [
                                                56.3,
                                                -7.15
                                            ],
                                            [
                                                56.8,
                                                -7.3
                                            ],
                                            [
                                                57.4,
                                                -7.3
                                            ],
                                            [
                                                57.4,
                                                0
                                            ],
                                            [
                                                54.75,
                                                0.6
                                            ],
                                            [
                                                52.3,
                                                0.8
                                            ],
                                            [
                                                45.35,
                                                -1.3
                                            ],
                                            [
                                                42.7,
                                                -7.7
                                            ],
                                            [
                                                42.7,
                                                -9.5
                                            ],
                                            [
                                                35.1,
                                                -1.9
                                            ],
                                            [
                                                22.7,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8999999999999986,
                                                1.7
                                            ],
                                            [
                                                -1,
                                                3.066666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4333333333333325,
                                                -0.3999999999999986
                                            ],
                                            [
                                                2.599999999999999,
                                                -0.5333333333333338
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3666666666666671,
                                                -1.6666666666666667
                                            ],
                                            [
                                                0,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2,
                                                -1.3333333333333333
                                            ],
                                            [
                                                -3.0666666666666678,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -1.7000000000000004
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0.6666666666666666
                                            ],
                                            [
                                                -1.4333333333333371,
                                                0.40000000000000097
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.2,
                                                0.8666666666666671
                                            ],
                                            [
                                                -1.3666666666666671,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                2.866666666666667
                                            ],
                                            [
                                                2,
                                                1.3333333333333328
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                25.3,
                                                -7.2
                                            ],
                                            [
                                                35.65,
                                                -9.75
                                            ],
                                            [
                                                41.5,
                                                -16.9
                                            ],
                                            [
                                                41.5,
                                                -29.8
                                            ],
                                            [
                                                42.6,
                                                -29.4
                                            ],
                                            [
                                                39.45,
                                                -27.8
                                            ],
                                            [
                                                33.4,
                                                -26.4
                                            ],
                                            [
                                                25.1,
                                                -24.7
                                            ],
                                            [
                                                16.75,
                                                -20.9
                                            ],
                                            [
                                                14.7,
                                                -15.5
                                            ],
                                            [
                                                17.7,
                                                -9.2
                                            ],
                                            [
                                                25.3,
                                                -7.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "d",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 64.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2,
                                                4.433333333333337
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.400000000000001
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.133333333333335,
                                                -1.7333333333333296
                                            ],
                                            [
                                                -1.8000000000000018,
                                                -3.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.300000000000002,
                                                -1.9000000000000001
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.633333333333334,
                                                2.3666666666666667
                                            ],
                                            [
                                                1.9333333333333336,
                                                4.300000000000001
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                -5.999999999999997
                                            ],
                                            [
                                                2,
                                                -4.433333333333333
                                            ],
                                            [
                                                3.666666666666668,
                                                -2.3999999999999964
                                            ],
                                            [
                                                4.266666666666666,
                                                0
                                            ],
                                            [
                                                3.1333333333333306,
                                                1.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.599999999999999,
                                                3.266666666666666
                                            ],
                                            [
                                                -3.299999999999997,
                                                1.9000000000000001
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.633333333333333,
                                                -2.3666666666666667
                                            ],
                                            [
                                                -1.9333333333333336,
                                                -4.3
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                4.1,
                                                -27.8
                                            ],
                                            [
                                                7.1,
                                                -43.45
                                            ],
                                            [
                                                15.6,
                                                -53.7
                                            ],
                                            [
                                                28.5,
                                                -57.3
                                            ],
                                            [
                                                39.6,
                                                -54.7
                                            ],
                                            [
                                                47,
                                                -47.2
                                            ],
                                            [
                                                47,
                                                -79
                                            ],
                                            [
                                                57.2,
                                                -79
                                            ],
                                            [
                                                57.2,
                                                0
                                            ],
                                            [
                                                47.7,
                                                0
                                            ],
                                            [
                                                47,
                                                -9.6
                                            ],
                                            [
                                                39.65,
                                                -1.85
                                            ],
                                            [
                                                28.2,
                                                1
                                            ],
                                            [
                                                15.35,
                                                -2.55
                                            ],
                                            [
                                                7,
                                                -12.55
                                            ],
                                            [
                                                4.1,
                                                -27.8
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.733333333333333,
                                                -3.4666666666666663
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                1.433333333333333
                                            ],
                                            [
                                                -1.3666666666666696,
                                                2.5666666666666664
                                            ],
                                            [
                                                0,
                                                3.3999999999999986
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                2.633333333333335
                                            ],
                                            [
                                                2.4666666666666686,
                                                1.4333333333333325
                                            ],
                                            [
                                                3.400000000000001,
                                                0
                                            ],
                                            [
                                                2.7666666666666657,
                                                -3.599999999999999
                                            ],
                                            [
                                                0,
                                                -6.600000000000001
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                6.400000000000001
                                            ],
                                            [
                                                2.7333333333333343,
                                                3.466666666666667
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.5,
                                                -1.4333333333333336
                                            ],
                                            [
                                                1.3666666666666647,
                                                -2.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.599999999999999
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2.633333333333335
                                            ],
                                            [
                                                -2.4666666666666637,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -5.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.766666666666667,
                                                3.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14.6,
                                                -27.8
                                            ],
                                            [
                                                18.7,
                                                -13
                                            ],
                                            [
                                                30.4,
                                                -7.8
                                            ],
                                            [
                                                39.15,
                                                -9.95
                                            ],
                                            [
                                                44.95,
                                                -15.95
                                            ],
                                            [
                                                47,
                                                -24.9
                                            ],
                                            [
                                                47,
                                                -30.9
                                            ],
                                            [
                                                45,
                                                -40.25
                                            ],
                                            [
                                                39.3,
                                                -46.35
                                            ],
                                            [
                                                30.5,
                                                -48.5
                                            ],
                                            [
                                                18.75,
                                                -43.1
                                            ],
                                            [
                                                14.6,
                                                -27.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "9",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.5666666666666678,
                                                1.6333333333333335
                                            ],
                                            [
                                                2.1666666666666665,
                                                3.0666666666666664
                                            ],
                                            [
                                                0.5333333333333332,
                                                4.133333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.433333333333335,
                                                -2.3000000000000007
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -2.799999999999997,
                                                2.5666666666666664
                                            ],
                                            [
                                                -1.0666666666666675,
                                                4.400000000000001
                                            ],
                                            [
                                                0.26666666666667044,
                                                5.466666666666669
                                            ],
                                            [
                                                3.5,
                                                -1.9333333333333325
                                            ],
                                            [
                                                4.399999999999999,
                                                0
                                            ],
                                            [
                                                3.7000000000000006,
                                                1.9333333333333347
                                            ],
                                            [
                                                2.0333333333333337,
                                                3.4333333333333322
                                            ],
                                            [
                                                0,
                                                4.600000000000004
                                            ],
                                            [
                                                -2.1333333333333333,
                                                3.633333333333335
                                            ],
                                            [
                                                -3.866666666666667,
                                                2.066666666666663
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -4.166666666666667,
                                                -3.133333333333335
                                            ],
                                            [
                                                -2,
                                                -5.733333333333334
                                            ],
                                            [
                                                0,
                                                -7.8666666666666645
                                            ],
                                            [
                                                1.1333333333333353,
                                                -4.4333333333333345
                                            ],
                                            [
                                                2.3333333333333335,
                                                -3.3000000000000007
                                            ],
                                            [
                                                3.599999999999999,
                                                -1.8
                                            ],
                                            [
                                                4.999999999999997,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.5666666666666664,
                                                -1.6333333333333335
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -3.0666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.39999999999999974,
                                                3.8000000000000007
                                            ],
                                            [
                                                2.4333333333333322,
                                                2.2999999999999994
                                            ],
                                            [
                                                5.066666666666667,
                                                0
                                            ],
                                            [
                                                2.800000000000002,
                                                -2.5666666666666664
                                            ],
                                            [
                                                1.0666666666666675,
                                                -4.399999999999999
                                            ],
                                            [
                                                -1.2666666666666657,
                                                3.0666666666666678
                                            ],
                                            [
                                                -3.5,
                                                1.9333333333333347
                                            ],
                                            [
                                                -4.866666666666667,
                                                0
                                            ],
                                            [
                                                -3.6999999999999993,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2.033333333333333,
                                                -3.4333333333333322
                                            ],
                                            [
                                                0,
                                                -4.73333333333333
                                            ],
                                            [
                                                2.133333333333333,
                                                -3.633333333333335
                                            ],
                                            [
                                                3.866666666666667,
                                                -2.066666666666672
                                            ],
                                            [
                                                6.400000000000001,
                                                0
                                            ],
                                            [
                                                4.166666666666667,
                                                3.133333333333335
                                            ],
                                            [
                                                2,
                                                5.733333333333334
                                            ],
                                            [
                                                0,
                                                5.266666666666666
                                            ],
                                            [
                                                -1.1333333333333304,
                                                4.433333333333333
                                            ],
                                            [
                                                -2.3333333333333335,
                                                3.2999999999999994
                                            ],
                                            [
                                                -3.6000000000000036,
                                                1.8
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                28.8,
                                                1
                                            ],
                                            [
                                                16.45,
                                                -1.45
                                            ],
                                            [
                                                7.85,
                                                -8.5
                                            ],
                                            [
                                                3.8,
                                                -19.3
                                            ],
                                            [
                                                13.6,
                                                -20.6
                                            ],
                                            [
                                                17.85,
                                                -11.45
                                            ],
                                            [
                                                28.5,
                                                -8
                                            ],
                                            [
                                                40.3,
                                                -11.85
                                            ],
                                            [
                                                46.1,
                                                -22.3
                                            ],
                                            [
                                                47.3,
                                                -37.1
                                            ],
                                            [
                                                40.15,
                                                -29.6
                                            ],
                                            [
                                                28.3,
                                                -26.7
                                            ],
                                            [
                                                15.45,
                                                -29.6
                                            ],
                                            [
                                                6.85,
                                                -37.65
                                            ],
                                            [
                                                3.8,
                                                -49.7
                                            ],
                                            [
                                                7,
                                                -62.25
                                            ],
                                            [
                                                16,
                                                -70.8
                                            ],
                                            [
                                                29.4,
                                                -73.9
                                            ],
                                            [
                                                45.25,
                                                -69.2
                                            ],
                                            [
                                                54.5,
                                                -55.9
                                            ],
                                            [
                                                57.5,
                                                -35.5
                                            ],
                                            [
                                                55.8,
                                                -20.95
                                            ],
                                            [
                                                50.6,
                                                -9.35
                                            ],
                                            [
                                                41.7,
                                                -1.7
                                            ],
                                            [
                                                28.8,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8333333333333335,
                                                2.7666666666666657
                                            ],
                                            [
                                                0,
                                                4.466666666666669
                                            ],
                                            [
                                                2.799999999999997,
                                                2.7333333333333294
                                            ],
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.7999999999999994,
                                                -2.733333333333339
                                            ],
                                            [
                                                0,
                                                -4.466666666666669
                                            ],
                                            [
                                                -2.7999999999999994,
                                                -2.599999999999999
                                            ],
                                            [
                                                -4.533333333333334,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.8333333333333335,
                                                -2.7666666666666657
                                            ],
                                            [
                                                0,
                                                -4.400000000000001
                                            ],
                                            [
                                                -2.800000000000002,
                                                -2.733333333333339
                                            ],
                                            [
                                                -4.600000000000001,
                                                0
                                            ],
                                            [
                                                -2.7999999999999994,
                                                2.7333333333333294
                                            ],
                                            [
                                                0,
                                                4.733333333333334
                                            ],
                                            [
                                                2.7999999999999994,
                                                2.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.5,
                                                -35.1
                                            ],
                                            [
                                                40.65,
                                                -39.25
                                            ],
                                            [
                                                44.9,
                                                -50.1
                                            ],
                                            [
                                                40.7,
                                                -60.8
                                            ],
                                            [
                                                29.6,
                                                -64.9
                                            ],
                                            [
                                                18.5,
                                                -60.8
                                            ],
                                            [
                                                14.3,
                                                -50
                                            ],
                                            [
                                                18.5,
                                                -39
                                            ],
                                            [
                                                29.5,
                                                -35.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "g",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.9,
                                                2.866666666666667
                                            ],
                                            [
                                                0.5333333333333332,
                                                4.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.2333333333333343,
                                                -1.4666666666666668
                                            ],
                                            [
                                                -2,
                                                -0.6333333333333329
                                            ],
                                            [
                                                -2.3333333333333335,
                                                0
                                            ],
                                            [
                                                -2.800000000000002,
                                                2.1666666666666674
                                            ],
                                            [
                                                0,
                                                4.933333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3,
                                                -1.366666666666666
                                            ],
                                            [
                                                3.999999999999998,
                                                0
                                            ],
                                            [
                                                3.5,
                                                2.133333333333334
                                            ],
                                            [
                                                1.866666666666666,
                                                3.8333333333333335
                                            ],
                                            [
                                                0,
                                                5.133333333333333
                                            ],
                                            [
                                                -1.8333333333333333,
                                                3.933333333333337
                                            ],
                                            [
                                                -3.4,
                                                2.2333333333333343
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.2333333333333343,
                                                -1.8333333333333333
                                            ],
                                            [
                                                -1.466666666666664,
                                                -3.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666647,
                                                -3.3000000000000003
                                            ],
                                            [
                                                3.8333333333333335,
                                                -1.8333333333333333
                                            ],
                                            [
                                                5.8666666666666645,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.600000000000001,
                                                0
                                            ],
                                            [
                                                -3.9,
                                                -2.866666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.2666666666666657,
                                                2.466666666666667
                                            ],
                                            [
                                                1.2333333333333343,
                                                1.4666666666666668
                                            ],
                                            [
                                                2,
                                                0.6333333333333341
                                            ],
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.799999999999997,
                                                -2.1666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7333333333333343,
                                                3.0666666666666678
                                            ],
                                            [
                                                -3,
                                                1.3666666666666671
                                            ],
                                            [
                                                -4.733333333333334,
                                                0
                                            ],
                                            [
                                                -3.5,
                                                -2.133333333333333
                                            ],
                                            [
                                                -1.8666666666666671,
                                                -3.8333333333333335
                                            ],
                                            [
                                                0,
                                                -5.0666666666666655
                                            ],
                                            [
                                                1.8333333333333333,
                                                -3.9333333333333322
                                            ],
                                            [
                                                3.400000000000001,
                                                -2.2333333333333294
                                            ],
                                            [
                                                4.133333333333333,
                                                0
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.8333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.333333333333333
                                            ],
                                            [
                                                -1.8666666666666696,
                                                3.2999999999999994
                                            ],
                                            [
                                                -3.8333333333333335,
                                                1.8333333333333346
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.1,
                                                17.6
                                            ],
                                            [
                                                13.35,
                                                13.3
                                            ],
                                            [
                                                6.7,
                                                2
                                            ],
                                            [
                                                16,
                                                -0.2
                                            ],
                                            [
                                                18.25,
                                                5.7
                                            ],
                                            [
                                                23.1,
                                                8.85
                                            ],
                                            [
                                                29.6,
                                                9.8
                                            ],
                                            [
                                                40.7,
                                                6.55
                                            ],
                                            [
                                                44.9,
                                                -4.1
                                            ],
                                            [
                                                44.9,
                                                -14.3
                                            ],
                                            [
                                                37.8,
                                                -7.65
                                            ],
                                            [
                                                27.3,
                                                -5.6
                                            ],
                                            [
                                                14.95,
                                                -8.8
                                            ],
                                            [
                                                6.9,
                                                -17.75
                                            ],
                                            [
                                                4.1,
                                                -31.2
                                            ],
                                            [
                                                6.85,
                                                -44.7
                                            ],
                                            [
                                                14.7,
                                                -53.95
                                            ],
                                            [
                                                26.8,
                                                -57.3
                                            ],
                                            [
                                                37.85,
                                                -54.55
                                            ],
                                            [
                                                44.9,
                                                -47
                                            ],
                                            [
                                                45.5,
                                                -56.3
                                            ],
                                            [
                                                55,
                                                -56.3
                                            ],
                                            [
                                                55,
                                                -4.3
                                            ],
                                            [
                                                52.2,
                                                7.15
                                            ],
                                            [
                                                43.65,
                                                14.85
                                            ],
                                            [
                                                29.1,
                                                17.6
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.299999999999997,
                                                1.4333333333333336
                                            ],
                                            [
                                                -1.3000000000000018,
                                                2.433333333333335
                                            ],
                                            [
                                                0,
                                                3.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                2.3333333333333335
                                            ],
                                            [
                                                2.3333333333333335,
                                                1.3666666666666647
                                            ],
                                            [
                                                3.133333333333333,
                                                0
                                            ],
                                            [
                                                2.5333333333333337,
                                                -3.2333333333333294
                                            ],
                                            [
                                                0,
                                                -5.333333333333333
                                            ],
                                            [
                                                -2.5333333333333328,
                                                -3.366666666666667
                                            ],
                                            [
                                                -4.866666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.0666666666666678,
                                                0
                                            ],
                                            [
                                                2.300000000000002,
                                                -1.4333333333333325
                                            ],
                                            [
                                                1.2999999999999972,
                                                -2.4333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2.3333333333333335,
                                                -1.3666666666666647
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -2.5333333333333328,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                5.266666666666668
                                            ],
                                            [
                                                2.5333333333333337,
                                                3.366666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.5,
                                                -13.1
                                            ],
                                            [
                                                37.55,
                                                -15.25
                                            ],
                                            [
                                                42.95,
                                                -21.05
                                            ],
                                            [
                                                44.9,
                                                -29.3
                                            ],
                                            [
                                                44.9,
                                                -33.1
                                            ],
                                            [
                                                42.9,
                                                -41.2
                                            ],
                                            [
                                                37.4,
                                                -46.75
                                            ],
                                            [
                                                29.2,
                                                -48.8
                                            ],
                                            [
                                                18.4,
                                                -43.95
                                            ],
                                            [
                                                14.6,
                                                -31.1
                                            ],
                                            [
                                                18.4,
                                                -18.15
                                            ],
                                            [
                                                29.5,
                                                -13.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "w",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 79.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.5,
                                                0
                                            ],
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                1,
                                                -56.3
                                            ],
                                            [
                                                11.7,
                                                -56.3
                                            ],
                                            [
                                                23.2,
                                                -10.1
                                            ],
                                            [
                                                34,
                                                -56.3
                                            ],
                                            [
                                                45.5,
                                                -56.3
                                            ],
                                            [
                                                56.6,
                                                -10.6
                                            ],
                                            [
                                                67.9,
                                                -56.3
                                            ],
                                            [
                                                78.2,
                                                -56.3
                                            ],
                                            [
                                                62.2,
                                                0
                                            ],
                                            [
                                                50.5,
                                                0
                                            ],
                                            [
                                                39.8,
                                                -44
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "k",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 56.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                57.1,
                                                0
                                            ],
                                            [
                                                44.9,
                                                0
                                            ],
                                            [
                                                26.1,
                                                -28.9
                                            ],
                                            [
                                                16.2,
                                                -19.6
                                            ],
                                            [
                                                16.3,
                                                -31.1
                                            ],
                                            [
                                                42.1,
                                                -56.3
                                            ],
                                            [
                                                55,
                                                -56.3
                                            ],
                                            [
                                                32.2,
                                                -34.7
                                            ],
                                            [
                                                32.2,
                                                -37.2
                                            ],
                                            [
                                                57.1,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.4,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "f",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 32.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.6999999999999993,
                                                2.6666666666666665
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -1,
                                                -0.1000000000000038
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -0.1999999999999981
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.6000000000000014,
                                                0.1000000000000038
                                            ],
                                            [
                                                0.7333333333333343,
                                                0
                                            ],
                                            [
                                                1.2666666666666682,
                                                -1.0999999999999943
                                            ],
                                            [
                                                0,
                                                -2.9333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -4.533333333333331
                                            ],
                                            [
                                                2.7000000000000006,
                                                -2.6666666666666665
                                            ],
                                            [
                                                0.9333333333333323,
                                                0
                                            ],
                                            [
                                                1,
                                                0.09999999999999432
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.3999999999999986,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.5999999999999991,
                                                -0.09999999999999432
                                            ],
                                            [
                                                -2.3999999999999986,
                                                0
                                            ],
                                            [
                                                -1.2666666666666657,
                                                1.1000000000000039
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19,
                                                0
                                            ],
                                            [
                                                8.9,
                                                0
                                            ],
                                            [
                                                8.9,
                                                -64.7
                                            ],
                                            [
                                                12.95,
                                                -75.5
                                            ],
                                            [
                                                25.1,
                                                -79.5
                                            ],
                                            [
                                                28,
                                                -79.35
                                            ],
                                            [
                                                30.5,
                                                -78.9
                                            ],
                                            [
                                                30.5,
                                                -70.2
                                            ],
                                            [
                                                29.9,
                                                -70.2
                                            ],
                                            [
                                                28.4,
                                                -70.65
                                            ],
                                            [
                                                26.4,
                                                -70.8
                                            ],
                                            [
                                                20.9,
                                                -69.15
                                            ],
                                            [
                                                19,
                                                -63.1
                                            ],
                                            [
                                                19,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14,
                                                -48.3
                                            ],
                                            [
                                                0.7,
                                                -48.3
                                            ],
                                            [
                                                0.7,
                                                -56.3
                                            ],
                                            [
                                                14,
                                                -56.3
                                            ],
                                            [
                                                14,
                                                -48.3
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.7,
                                                -48.3
                                            ],
                                            [
                                                14,
                                                -48.3
                                            ],
                                            [
                                                14,
                                                -56.3
                                            ],
                                            [
                                                30.7,
                                                -56.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "l",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 24.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.3,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ".",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 21.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                16.1,
                                                0
                                            ],
                                            [
                                                5.6,
                                                0
                                            ],
                                            [
                                                5.6,
                                                -11.4
                                            ],
                                            [
                                                16.1,
                                                -11.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "j",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 20.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.9666666666666668,
                                                0.13333333333333286
                                            ],
                                            [
                                                0.7333333333333337,
                                                0.1999999999999981
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333331,
                                                -0.06666666666666643
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0
                                            ],
                                            [
                                                -1.1666666666666667,
                                                1.3
                                            ],
                                            [
                                                0,
                                                2.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.6999999999999993,
                                                -2.4
                                            ],
                                            [
                                                4.933333333333334,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1.2000000000000002,
                                                0
                                            ],
                                            [
                                                -0.9666666666666662,
                                                -0.13333333333333522
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.4666666666666668,
                                                0.13333333333333405
                                            ],
                                            [
                                                0.7333333333333337,
                                                0.06666666666666643
                                            ],
                                            [
                                                2.533333333333333,
                                                0
                                            ],
                                            [
                                                1.1666666666666667,
                                                -1.3
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.8
                                            ],
                                            [
                                                -2.7000000000000006,
                                                2.400000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                -1.9,
                                                17.3
                                            ],
                                            [
                                                -5.15,
                                                17.1
                                            ],
                                            [
                                                -7.7,
                                                16.6
                                            ],
                                            [
                                                -7.7,
                                                8.6
                                            ],
                                            [
                                                -5.9,
                                                8.9
                                            ],
                                            [
                                                -3.8,
                                                9
                                            ],
                                            [
                                                1.75,
                                                7.05
                                            ],
                                            [
                                                3.5,
                                                1.1
                                            ],
                                            [
                                                3.5,
                                                -56.3
                                            ],
                                            [
                                                13.6,
                                                -56.3
                                            ],
                                            [
                                                13.6,
                                                2.9
                                            ],
                                            [
                                                9.55,
                                                13.7
                                            ],
                                            [
                                                -1.9,
                                                17.3
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                13.7,
                                                -66.2
                                            ],
                                            [
                                                3.5,
                                                -66.2
                                            ],
                                            [
                                                3.5,
                                                -79
                                            ],
                                            [
                                                13.7,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "h",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.9666666666666686,
                                                1.466666666666664
                                            ],
                                            [
                                                -3.7999999999999994,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -3.2333333333333343
                                            ],
                                            [
                                                0,
                                                -6.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2,
                                                2.0666666666666678
                                            ],
                                            [
                                                4.066666666666667,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.3666666666666671,
                                                -2.199999999999998
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -3.133333333333335
                                            ],
                                            [
                                                2.9666666666666663,
                                                -1.4666666666666686
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                3.6333333333333306,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.5333333333333363
                                            ],
                                            [
                                                -2,
                                                -2.066666666666663
                                            ],
                                            [
                                                -2.7333333333333343,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                1.1666666666666667
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.4,
                                                -79
                                            ],
                                            [
                                                17.4,
                                                -48.4
                                            ],
                                            [
                                                25.35,
                                                -55.3
                                            ],
                                            [
                                                35.5,
                                                -57.5
                                            ],
                                            [
                                                49.45,
                                                -52.65
                                            ],
                                            [
                                                54.9,
                                                -37.8
                                            ],
                                            [
                                                54.9,
                                                0
                                            ],
                                            [
                                                44.7,
                                                0
                                            ],
                                            [
                                                44.7,
                                                -36.8
                                            ],
                                            [
                                                41.7,
                                                -45.2
                                            ],
                                            [
                                                32.6,
                                                -48.3
                                            ],
                                            [
                                                25,
                                                -46.55
                                            ],
                                            [
                                                19.45,
                                                -41.5
                                            ],
                                            [
                                                17.4,
                                                -33.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "E",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 66.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                63.6,
                                                0
                                            ],
                                            [
                                                8.6,
                                                0
                                            ],
                                            [
                                                8.6,
                                                -72.9
                                            ],
                                            [
                                                60.6,
                                                -72.9
                                            ],
                                            [
                                                60.6,
                                                -63.8
                                            ],
                                            [
                                                19,
                                                -63.8
                                            ],
                                            [
                                                19,
                                                -9.2
                                            ],
                                            [
                                                63.6,
                                                -9.2
                                            ],
                                            [
                                                63.6,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                56.5,
                                                -32.9
                                            ],
                                            [
                                                17.4,
                                                -32.9
                                            ],
                                            [
                                                17.4,
                                                -41.7
                                            ],
                                            [
                                                56.5,
                                                -41.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "y",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 51.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2666666666666657,
                                                0.20000000000000048
                                            ],
                                            [
                                                0.8000000000000002,
                                                0.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333334,
                                                -0.13333333333333286
                                            ],
                                            [
                                                -0.7333333333333331,
                                                0
                                            ],
                                            [
                                                -1.4333333333333325,
                                                1.0000000000000007
                                            ],
                                            [
                                                -0.7999999999999995,
                                                2.0666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.733333333333332,
                                                -2.099999999999999
                                            ],
                                            [
                                                -0.8333333333333334,
                                                -2.5666666666666678
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -2.5333333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6000000000000014,
                                                2
                                            ],
                                            [
                                                -0.7000000000000005,
                                                1.9333333333333325
                                            ],
                                            [
                                                -0.8666666666666671,
                                                2.4666666666666663
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6666666666666667,
                                                -1.8333333333333333
                                            ],
                                            [
                                                2.066666666666665,
                                                -0.733333333333332
                                            ],
                                            [
                                                2.5333333333333337,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1,
                                                0
                                            ],
                                            [
                                                -1.2666666666666668,
                                                -0.20000000000000048
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.4666666666666668,
                                                0.20000000000000048
                                            ],
                                            [
                                                0.6333333333333329,
                                                0.13333333333333405
                                            ],
                                            [
                                                2.400000000000001,
                                                0
                                            ],
                                            [
                                                1.4333333333333347,
                                                -1
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.40000000000000097,
                                                1.0666666666666675
                                            ],
                                            [
                                                0.7333333333333343,
                                                2.099999999999999
                                            ],
                                            [
                                                0.8333333333333334,
                                                2.5666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7999999999999995,
                                                -2.6
                                            ],
                                            [
                                                0.5999999999999991,
                                                -2
                                            ],
                                            [
                                                0.7000000000000005,
                                                -1.9333333333333347
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.2000000000000004,
                                                3.266666666666667
                                            ],
                                            [
                                                -1.6666666666666667,
                                                1.8333333333333333
                                            ],
                                            [
                                                -2.0666666666666678,
                                                0.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                11.7,
                                                17.5
                                            ],
                                            [
                                                8.3,
                                                17.2
                                            ],
                                            [
                                                5.2,
                                                16.5
                                            ],
                                            [
                                                5.2,
                                                8.1
                                            ],
                                            [
                                                6,
                                                8.1
                                            ],
                                            [
                                                7.65,
                                                8.6
                                            ],
                                            [
                                                9.7,
                                                8.8
                                            ],
                                            [
                                                15.45,
                                                7.3
                                            ],
                                            [
                                                18.8,
                                                2.7
                                            ],
                                            [
                                                20.7,
                                                -2.1
                                            ],
                                            [
                                                -0.5,
                                                -56.3
                                            ],
                                            [
                                                10.6,
                                                -56.3
                                            ],
                                            [
                                                20,
                                                -30
                                            ],
                                            [
                                                21.7,
                                                -25.25
                                            ],
                                            [
                                                24.05,
                                                -18.25
                                            ],
                                            [
                                                26.3,
                                                -10.6
                                            ],
                                            [
                                                25.7,
                                                -10.6
                                            ],
                                            [
                                                27.8,
                                                -17.5
                                            ],
                                            [
                                                29.75,
                                                -23.4
                                            ],
                                            [
                                                32.1,
                                                -30
                                            ],
                                            [
                                                41.6,
                                                -56.3
                                            ],
                                            [
                                                51.8,
                                                -56.3
                                            ],
                                            [
                                                28.5,
                                                4.9
                                            ],
                                            [
                                                24.2,
                                                12.55
                                            ],
                                            [
                                                18.6,
                                                16.4
                                            ],
                                            [
                                                11.7,
                                                17.5
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "@",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 98.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                1.4666666666666668
                                            ],
                                            [
                                                0.46666666666666856,
                                                3.5333333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.633333333333335,
                                                -1.7666666666666668
                                            ],
                                            [
                                                3.5333333333333363,
                                                0
                                            ],
                                            [
                                                2.633333333333333,
                                                3.233333333333333
                                            ],
                                            [
                                                0.06666666666666761,
                                                5
                                            ],
                                            [
                                                -1.0333333333333339,
                                                3.400000000000001
                                            ],
                                            [
                                                -1.9333333333333325,
                                                2.6333333333333306
                                            ],
                                            [
                                                -2.7666666666666657,
                                                1.5333333333333314
                                            ],
                                            [
                                                -3.4666666666666637,
                                                0
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -1.5666666666666675
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -2.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9333333333333277,
                                                -1.8999999999999997
                                            ],
                                            [
                                                -2.933333333333337,
                                                0
                                            ],
                                            [
                                                -1.7333333333333296,
                                                0.7999999999999995
                                            ],
                                            [
                                                -1.4666666666666686,
                                                1.7999999999999996
                                            ],
                                            [
                                                -0.8999999999999962,
                                                2.866666666666665
                                            ],
                                            [
                                                0,
                                                4.133333333333333
                                            ],
                                            [
                                                1.7666666666666704,
                                                4.13333333333333
                                            ],
                                            [
                                                3.233333333333339,
                                                3.099999999999999
                                            ],
                                            [
                                                4.5,
                                                1.7000000000000028
                                            ],
                                            [
                                                5.533333333333336,
                                                0
                                            ],
                                            [
                                                4.833333333333333,
                                                -2.133333333333335
                                            ],
                                            [
                                                3.599999999999999,
                                                -3.8333333333333335
                                            ],
                                            [
                                                2.0333333333333337,
                                                -5.099999999999999
                                            ],
                                            [
                                                0,
                                                -5.933333333333333
                                            ],
                                            [
                                                -3.233333333333333,
                                                -5.866666666666667
                                            ],
                                            [
                                                -5.666666666666667,
                                                -3.1999999999999997
                                            ],
                                            [
                                                -7.266666666666666,
                                                0
                                            ],
                                            [
                                                -4.566666666666667,
                                                1.7000000000000004
                                            ],
                                            [
                                                -3,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.099999999999994,
                                                -1.900000000000001
                                            ],
                                            [
                                                6.666666666666667,
                                                0
                                            ],
                                            [
                                                5.3666666666666645,
                                                2.133333333333333
                                            ],
                                            [
                                                3.900000000000001,
                                                3.966666666666667
                                            ],
                                            [
                                                2.1666666666666665,
                                                5.5
                                            ],
                                            [
                                                0,
                                                6.666666666666667
                                            ],
                                            [
                                                -2.4000000000000004,
                                                5.766666666666666
                                            ],
                                            [
                                                -4.266666666666666,
                                                4.266666666666666
                                            ],
                                            [
                                                -5.699999999999998,
                                                2.366666666666665
                                            ],
                                            [
                                                -6.599999999999999,
                                                0
                                            ],
                                            [
                                                -5.266666666666666,
                                                -1.8666666666666742
                                            ],
                                            [
                                                -3.866666666666665,
                                                -3.4666666666666637
                                            ],
                                            [
                                                -2.1000000000000036,
                                                -4.799999999999997
                                            ],
                                            [
                                                0,
                                                -5.800000000000002
                                            ],
                                            [
                                                1.4333333333333276,
                                                -3.7000000000000006
                                            ],
                                            [
                                                2.300000000000002,
                                                -2.266666666666667
                                            ],
                                            [
                                                2.699999999999998,
                                                -1.0000000000000007
                                            ],
                                            [
                                                2.5333333333333314,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -3.2666666666666706,
                                                0
                                            ],
                                            [
                                                -2.4333333333333322,
                                                -1.4666666666666661
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.6666666666666667,
                                                3.133333333333333
                                            ],
                                            [
                                                -2.6333333333333306,
                                                1.7666666666666668
                                            ],
                                            [
                                                -4.8666666666666645,
                                                0
                                            ],
                                            [
                                                -2.633333333333333,
                                                -3.233333333333333
                                            ],
                                            [
                                                0,
                                                -3.7999999999999994
                                            ],
                                            [
                                                1.0333333333333339,
                                                -3.400000000000001
                                            ],
                                            [
                                                1.9333333333333325,
                                                -2.633333333333335
                                            ],
                                            [
                                                2.7666666666666706,
                                                -1.533333333333336
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                1.5666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5999999999999943,
                                                2.9333333333333322
                                            ],
                                            [
                                                0.9333333333333371,
                                                1.8999999999999997
                                            ],
                                            [
                                                1.6666666666666667,
                                                0
                                            ],
                                            [
                                                1.7333333333333296,
                                                -0.7999999999999995
                                            ],
                                            [
                                                1.4666666666666686,
                                                -1.8000000000000018
                                            ],
                                            [
                                                0.9000000000000057,
                                                -2.866666666666667
                                            ],
                                            [
                                                0,
                                                -4.86666666666667
                                            ],
                                            [
                                                -1.766666666666661,
                                                -4.1333333333333355
                                            ],
                                            [
                                                -3.2333333333333294,
                                                -3.099999999999999
                                            ],
                                            [
                                                -4.5,
                                                -1.6999999999999982
                                            ],
                                            [
                                                -5.666666666666667,
                                                0
                                            ],
                                            [
                                                -4.833333333333333,
                                                2.1333333333333306
                                            ],
                                            [
                                                -3.599999999999999,
                                                3.8333333333333335
                                            ],
                                            [
                                                -2.0333333333333337,
                                                5.100000000000004
                                            ],
                                            [
                                                0,
                                                7.999999999999999
                                            ],
                                            [
                                                3.233333333333333,
                                                5.866666666666667
                                            ],
                                            [
                                                5.666666666666669,
                                                3.2000000000000006
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                4.566666666666663,
                                                -1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.9333333333333322
                                            ],
                                            [
                                                -5.100000000000004,
                                                1.8999999999999986
                                            ],
                                            [
                                                -6.400000000000001,
                                                0
                                            ],
                                            [
                                                -5.366666666666667,
                                                -2.133333333333333
                                            ],
                                            [
                                                -3.9,
                                                -3.966666666666667
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -5.499999999999999
                                            ],
                                            [
                                                0,
                                                -6.86666666666667
                                            ],
                                            [
                                                2.4000000000000004,
                                                -5.766666666666666
                                            ],
                                            [
                                                4.266666666666668,
                                                -4.266666666666666
                                            ],
                                            [
                                                5.700000000000003,
                                                -2.3666666666666742
                                            ],
                                            [
                                                6.333333333333333,
                                                0
                                            ],
                                            [
                                                5.26666666666667,
                                                1.8666666666666647
                                            ],
                                            [
                                                3.866666666666665,
                                                3.4666666666666686
                                            ],
                                            [
                                                2.0999999999999943,
                                                4.800000000000002
                                            ],
                                            [
                                                0,
                                                5.399999999999999
                                            ],
                                            [
                                                -1.4333333333333371,
                                                3.6999999999999993
                                            ],
                                            [
                                                -2.300000000000002,
                                                2.2666666666666657
                                            ],
                                            [
                                                -2.699999999999998,
                                                1
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                71.2,
                                                -5.8
                                            ],
                                            [
                                                62.65,
                                                -8
                                            ],
                                            [
                                                58.3,
                                                -15.5
                                            ],
                                            [
                                                58,
                                                -15.5
                                            ],
                                            [
                                                51.55,
                                                -8.15
                                            ],
                                            [
                                                42.3,
                                                -5.5
                                            ],
                                            [
                                                31.05,
                                                -10.35
                                            ],
                                            [
                                                27,
                                                -22.7
                                            ],
                                            [
                                                28.55,
                                                -33.5
                                            ],
                                            [
                                                33,
                                                -42.55
                                            ],
                                            [
                                                40.05,
                                                -48.8
                                            ],
                                            [
                                                49.4,
                                                -51.1
                                            ],
                                            [
                                                57.5,
                                                -48.75
                                            ],
                                            [
                                                61.6,
                                                -43
                                            ],
                                            [
                                                61.9,
                                                -43
                                            ],
                                            [
                                                63.1,
                                                -49.5
                                            ],
                                            [
                                                72.2,
                                                -49.5
                                            ],
                                            [
                                                66.6,
                                                -21.9
                                            ],
                                            [
                                                67.1,
                                                -14.65
                                            ],
                                            [
                                                72.9,
                                                -11.8
                                            ],
                                            [
                                                78,
                                                -13
                                            ],
                                            [
                                                82.8,
                                                -16.9
                                            ],
                                            [
                                                86.35,
                                                -23.9
                                            ],
                                            [
                                                87.7,
                                                -34.4
                                            ],
                                            [
                                                85.05,
                                                -47.9
                                            ],
                                            [
                                                77.55,
                                                -58.75
                                            ],
                                            [
                                                65.95,
                                                -65.95
                                            ],
                                            [
                                                50.9,
                                                -68.5
                                            ],
                                            [
                                                35.15,
                                                -65.3
                                            ],
                                            [
                                                22.5,
                                                -56.35
                                            ],
                                            [
                                                14.05,
                                                -42.95
                                            ],
                                            [
                                                11,
                                                -26.4
                                            ],
                                            [
                                                15.85,
                                                -5.6
                                            ],
                                            [
                                                29.2,
                                                8
                                            ],
                                            [
                                                48.6,
                                                12.8
                                            ],
                                            [
                                                63.95,
                                                10.25
                                            ],
                                            [
                                                75.3,
                                                4.2
                                            ],
                                            [
                                                78.8,
                                                8.3
                                            ],
                                            [
                                                65.65,
                                                15.55
                                            ],
                                            [
                                                48,
                                                18.4
                                            ],
                                            [
                                                30.35,
                                                15.2
                                            ],
                                            [
                                                16.45,
                                                6.05
                                            ],
                                            [
                                                7.35,
                                                -8.15
                                            ],
                                            [
                                                4.1,
                                                -26.4
                                            ],
                                            [
                                                7.7,
                                                -45.35
                                            ],
                                            [
                                                17.7,
                                                -60.4
                                            ],
                                            [
                                                32.65,
                                                -70.35
                                            ],
                                            [
                                                51.1,
                                                -73.9
                                            ],
                                            [
                                                68.5,
                                                -71.1
                                            ],
                                            [
                                                82.2,
                                                -63.1
                                            ],
                                            [
                                                91.15,
                                                -50.7
                                            ],
                                            [
                                                94.3,
                                                -34.8
                                            ],
                                            [
                                                92.15,
                                                -21.15
                                            ],
                                            [
                                                86.55,
                                                -12.2
                                            ],
                                            [
                                                79.05,
                                                -7.3
                                            ],
                                            [
                                                71.2,
                                                -5.8
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.4333333333333322,
                                                2.6666666666666665
                                            ],
                                            [
                                                -0.7999999999999972,
                                                4.133333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.3666666666666695,
                                                2.133333333333335
                                            ],
                                            [
                                                1.3333333333333333,
                                                1.4333333333333371
                                            ],
                                            [
                                                2.5333333333333363,
                                                0
                                            ],
                                            [
                                                1.7666666666666704,
                                                -1.2666666666666657
                                            ],
                                            [
                                                1.1333333333333304,
                                                -2.099999999999999
                                            ],
                                            [
                                                0.5666666666666677,
                                                -2.4333333333333322
                                            ],
                                            [
                                                0,
                                                -2.3999999999999986
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -1.8999999999999986
                                            ],
                                            [
                                                -2.8666666666666694,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.199999999999998,
                                                0
                                            ],
                                            [
                                                2.433333333333337,
                                                -2.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.46666666666666856,
                                                -2.2666666666666657
                                            ],
                                            [
                                                -0.36666666666666475,
                                                -2.1333333333333306
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -2.3999999999999964,
                                                0
                                            ],
                                            [
                                                -1.7666666666666657,
                                                1.2666666666666704
                                            ],
                                            [
                                                -1.1333333333333353,
                                                2.099999999999999
                                            ],
                                            [
                                                -0.5666666666666677,
                                                2.433333333333335
                                            ],
                                            [
                                                0,
                                                3.133333333333335
                                            ],
                                            [
                                                1.3333333333333333,
                                                1.900000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                45.1,
                                                -12.7
                                            ],
                                            [
                                                53.55,
                                                -16.7
                                            ],
                                            [
                                                58.4,
                                                -26.9
                                            ],
                                            [
                                                59,
                                                -30
                                            ],
                                            [
                                                59.15,
                                                -36.6
                                            ],
                                            [
                                                56.6,
                                                -41.95
                                            ],
                                            [
                                                50.8,
                                                -44.1
                                            ],
                                            [
                                                44.55,
                                                -42.2
                                            ],
                                            [
                                                40.2,
                                                -37.15
                                            ],
                                            [
                                                37.65,
                                                -30.35
                                            ],
                                            [
                                                36.8,
                                                -23.1
                                            ],
                                            [
                                                38.8,
                                                -15.55
                                            ],
                                            [
                                                45.1,
                                                -12.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "*",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 47.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23.5,
                                                -47.1
                                            ],
                                            [
                                                14.1,
                                                -34
                                            ],
                                            [
                                                8.6,
                                                -38.1
                                            ],
                                            [
                                                18.5,
                                                -50.7
                                            ],
                                            [
                                                3.2,
                                                -55.8
                                            ],
                                            [
                                                5.4,
                                                -62.1
                                            ],
                                            [
                                                20.3,
                                                -56.8
                                            ],
                                            [
                                                20.3,
                                                -72.9
                                            ],
                                            [
                                                26.9,
                                                -72.9
                                            ],
                                            [
                                                26.9,
                                                -56.8
                                            ],
                                            [
                                                41.9,
                                                -62.1
                                            ],
                                            [
                                                44.1,
                                                -55.8
                                            ],
                                            [
                                                29,
                                                -50.7
                                            ],
                                            [
                                                38.4,
                                                -38.1
                                            ],
                                            [
                                                33.2,
                                                -34
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "6",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.166666666666667,
                                                2.9
                                            ],
                                            [
                                                2,
                                                5.633333333333333
                                            ],
                                            [
                                                -0.06666666666666703,
                                                8.199999999999998
                                            ],
                                            [
                                                -1.1000000000000003,
                                                4.466666666666669
                                            ],
                                            [
                                                -2.3000000000000007,
                                                3.366666666666665
                                            ],
                                            [
                                                -3.633333333333333,
                                                1.8666666666666647
                                            ],
                                            [
                                                -5,
                                                0
                                            ],
                                            [
                                                -3.5333333333333314,
                                                -1.6333333333333353
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -3.0333333333333314
                                            ],
                                            [
                                                -0.5333333333333314,
                                                -4.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                2.300000000000002
                                            ],
                                            [
                                                4.666666666666667,
                                                0
                                            ],
                                            [
                                                2.8333333333333335,
                                                -2.200000000000003
                                            ],
                                            [
                                                1.2666666666666657,
                                                -4.299999999999997
                                            ],
                                            [
                                                -0.13333333333333405,
                                                -6.400000000000001
                                            ],
                                            [
                                                -3.4333333333333322,
                                                1.7666666666666657
                                            ],
                                            [
                                                -4.199999999999998,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -1.900000000000001
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -3.4333333333333322
                                            ],
                                            [
                                                0,
                                                -4.666666666666667
                                            ],
                                            [
                                                2.1333333333333306,
                                                -3.633333333333334
                                            ],
                                            [
                                                3.8333333333333335,
                                                -2.066666666666667
                                            ],
                                            [
                                                5.1333333333333355,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.466666666666664,
                                                0
                                            ],
                                            [
                                                -4.166666666666668,
                                                -2.9
                                            ],
                                            [
                                                -2,
                                                -5.6333333333333355
                                            ],
                                            [
                                                0.06666666666666643,
                                                -5.266666666666666
                                            ],
                                            [
                                                1.0999999999999996,
                                                -4.466666666666669
                                            ],
                                            [
                                                2.2999999999999994,
                                                -3.366666666666665
                                            ],
                                            [
                                                3.633333333333333,
                                                -1.8666666666666742
                                            ],
                                            [
                                                4.733333333333334,
                                                0
                                            ],
                                            [
                                                3.5333333333333363,
                                                1.6333333333333353
                                            ],
                                            [
                                                2.1666666666666665,
                                                3.0333333333333363
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.40000000000000097,
                                                -3.800000000000002
                                            ],
                                            [
                                                -2.4333333333333322,
                                                -2.300000000000002
                                            ],
                                            [
                                                -4.533333333333336,
                                                0
                                            ],
                                            [
                                                -2.8333333333333335,
                                                2.200000000000003
                                            ],
                                            [
                                                -1.2666666666666668,
                                                4.300000000000002
                                            ],
                                            [
                                                2,
                                                -3.400000000000001
                                            ],
                                            [
                                                3.433333333333335,
                                                -1.7666666666666704
                                            ],
                                            [
                                                4.400000000000001,
                                                0
                                            ],
                                            [
                                                3.6333333333333306,
                                                1.900000000000001
                                            ],
                                            [
                                                2.1666666666666665,
                                                3.433333333333335
                                            ],
                                            [
                                                0,
                                                4.733333333333332
                                            ],
                                            [
                                                -2.133333333333335,
                                                3.6333333333333333
                                            ],
                                            [
                                                -3.8333333333333335,
                                                2.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.8,
                                                1
                                            ],
                                            [
                                                16.85,
                                                -3.35
                                            ],
                                            [
                                                7.6,
                                                -16.15
                                            ],
                                            [
                                                4.7,
                                                -36.9
                                            ],
                                            [
                                                6.45,
                                                -51.5
                                            ],
                                            [
                                                11.55,
                                                -63.25
                                            ],
                                            [
                                                20.45,
                                                -71.1
                                            ],
                                            [
                                                33.4,
                                                -73.9
                                            ],
                                            [
                                                45.8,
                                                -71.45
                                            ],
                                            [
                                                54.35,
                                                -64.45
                                            ],
                                            [
                                                58.4,
                                                -53.6
                                            ],
                                            [
                                                48.6,
                                                -52.3
                                            ],
                                            [
                                                44.35,
                                                -61.45
                                            ],
                                            [
                                                33.7,
                                                -64.9
                                            ],
                                            [
                                                22.65,
                                                -61.6
                                            ],
                                            [
                                                16.5,
                                                -51.85
                                            ],
                                            [
                                                14.8,
                                                -35.8
                                            ],
                                            [
                                                22.95,
                                                -43.55
                                            ],
                                            [
                                                34.4,
                                                -46.2
                                            ],
                                            [
                                                46.45,
                                                -43.35
                                            ],
                                            [
                                                55.15,
                                                -35.35
                                            ],
                                            [
                                                58.4,
                                                -23.2
                                            ],
                                            [
                                                55.2,
                                                -10.65
                                            ],
                                            [
                                                46.25,
                                                -2.1
                                            ],
                                            [
                                                32.8,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.800000000000002,
                                                2.733333333333333
                                            ],
                                            [
                                                0,
                                                4.466666666666666
                                            ],
                                            [
                                                2.799999999999997,
                                                2.599999999999999
                                            ],
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.8333333333333335,
                                                -2.7333333333333294
                                            ],
                                            [
                                                0,
                                                -4.466666666666669
                                            ],
                                            [
                                                -2.7999999999999994,
                                                -2.6
                                            ],
                                            [
                                                -4.600000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.799999999999997,
                                                -2.733333333333333
                                            ],
                                            [
                                                0,
                                                -4.733333333333334
                                            ],
                                            [
                                                -2.800000000000002,
                                                -2.599999999999999
                                            ],
                                            [
                                                -4.533333333333334,
                                                0
                                            ],
                                            [
                                                -2.8333333333333335,
                                                2.7333333333333343
                                            ],
                                            [
                                                0,
                                                4.733333333333332
                                            ],
                                            [
                                                2.7999999999999994,
                                                2.6
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.6,
                                                -8
                                            ],
                                            [
                                                43.7,
                                                -12.1
                                            ],
                                            [
                                                47.9,
                                                -22.9
                                            ],
                                            [
                                                43.7,
                                                -33.9
                                            ],
                                            [
                                                32.6,
                                                -37.8
                                            ],
                                            [
                                                21.55,
                                                -33.7
                                            ],
                                            [
                                                17.3,
                                                -22.9
                                            ],
                                            [
                                                21.5,
                                                -11.9
                                            ],
                                            [
                                                32.6,
                                                -8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "+",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 60.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                56.3,
                                                -30.4
                                            ],
                                            [
                                                34.7,
                                                -30.4
                                            ],
                                            [
                                                34.8,
                                                -7.4
                                            ],
                                            [
                                                25.3,
                                                -7.4
                                            ],
                                            [
                                                25.2,
                                                -30.4
                                            ],
                                            [
                                                3.8,
                                                -30.4
                                            ],
                                            [
                                                3.8,
                                                -38.8
                                            ],
                                            [
                                                25.2,
                                                -38.8
                                            ],
                                            [
                                                25.3,
                                                -60.8
                                            ],
                                            [
                                                34.8,
                                                -60.8
                                            ],
                                            [
                                                34.7,
                                                -38.8
                                            ],
                                            [
                                                56.3,
                                                -38.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ],
    "assets": [
        {
            "nm": "Popup ",
            "id": "1",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Pop up 4",
                    "sr": 1,
                    "st": 145,
                    "op": 18146,
                    "ip": 145,
                    "ln": "410",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "2",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "Pop up 3",
                    "sr": 1,
                    "st": 151,
                    "op": 18152,
                    "ip": 151,
                    "ln": "409",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                335,
                                373.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "8",
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "Pop up 2",
                    "sr": 1,
                    "st": 150,
                    "op": 18151,
                    "ip": 150,
                    "ln": "408",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "9",
                    "ind": 3
                },
                {
                    "ty": 0,
                    "nm": "popup 1",
                    "sr": 1,
                    "st": 145,
                    "op": 18146,
                    "ip": 145,
                    "ln": "407",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "10",
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Pop up 4",
            "id": "2",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Tick.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "389",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                675.129,
                                559.995
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 19,
                    "h": 19,
                    "refId": "3",
                    "ind": 1
                },
                {
                    "ty": 5,
                    "nm": "User Request",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "388",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                39.468,
                                -3.097
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                620.977,
                                561.349
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "User Request",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "387",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                263.747,
                                197.538
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                632.143,
                                559.242
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            117.276,
                                            31.025
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            263.747,
                                            197.538
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Tick.svg",
            "id": "3",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Tick.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "300",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.222,
                                                    -2.903
                                                ],
                                                [
                                                    -1.583,
                                                    2.903
                                                ],
                                                [
                                                    -4.222,
                                                    0.264
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.826
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.5,
                                            9.237
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -5.247,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.247
                                                ],
                                                [
                                                    5.247,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    5.247
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    5.247,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    5.247
                                                ],
                                                [
                                                    -5.247,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.247
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -9.5
                                                ],
                                                [
                                                    9.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.5
                                                ],
                                                [
                                                    -9.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.2941,
                                            0.6784,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.5,
                                            9.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Pop up 3",
            "id": "8",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Tick.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "363",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                638.798,
                                483.872
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 19,
                    "h": 19,
                    "refId": "3",
                    "ind": 1
                },
                {
                    "ty": 5,
                    "nm": "Form inputs captured",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "362",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                499.667,
                                488.563
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "Form inputs captured",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "361",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                383.5,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            167.605,
                                            31.486
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            189.439,
                                            117.943
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Pop up 2",
            "id": "9",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Tick.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "337",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                266.068,
                                480.544
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 19,
                    "h": 19,
                    "refId": "3",
                    "ind": 1
                },
                {
                    "ty": 5,
                    "nm": "9 actions captured",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "336",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                54.158,
                                -3.427
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                198.158,
                                481.573
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "9 actions captured",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "335",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                101.93,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                383.667,
                                365
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            147.238,
                                            24.956
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -171.078,
                                            115.474
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "popup 1",
            "id": "10",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Tick.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "311",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                182.467,
                                556.772
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 19,
                    "h": 19,
                    "refId": "3",
                    "ind": 1
                },
                {
                    "ty": 5,
                    "nm": "Recording workflow...",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "310",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                43.763,
                                560.73
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "Recording workflow...",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "309",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                359.447,
                                364
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            171.14,
                                            28.063
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -242.015,
                                            192.897
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Dot Line",
            "id": "11",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 6",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "245",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -157.111,
                                86.25
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                524.889,
                                452.25
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.5,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.5,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -157,
                                                    56.5
                                                ],
                                                [
                                                    -157,
                                                    116
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 0,
                                                "k": 0
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": 32
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 48
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 3",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "244",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -157.111,
                                86.25
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                224.889,
                                452.25
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.5,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.5,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -157,
                                                    56.5
                                                ],
                                                [
                                                    -157,
                                                    116
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 0,
                                                "k": 0
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": 32
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 48
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 5",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "242",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -135.772,
                                95.167
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                -98.362,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                505.548,
                                461.167
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.081,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.081,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.176,
                                                    2.661
                                                ],
                                                [
                                                    -5.176,
                                                    57.076
                                                ],
                                                [
                                                    -266.368,
                                                    57.076
                                                ],
                                                [
                                                    -266.368,
                                                    187.672
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 0,
                                                "k": 0
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": -2
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 45
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "241",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -135.772,
                                95.167
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                246.228,
                                461.167
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.081,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.081,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.176,
                                                    2.661
                                                ],
                                                [
                                                    -5.176,
                                                    57.076
                                                ],
                                                [
                                                    -266.368,
                                                    57.076
                                                ],
                                                [
                                                    -266.368,
                                                    187.672
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 0,
                                                "k": 0
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": -2
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 45
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Text field",
            "id": "12",
            "fr": 30,
            "layers": [
                {
                    "ty": 5,
                    "nm": "Harsh Sharma",
                    "sr": 1,
                    "st": 18,
                    "op": 18093,
                    "ip": 18,
                    "ln": "157",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                47.865,
                                -3.053
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                314.985,
                                126.653
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [
                            {
                                "s": {
                                    "t": 0,
                                    "xe": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ne": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "b": 1,
                                    "rn": 0,
                                    "sh": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "r": 1,
                                    "sm": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 47
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 74
                                            }
                                        ]
                                    },
                                    "e": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                "a": {
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "rx": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ry": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sw": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fh": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fs": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "fb": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "t": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            }
                        ],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "john doe",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 1
                },
                {
                    "ty": 5,
                    "nm": "Enter your name",
                    "sr": 1,
                    "st": 0,
                    "op": 47,
                    "ip": 0,
                    "ln": "156",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                47.865,
                                -3.053
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                314.985,
                                126.653
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "Enter your name",
                                        "fc": [
                                            0.6974,
                                            0.6974,
                                            0.6974
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 2
                },
                {
                    "ty": 5,
                    "nm": "joh.doe@gmail.com",
                    "sr": 1,
                    "st": -47,
                    "op": 17954,
                    "ip": 71,
                    "ln": "155",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                75.609,
                                -3.333
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                342.838,
                                189.156
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [
                            {
                                "s": {
                                    "t": 0,
                                    "xe": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ne": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "b": 1,
                                    "rn": 0,
                                    "sh": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "r": 1,
                                    "sm": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 78.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 105.999
                                            }
                                        ]
                                    },
                                    "e": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                "a": {
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "rx": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ry": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sw": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fh": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fs": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "fb": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "t": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            }
                        ],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "joh.doe@gmail.com",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 3
                },
                {
                    "ty": 5,
                    "nm": "name@gmail.com",
                    "sr": 1,
                    "st": 0,
                    "op": 78,
                    "ip": 0,
                    "ln": "154",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                47.865,
                                -3.053
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                314.985,
                                188.331
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "name@gmail.com",
                                        "fc": [
                                            0.6974,
                                            0.6974,
                                            0.6974
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 4
                },
                {
                    "ty": 5,
                    "nm": "******** 2",
                    "sr": 1,
                    "st": 5,
                    "op": 18006,
                    "ip": 80,
                    "ln": "153",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                23.007,
                                -5.879
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                292.741,
                                250.911
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [
                            {
                                "s": {
                                    "t": 0,
                                    "xe": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ne": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "b": 1,
                                    "rn": 0,
                                    "sh": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "r": 1,
                                    "sm": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 108.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 137.999
                                            }
                                        ]
                                    },
                                    "e": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                "a": {
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "rx": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ry": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sw": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fh": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fs": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "fb": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "t": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            }
                        ],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "********",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 5
                },
                {
                    "ty": 5,
                    "nm": "6+ characters",
                    "sr": 1,
                    "st": 0,
                    "op": 107,
                    "ip": 0,
                    "ln": "152",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                52.085,
                                -3.333
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                319.205,
                                251.089
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "6+ characters",
                                        "fc": [
                                            0.6974,
                                            0.6974,
                                            0.6974
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 6
                }
            ]
        },
        {
            "nm": "Register.svg",
            "id": "13",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Button .svg",
                    "sr": 1,
                    "st": 0,
                    "op": 84,
                    "ip": 0,
                    "ln": "498",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                113,
                                19
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                102,
                                102
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                133.5,
                                279.277
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 226,
                    "h": 38,
                    "refId": "14",
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Register.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "25",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                133.5,
                                158.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                133.5,
                                158.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    -0.086
                                                ],
                                                [
                                                    -0.211,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.19,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.201
                                                ],
                                                [
                                                    0.085,
                                                    0.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.38,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.524,
                                                    -0.729
                                                ],
                                                [
                                                    -38.524,
                                                    1.698
                                                ],
                                                [
                                                    -38.396,
                                                    2.127
                                                ],
                                                [
                                                    -37.952,
                                                    2.247
                                                ],
                                                [
                                                    -37.45,
                                                    2.247
                                                ],
                                                [
                                                    -37.45,
                                                    2.825
                                                ],
                                                [
                                                    -38.066,
                                                    2.825
                                                ],
                                                [
                                                    -38.922,
                                                    2.562
                                                ],
                                                [
                                                    -39.208,
                                                    1.698
                                                ],
                                                [
                                                    -39.208,
                                                    -0.729
                                                ],
                                                [
                                                    -39.741,
                                                    -0.729
                                                ],
                                                [
                                                    -39.741,
                                                    -1.292
                                                ],
                                                [
                                                    -39.208,
                                                    -1.292
                                                ],
                                                [
                                                    -39.208,
                                                    -2.329
                                                ],
                                                [
                                                    -38.524,
                                                    -2.329
                                                ],
                                                [
                                                    -38.524,
                                                    -1.292
                                                ],
                                                [
                                                    -37.45,
                                                    -1.292
                                                ],
                                                [
                                                    -37.45,
                                                    -0.729
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.376
                                                ],
                                                [
                                                    0.015,
                                                    -0.145
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.251,
                                                    -0.23
                                                ],
                                                [
                                                    -0.361,
                                                    0
                                                ],
                                                [
                                                    -0.195,
                                                    0.135
                                                ],
                                                [
                                                    -0.08,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.33,
                                                    -0.251
                                                ],
                                                [
                                                    0.491,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.175
                                                ],
                                                [
                                                    0.176,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.17,
                                                    0.321
                                                ],
                                                [
                                                    -0.306,
                                                    0.17
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    -0.171
                                                ],
                                                [
                                                    -0.16,
                                                    -0.301
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    0.406
                                                ],
                                                [
                                                    0.256,
                                                    0.226
                                                ],
                                                [
                                                    0.295,
                                                    0
                                                ],
                                                [
                                                    0.2,
                                                    -0.141
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.395
                                                ],
                                                [
                                                    -0.332,
                                                    0.245
                                                ],
                                                [
                                                    -0.39,
                                                    0
                                                ],
                                                [
                                                    -0.306,
                                                    -0.175
                                                ],
                                                [
                                                    -0.175,
                                                    -0.325
                                                ],
                                                [
                                                    0,
                                                    -0.426
                                                ],
                                                [
                                                    0.17,
                                                    -0.32
                                                ],
                                                [
                                                    0.31,
                                                    -0.175
                                                ],
                                                [
                                                    0.39,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.17
                                                ],
                                                [
                                                    0.164,
                                                    0.295
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -32.864,
                                                    0.609
                                                ],
                                                [
                                                    -32.887,
                                                    1.022
                                                ],
                                                [
                                                    -36.178,
                                                    1.022
                                                ],
                                                [
                                                    -35.764,
                                                    1.976
                                                ],
                                                [
                                                    -34.84,
                                                    2.314
                                                ],
                                                [
                                                    -34.104,
                                                    2.112
                                                ],
                                                [
                                                    -33.682,
                                                    1.556
                                                ],
                                                [
                                                    -32.947,
                                                    1.556
                                                ],
                                                [
                                                    -33.607,
                                                    2.525
                                                ],
                                                [
                                                    -34.84,
                                                    2.893
                                                ],
                                                [
                                                    -35.892,
                                                    2.63
                                                ],
                                                [
                                                    -36.614,
                                                    1.886
                                                ],
                                                [
                                                    -36.877,
                                                    0.759
                                                ],
                                                [
                                                    -36.621,
                                                    -0.361
                                                ],
                                                [
                                                    -35.907,
                                                    -1.097
                                                ],
                                                [
                                                    -34.84,
                                                    -1.36
                                                ],
                                                [
                                                    -33.803,
                                                    -1.104
                                                ],
                                                [
                                                    -33.111,
                                                    -0.398
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.115,
                                                    0.186
                                                ],
                                                [
                                                    0.2,
                                                    0.095
                                                ],
                                                [
                                                    0.239,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    -0.22
                                                ],
                                                [
                                                    0.035,
                                                    -0.391
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.26
                                                ],
                                                [
                                                    -0.114,
                                                    -0.19
                                                ],
                                                [
                                                    -0.195,
                                                    -0.1
                                                ],
                                                [
                                                    -0.346,
                                                    0
                                                ],
                                                [
                                                    -0.24,
                                                    0.221
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -33.57,
                                                    0.466
                                                ],
                                                [
                                                    -33.743,
                                                    -0.203
                                                ],
                                                [
                                                    -34.216,
                                                    -0.631
                                                ],
                                                [
                                                    -34.869,
                                                    -0.781
                                                ],
                                                [
                                                    -35.757,
                                                    -0.451
                                                ],
                                                [
                                                    -36.17,
                                                    0.466
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.219,
                                                    0.13
                                                ],
                                                [
                                                    -0.32,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.119,
                                                    -0.235
                                                ],
                                                [
                                                    0.227,
                                                    -0.13
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.767,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.277,
                                                    -0.624
                                                ],
                                                [
                                                    -30.767,
                                                    -1.172
                                                ],
                                                [
                                                    -29.948,
                                                    -1.367
                                                ],
                                                [
                                                    -29.948,
                                                    -0.661
                                                ],
                                                [
                                                    -30.128,
                                                    -0.661
                                                ],
                                                [
                                                    -31.277,
                                                    0.586
                                                ],
                                                [
                                                    -31.277,
                                                    2.825
                                                ],
                                                [
                                                    -31.962,
                                                    2.825
                                                ],
                                                [
                                                    -31.962,
                                                    -1.292
                                                ],
                                                [
                                                    -31.277,
                                                    -1.292
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.326,
                                                    0
                                                ],
                                                [
                                                    -0.251,
                                                    -0.135
                                                ],
                                                [
                                                    -0.145,
                                                    -0.265
                                                ],
                                                [
                                                    0,
                                                    -0.38
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.347,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.346,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.225,
                                                    0.116
                                                ],
                                                [
                                                    -0.276,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.156
                                                ],
                                                [
                                                    -0.132,
                                                    -0.3
                                                ],
                                                [
                                                    -0.267,
                                                    0.16
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.321,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.131
                                                ],
                                                [
                                                    0.146,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.2,
                                                    -0.221
                                                ],
                                                [
                                                    -0.356,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.225
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.2,
                                                    -0.221
                                                ],
                                                [
                                                    -0.355,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.225
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.215
                                                ],
                                                [
                                                    0.232,
                                                    -0.115
                                                ],
                                                [
                                                    0.345,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    0.155
                                                ],
                                                [
                                                    0.114,
                                                    -0.29
                                                ],
                                                [
                                                    0.265,
                                                    -0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.206,
                                                    -1.367
                                                ],
                                                [
                                                    -23.35,
                                                    -1.165
                                                ],
                                                [
                                                    -22.757,
                                                    -0.571
                                                ],
                                                [
                                                    -22.538,
                                                    0.398
                                                ],
                                                [
                                                    -22.538,
                                                    2.825
                                                ],
                                                [
                                                    -23.215,
                                                    2.825
                                                ],
                                                [
                                                    -23.215,
                                                    0.496
                                                ],
                                                [
                                                    -23.523,
                                                    -0.443
                                                ],
                                                [
                                                    -24.342,
                                                    -0.774
                                                ],
                                                [
                                                    -25.191,
                                                    -0.428
                                                ],
                                                [
                                                    -25.507,
                                                    0.556
                                                ],
                                                [
                                                    -25.507,
                                                    2.825
                                                ],
                                                [
                                                    -26.182,
                                                    2.825
                                                ],
                                                [
                                                    -26.182,
                                                    0.496
                                                ],
                                                [
                                                    -26.491,
                                                    -0.443
                                                ],
                                                [
                                                    -27.31,
                                                    -0.774
                                                ],
                                                [
                                                    -28.159,
                                                    -0.428
                                                ],
                                                [
                                                    -28.475,
                                                    0.556
                                                ],
                                                [
                                                    -28.475,
                                                    2.825
                                                ],
                                                [
                                                    -29.158,
                                                    2.825
                                                ],
                                                [
                                                    -29.158,
                                                    -1.292
                                                ],
                                                [
                                                    -28.475,
                                                    -1.292
                                                ],
                                                [
                                                    -28.475,
                                                    -0.699
                                                ],
                                                [
                                                    -27.934,
                                                    -1.195
                                                ],
                                                [
                                                    -27.174,
                                                    -1.367
                                                ],
                                                [
                                                    -26.258,
                                                    -1.134
                                                ],
                                                [
                                                    -25.663,
                                                    -0.451
                                                ],
                                                [
                                                    -25.092,
                                                    -1.127
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.295,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.105
                                                ],
                                                [
                                                    0.145,
                                                    0.191
                                                ],
                                                [
                                                    0.016,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.13
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.15,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.175
                                                ],
                                                [
                                                    0.162,
                                                    0.085
                                                ],
                                                [
                                                    0.336,
                                                    0.085
                                                ],
                                                [
                                                    0.196,
                                                    0.08
                                                ],
                                                [
                                                    0.14,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.265
                                                ],
                                                [
                                                    -0.125,
                                                    0.175
                                                ],
                                                [
                                                    -0.23,
                                                    0.1
                                                ],
                                                [
                                                    -0.295,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.231
                                                ],
                                                [
                                                    -0.021,
                                                    -0.4
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    0.13
                                                ],
                                                [
                                                    0.267,
                                                    0
                                                ],
                                                [
                                                    0.146,
                                                    -0.105
                                                ],
                                                [
                                                    0,
                                                    -0.171
                                                ],
                                                [
                                                    -0.086,
                                                    -0.09
                                                ],
                                                [
                                                    -0.131,
                                                    -0.055
                                                ],
                                                [
                                                    -0.235,
                                                    -0.065
                                                ],
                                                [
                                                    -0.187,
                                                    -0.081
                                                ],
                                                [
                                                    -0.13,
                                                    -0.155
                                                ],
                                                [
                                                    -0.004,
                                                    -0.251
                                                ],
                                                [
                                                    0.125,
                                                    -0.18
                                                ],
                                                [
                                                    0.231,
                                                    -0.105
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.317,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.11
                                                ],
                                                [
                                                    -0.145,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    0.205
                                                ],
                                                [
                                                    0.175,
                                                    0.13
                                                ],
                                                [
                                                    0.261,
                                                    0
                                                ],
                                                [
                                                    0.151,
                                                    -0.116
                                                ],
                                                [
                                                    0,
                                                    -0.181
                                                ],
                                                [
                                                    -0.159,
                                                    -0.091
                                                ],
                                                [
                                                    -0.306,
                                                    -0.081
                                                ],
                                                [
                                                    -0.19,
                                                    -0.085
                                                ],
                                                [
                                                    -0.135,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    -0.211
                                                ],
                                                [
                                                    0.125,
                                                    -0.175
                                                ],
                                                [
                                                    0.231,
                                                    -0.105
                                                ],
                                                [
                                                    0.455,
                                                    0
                                                ],
                                                [
                                                    0.282,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.015,
                                                    -0.215
                                                ],
                                                [
                                                    -0.155,
                                                    -0.13
                                                ],
                                                [
                                                    -0.244,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.106
                                                ],
                                                [
                                                    0,
                                                    0.135
                                                ],
                                                [
                                                    0.089,
                                                    0.085
                                                ],
                                                [
                                                    0.135,
                                                    0.05
                                                ],
                                                [
                                                    0.295,
                                                    0.08
                                                ],
                                                [
                                                    0.185,
                                                    0.075
                                                ],
                                                [
                                                    0.135,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0.225
                                                ],
                                                [
                                                    -0.126,
                                                    0.181
                                                ],
                                                [
                                                    -0.224,
                                                    0.1
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -19.958,
                                                    2.893
                                                ],
                                                [
                                                    -20.807,
                                                    2.735
                                                ],
                                                [
                                                    -21.402,
                                                    2.284
                                                ],
                                                [
                                                    -21.642,
                                                    1.616
                                                ],
                                                [
                                                    -20.936,
                                                    1.616
                                                ],
                                                [
                                                    -20.65,
                                                    2.119
                                                ],
                                                [
                                                    -19.967,
                                                    2.314
                                                ],
                                                [
                                                    -19.351,
                                                    2.142
                                                ],
                                                [
                                                    -19.124,
                                                    1.706
                                                ],
                                                [
                                                    -19.366,
                                                    1.308
                                                ],
                                                [
                                                    -20.109,
                                                    1.045
                                                ],
                                                [
                                                    -20.861,
                                                    0.804
                                                ],
                                                [
                                                    -21.357,
                                                    0.436
                                                ],
                                                [
                                                    -21.56,
                                                    -0.21
                                                ],
                                                [
                                                    -21.372,
                                                    -0.789
                                                ],
                                                [
                                                    -20.838,
                                                    -1.202
                                                ],
                                                [
                                                    -20.049,
                                                    -1.36
                                                ],
                                                [
                                                    -18.945,
                                                    -1.014
                                                ],
                                                [
                                                    -18.493,
                                                    -0.068
                                                ],
                                                [
                                                    -19.178,
                                                    -0.068
                                                ],
                                                [
                                                    -19.441,
                                                    -0.586
                                                ],
                                                [
                                                    -20.072,
                                                    -0.781
                                                ],
                                                [
                                                    -20.658,
                                                    -0.624
                                                ],
                                                [
                                                    -20.876,
                                                    -0.21
                                                ],
                                                [
                                                    -20.747,
                                                    0.128
                                                ],
                                                [
                                                    -20.417,
                                                    0.338
                                                ],
                                                [
                                                    -19.861,
                                                    0.511
                                                ],
                                                [
                                                    -19.139,
                                                    0.752
                                                ],
                                                [
                                                    -18.667,
                                                    1.097
                                                ],
                                                [
                                                    -18.456,
                                                    1.706
                                                ],
                                                [
                                                    -18.644,
                                                    2.314
                                                ],
                                                [
                                                    -19.178,
                                                    2.743
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.316
                                                ],
                                                [
                                                    -0.297,
                                                    0.175
                                                ],
                                                [
                                                    -0.364,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.272,
                                                    -0.16
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.295,
                                                    0.18
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.321
                                                ],
                                                [
                                                    0.299,
                                                    -0.175
                                                ],
                                                [
                                                    0.362,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.24
                                                ],
                                                [
                                                    -0.265,
                                                    0.155
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.297,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.743,
                                                    0.752
                                                ],
                                                [
                                                    -15.488,
                                                    -0.353
                                                ],
                                                [
                                                    -14.788,
                                                    -1.097
                                                ],
                                                [
                                                    -13.79,
                                                    -1.36
                                                ],
                                                [
                                                    -12.851,
                                                    -1.127
                                                ],
                                                [
                                                    -12.257,
                                                    -0.541
                                                ],
                                                [
                                                    -12.257,
                                                    -1.292
                                                ],
                                                [
                                                    -11.566,
                                                    -1.292
                                                ],
                                                [
                                                    -11.566,
                                                    2.825
                                                ],
                                                [
                                                    -12.257,
                                                    2.825
                                                ],
                                                [
                                                    -12.257,
                                                    2.059
                                                ],
                                                [
                                                    -12.866,
                                                    2.66
                                                ],
                                                [
                                                    -13.797,
                                                    2.893
                                                ],
                                                [
                                                    -14.788,
                                                    2.623
                                                ],
                                                [
                                                    -15.488,
                                                    1.864
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.311
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.12
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.209,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.315
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.21,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.126
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.257,
                                                    0.759
                                                ],
                                                [
                                                    -12.445,
                                                    -0.052
                                                ],
                                                [
                                                    -12.956,
                                                    -0.578
                                                ],
                                                [
                                                    -13.654,
                                                    -0.766
                                                ],
                                                [
                                                    -14.353,
                                                    -0.586
                                                ],
                                                [
                                                    -14.857,
                                                    -0.06
                                                ],
                                                [
                                                    -15.045,
                                                    0.752
                                                ],
                                                [
                                                    -14.857,
                                                    1.578
                                                ],
                                                [
                                                    -14.353,
                                                    2.112
                                                ],
                                                [
                                                    -13.654,
                                                    2.292
                                                ],
                                                [
                                                    -12.956,
                                                    2.112
                                                ],
                                                [
                                                    -12.445,
                                                    1.578
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.502,
                                                    0
                                                ],
                                                [
                                                    0.311,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.206,
                                                    -0.221
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.237,
                                                    -0.115
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -8.404,
                                                    -1.367
                                                ],
                                                [
                                                    -7.187,
                                                    -0.909
                                                ],
                                                [
                                                    -6.721,
                                                    0.398
                                                ],
                                                [
                                                    -6.721,
                                                    2.825
                                                ],
                                                [
                                                    -7.396,
                                                    2.825
                                                ],
                                                [
                                                    -7.396,
                                                    0.496
                                                ],
                                                [
                                                    -7.704,
                                                    -0.443
                                                ],
                                                [
                                                    -8.547,
                                                    -0.774
                                                ],
                                                [
                                                    -9.411,
                                                    -0.436
                                                ],
                                                [
                                                    -9.726,
                                                    0.549
                                                ],
                                                [
                                                    -9.726,
                                                    2.825
                                                ],
                                                [
                                                    -10.41,
                                                    2.825
                                                ],
                                                [
                                                    -10.41,
                                                    -1.292
                                                ],
                                                [
                                                    -9.726,
                                                    -1.292
                                                ],
                                                [
                                                    -9.726,
                                                    -0.706
                                                ],
                                                [
                                                    -9.178,
                                                    -1.195
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.169,
                                                    0.316
                                                ],
                                                [
                                                    -0.297,
                                                    0.175
                                                ],
                                                [
                                                    -0.371,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.151
                                                ],
                                                [
                                                    -0.146,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    -0.16
                                                ],
                                                [
                                                    0.357,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.18
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.321
                                                ],
                                                [
                                                    0.3,
                                                    -0.175
                                                ],
                                                [
                                                    0.321,
                                                    0
                                                ],
                                                [
                                                    0.276,
                                                    0.145
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.136,
                                                    0.246
                                                ],
                                                [
                                                    -0.266,
                                                    0.155
                                                ],
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.297,
                                                    -0.181
                                                ],
                                                [
                                                    -0.169,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.859,
                                                    0.752
                                                ],
                                                [
                                                    -5.604,
                                                    -0.353
                                                ],
                                                [
                                                    -4.904,
                                                    -1.097
                                                ],
                                                [
                                                    -3.898,
                                                    -1.36
                                                ],
                                                [
                                                    -3.004,
                                                    -1.134
                                                ],
                                                [
                                                    -2.372,
                                                    -0.556
                                                ],
                                                [
                                                    -2.372,
                                                    -2.735
                                                ],
                                                [
                                                    -1.682,
                                                    -2.735
                                                ],
                                                [
                                                    -1.682,
                                                    2.825
                                                ],
                                                [
                                                    -2.372,
                                                    2.825
                                                ],
                                                [
                                                    -2.372,
                                                    2.051
                                                ],
                                                [
                                                    -2.973,
                                                    2.66
                                                ],
                                                [
                                                    -3.906,
                                                    2.893
                                                ],
                                                [
                                                    -4.904,
                                                    2.623
                                                ],
                                                [
                                                    -5.604,
                                                    1.864
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.311
                                                ],
                                                [
                                                    0.126,
                                                    0.23
                                                ],
                                                [
                                                    0.217,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.12
                                                ],
                                                [
                                                    0.127,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.315
                                                ],
                                                [
                                                    0.127,
                                                    0.23
                                                ],
                                                [
                                                    0.211,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.217,
                                                    -0.126
                                                ],
                                                [
                                                    0.126,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.372,
                                                    0.759
                                                ],
                                                [
                                                    -2.561,
                                                    -0.052
                                                ],
                                                [
                                                    -3.072,
                                                    -0.578
                                                ],
                                                [
                                                    -3.77,
                                                    -0.766
                                                ],
                                                [
                                                    -4.469,
                                                    -0.586
                                                ],
                                                [
                                                    -4.973,
                                                    -0.06
                                                ],
                                                [
                                                    -5.161,
                                                    0.752
                                                ],
                                                [
                                                    -4.973,
                                                    1.578
                                                ],
                                                [
                                                    -4.469,
                                                    2.112
                                                ],
                                                [
                                                    -3.77,
                                                    2.292
                                                ],
                                                [
                                                    -3.072,
                                                    2.112
                                                ],
                                                [
                                                    -2.561,
                                                    1.578
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.431
                                                ],
                                                [
                                                    -0.17,
                                                    0.316
                                                ],
                                                [
                                                    -0.301,
                                                    0.175
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.325,
                                                    -0.245
                                                ],
                                                [
                                                    -0.106,
                                                    -0.436
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.207,
                                                    0.145
                                                ],
                                                [
                                                    0.3,
                                                    0
                                                ],
                                                [
                                                    0.241,
                                                    -0.27
                                                ],
                                                [
                                                    0,
                                                    -0.491
                                                ],
                                                [
                                                    -0.239,
                                                    -0.271
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.2,
                                                    0.14
                                                ],
                                                [
                                                    -0.075,
                                                    0.26
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.33,
                                                    -0.255
                                                ],
                                                [
                                                    0.496,
                                                    0
                                                ],
                                                [
                                                    0.306,
                                                    0.175
                                                ],
                                                [
                                                    0.171,
                                                    0.321
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.426
                                                ],
                                                [
                                                    0.171,
                                                    -0.321
                                                ],
                                                [
                                                    0.306,
                                                    -0.175
                                                ],
                                                [
                                                    0.505,
                                                    0
                                                ],
                                                [
                                                    0.332,
                                                    0.246
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.069,
                                                    -0.25
                                                ],
                                                [
                                                    -0.2,
                                                    -0.146
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.239,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.496
                                                ],
                                                [
                                                    0.241,
                                                    0.27
                                                ],
                                                [
                                                    0.3,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    -0.14
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.421
                                                ],
                                                [
                                                    -0.331,
                                                    0.251
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    -0.175
                                                ],
                                                [
                                                    -0.17,
                                                    -0.32
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.223,
                                                    0.759
                                                ],
                                                [
                                                    1.477,
                                                    -0.353
                                                ],
                                                [
                                                    2.184,
                                                    -1.097
                                                ],
                                                [
                                                    3.229,
                                                    -1.36
                                                ],
                                                [
                                                    4.475,
                                                    -0.992
                                                ],
                                                [
                                                    5.13,
                                                    0.03
                                                ],
                                                [
                                                    4.393,
                                                    0.03
                                                ],
                                                [
                                                    3.979,
                                                    -0.563
                                                ],
                                                [
                                                    3.229,
                                                    -0.781
                                                ],
                                                [
                                                    2.281,
                                                    -0.376
                                                ],
                                                [
                                                    1.921,
                                                    0.759
                                                ],
                                                [
                                                    2.281,
                                                    1.909
                                                ],
                                                [
                                                    3.229,
                                                    2.314
                                                ],
                                                [
                                                    3.979,
                                                    2.104
                                                ],
                                                [
                                                    4.393,
                                                    1.503
                                                ],
                                                [
                                                    5.13,
                                                    1.503
                                                ],
                                                [
                                                    4.468,
                                                    2.517
                                                ],
                                                [
                                                    3.229,
                                                    2.893
                                                ],
                                                [
                                                    2.184,
                                                    2.63
                                                ],
                                                [
                                                    1.477,
                                                    1.886
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.392,
                                                    0
                                                ],
                                                [
                                                    0.317,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.181,
                                                    0.321
                                                ],
                                                [
                                                    -0.317,
                                                    0.17
                                                ],
                                                [
                                                    -0.39,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    -0.175
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.426
                                                ],
                                                [
                                                    0.191,
                                                    -0.325
                                                ],
                                                [
                                                    0.321,
                                                    -0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.175
                                                ],
                                                [
                                                    -0.175,
                                                    -0.325
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.185,
                                                    -0.326
                                                ],
                                                [
                                                    0.315,
                                                    -0.175
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.17
                                                ],
                                                [
                                                    0.185,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.184,
                                                    0.321
                                                ],
                                                [
                                                    -0.319,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.837,
                                                    2.893
                                                ],
                                                [
                                                    6.785,
                                                    2.63
                                                ],
                                                [
                                                    6.049,
                                                    1.886
                                                ],
                                                [
                                                    5.786,
                                                    0.759
                                                ],
                                                [
                                                    6.057,
                                                    -0.353
                                                ],
                                                [
                                                    6.809,
                                                    -1.097
                                                ],
                                                [
                                                    7.867,
                                                    -1.36
                                                ],
                                                [
                                                    8.927,
                                                    -1.097
                                                ],
                                                [
                                                    9.671,
                                                    -0.361
                                                ],
                                                [
                                                    9.949,
                                                    0.759
                                                ],
                                                [
                                                    9.663,
                                                    1.886
                                                ],
                                                [
                                                    8.904,
                                                    2.63
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    0.115
                                                ],
                                                [
                                                    -0.131,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.244,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.116
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.119,
                                                    -0.23
                                                ],
                                                [
                                                    -0.205,
                                                    -0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.115
                                                ],
                                                [
                                                    0.134,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.131,
                                                    -0.23
                                                ],
                                                [
                                                    -0.211,
                                                    -0.116
                                                ],
                                                [
                                                    -0.252,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.231
                                                ],
                                                [
                                                    0.206,
                                                    0.11
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.837,
                                                    2.292
                                                ],
                                                [
                                                    8.529,
                                                    2.119
                                                ],
                                                [
                                                    9.048,
                                                    1.601
                                                ],
                                                [
                                                    9.251,
                                                    0.759
                                                ],
                                                [
                                                    9.055,
                                                    -0.083
                                                ],
                                                [
                                                    8.544,
                                                    -0.593
                                                ],
                                                [
                                                    7.861,
                                                    -0.766
                                                ],
                                                [
                                                    7.169,
                                                    -0.593
                                                ],
                                                [
                                                    6.673,
                                                    -0.083
                                                ],
                                                [
                                                    6.486,
                                                    0.759
                                                ],
                                                [
                                                    6.665,
                                                    1.608
                                                ],
                                                [
                                                    7.161,
                                                    2.127
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.205,
                                                    -0.221
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.235,
                                                    -0.115
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.854,
                                                    -1.367
                                                ],
                                                [
                                                    14.072,
                                                    -0.909
                                                ],
                                                [
                                                    14.537,
                                                    0.398
                                                ],
                                                [
                                                    14.537,
                                                    2.825
                                                ],
                                                [
                                                    13.861,
                                                    2.825
                                                ],
                                                [
                                                    13.861,
                                                    0.496
                                                ],
                                                [
                                                    13.553,
                                                    -0.443
                                                ],
                                                [
                                                    12.712,
                                                    -0.774
                                                ],
                                                [
                                                    11.848,
                                                    -0.436
                                                ],
                                                [
                                                    11.531,
                                                    0.549
                                                ],
                                                [
                                                    11.531,
                                                    2.825
                                                ],
                                                [
                                                    10.848,
                                                    2.825
                                                ],
                                                [
                                                    10.848,
                                                    -1.292
                                                ],
                                                [
                                                    11.531,
                                                    -1.292
                                                ],
                                                [
                                                    11.531,
                                                    -0.706
                                                ],
                                                [
                                                    12.08,
                                                    -1.195
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.316
                                                ],
                                                [
                                                    -0.297,
                                                    0.175
                                                ],
                                                [
                                                    -0.371,
                                                    0
                                                ],
                                                [
                                                    -0.276,
                                                    -0.151
                                                ],
                                                [
                                                    -0.145,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.264,
                                                    -0.16
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.18
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.321
                                                ],
                                                [
                                                    0.3,
                                                    -0.175
                                                ],
                                                [
                                                    0.319,
                                                    0
                                                ],
                                                [
                                                    0.274,
                                                    0.145
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.134,
                                                    0.246
                                                ],
                                                [
                                                    -0.267,
                                                    0.155
                                                ],
                                                [
                                                    -0.364,
                                                    0
                                                ],
                                                [
                                                    -0.297,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.399,
                                                    0.752
                                                ],
                                                [
                                                    15.654,
                                                    -0.353
                                                ],
                                                [
                                                    16.354,
                                                    -1.097
                                                ],
                                                [
                                                    17.361,
                                                    -1.36
                                                ],
                                                [
                                                    18.255,
                                                    -1.134
                                                ],
                                                [
                                                    18.885,
                                                    -0.556
                                                ],
                                                [
                                                    18.885,
                                                    -2.735
                                                ],
                                                [
                                                    19.576,
                                                    -2.735
                                                ],
                                                [
                                                    19.576,
                                                    2.825
                                                ],
                                                [
                                                    18.885,
                                                    2.825
                                                ],
                                                [
                                                    18.885,
                                                    2.051
                                                ],
                                                [
                                                    18.285,
                                                    2.66
                                                ],
                                                [
                                                    17.352,
                                                    2.893
                                                ],
                                                [
                                                    16.354,
                                                    2.623
                                                ],
                                                [
                                                    15.654,
                                                    1.864
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.311
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.209,
                                                    -0.12
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.212,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.209,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.212,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.315
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.209,
                                                    0.12
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.126
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.885,
                                                    0.759
                                                ],
                                                [
                                                    18.697,
                                                    -0.052
                                                ],
                                                [
                                                    18.186,
                                                    -0.578
                                                ],
                                                [
                                                    17.488,
                                                    -0.766
                                                ],
                                                [
                                                    16.79,
                                                    -0.586
                                                ],
                                                [
                                                    16.285,
                                                    -0.06
                                                ],
                                                [
                                                    16.098,
                                                    0.752
                                                ],
                                                [
                                                    16.285,
                                                    1.578
                                                ],
                                                [
                                                    16.79,
                                                    2.112
                                                ],
                                                [
                                                    17.488,
                                                    2.292
                                                ],
                                                [
                                                    18.186,
                                                    2.112
                                                ],
                                                [
                                                    18.697,
                                                    1.578
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.091,
                                                    0.09
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.09,
                                                    0.091
                                                ],
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.087,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.091,
                                                    -0.09
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.087,
                                                    0.09
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.085,
                                                    -1.961
                                                ],
                                                [
                                                    20.755,
                                                    -2.096
                                                ],
                                                [
                                                    20.619,
                                                    -2.427
                                                ],
                                                [
                                                    20.755,
                                                    -2.758
                                                ],
                                                [
                                                    21.085,
                                                    -2.893
                                                ],
                                                [
                                                    21.402,
                                                    -2.758
                                                ],
                                                [
                                                    21.536,
                                                    -2.427
                                                ],
                                                [
                                                    21.402,
                                                    -2.096
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.417,
                                                    -1.292
                                                ],
                                                [
                                                    21.417,
                                                    2.825
                                                ],
                                                [
                                                    20.732,
                                                    2.825
                                                ],
                                                [
                                                    20.732,
                                                    -1.292
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.086
                                                ],
                                                [
                                                    -0.209,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.19,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.201
                                                ],
                                                [
                                                    0.084,
                                                    0.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.381,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.415,
                                                    -0.729
                                                ],
                                                [
                                                    23.415,
                                                    1.698
                                                ],
                                                [
                                                    23.544,
                                                    2.127
                                                ],
                                                [
                                                    23.986,
                                                    2.247
                                                ],
                                                [
                                                    24.49,
                                                    2.247
                                                ],
                                                [
                                                    24.49,
                                                    2.825
                                                ],
                                                [
                                                    23.874,
                                                    2.825
                                                ],
                                                [
                                                    23.018,
                                                    2.562
                                                ],
                                                [
                                                    22.731,
                                                    1.698
                                                ],
                                                [
                                                    22.731,
                                                    -0.729
                                                ],
                                                [
                                                    22.199,
                                                    -0.729
                                                ],
                                                [
                                                    22.199,
                                                    -1.292
                                                ],
                                                [
                                                    22.731,
                                                    -1.292
                                                ],
                                                [
                                                    22.731,
                                                    -2.329
                                                ],
                                                [
                                                    23.415,
                                                    -2.329
                                                ],
                                                [
                                                    23.415,
                                                    -1.292
                                                ],
                                                [
                                                    24.49,
                                                    -1.292
                                                ],
                                                [
                                                    24.49,
                                                    -0.729
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.091,
                                                    0.09
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.09,
                                                    0.091
                                                ],
                                                [
                                                    -0.129,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.089,
                                                    -0.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.129,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.091,
                                                    -0.09
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.086,
                                                    0.09
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.671,
                                                    -1.961
                                                ],
                                                [
                                                    25.341,
                                                    -2.096
                                                ],
                                                [
                                                    25.205,
                                                    -2.427
                                                ],
                                                [
                                                    25.341,
                                                    -2.758
                                                ],
                                                [
                                                    25.671,
                                                    -2.893
                                                ],
                                                [
                                                    25.988,
                                                    -2.758
                                                ],
                                                [
                                                    26.122,
                                                    -2.427
                                                ],
                                                [
                                                    25.988,
                                                    -2.096
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    26.003,
                                                    -1.292
                                                ],
                                                [
                                                    26.003,
                                                    2.825
                                                ],
                                                [
                                                    25.318,
                                                    2.825
                                                ],
                                                [
                                                    25.318,
                                                    -1.292
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.39,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.179,
                                                    0.321
                                                ],
                                                [
                                                    -0.316,
                                                    0.17
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.315,
                                                    -0.175
                                                ],
                                                [
                                                    -0.179,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.426
                                                ],
                                                [
                                                    0.189,
                                                    -0.325
                                                ],
                                                [
                                                    0.321,
                                                    -0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.387,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.175
                                                ],
                                                [
                                                    -0.176,
                                                    -0.325
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.186,
                                                    -0.326
                                                ],
                                                [
                                                    0.315,
                                                    -0.175
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.17
                                                ],
                                                [
                                                    0.186,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.186,
                                                    0.321
                                                ],
                                                [
                                                    -0.321,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.964,
                                                    2.893
                                                ],
                                                [
                                                    27.911,
                                                    2.63
                                                ],
                                                [
                                                    27.175,
                                                    1.886
                                                ],
                                                [
                                                    26.912,
                                                    0.759
                                                ],
                                                [
                                                    27.182,
                                                    -0.353
                                                ],
                                                [
                                                    27.934,
                                                    -1.097
                                                ],
                                                [
                                                    28.993,
                                                    -1.36
                                                ],
                                                [
                                                    30.053,
                                                    -1.097
                                                ],
                                                [
                                                    30.796,
                                                    -0.361
                                                ],
                                                [
                                                    31.074,
                                                    0.759
                                                ],
                                                [
                                                    30.79,
                                                    1.886
                                                ],
                                                [
                                                    30.031,
                                                    2.63
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.246,
                                                    0
                                                ],
                                                [
                                                    -0.215,
                                                    0.115
                                                ],
                                                [
                                                    -0.129,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.116
                                                ],
                                                [
                                                    0.126,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.121,
                                                    -0.23
                                                ],
                                                [
                                                    -0.206,
                                                    -0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.244,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.115
                                                ],
                                                [
                                                    0.136,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.209,
                                                    -0.116
                                                ],
                                                [
                                                    -0.25,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.231
                                                ],
                                                [
                                                    0.205,
                                                    0.11
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.964,
                                                    2.292
                                                ],
                                                [
                                                    29.654,
                                                    2.119
                                                ],
                                                [
                                                    30.173,
                                                    1.601
                                                ],
                                                [
                                                    30.376,
                                                    0.759
                                                ],
                                                [
                                                    30.18,
                                                    -0.083
                                                ],
                                                [
                                                    29.669,
                                                    -0.593
                                                ],
                                                [
                                                    28.986,
                                                    -0.766
                                                ],
                                                [
                                                    28.294,
                                                    -0.593
                                                ],
                                                [
                                                    27.798,
                                                    -0.083
                                                ],
                                                [
                                                    27.611,
                                                    0.759
                                                ],
                                                [
                                                    27.792,
                                                    1.608
                                                ],
                                                [
                                                    28.287,
                                                    2.127
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.281,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.204,
                                                    0.215
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.231,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.311,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.207,
                                                    -0.221
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.235,
                                                    -0.115
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    33.98,
                                                    -1.367
                                                ],
                                                [
                                                    35.197,
                                                    -0.909
                                                ],
                                                [
                                                    35.663,
                                                    0.398
                                                ],
                                                [
                                                    35.663,
                                                    2.825
                                                ],
                                                [
                                                    34.988,
                                                    2.825
                                                ],
                                                [
                                                    34.988,
                                                    0.496
                                                ],
                                                [
                                                    34.68,
                                                    -0.443
                                                ],
                                                [
                                                    33.837,
                                                    -0.774
                                                ],
                                                [
                                                    32.973,
                                                    -0.436
                                                ],
                                                [
                                                    32.658,
                                                    0.549
                                                ],
                                                [
                                                    32.658,
                                                    2.825
                                                ],
                                                [
                                                    31.973,
                                                    2.825
                                                ],
                                                [
                                                    31.973,
                                                    -1.292
                                                ],
                                                [
                                                    32.658,
                                                    -1.292
                                                ],
                                                [
                                                    32.658,
                                                    -0.706
                                                ],
                                                [
                                                    33.206,
                                                    -1.195
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.295,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.105
                                                ],
                                                [
                                                    0.144,
                                                    0.191
                                                ],
                                                [
                                                    0.015,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.13
                                                ],
                                                [
                                                    -0.281,
                                                    0
                                                ],
                                                [
                                                    -0.149,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.175
                                                ],
                                                [
                                                    0.161,
                                                    0.085
                                                ],
                                                [
                                                    0.336,
                                                    0.085
                                                ],
                                                [
                                                    0.194,
                                                    0.08
                                                ],
                                                [
                                                    0.14,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.265
                                                ],
                                                [
                                                    -0.125,
                                                    0.175
                                                ],
                                                [
                                                    -0.23,
                                                    0.1
                                                ],
                                                [
                                                    -0.295,
                                                    0
                                                ],
                                                [
                                                    -0.282,
                                                    -0.231
                                                ],
                                                [
                                                    -0.019,
                                                    -0.4
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    0.13
                                                ],
                                                [
                                                    0.265,
                                                    0
                                                ],
                                                [
                                                    0.144,
                                                    -0.105
                                                ],
                                                [
                                                    0,
                                                    -0.171
                                                ],
                                                [
                                                    -0.086,
                                                    -0.09
                                                ],
                                                [
                                                    -0.13,
                                                    -0.055
                                                ],
                                                [
                                                    -0.235,
                                                    -0.065
                                                ],
                                                [
                                                    -0.186,
                                                    -0.081
                                                ],
                                                [
                                                    -0.131,
                                                    -0.155
                                                ],
                                                [
                                                    -0.004,
                                                    -0.251
                                                ],
                                                [
                                                    0.126,
                                                    -0.18
                                                ],
                                                [
                                                    0.229,
                                                    -0.105
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.315,
                                                    0
                                                ],
                                                [
                                                    -0.25,
                                                    -0.11
                                                ],
                                                [
                                                    -0.146,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.02,
                                                    0.205
                                                ],
                                                [
                                                    0.177,
                                                    0.13
                                                ],
                                                [
                                                    0.262,
                                                    0
                                                ],
                                                [
                                                    0.15,
                                                    -0.116
                                                ],
                                                [
                                                    0,
                                                    -0.181
                                                ],
                                                [
                                                    -0.16,
                                                    -0.091
                                                ],
                                                [
                                                    -0.304,
                                                    -0.081
                                                ],
                                                [
                                                    -0.192,
                                                    -0.085
                                                ],
                                                [
                                                    -0.135,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    -0.211
                                                ],
                                                [
                                                    0.125,
                                                    -0.175
                                                ],
                                                [
                                                    0.231,
                                                    -0.105
                                                ],
                                                [
                                                    0.457,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.015,
                                                    -0.215
                                                ],
                                                [
                                                    -0.155,
                                                    -0.13
                                                ],
                                                [
                                                    -0.246,
                                                    0
                                                ],
                                                [
                                                    -0.147,
                                                    0.106
                                                ],
                                                [
                                                    0,
                                                    0.135
                                                ],
                                                [
                                                    0.091,
                                                    0.085
                                                ],
                                                [
                                                    0.136,
                                                    0.05
                                                ],
                                                [
                                                    0.297,
                                                    0.08
                                                ],
                                                [
                                                    0.185,
                                                    0.075
                                                ],
                                                [
                                                    0.134,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0.225
                                                ],
                                                [
                                                    -0.125,
                                                    0.181
                                                ],
                                                [
                                                    -0.226,
                                                    0.1
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    38.238,
                                                    2.893
                                                ],
                                                [
                                                    37.389,
                                                    2.735
                                                ],
                                                [
                                                    36.796,
                                                    2.284
                                                ],
                                                [
                                                    36.555,
                                                    1.616
                                                ],
                                                [
                                                    37.261,
                                                    1.616
                                                ],
                                                [
                                                    37.546,
                                                    2.119
                                                ],
                                                [
                                                    38.23,
                                                    2.314
                                                ],
                                                [
                                                    38.846,
                                                    2.142
                                                ],
                                                [
                                                    39.072,
                                                    1.706
                                                ],
                                                [
                                                    38.831,
                                                    1.308
                                                ],
                                                [
                                                    38.087,
                                                    1.045
                                                ],
                                                [
                                                    37.337,
                                                    0.804
                                                ],
                                                [
                                                    36.84,
                                                    0.436
                                                ],
                                                [
                                                    36.637,
                                                    -0.21
                                                ],
                                                [
                                                    36.826,
                                                    -0.789
                                                ],
                                                [
                                                    37.358,
                                                    -1.202
                                                ],
                                                [
                                                    38.147,
                                                    -1.36
                                                ],
                                                [
                                                    39.253,
                                                    -1.014
                                                ],
                                                [
                                                    39.703,
                                                    -0.068
                                                ],
                                                [
                                                    39.02,
                                                    -0.068
                                                ],
                                                [
                                                    38.757,
                                                    -0.586
                                                ],
                                                [
                                                    38.126,
                                                    -0.781
                                                ],
                                                [
                                                    37.54,
                                                    -0.624
                                                ],
                                                [
                                                    37.322,
                                                    -0.21
                                                ],
                                                [
                                                    37.449,
                                                    0.128
                                                ],
                                                [
                                                    37.779,
                                                    0.338
                                                ],
                                                [
                                                    38.335,
                                                    0.511
                                                ],
                                                [
                                                    39.057,
                                                    0.752
                                                ],
                                                [
                                                    39.531,
                                                    1.097
                                                ],
                                                [
                                                    39.74,
                                                    1.706
                                                ],
                                                [
                                                    39.552,
                                                    2.314
                                                ],
                                                [
                                                    39.02,
                                                    2.743
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.2392,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            161.975,
                                            247.117
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.276,
                                                    -0.09
                                                ],
                                                [
                                                    -0.155,
                                                    -0.125
                                                ],
                                                [
                                                    -0.091,
                                                    -0.186
                                                ],
                                                [
                                                    0,
                                                    -0.21
                                                ],
                                                [
                                                    0.136,
                                                    -0.216
                                                ],
                                                [
                                                    0.26,
                                                    -0.125
                                                ],
                                                [
                                                    0.35,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.251,
                                                    -0.12
                                                ],
                                                [
                                                    -0.125,
                                                    -0.2
                                                ],
                                                [
                                                    0,
                                                    -0.251
                                                ],
                                                [
                                                    0.17,
                                                    -0.205
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.191,
                                                    0.03
                                                ],
                                                [
                                                    0.16,
                                                    0.125
                                                ],
                                                [
                                                    0.095,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0.266
                                                ],
                                                [
                                                    -0.135,
                                                    0.21
                                                ],
                                                [
                                                    -0.256,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.117
                                                ],
                                                [
                                                    0.125,
                                                    0.201
                                                ],
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    -0.166,
                                                    0.199
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -103.477,
                                                    -0.853
                                                ],
                                                [
                                                    -102.958,
                                                    -0.62
                                                ],
                                                [
                                                    -102.582,
                                                    -0.154
                                                ],
                                                [
                                                    -102.44,
                                                    0.439
                                                ],
                                                [
                                                    -102.643,
                                                    1.161
                                                ],
                                                [
                                                    -103.236,
                                                    1.664
                                                ],
                                                [
                                                    -104.145,
                                                    1.844
                                                ],
                                                [
                                                    -106.099,
                                                    1.844
                                                ],
                                                [
                                                    -106.099,
                                                    -3.393
                                                ],
                                                [
                                                    -104.221,
                                                    -3.393
                                                ],
                                                [
                                                    -103.311,
                                                    -3.213
                                                ],
                                                [
                                                    -102.748,
                                                    -2.739
                                                ],
                                                [
                                                    -102.56,
                                                    -2.062
                                                ],
                                                [
                                                    -102.815,
                                                    -1.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.175,
                                                    0.151
                                                ],
                                                [
                                                    0,
                                                    0.265
                                                ],
                                                [
                                                    0.176,
                                                    0.15
                                                ],
                                                [
                                                    0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.321,
                                                    0
                                                ],
                                                [
                                                    0.176,
                                                    -0.15
                                                ],
                                                [
                                                    0,
                                                    -0.265
                                                ],
                                                [
                                                    -0.175,
                                                    -0.15
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -105.415,
                                                    -1.131
                                                ],
                                                [
                                                    -104.266,
                                                    -1.131
                                                ],
                                                [
                                                    -103.522,
                                                    -1.357
                                                ],
                                                [
                                                    -103.259,
                                                    -1.98
                                                ],
                                                [
                                                    -103.522,
                                                    -2.604
                                                ],
                                                [
                                                    -104.281,
                                                    -2.829
                                                ],
                                                [
                                                    -105.415,
                                                    -2.829
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.19,
                                                    0.161
                                                ],
                                                [
                                                    0,
                                                    0.286
                                                ],
                                                [
                                                    0.2,
                                                    0.166
                                                ],
                                                [
                                                    0.336,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.341,
                                                    0
                                                ],
                                                [
                                                    0.19,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    -0.2,
                                                    -0.17
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -104.206,
                                                    1.281
                                                ],
                                                [
                                                    -103.409,
                                                    1.04
                                                ],
                                                [
                                                    -103.124,
                                                    0.372
                                                ],
                                                [
                                                    -103.424,
                                                    -0.312
                                                ],
                                                [
                                                    -104.228,
                                                    -0.568
                                                ],
                                                [
                                                    -105.415,
                                                    -0.568
                                                ],
                                                [
                                                    -105.415,
                                                    1.281
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -97.944,
                                                    -2.273
                                                ],
                                                [
                                                    -100.424,
                                                    3.783
                                                ],
                                                [
                                                    -101.13,
                                                    3.783
                                                ],
                                                [
                                                    -100.319,
                                                    1.799
                                                ],
                                                [
                                                    -101.979,
                                                    -2.273
                                                ],
                                                [
                                                    -101.22,
                                                    -2.273
                                                ],
                                                [
                                                    -99.928,
                                                    1.063
                                                ],
                                                [
                                                    -98.651,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.296,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.104
                                                ],
                                                [
                                                    0.146,
                                                    0.191
                                                ],
                                                [
                                                    0.015,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.13
                                                ],
                                                [
                                                    -0.281,
                                                    0
                                                ],
                                                [
                                                    -0.151,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.175
                                                ],
                                                [
                                                    0.16,
                                                    0.085
                                                ],
                                                [
                                                    0.335,
                                                    0.085
                                                ],
                                                [
                                                    0.196,
                                                    0.08
                                                ],
                                                [
                                                    0.141,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.265
                                                ],
                                                [
                                                    -0.125,
                                                    0.176
                                                ],
                                                [
                                                    -0.231,
                                                    0.1
                                                ],
                                                [
                                                    -0.296,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.231
                                                ],
                                                [
                                                    -0.02,
                                                    -0.4
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    0.129
                                                ],
                                                [
                                                    0.266,
                                                    0
                                                ],
                                                [
                                                    0.146,
                                                    -0.105
                                                ],
                                                [
                                                    0,
                                                    -0.171
                                                ],
                                                [
                                                    -0.085,
                                                    -0.09
                                                ],
                                                [
                                                    -0.131,
                                                    -0.055
                                                ],
                                                [
                                                    -0.236,
                                                    -0.066
                                                ],
                                                [
                                                    -0.185,
                                                    -0.081
                                                ],
                                                [
                                                    -0.13,
                                                    -0.155
                                                ],
                                                [
                                                    -0.005,
                                                    -0.25
                                                ],
                                                [
                                                    0.125,
                                                    -0.179
                                                ],
                                                [
                                                    0.23,
                                                    -0.104
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.316,
                                                    0
                                                ],
                                                [
                                                    -0.25,
                                                    -0.11
                                                ],
                                                [
                                                    -0.145,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.02,
                                                    0.205
                                                ],
                                                [
                                                    0.175,
                                                    0.13
                                                ],
                                                [
                                                    0.26,
                                                    0
                                                ],
                                                [
                                                    0.15,
                                                    -0.115
                                                ],
                                                [
                                                    0,
                                                    -0.181
                                                ],
                                                [
                                                    -0.161,
                                                    -0.091
                                                ],
                                                [
                                                    -0.306,
                                                    -0.081
                                                ],
                                                [
                                                    -0.19,
                                                    -0.086
                                                ],
                                                [
                                                    -0.135,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    -0.211
                                                ],
                                                [
                                                    0.126,
                                                    -0.175
                                                ],
                                                [
                                                    0.23,
                                                    -0.105
                                                ],
                                                [
                                                    0.456,
                                                    0
                                                ],
                                                [
                                                    0.281,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    -0.215
                                                ],
                                                [
                                                    -0.156,
                                                    -0.131
                                                ],
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.106
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    0.09,
                                                    0.085
                                                ],
                                                [
                                                    0.135,
                                                    0.051
                                                ],
                                                [
                                                    0.295,
                                                    0.079
                                                ],
                                                [
                                                    0.185,
                                                    0.075
                                                ],
                                                [
                                                    0.136,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0.226
                                                ],
                                                [
                                                    -0.125,
                                                    0.181
                                                ],
                                                [
                                                    -0.226,
                                                    0.101
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -93.796,
                                                    1.912
                                                ],
                                                [
                                                    -94.645,
                                                    1.755
                                                ],
                                                [
                                                    -95.239,
                                                    1.303
                                                ],
                                                [
                                                    -95.479,
                                                    0.635
                                                ],
                                                [
                                                    -94.773,
                                                    0.635
                                                ],
                                                [
                                                    -94.487,
                                                    1.138
                                                ],
                                                [
                                                    -93.803,
                                                    1.333
                                                ],
                                                [
                                                    -93.187,
                                                    1.161
                                                ],
                                                [
                                                    -92.962,
                                                    0.725
                                                ],
                                                [
                                                    -93.202,
                                                    0.327
                                                ],
                                                [
                                                    -93.946,
                                                    0.064
                                                ],
                                                [
                                                    -94.698,
                                                    -0.176
                                                ],
                                                [
                                                    -95.194,
                                                    -0.545
                                                ],
                                                [
                                                    -95.396,
                                                    -1.191
                                                ],
                                                [
                                                    -95.209,
                                                    -1.77
                                                ],
                                                [
                                                    -94.675,
                                                    -2.183
                                                ],
                                                [
                                                    -93.886,
                                                    -2.34
                                                ],
                                                [
                                                    -92.782,
                                                    -1.995
                                                ],
                                                [
                                                    -92.331,
                                                    -1.049
                                                ],
                                                [
                                                    -93.014,
                                                    -1.049
                                                ],
                                                [
                                                    -93.277,
                                                    -1.566
                                                ],
                                                [
                                                    -93.909,
                                                    -1.762
                                                ],
                                                [
                                                    -94.495,
                                                    -1.605
                                                ],
                                                [
                                                    -94.713,
                                                    -1.191
                                                ],
                                                [
                                                    -94.585,
                                                    -0.853
                                                ],
                                                [
                                                    -94.254,
                                                    -0.643
                                                ],
                                                [
                                                    -93.698,
                                                    -0.469
                                                ],
                                                [
                                                    -92.977,
                                                    -0.229
                                                ],
                                                [
                                                    -92.504,
                                                    0.117
                                                ],
                                                [
                                                    -92.293,
                                                    0.725
                                                ],
                                                [
                                                    -92.481,
                                                    1.333
                                                ],
                                                [
                                                    -93.014,
                                                    1.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.126,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.09
                                                ],
                                                [
                                                    0,
                                                    0.131
                                                ],
                                                [
                                                    -0.091,
                                                    0.091
                                                ],
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.091,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0.126,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.131
                                                ],
                                                [
                                                    -0.085,
                                                    0.09
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -90.975,
                                                    -2.941
                                                ],
                                                [
                                                    -91.305,
                                                    -3.077
                                                ],
                                                [
                                                    -91.441,
                                                    -3.408
                                                ],
                                                [
                                                    -91.305,
                                                    -3.739
                                                ],
                                                [
                                                    -90.975,
                                                    -3.874
                                                ],
                                                [
                                                    -90.659,
                                                    -3.739
                                                ],
                                                [
                                                    -90.524,
                                                    -3.408
                                                ],
                                                [
                                                    -90.659,
                                                    -3.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -90.644,
                                                    -2.273
                                                ],
                                                [
                                                    -90.644,
                                                    1.844
                                                ],
                                                [
                                                    -91.328,
                                                    1.844
                                                ],
                                                [
                                                    -91.328,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.291
                                                ],
                                                [
                                                    0.301,
                                                    -0.166
                                                ],
                                                [
                                                    0.396,
                                                    0
                                                ],
                                                [
                                                    0.361,
                                                    0.255
                                                ],
                                                [
                                                    0.065,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    -0.152
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    0.236
                                                ],
                                                [
                                                    0,
                                                    0.424
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    -0.162
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    0.179
                                                ],
                                                [
                                                    0.171,
                                                    0.325
                                                ],
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.295,
                                                    0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.375
                                                ],
                                                [
                                                    -0.16,
                                                    0.295
                                                ],
                                                [
                                                    -0.296,
                                                    0.166
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    -0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.25
                                                ],
                                                [
                                                    0.235,
                                                    0.154
                                                ],
                                                [
                                                    0.376,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.241
                                                ],
                                                [
                                                    -0.265,
                                                    0.159
                                                ],
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.295,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.171,
                                                    -0.322
                                                ],
                                                [
                                                    0.301,
                                                    -0.176
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -87.781,
                                                    -2.34
                                                ],
                                                [
                                                    -86.849,
                                                    -2.107
                                                ],
                                                [
                                                    -86.248,
                                                    -1.521
                                                ],
                                                [
                                                    -86.248,
                                                    -2.273
                                                ],
                                                [
                                                    -85.556,
                                                    -2.273
                                                ],
                                                [
                                                    -85.556,
                                                    1.936
                                                ],
                                                [
                                                    -85.797,
                                                    2.934
                                                ],
                                                [
                                                    -86.488,
                                                    3.626
                                                ],
                                                [
                                                    -87.525,
                                                    3.873
                                                ],
                                                [
                                                    -88.878,
                                                    3.49
                                                ],
                                                [
                                                    -89.516,
                                                    2.447
                                                ],
                                                [
                                                    -88.84,
                                                    2.447
                                                ],
                                                [
                                                    -88.374,
                                                    3.048
                                                ],
                                                [
                                                    -87.525,
                                                    3.281
                                                ],
                                                [
                                                    -86.608,
                                                    2.926
                                                ],
                                                [
                                                    -86.248,
                                                    1.936
                                                ],
                                                [
                                                    -86.248,
                                                    1.07
                                                ],
                                                [
                                                    -86.849,
                                                    1.673
                                                ],
                                                [
                                                    -87.781,
                                                    1.912
                                                ],
                                                [
                                                    -88.78,
                                                    1.643
                                                ],
                                                [
                                                    -89.479,
                                                    0.883
                                                ],
                                                [
                                                    -89.734,
                                                    -0.229
                                                ],
                                                [
                                                    -89.479,
                                                    -1.333
                                                ],
                                                [
                                                    -88.78,
                                                    -2.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.126,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.121
                                                ],
                                                [
                                                    0.126,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.127
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.126,
                                                    0.229
                                                ],
                                                [
                                                    0.21,
                                                    0.119
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.127
                                                ],
                                                [
                                                    0.126,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -86.248,
                                                    -0.221
                                                ],
                                                [
                                                    -86.436,
                                                    -1.033
                                                ],
                                                [
                                                    -86.947,
                                                    -1.559
                                                ],
                                                [
                                                    -87.645,
                                                    -1.747
                                                ],
                                                [
                                                    -88.344,
                                                    -1.566
                                                ],
                                                [
                                                    -88.848,
                                                    -1.04
                                                ],
                                                [
                                                    -89.035,
                                                    -0.229
                                                ],
                                                [
                                                    -88.848,
                                                    0.598
                                                ],
                                                [
                                                    -88.344,
                                                    1.132
                                                ],
                                                [
                                                    -87.645,
                                                    1.311
                                                ],
                                                [
                                                    -86.947,
                                                    1.132
                                                ],
                                                [
                                                    -86.436,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.206,
                                                    0.216
                                                ],
                                                [
                                                    0.355,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.412
                                                ],
                                                [
                                                    -0.205,
                                                    -0.221
                                                ],
                                                [
                                                    -0.361,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.135,
                                                    -0.211
                                                ],
                                                [
                                                    0.236,
                                                    -0.114
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -82.395,
                                                    -2.348
                                                ],
                                                [
                                                    -81.177,
                                                    -1.89
                                                ],
                                                [
                                                    -80.712,
                                                    -0.583
                                                ],
                                                [
                                                    -80.712,
                                                    1.844
                                                ],
                                                [
                                                    -81.388,
                                                    1.844
                                                ],
                                                [
                                                    -81.388,
                                                    -0.484
                                                ],
                                                [
                                                    -81.696,
                                                    -1.424
                                                ],
                                                [
                                                    -82.537,
                                                    -1.755
                                                ],
                                                [
                                                    -83.402,
                                                    -1.417
                                                ],
                                                [
                                                    -83.717,
                                                    -0.432
                                                ],
                                                [
                                                    -83.717,
                                                    1.844
                                                ],
                                                [
                                                    -84.401,
                                                    1.844
                                                ],
                                                [
                                                    -84.401,
                                                    -2.273
                                                ],
                                                [
                                                    -83.717,
                                                    -2.273
                                                ],
                                                [
                                                    -83.717,
                                                    -1.687
                                                ],
                                                [
                                                    -83.169,
                                                    -2.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.09
                                                ],
                                                [
                                                    0,
                                                    0.131
                                                ],
                                                [
                                                    -0.09,
                                                    0.091
                                                ],
                                                [
                                                    -0.131,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.131,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.131
                                                ],
                                                [
                                                    -0.085,
                                                    0.09
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -79.241,
                                                    -2.941
                                                ],
                                                [
                                                    -79.572,
                                                    -3.077
                                                ],
                                                [
                                                    -79.707,
                                                    -3.408
                                                ],
                                                [
                                                    -79.572,
                                                    -3.739
                                                ],
                                                [
                                                    -79.241,
                                                    -3.874
                                                ],
                                                [
                                                    -78.926,
                                                    -3.739
                                                ],
                                                [
                                                    -78.791,
                                                    -3.408
                                                ],
                                                [
                                                    -78.926,
                                                    -3.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -78.911,
                                                    -2.273
                                                ],
                                                [
                                                    -78.911,
                                                    1.844
                                                ],
                                                [
                                                    -79.595,
                                                    1.844
                                                ],
                                                [
                                                    -79.595,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.281,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.216
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.311,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.412
                                                ],
                                                [
                                                    -0.206,
                                                    -0.221
                                                ],
                                                [
                                                    -0.361,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.235,
                                                    -0.114
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -75.739,
                                                    -2.348
                                                ],
                                                [
                                                    -74.522,
                                                    -1.89
                                                ],
                                                [
                                                    -74.056,
                                                    -0.583
                                                ],
                                                [
                                                    -74.056,
                                                    1.844
                                                ],
                                                [
                                                    -74.732,
                                                    1.844
                                                ],
                                                [
                                                    -74.732,
                                                    -0.484
                                                ],
                                                [
                                                    -75.04,
                                                    -1.424
                                                ],
                                                [
                                                    -75.882,
                                                    -1.755
                                                ],
                                                [
                                                    -76.746,
                                                    -1.417
                                                ],
                                                [
                                                    -77.062,
                                                    -0.432
                                                ],
                                                [
                                                    -77.062,
                                                    1.844
                                                ],
                                                [
                                                    -77.745,
                                                    1.844
                                                ],
                                                [
                                                    -77.745,
                                                    -2.273
                                                ],
                                                [
                                                    -77.062,
                                                    -2.273
                                                ],
                                                [
                                                    -77.062,
                                                    -1.687
                                                ],
                                                [
                                                    -76.513,
                                                    -2.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.291
                                                ],
                                                [
                                                    0.301,
                                                    -0.166
                                                ],
                                                [
                                                    0.395,
                                                    0
                                                ],
                                                [
                                                    0.361,
                                                    0.255
                                                ],
                                                [
                                                    0.066,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.152
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.236
                                                ],
                                                [
                                                    0,
                                                    0.424
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    -0.162
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.179
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ],
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.296,
                                                    0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.27,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.375
                                                ],
                                                [
                                                    -0.161,
                                                    0.295
                                                ],
                                                [
                                                    -0.295,
                                                    0.166
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.361,
                                                    -0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.25
                                                ],
                                                [
                                                    0.236,
                                                    0.154
                                                ],
                                                [
                                                    0.375,
                                                    0
                                                ],
                                                [
                                                    0.241,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.241
                                                ],
                                                [
                                                    -0.266,
                                                    0.159
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.296,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.322
                                                ],
                                                [
                                                    0.3,
                                                    -0.176
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -71.241,
                                                    -2.34
                                                ],
                                                [
                                                    -70.309,
                                                    -2.107
                                                ],
                                                [
                                                    -69.708,
                                                    -1.521
                                                ],
                                                [
                                                    -69.708,
                                                    -2.273
                                                ],
                                                [
                                                    -69.017,
                                                    -2.273
                                                ],
                                                [
                                                    -69.017,
                                                    1.936
                                                ],
                                                [
                                                    -69.257,
                                                    2.934
                                                ],
                                                [
                                                    -69.949,
                                                    3.626
                                                ],
                                                [
                                                    -70.985,
                                                    3.873
                                                ],
                                                [
                                                    -72.338,
                                                    3.49
                                                ],
                                                [
                                                    -72.977,
                                                    2.447
                                                ],
                                                [
                                                    -72.3,
                                                    2.447
                                                ],
                                                [
                                                    -71.835,
                                                    3.048
                                                ],
                                                [
                                                    -70.985,
                                                    3.281
                                                ],
                                                [
                                                    -70.069,
                                                    2.926
                                                ],
                                                [
                                                    -69.708,
                                                    1.936
                                                ],
                                                [
                                                    -69.708,
                                                    1.07
                                                ],
                                                [
                                                    -70.309,
                                                    1.673
                                                ],
                                                [
                                                    -71.241,
                                                    1.912
                                                ],
                                                [
                                                    -72.24,
                                                    1.643
                                                ],
                                                [
                                                    -72.939,
                                                    0.883
                                                ],
                                                [
                                                    -73.195,
                                                    -0.229
                                                ],
                                                [
                                                    -72.939,
                                                    -1.333
                                                ],
                                                [
                                                    -72.24,
                                                    -2.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.215,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.121
                                                ],
                                                [
                                                    0.125,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.21,
                                                    -0.127
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.125,
                                                    0.229
                                                ],
                                                [
                                                    0.211,
                                                    0.119
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.127
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -69.708,
                                                    -0.221
                                                ],
                                                [
                                                    -69.896,
                                                    -1.033
                                                ],
                                                [
                                                    -70.407,
                                                    -1.559
                                                ],
                                                [
                                                    -71.106,
                                                    -1.747
                                                ],
                                                [
                                                    -71.805,
                                                    -1.566
                                                ],
                                                [
                                                    -72.308,
                                                    -1.04
                                                ],
                                                [
                                                    -72.496,
                                                    -0.229
                                                ],
                                                [
                                                    -72.308,
                                                    0.598
                                                ],
                                                [
                                                    -71.805,
                                                    1.132
                                                ],
                                                [
                                                    -71.106,
                                                    1.311
                                                ],
                                                [
                                                    -70.407,
                                                    1.132
                                                ],
                                                [
                                                    -69.896,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.236,
                                                    -0.121
                                                ],
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    0.255,
                                                    0.129
                                                ],
                                                [
                                                    0.151,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.381
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.206,
                                                    -0.22
                                                ],
                                                [
                                                    -0.355,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.13,
                                                    0.211
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ],
                                                [
                                                    -0.321,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    -0.136
                                                ],
                                                [
                                                    -0.145,
                                                    -0.265
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.405
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.366,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -62.206,
                                                    -2.273
                                                ],
                                                [
                                                    -62.206,
                                                    1.844
                                                ],
                                                [
                                                    -62.89,
                                                    1.844
                                                ],
                                                [
                                                    -62.89,
                                                    1.236
                                                ],
                                                [
                                                    -63.439,
                                                    1.732
                                                ],
                                                [
                                                    -64.205,
                                                    1.904
                                                ],
                                                [
                                                    -65.069,
                                                    1.71
                                                ],
                                                [
                                                    -65.678,
                                                    1.108
                                                ],
                                                [
                                                    -65.896,
                                                    0.139
                                                ],
                                                [
                                                    -65.896,
                                                    -2.273
                                                ],
                                                [
                                                    -65.219,
                                                    -2.273
                                                ],
                                                [
                                                    -65.219,
                                                    0.049
                                                ],
                                                [
                                                    -64.911,
                                                    0.988
                                                ],
                                                [
                                                    -64.07,
                                                    1.311
                                                ],
                                                [
                                                    -63.206,
                                                    0.973
                                                ],
                                                [
                                                    -62.89,
                                                    -0.012
                                                ],
                                                [
                                                    -62.89,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    0.155
                                                ],
                                                [
                                                    -0.355,
                                                    0
                                                ],
                                                [
                                                    -0.295,
                                                    -0.176
                                                ],
                                                [
                                                    -0.171,
                                                    -0.322
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.326
                                                ],
                                                [
                                                    0.301,
                                                    -0.181
                                                ],
                                                [
                                                    0.366,
                                                    0
                                                ],
                                                [
                                                    0.27,
                                                    0.156
                                                ],
                                                [
                                                    0.14,
                                                    0.237
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.135,
                                                    -0.235
                                                ],
                                                [
                                                    0.271,
                                                    -0.16
                                                ],
                                                [
                                                    0.366,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    0.175
                                                ],
                                                [
                                                    0.17,
                                                    0.315
                                                ],
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.171,
                                                    0.325
                                                ],
                                                [
                                                    -0.295,
                                                    0.179
                                                ],
                                                [
                                                    -0.35,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.159
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -60.368,
                                                    -1.514
                                                ],
                                                [
                                                    -59.767,
                                                    -2.1
                                                ],
                                                [
                                                    -58.828,
                                                    -2.34
                                                ],
                                                [
                                                    -57.836,
                                                    -2.077
                                                ],
                                                [
                                                    -57.129,
                                                    -1.333
                                                ],
                                                [
                                                    -56.874,
                                                    -0.229
                                                ],
                                                [
                                                    -57.129,
                                                    0.883
                                                ],
                                                [
                                                    -57.836,
                                                    1.643
                                                ],
                                                [
                                                    -58.828,
                                                    1.912
                                                ],
                                                [
                                                    -59.759,
                                                    1.679
                                                ],
                                                [
                                                    -60.368,
                                                    1.085
                                                ],
                                                [
                                                    -60.368,
                                                    3.798
                                                ],
                                                [
                                                    -61.052,
                                                    3.798
                                                ],
                                                [
                                                    -61.052,
                                                    -2.273
                                                ],
                                                [
                                                    -60.368,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.126,
                                                    0.229
                                                ],
                                                [
                                                    0.216,
                                                    0.119
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.126
                                                ],
                                                [
                                                    0.13,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.306
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.127
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.121
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.13,
                                                    0.229
                                                ],
                                                [
                                                    0.215,
                                                    0.119
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.127
                                                ],
                                                [
                                                    0.126,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -57.573,
                                                    -0.229
                                                ],
                                                [
                                                    -57.761,
                                                    -1.04
                                                ],
                                                [
                                                    -58.272,
                                                    -1.566
                                                ],
                                                [
                                                    -58.97,
                                                    -1.747
                                                ],
                                                [
                                                    -59.669,
                                                    -1.559
                                                ],
                                                [
                                                    -60.18,
                                                    -1.025
                                                ],
                                                [
                                                    -60.368,
                                                    -0.221
                                                ],
                                                [
                                                    -60.18,
                                                    0.598
                                                ],
                                                [
                                                    -59.669,
                                                    1.132
                                                ],
                                                [
                                                    -58.97,
                                                    1.311
                                                ],
                                                [
                                                    -58.272,
                                                    1.132
                                                ],
                                                [
                                                    -57.761,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -50.424,
                                                    -2.273
                                                ],
                                                [
                                                    -52.904,
                                                    3.783
                                                ],
                                                [
                                                    -53.61,
                                                    3.783
                                                ],
                                                [
                                                    -52.799,
                                                    1.799
                                                ],
                                                [
                                                    -54.459,
                                                    -2.273
                                                ],
                                                [
                                                    -53.7,
                                                    -2.273
                                                ],
                                                [
                                                    -52.408,
                                                    1.063
                                                ],
                                                [
                                                    -51.13,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.18,
                                                    0.321
                                                ],
                                                [
                                                    -0.316,
                                                    0.169
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    -0.176
                                                ],
                                                [
                                                    -0.181,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.19,
                                                    -0.326
                                                ],
                                                [
                                                    0.321,
                                                    -0.174
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.174
                                                ],
                                                [
                                                    -0.176,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.422
                                                ],
                                                [
                                                    0.186,
                                                    -0.327
                                                ],
                                                [
                                                    0.315,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.169
                                                ],
                                                [
                                                    0.185,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.185,
                                                    0.321
                                                ],
                                                [
                                                    -0.32,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -47.941,
                                                    1.912
                                                ],
                                                [
                                                    -48.993,
                                                    1.649
                                                ],
                                                [
                                                    -49.729,
                                                    0.906
                                                ],
                                                [
                                                    -49.992,
                                                    -0.221
                                                ],
                                                [
                                                    -49.722,
                                                    -1.333
                                                ],
                                                [
                                                    -48.97,
                                                    -2.077
                                                ],
                                                [
                                                    -47.911,
                                                    -2.34
                                                ],
                                                [
                                                    -46.851,
                                                    -2.077
                                                ],
                                                [
                                                    -46.107,
                                                    -1.342
                                                ],
                                                [
                                                    -45.829,
                                                    -0.221
                                                ],
                                                [
                                                    -46.115,
                                                    0.906
                                                ],
                                                [
                                                    -46.874,
                                                    1.649
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.215,
                                                    0.115
                                                ],
                                                [
                                                    -0.13,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.33
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.115
                                                ],
                                                [
                                                    0.126,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.12,
                                                    -0.231
                                                ],
                                                [
                                                    -0.206,
                                                    -0.115
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.115
                                                ],
                                                [
                                                    0.135,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.21,
                                                    -0.115
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.205,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -47.941,
                                                    1.311
                                                ],
                                                [
                                                    -47.25,
                                                    1.138
                                                ],
                                                [
                                                    -46.731,
                                                    0.62
                                                ],
                                                [
                                                    -46.528,
                                                    -0.221
                                                ],
                                                [
                                                    -46.724,
                                                    -1.064
                                                ],
                                                [
                                                    -47.235,
                                                    -1.574
                                                ],
                                                [
                                                    -47.918,
                                                    -1.747
                                                ],
                                                [
                                                    -48.61,
                                                    -1.574
                                                ],
                                                [
                                                    -49.106,
                                                    -1.064
                                                ],
                                                [
                                                    -49.293,
                                                    -0.221
                                                ],
                                                [
                                                    -49.113,
                                                    0.628
                                                ],
                                                [
                                                    -48.617,
                                                    1.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.236,
                                                    -0.121
                                                ],
                                                [
                                                    0.28,
                                                    0
                                                ],
                                                [
                                                    0.255,
                                                    0.129
                                                ],
                                                [
                                                    0.15,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.381
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    -0.22
                                                ],
                                                [
                                                    -0.356,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.131,
                                                    0.211
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ],
                                                [
                                                    -0.321,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    -0.136
                                                ],
                                                [
                                                    -0.145,
                                                    -0.265
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.405
                                                ],
                                                [
                                                    0.206,
                                                    0.215
                                                ],
                                                [
                                                    0.366,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -41.279,
                                                    -2.273
                                                ],
                                                [
                                                    -41.279,
                                                    1.844
                                                ],
                                                [
                                                    -41.962,
                                                    1.844
                                                ],
                                                [
                                                    -41.962,
                                                    1.236
                                                ],
                                                [
                                                    -42.511,
                                                    1.732
                                                ],
                                                [
                                                    -43.277,
                                                    1.904
                                                ],
                                                [
                                                    -44.141,
                                                    1.71
                                                ],
                                                [
                                                    -44.75,
                                                    1.108
                                                ],
                                                [
                                                    -44.968,
                                                    0.139
                                                ],
                                                [
                                                    -44.968,
                                                    -2.273
                                                ],
                                                [
                                                    -44.292,
                                                    -2.273
                                                ],
                                                [
                                                    -44.292,
                                                    0.049
                                                ],
                                                [
                                                    -43.984,
                                                    0.988
                                                ],
                                                [
                                                    -43.142,
                                                    1.311
                                                ],
                                                [
                                                    -42.278,
                                                    0.973
                                                ],
                                                [
                                                    -41.962,
                                                    -0.012
                                                ],
                                                [
                                                    -41.962,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.296,
                                                    0.175
                                                ],
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.27,
                                                    -0.159
                                                ],
                                                [
                                                    0.355,
                                                    0
                                                ],
                                                [
                                                    0.296,
                                                    0.179
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.322
                                                ],
                                                [
                                                    0.301,
                                                    -0.176
                                                ],
                                                [
                                                    0.361,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.24
                                                ],
                                                [
                                                    -0.266,
                                                    0.156
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.296,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.376,
                                                    -0.229
                                                ],
                                                [
                                                    -38.121,
                                                    -1.333
                                                ],
                                                [
                                                    -37.422,
                                                    -2.077
                                                ],
                                                [
                                                    -36.423,
                                                    -2.34
                                                ],
                                                [
                                                    -35.483,
                                                    -2.107
                                                ],
                                                [
                                                    -34.89,
                                                    -1.521
                                                ],
                                                [
                                                    -34.89,
                                                    -2.273
                                                ],
                                                [
                                                    -34.199,
                                                    -2.273
                                                ],
                                                [
                                                    -34.199,
                                                    1.844
                                                ],
                                                [
                                                    -34.89,
                                                    1.844
                                                ],
                                                [
                                                    -34.89,
                                                    1.078
                                                ],
                                                [
                                                    -35.498,
                                                    1.679
                                                ],
                                                [
                                                    -36.43,
                                                    1.912
                                                ],
                                                [
                                                    -37.422,
                                                    1.643
                                                ],
                                                [
                                                    -38.121,
                                                    0.883
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.126,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.121
                                                ],
                                                [
                                                    0.126,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.127
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.126,
                                                    0.229
                                                ],
                                                [
                                                    0.21,
                                                    0.119
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.127
                                                ],
                                                [
                                                    0.126,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -34.89,
                                                    -0.221
                                                ],
                                                [
                                                    -35.078,
                                                    -1.033
                                                ],
                                                [
                                                    -35.589,
                                                    -1.559
                                                ],
                                                [
                                                    -36.287,
                                                    -1.747
                                                ],
                                                [
                                                    -36.986,
                                                    -1.566
                                                ],
                                                [
                                                    -37.49,
                                                    -1.04
                                                ],
                                                [
                                                    -37.678,
                                                    -0.229
                                                ],
                                                [
                                                    -37.49,
                                                    0.598
                                                ],
                                                [
                                                    -36.986,
                                                    1.132
                                                ],
                                                [
                                                    -36.287,
                                                    1.311
                                                ],
                                                [
                                                    -35.589,
                                                    1.132
                                                ],
                                                [
                                                    -35.078,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.291
                                                ],
                                                [
                                                    0.3,
                                                    -0.166
                                                ],
                                                [
                                                    0.395,
                                                    0
                                                ],
                                                [
                                                    0.361,
                                                    0.255
                                                ],
                                                [
                                                    0.066,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    -0.152
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.236
                                                ],
                                                [
                                                    0,
                                                    0.424
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    -0.162
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.179
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ],
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.296,
                                                    0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.27,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.375
                                                ],
                                                [
                                                    -0.16,
                                                    0.295
                                                ],
                                                [
                                                    -0.296,
                                                    0.166
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.361,
                                                    -0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.25
                                                ],
                                                [
                                                    0.235,
                                                    0.154
                                                ],
                                                [
                                                    0.375,
                                                    0
                                                ],
                                                [
                                                    0.241,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.241
                                                ],
                                                [
                                                    -0.266,
                                                    0.159
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.296,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.322
                                                ],
                                                [
                                                    0.3,
                                                    -0.176
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.345,
                                                    -2.34
                                                ],
                                                [
                                                    -30.413,
                                                    -2.107
                                                ],
                                                [
                                                    -29.812,
                                                    -1.521
                                                ],
                                                [
                                                    -29.812,
                                                    -2.273
                                                ],
                                                [
                                                    -29.121,
                                                    -2.273
                                                ],
                                                [
                                                    -29.121,
                                                    1.936
                                                ],
                                                [
                                                    -29.361,
                                                    2.934
                                                ],
                                                [
                                                    -30.052,
                                                    3.626
                                                ],
                                                [
                                                    -31.089,
                                                    3.873
                                                ],
                                                [
                                                    -32.442,
                                                    3.49
                                                ],
                                                [
                                                    -33.081,
                                                    2.447
                                                ],
                                                [
                                                    -32.404,
                                                    2.447
                                                ],
                                                [
                                                    -31.938,
                                                    3.048
                                                ],
                                                [
                                                    -31.089,
                                                    3.281
                                                ],
                                                [
                                                    -30.173,
                                                    2.926
                                                ],
                                                [
                                                    -29.812,
                                                    1.936
                                                ],
                                                [
                                                    -29.812,
                                                    1.07
                                                ],
                                                [
                                                    -30.413,
                                                    1.673
                                                ],
                                                [
                                                    -31.345,
                                                    1.912
                                                ],
                                                [
                                                    -32.344,
                                                    1.643
                                                ],
                                                [
                                                    -33.043,
                                                    0.883
                                                ],
                                                [
                                                    -33.299,
                                                    -0.229
                                                ],
                                                [
                                                    -33.043,
                                                    -1.333
                                                ],
                                                [
                                                    -32.344,
                                                    -2.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.121
                                                ],
                                                [
                                                    0.125,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.127
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.125,
                                                    0.229
                                                ],
                                                [
                                                    0.21,
                                                    0.119
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.127
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -29.812,
                                                    -0.221
                                                ],
                                                [
                                                    -30,
                                                    -1.033
                                                ],
                                                [
                                                    -30.511,
                                                    -1.559
                                                ],
                                                [
                                                    -31.21,
                                                    -1.747
                                                ],
                                                [
                                                    -31.908,
                                                    -1.566
                                                ],
                                                [
                                                    -32.412,
                                                    -1.04
                                                ],
                                                [
                                                    -32.6,
                                                    -0.229
                                                ],
                                                [
                                                    -32.412,
                                                    0.598
                                                ],
                                                [
                                                    -31.908,
                                                    1.132
                                                ],
                                                [
                                                    -31.21,
                                                    1.311
                                                ],
                                                [
                                                    -30.511,
                                                    1.132
                                                ],
                                                [
                                                    -30,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 27",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.221,
                                                    0.129
                                                ],
                                                [
                                                    -0.321,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.12,
                                                    -0.235
                                                ],
                                                [
                                                    0.225,
                                                    -0.131
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.766,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -27.281,
                                                    -1.605
                                                ],
                                                [
                                                    -26.77,
                                                    -2.152
                                                ],
                                                [
                                                    -25.951,
                                                    -2.348
                                                ],
                                                [
                                                    -25.951,
                                                    -1.642
                                                ],
                                                [
                                                    -26.132,
                                                    -1.642
                                                ],
                                                [
                                                    -27.281,
                                                    -0.395
                                                ],
                                                [
                                                    -27.281,
                                                    1.844
                                                ],
                                                [
                                                    -27.965,
                                                    1.844
                                                ],
                                                [
                                                    -27.965,
                                                    -2.273
                                                ],
                                                [
                                                    -27.281,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 28",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.375
                                                ],
                                                [
                                                    0.015,
                                                    -0.146
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.251,
                                                    -0.229
                                                ],
                                                [
                                                    -0.361,
                                                    0
                                                ],
                                                [
                                                    -0.195,
                                                    0.134
                                                ],
                                                [
                                                    -0.08,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    -0.25
                                                ],
                                                [
                                                    0.491,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.175
                                                ],
                                                [
                                                    0.176,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.17,
                                                    0.321
                                                ],
                                                [
                                                    -0.306,
                                                    0.169
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    -0.171
                                                ],
                                                [
                                                    -0.16,
                                                    -0.301
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    0.405
                                                ],
                                                [
                                                    0.255,
                                                    0.226
                                                ],
                                                [
                                                    0.295,
                                                    0
                                                ],
                                                [
                                                    0.2,
                                                    -0.142
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.394
                                                ],
                                                [
                                                    -0.331,
                                                    0.245
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.306,
                                                    -0.174
                                                ],
                                                [
                                                    -0.175,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.17,
                                                    -0.319
                                                ],
                                                [
                                                    0.31,
                                                    -0.176
                                                ],
                                                [
                                                    0.39,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.17
                                                ],
                                                [
                                                    0.165,
                                                    0.296
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -21.405,
                                                    -0.372
                                                ],
                                                [
                                                    -21.428,
                                                    0.042
                                                ],
                                                [
                                                    -24.719,
                                                    0.042
                                                ],
                                                [
                                                    -24.305,
                                                    0.995
                                                ],
                                                [
                                                    -23.381,
                                                    1.333
                                                ],
                                                [
                                                    -22.645,
                                                    1.132
                                                ],
                                                [
                                                    -22.224,
                                                    0.576
                                                ],
                                                [
                                                    -21.488,
                                                    0.576
                                                ],
                                                [
                                                    -22.149,
                                                    1.544
                                                ],
                                                [
                                                    -23.381,
                                                    1.912
                                                ],
                                                [
                                                    -24.433,
                                                    1.649
                                                ],
                                                [
                                                    -25.155,
                                                    0.906
                                                ],
                                                [
                                                    -25.418,
                                                    -0.221
                                                ],
                                                [
                                                    -25.162,
                                                    -1.342
                                                ],
                                                [
                                                    -24.448,
                                                    -2.077
                                                ],
                                                [
                                                    -23.381,
                                                    -2.34
                                                ],
                                                [
                                                    -22.344,
                                                    -2.085
                                                ],
                                                [
                                                    -21.653,
                                                    -1.379
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 29",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.115,
                                                    0.187
                                                ],
                                                [
                                                    0.201,
                                                    0.095
                                                ],
                                                [
                                                    0.24,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    -0.22
                                                ],
                                                [
                                                    0.035,
                                                    -0.391
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.26
                                                ],
                                                [
                                                    -0.115,
                                                    -0.19
                                                ],
                                                [
                                                    -0.195,
                                                    -0.1
                                                ],
                                                [
                                                    -0.346,
                                                    0
                                                ],
                                                [
                                                    -0.24,
                                                    0.221
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -22.111,
                                                    -0.515
                                                ],
                                                [
                                                    -22.284,
                                                    -1.184
                                                ],
                                                [
                                                    -22.758,
                                                    -1.612
                                                ],
                                                [
                                                    -23.411,
                                                    -1.762
                                                ],
                                                [
                                                    -24.298,
                                                    -1.432
                                                ],
                                                [
                                                    -24.711,
                                                    -0.515
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 30",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.375
                                                ],
                                                [
                                                    0.015,
                                                    -0.146
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.25,
                                                    -0.229
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.196,
                                                    0.134
                                                ],
                                                [
                                                    -0.08,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.33,
                                                    -0.25
                                                ],
                                                [
                                                    0.491,
                                                    0
                                                ],
                                                [
                                                    0.311,
                                                    0.175
                                                ],
                                                [
                                                    0.175,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.17,
                                                    0.321
                                                ],
                                                [
                                                    -0.305,
                                                    0.169
                                                ],
                                                [
                                                    -0.4,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    -0.171
                                                ],
                                                [
                                                    -0.161,
                                                    -0.301
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    0.405
                                                ],
                                                [
                                                    0.256,
                                                    0.226
                                                ],
                                                [
                                                    0.296,
                                                    0
                                                ],
                                                [
                                                    0.2,
                                                    -0.142
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.394
                                                ],
                                                [
                                                    -0.331,
                                                    0.245
                                                ],
                                                [
                                                    -0.39,
                                                    0
                                                ],
                                                [
                                                    -0.305,
                                                    -0.174
                                                ],
                                                [
                                                    -0.175,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.171,
                                                    -0.319
                                                ],
                                                [
                                                    0.311,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    0.17
                                                ],
                                                [
                                                    0.165,
                                                    0.296
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -16.746,
                                                    -0.372
                                                ],
                                                [
                                                    -16.768,
                                                    0.042
                                                ],
                                                [
                                                    -20.059,
                                                    0.042
                                                ],
                                                [
                                                    -19.646,
                                                    0.995
                                                ],
                                                [
                                                    -18.722,
                                                    1.333
                                                ],
                                                [
                                                    -17.985,
                                                    1.132
                                                ],
                                                [
                                                    -17.565,
                                                    0.576
                                                ],
                                                [
                                                    -16.828,
                                                    0.576
                                                ],
                                                [
                                                    -17.489,
                                                    1.544
                                                ],
                                                [
                                                    -18.722,
                                                    1.912
                                                ],
                                                [
                                                    -19.774,
                                                    1.649
                                                ],
                                                [
                                                    -20.495,
                                                    0.906
                                                ],
                                                [
                                                    -20.758,
                                                    -0.221
                                                ],
                                                [
                                                    -20.503,
                                                    -1.342
                                                ],
                                                [
                                                    -19.789,
                                                    -2.077
                                                ],
                                                [
                                                    -18.722,
                                                    -2.34
                                                ],
                                                [
                                                    -17.685,
                                                    -2.085
                                                ],
                                                [
                                                    -16.993,
                                                    -1.379
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 31",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.116,
                                                    0.187
                                                ],
                                                [
                                                    0.2,
                                                    0.095
                                                ],
                                                [
                                                    0.241,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    -0.22
                                                ],
                                                [
                                                    0.035,
                                                    -0.391
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.26
                                                ],
                                                [
                                                    -0.115,
                                                    -0.19
                                                ],
                                                [
                                                    -0.195,
                                                    -0.1
                                                ],
                                                [
                                                    -0.345,
                                                    0
                                                ],
                                                [
                                                    -0.241,
                                                    0.221
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -17.452,
                                                    -0.515
                                                ],
                                                [
                                                    -17.625,
                                                    -1.184
                                                ],
                                                [
                                                    -18.098,
                                                    -1.612
                                                ],
                                                [
                                                    -18.752,
                                                    -1.762
                                                ],
                                                [
                                                    -19.638,
                                                    -1.432
                                                ],
                                                [
                                                    -20.052,
                                                    -0.515
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 32",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.085
                                                ],
                                                [
                                                    -0.21,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.19,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.202
                                                ],
                                                [
                                                    0.085,
                                                    0.081
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.381,
                                                    0
                                                ],
                                                [
                                                    -0.19,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.006,
                                                    -1.71
                                                ],
                                                [
                                                    -13.006,
                                                    0.717
                                                ],
                                                [
                                                    -12.878,
                                                    1.146
                                                ],
                                                [
                                                    -12.435,
                                                    1.266
                                                ],
                                                [
                                                    -11.931,
                                                    1.266
                                                ],
                                                [
                                                    -11.931,
                                                    1.844
                                                ],
                                                [
                                                    -12.547,
                                                    1.844
                                                ],
                                                [
                                                    -13.404,
                                                    1.581
                                                ],
                                                [
                                                    -13.689,
                                                    0.717
                                                ],
                                                [
                                                    -13.689,
                                                    -1.71
                                                ],
                                                [
                                                    -14.223,
                                                    -1.71
                                                ],
                                                [
                                                    -14.223,
                                                    -2.273
                                                ],
                                                [
                                                    -13.689,
                                                    -2.273
                                                ],
                                                [
                                                    -13.689,
                                                    -3.31
                                                ],
                                                [
                                                    -13.006,
                                                    -3.31
                                                ],
                                                [
                                                    -13.006,
                                                    -2.273
                                                ],
                                                [
                                                    -11.931,
                                                    -2.273
                                                ],
                                                [
                                                    -11.931,
                                                    -1.71
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 33",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.18,
                                                    0.321
                                                ],
                                                [
                                                    -0.316,
                                                    0.169
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    -0.176
                                                ],
                                                [
                                                    -0.181,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.19,
                                                    -0.326
                                                ],
                                                [
                                                    0.321,
                                                    -0.174
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.386,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.174
                                                ],
                                                [
                                                    -0.175,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.422
                                                ],
                                                [
                                                    0.186,
                                                    -0.327
                                                ],
                                                [
                                                    0.315,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.169
                                                ],
                                                [
                                                    0.185,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.185,
                                                    0.321
                                                ],
                                                [
                                                    -0.32,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.307,
                                                    1.912
                                                ],
                                                [
                                                    -10.359,
                                                    1.649
                                                ],
                                                [
                                                    -11.095,
                                                    0.906
                                                ],
                                                [
                                                    -11.358,
                                                    -0.221
                                                ],
                                                [
                                                    -11.088,
                                                    -1.333
                                                ],
                                                [
                                                    -10.336,
                                                    -2.077
                                                ],
                                                [
                                                    -9.277,
                                                    -2.34
                                                ],
                                                [
                                                    -8.217,
                                                    -2.077
                                                ],
                                                [
                                                    -7.473,
                                                    -1.342
                                                ],
                                                [
                                                    -7.195,
                                                    -0.221
                                                ],
                                                [
                                                    -7.481,
                                                    0.906
                                                ],
                                                [
                                                    -8.24,
                                                    1.649
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 34",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.215,
                                                    0.115
                                                ],
                                                [
                                                    -0.13,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.33
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.115
                                                ],
                                                [
                                                    0.126,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.12,
                                                    -0.231
                                                ],
                                                [
                                                    -0.205,
                                                    -0.115
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.115
                                                ],
                                                [
                                                    0.135,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.21,
                                                    -0.115
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.205,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.307,
                                                    1.311
                                                ],
                                                [
                                                    -8.616,
                                                    1.138
                                                ],
                                                [
                                                    -8.097,
                                                    0.62
                                                ],
                                                [
                                                    -7.894,
                                                    -0.221
                                                ],
                                                [
                                                    -8.09,
                                                    -1.064
                                                ],
                                                [
                                                    -8.601,
                                                    -1.574
                                                ],
                                                [
                                                    -9.284,
                                                    -1.747
                                                ],
                                                [
                                                    -9.976,
                                                    -1.574
                                                ],
                                                [
                                                    -10.472,
                                                    -1.064
                                                ],
                                                [
                                                    -10.659,
                                                    -0.221
                                                ],
                                                [
                                                    -10.479,
                                                    0.628
                                                ],
                                                [
                                                    -9.983,
                                                    1.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 35",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.296,
                                                    0.175
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    -0.159
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.295,
                                                    0.179
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.322
                                                ],
                                                [
                                                    0.3,
                                                    -0.176
                                                ],
                                                [
                                                    0.361,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.24
                                                ],
                                                [
                                                    -0.265,
                                                    0.156
                                                ],
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.296,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    77.518,
                                                    -0.229
                                                ],
                                                [
                                                    77.774,
                                                    -1.333
                                                ],
                                                [
                                                    78.473,
                                                    -2.077
                                                ],
                                                [
                                                    79.472,
                                                    -2.34
                                                ],
                                                [
                                                    80.411,
                                                    -2.107
                                                ],
                                                [
                                                    81.005,
                                                    -1.521
                                                ],
                                                [
                                                    81.005,
                                                    -2.273
                                                ],
                                                [
                                                    81.696,
                                                    -2.273
                                                ],
                                                [
                                                    81.696,
                                                    1.844
                                                ],
                                                [
                                                    81.005,
                                                    1.844
                                                ],
                                                [
                                                    81.005,
                                                    1.078
                                                ],
                                                [
                                                    80.396,
                                                    1.679
                                                ],
                                                [
                                                    79.464,
                                                    1.912
                                                ],
                                                [
                                                    78.473,
                                                    1.643
                                                ],
                                                [
                                                    77.774,
                                                    0.883
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 36",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.215,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.121
                                                ],
                                                [
                                                    0.125,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.21,
                                                    -0.127
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.125,
                                                    0.229
                                                ],
                                                [
                                                    0.211,
                                                    0.119
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.127
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    81.005,
                                                    -0.221
                                                ],
                                                [
                                                    80.817,
                                                    -1.033
                                                ],
                                                [
                                                    80.306,
                                                    -1.559
                                                ],
                                                [
                                                    79.607,
                                                    -1.747
                                                ],
                                                [
                                                    78.908,
                                                    -1.566
                                                ],
                                                [
                                                    78.405,
                                                    -1.04
                                                ],
                                                [
                                                    78.217,
                                                    -0.229
                                                ],
                                                [
                                                    78.405,
                                                    0.598
                                                ],
                                                [
                                                    78.908,
                                                    1.132
                                                ],
                                                [
                                                    79.607,
                                                    1.311
                                                ],
                                                [
                                                    80.306,
                                                    1.132
                                                ],
                                                [
                                                    80.817,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 37",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.085
                                                ],
                                                [
                                                    -0.211,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.202
                                                ],
                                                [
                                                    0.086,
                                                    0.081
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.381,
                                                    0
                                                ],
                                                [
                                                    -0.19,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    83.686,
                                                    -1.71
                                                ],
                                                [
                                                    83.686,
                                                    0.717
                                                ],
                                                [
                                                    83.813,
                                                    1.146
                                                ],
                                                [
                                                    84.257,
                                                    1.266
                                                ],
                                                [
                                                    84.76,
                                                    1.266
                                                ],
                                                [
                                                    84.76,
                                                    1.844
                                                ],
                                                [
                                                    84.144,
                                                    1.844
                                                ],
                                                [
                                                    83.287,
                                                    1.581
                                                ],
                                                [
                                                    83.002,
                                                    0.717
                                                ],
                                                [
                                                    83.002,
                                                    -1.71
                                                ],
                                                [
                                                    82.468,
                                                    -1.71
                                                ],
                                                [
                                                    82.468,
                                                    -2.273
                                                ],
                                                [
                                                    83.002,
                                                    -2.273
                                                ],
                                                [
                                                    83.002,
                                                    -3.31
                                                ],
                                                [
                                                    83.686,
                                                    -3.31
                                                ],
                                                [
                                                    83.686,
                                                    -2.273
                                                ],
                                                [
                                                    84.76,
                                                    -2.273
                                                ],
                                                [
                                                    84.76,
                                                    -1.71
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 38",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    88.103,
                                                    1.281
                                                ],
                                                [
                                                    90.124,
                                                    1.281
                                                ],
                                                [
                                                    90.124,
                                                    1.844
                                                ],
                                                [
                                                    87.321,
                                                    1.844
                                                ],
                                                [
                                                    87.321,
                                                    1.281
                                                ],
                                                [
                                                    89.32,
                                                    -1.717
                                                ],
                                                [
                                                    87.336,
                                                    -1.717
                                                ],
                                                [
                                                    87.336,
                                                    -2.273
                                                ],
                                                [
                                                    90.109,
                                                    -2.273
                                                ],
                                                [
                                                    90.109,
                                                    -1.717
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 39",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.18,
                                                    0.321
                                                ],
                                                [
                                                    -0.316,
                                                    0.169
                                                ],
                                                [
                                                    -0.39,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    -0.176
                                                ],
                                                [
                                                    -0.181,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.19,
                                                    -0.326
                                                ],
                                                [
                                                    0.321,
                                                    -0.174
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.174
                                                ],
                                                [
                                                    -0.175,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.422
                                                ],
                                                [
                                                    0.186,
                                                    -0.327
                                                ],
                                                [
                                                    0.315,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.169
                                                ],
                                                [
                                                    0.185,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.185,
                                                    0.321
                                                ],
                                                [
                                                    -0.32,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    92.807,
                                                    1.912
                                                ],
                                                [
                                                    91.755,
                                                    1.649
                                                ],
                                                [
                                                    91.019,
                                                    0.906
                                                ],
                                                [
                                                    90.756,
                                                    -0.221
                                                ],
                                                [
                                                    91.026,
                                                    -1.333
                                                ],
                                                [
                                                    91.778,
                                                    -2.077
                                                ],
                                                [
                                                    92.837,
                                                    -2.34
                                                ],
                                                [
                                                    93.897,
                                                    -2.077
                                                ],
                                                [
                                                    94.641,
                                                    -1.342
                                                ],
                                                [
                                                    94.919,
                                                    -0.221
                                                ],
                                                [
                                                    94.633,
                                                    0.906
                                                ],
                                                [
                                                    93.874,
                                                    1.649
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 40",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    0.115
                                                ],
                                                [
                                                    -0.13,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.33
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.21,
                                                    0.11
                                                ],
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.115
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.12,
                                                    -0.231
                                                ],
                                                [
                                                    -0.205,
                                                    -0.115
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.115
                                                ],
                                                [
                                                    0.135,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.211,
                                                    -0.115
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.126,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.205,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    92.807,
                                                    1.311
                                                ],
                                                [
                                                    93.499,
                                                    1.138
                                                ],
                                                [
                                                    94.017,
                                                    0.62
                                                ],
                                                [
                                                    94.22,
                                                    -0.221
                                                ],
                                                [
                                                    94.024,
                                                    -1.064
                                                ],
                                                [
                                                    93.514,
                                                    -1.574
                                                ],
                                                [
                                                    92.83,
                                                    -1.747
                                                ],
                                                [
                                                    92.138,
                                                    -1.574
                                                ],
                                                [
                                                    91.643,
                                                    -1.064
                                                ],
                                                [
                                                    91.455,
                                                    -0.221
                                                ],
                                                [
                                                    91.635,
                                                    0.628
                                                ],
                                                [
                                                    92.131,
                                                    1.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 41",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.296,
                                                    0
                                                ],
                                                [
                                                    -0.25,
                                                    -0.135
                                                ],
                                                [
                                                    -0.14,
                                                    -0.265
                                                ],
                                                [
                                                    0,
                                                    -0.38
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.216
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.31,
                                                    0
                                                ],
                                                [
                                                    0.251,
                                                    0.131
                                                ],
                                                [
                                                    0.145,
                                                    0.265
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.412
                                                ],
                                                [
                                                    -0.206,
                                                    -0.221
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.24,
                                                    -0.114
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    97.862,
                                                    -2.348
                                                ],
                                                [
                                                    98.703,
                                                    -2.146
                                                ],
                                                [
                                                    99.289,
                                                    -1.551
                                                ],
                                                [
                                                    99.507,
                                                    -0.583
                                                ],
                                                [
                                                    99.507,
                                                    1.844
                                                ],
                                                [
                                                    98.831,
                                                    1.844
                                                ],
                                                [
                                                    98.831,
                                                    -0.484
                                                ],
                                                [
                                                    98.523,
                                                    -1.424
                                                ],
                                                [
                                                    97.681,
                                                    -1.755
                                                ],
                                                [
                                                    96.817,
                                                    -1.417
                                                ],
                                                [
                                                    96.501,
                                                    -0.432
                                                ],
                                                [
                                                    96.501,
                                                    1.844
                                                ],
                                                [
                                                    95.818,
                                                    1.844
                                                ],
                                                [
                                                    95.818,
                                                    -3.715
                                                ],
                                                [
                                                    96.501,
                                                    -3.715
                                                ],
                                                [
                                                    96.501,
                                                    -1.687
                                                ],
                                                [
                                                    97.058,
                                                    -2.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 42",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.18,
                                                    0.321
                                                ],
                                                [
                                                    -0.315,
                                                    0.169
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.315,
                                                    -0.176
                                                ],
                                                [
                                                    -0.18,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.19,
                                                    -0.326
                                                ],
                                                [
                                                    0.32,
                                                    -0.174
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.386,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.174
                                                ],
                                                [
                                                    -0.176,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.422
                                                ],
                                                [
                                                    0.185,
                                                    -0.327
                                                ],
                                                [
                                                    0.316,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.169
                                                ],
                                                [
                                                    0.186,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.186,
                                                    0.321
                                                ],
                                                [
                                                    -0.321,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    102.42,
                                                    1.912
                                                ],
                                                [
                                                    101.368,
                                                    1.649
                                                ],
                                                [
                                                    100.632,
                                                    0.906
                                                ],
                                                [
                                                    100.369,
                                                    -0.221
                                                ],
                                                [
                                                    100.639,
                                                    -1.333
                                                ],
                                                [
                                                    101.39,
                                                    -2.077
                                                ],
                                                [
                                                    102.45,
                                                    -2.34
                                                ],
                                                [
                                                    103.509,
                                                    -2.077
                                                ],
                                                [
                                                    104.253,
                                                    -1.342
                                                ],
                                                [
                                                    104.531,
                                                    -0.221
                                                ],
                                                [
                                                    104.246,
                                                    0.906
                                                ],
                                                [
                                                    103.487,
                                                    1.649
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 43",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.246,
                                                    0
                                                ],
                                                [
                                                    -0.215,
                                                    0.115
                                                ],
                                                [
                                                    -0.131,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.33
                                                ],
                                                [
                                                    0.13,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.115
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.121,
                                                    -0.231
                                                ],
                                                [
                                                    -0.206,
                                                    -0.115
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.115
                                                ],
                                                [
                                                    0.135,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.21,
                                                    -0.115
                                                ],
                                                [
                                                    -0.25,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.205,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    102.42,
                                                    1.311
                                                ],
                                                [
                                                    103.111,
                                                    1.138
                                                ],
                                                [
                                                    103.63,
                                                    0.62
                                                ],
                                                [
                                                    103.832,
                                                    -0.221
                                                ],
                                                [
                                                    103.637,
                                                    -1.064
                                                ],
                                                [
                                                    103.126,
                                                    -1.574
                                                ],
                                                [
                                                    102.442,
                                                    -1.747
                                                ],
                                                [
                                                    101.751,
                                                    -1.574
                                                ],
                                                [
                                                    101.255,
                                                    -1.064
                                                ],
                                                [
                                                    101.067,
                                                    -0.221
                                                ],
                                                [
                                                    101.248,
                                                    0.628
                                                ],
                                                [
                                                    101.744,
                                                    1.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 44",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.089
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.091,
                                                    0.091
                                                ],
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.091
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.091,
                                                    -0.091
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.085,
                                                    0.089
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    105.648,
                                                    1.889
                                                ],
                                                [
                                                    105.318,
                                                    1.755
                                                ],
                                                [
                                                    105.182,
                                                    1.424
                                                ],
                                                [
                                                    105.318,
                                                    1.093
                                                ],
                                                [
                                                    105.648,
                                                    0.958
                                                ],
                                                [
                                                    105.964,
                                                    1.093
                                                ],
                                                [
                                                    106.099,
                                                    1.424
                                                ],
                                                [
                                                    105.964,
                                                    1.755
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            126.91,
                                            248.098
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.517,
                                                    -0.263
                                                ],
                                                [
                                                    -0.253,
                                                    -0.441
                                                ],
                                                [
                                                    0,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.526
                                                ],
                                                [
                                                    0.77,
                                                    -0.188
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.751,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    0.263
                                                ],
                                                [
                                                    0.263,
                                                    0.442
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.366,
                                                    0.517
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.041,
                                                    3.508
                                                ],
                                                [
                                                    -25.295,
                                                    -0.409
                                                ],
                                                [
                                                    -26.521,
                                                    -0.409
                                                ],
                                                [
                                                    -26.521,
                                                    3.508
                                                ],
                                                [
                                                    -28.127,
                                                    3.508
                                                ],
                                                [
                                                    -28.127,
                                                    -6.284
                                                ],
                                                [
                                                    -24.746,
                                                    -6.284
                                                ],
                                                [
                                                    -22.844,
                                                    -5.89
                                                ],
                                                [
                                                    -21.675,
                                                    -4.833
                                                ],
                                                [
                                                    -21.28,
                                                    -3.354
                                                ],
                                                [
                                                    -21.844,
                                                    -1.607
                                                ],
                                                [
                                                    -23.548,
                                                    -0.55
                                                ],
                                                [
                                                    -21.125,
                                                    3.508
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    0.301
                                                ],
                                                [
                                                    0,
                                                    0.508
                                                ],
                                                [
                                                    0.3,
                                                    0.282
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    -0.301
                                                ],
                                                [
                                                    0,
                                                    -0.507
                                                ],
                                                [
                                                    -0.301,
                                                    -0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.521,
                                                    -1.691
                                                ],
                                                [
                                                    -24.746,
                                                    -1.691
                                                ],
                                                [
                                                    -23.393,
                                                    -2.142
                                                ],
                                                [
                                                    -22.928,
                                                    -3.354
                                                ],
                                                [
                                                    -23.379,
                                                    -4.537
                                                ],
                                                [
                                                    -24.746,
                                                    -4.974
                                                ],
                                                [
                                                    -26.521,
                                                    -4.974
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.751
                                                ],
                                                [
                                                    0.038,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    -0.375
                                                ],
                                                [
                                                    -0.602,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.723
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.62,
                                                    -0.46
                                                ],
                                                [
                                                    0.911,
                                                    0
                                                ],
                                                [
                                                    0.592,
                                                    0.329
                                                ],
                                                [
                                                    0.338,
                                                    0.602
                                                ],
                                                [
                                                    0,
                                                    0.799
                                                ],
                                                [
                                                    -0.319,
                                                    0.601
                                                ],
                                                [
                                                    -0.583,
                                                    0.329
                                                ],
                                                [
                                                    -0.761,
                                                    0
                                                ],
                                                [
                                                    -0.573,
                                                    -0.319
                                                ],
                                                [
                                                    -0.319,
                                                    -0.582
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.62
                                                ],
                                                [
                                                    0.413,
                                                    0.376
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.714
                                                ],
                                                [
                                                    -0.611,
                                                    0.451
                                                ],
                                                [
                                                    -0.742,
                                                    0
                                                ],
                                                [
                                                    -0.582,
                                                    -0.338
                                                ],
                                                [
                                                    -0.328,
                                                    -0.61
                                                ],
                                                [
                                                    0,
                                                    -0.798
                                                ],
                                                [
                                                    0.329,
                                                    -0.611
                                                ],
                                                [
                                                    0.592,
                                                    -0.329
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.573,
                                                    0.319
                                                ],
                                                [
                                                    0.32,
                                                    0.573
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.111,
                                                    -0.564
                                                ],
                                                [
                                                    -12.167,
                                                    0.225
                                                ],
                                                [
                                                    -18.098,
                                                    0.225
                                                ],
                                                [
                                                    -17.408,
                                                    1.718
                                                ],
                                                [
                                                    -15.886,
                                                    2.282
                                                ],
                                                [
                                                    -14.055,
                                                    1.197
                                                ],
                                                [
                                                    -12.322,
                                                    1.197
                                                ],
                                                [
                                                    -13.604,
                                                    2.958
                                                ],
                                                [
                                                    -15.886,
                                                    3.634
                                                ],
                                                [
                                                    -17.887,
                                                    3.141
                                                ],
                                                [
                                                    -19.268,
                                                    1.732
                                                ],
                                                [
                                                    -19.761,
                                                    -0.381
                                                ],
                                                [
                                                    -19.282,
                                                    -2.48
                                                ],
                                                [
                                                    -17.915,
                                                    -3.889
                                                ],
                                                [
                                                    -15.886,
                                                    -4.382
                                                ],
                                                [
                                                    -13.928,
                                                    -3.903
                                                ],
                                                [
                                                    -12.59,
                                                    -2.551
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.357
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.357
                                                ],
                                                [
                                                    0.075,
                                                    -0.601
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.01,
                                                    -0.592
                                                ],
                                                [
                                                    -0.413,
                                                    -0.357
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.347
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.787,
                                                    -1.071
                                                ],
                                                [
                                                    -14.421,
                                                    -2.494
                                                ],
                                                [
                                                    -15.957,
                                                    -3.03
                                                ],
                                                [
                                                    -17.38,
                                                    -2.494
                                                ],
                                                [
                                                    -18.084,
                                                    -1.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.677,
                                                    0
                                                ],
                                                [
                                                    -0.461,
                                                    -0.244
                                                ],
                                                [
                                                    -0.263,
                                                    -0.357
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    -0.554
                                                ],
                                                [
                                                    0.573,
                                                    -0.32
                                                ],
                                                [
                                                    0.789,
                                                    0
                                                ],
                                                [
                                                    0.695,
                                                    0.498
                                                ],
                                                [
                                                    0.094,
                                                    0.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    -0.245
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0.752
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    -0.253
                                                ],
                                                [
                                                    0.591,
                                                    0
                                                ],
                                                [
                                                    0.563,
                                                    0.338
                                                ],
                                                [
                                                    0.328,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.78
                                                ],
                                                [
                                                    -0.32,
                                                    0.601
                                                ],
                                                [
                                                    -0.554,
                                                    0.329
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    -0.301,
                                                    0.564
                                                ],
                                                [
                                                    -0.564,
                                                    0.319
                                                ],
                                                [
                                                    -1.052,
                                                    0
                                                ],
                                                [
                                                    -0.695,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.122,
                                                    0.404
                                                ],
                                                [
                                                    0.404,
                                                    0.253
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.404,
                                                    -0.394
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.273,
                                                    0.367
                                                ],
                                                [
                                                    -0.461,
                                                    0.244
                                                ],
                                                [
                                                    -0.677,
                                                    0
                                                ],
                                                [
                                                    -0.554,
                                                    -0.347
                                                ],
                                                [
                                                    -0.32,
                                                    -0.62
                                                ],
                                                [
                                                    0,
                                                    -0.78
                                                ],
                                                [
                                                    0.328,
                                                    -0.601
                                                ],
                                                [
                                                    0.563,
                                                    -0.338
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.402,
                                                    -4.382
                                                ],
                                                [
                                                    -5.81,
                                                    -4.016
                                                ],
                                                [
                                                    -4.711,
                                                    -3.128
                                                ],
                                                [
                                                    -4.711,
                                                    -4.255
                                                ],
                                                [
                                                    -3.091,
                                                    -4.255
                                                ],
                                                [
                                                    -3.091,
                                                    3.634
                                                ],
                                                [
                                                    -3.542,
                                                    5.536
                                                ],
                                                [
                                                    -4.852,
                                                    6.861
                                                ],
                                                [
                                                    -6.881,
                                                    7.34
                                                ],
                                                [
                                                    -9.502,
                                                    6.593
                                                ],
                                                [
                                                    -10.685,
                                                    4.592
                                                ],
                                                [
                                                    -9.093,
                                                    4.592
                                                ],
                                                [
                                                    -8.318,
                                                    5.565
                                                ],
                                                [
                                                    -6.881,
                                                    5.945
                                                ],
                                                [
                                                    -5.317,
                                                    5.353
                                                ],
                                                [
                                                    -4.711,
                                                    3.634
                                                ],
                                                [
                                                    -4.711,
                                                    2.338
                                                ],
                                                [
                                                    -5.824,
                                                    3.268
                                                ],
                                                [
                                                    -7.402,
                                                    3.634
                                                ],
                                                [
                                                    -9.262,
                                                    3.127
                                                ],
                                                [
                                                    -10.586,
                                                    1.69
                                                ],
                                                [
                                                    -11.065,
                                                    -0.409
                                                ],
                                                [
                                                    -10.586,
                                                    -2.48
                                                ],
                                                [
                                                    -9.262,
                                                    -3.875
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.536
                                                ],
                                                [
                                                    0.226,
                                                    0.395
                                                ],
                                                [
                                                    0.357,
                                                    0.206
                                                ],
                                                [
                                                    0.413,
                                                    0
                                                ],
                                                [
                                                    0.356,
                                                    -0.207
                                                ],
                                                [
                                                    0.225,
                                                    -0.394
                                                ],
                                                [
                                                    0,
                                                    -0.535
                                                ],
                                                [
                                                    -0.216,
                                                    -0.404
                                                ],
                                                [
                                                    -0.357,
                                                    -0.216
                                                ],
                                                [
                                                    -0.404,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.206
                                                ],
                                                [
                                                    -0.216,
                                                    0.394
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.535
                                                ],
                                                [
                                                    -0.216,
                                                    -0.394
                                                ],
                                                [
                                                    -0.357,
                                                    -0.207
                                                ],
                                                [
                                                    -0.413,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.197
                                                ],
                                                [
                                                    -0.216,
                                                    0.385
                                                ],
                                                [
                                                    0,
                                                    0.535
                                                ],
                                                [
                                                    0.225,
                                                    0.404
                                                ],
                                                [
                                                    0.366,
                                                    0.206
                                                ],
                                                [
                                                    0.413,
                                                    0
                                                ],
                                                [
                                                    0.357,
                                                    -0.207
                                                ],
                                                [
                                                    0.226,
                                                    -0.404
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.711,
                                                    -0.381
                                                ],
                                                [
                                                    -5.05,
                                                    -1.776
                                                ],
                                                [
                                                    -5.909,
                                                    -2.677
                                                ],
                                                [
                                                    -7.064,
                                                    -2.987
                                                ],
                                                [
                                                    -8.219,
                                                    -2.677
                                                ],
                                                [
                                                    -9.093,
                                                    -1.79
                                                ],
                                                [
                                                    -9.417,
                                                    -0.409
                                                ],
                                                [
                                                    -9.093,
                                                    1
                                                ],
                                                [
                                                    -8.219,
                                                    1.93
                                                ],
                                                [
                                                    -7.064,
                                                    2.24
                                                ],
                                                [
                                                    -5.909,
                                                    1.93
                                                ],
                                                [
                                                    -5.05,
                                                    1.028
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    0.197,
                                                    0.198
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    -0.197,
                                                    0.197
                                                ],
                                                [
                                                    -0.292,
                                                    0
                                                ],
                                                [
                                                    -0.197,
                                                    -0.197
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    0.197,
                                                    -0.197
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.292,
                                                    0
                                                ],
                                                [
                                                    -0.197,
                                                    -0.197
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    0.197,
                                                    -0.197
                                                ],
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    0.197,
                                                    0.197
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    -0.197,
                                                    0.198
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.164,
                                                    -5.284
                                                ],
                                                [
                                                    -0.897,
                                                    -5.58
                                                ],
                                                [
                                                    -1.193,
                                                    -6.312
                                                ],
                                                [
                                                    -0.897,
                                                    -7.045
                                                ],
                                                [
                                                    -0.164,
                                                    -7.341
                                                ],
                                                [
                                                    0.554,
                                                    -7.045
                                                ],
                                                [
                                                    0.85,
                                                    -6.312
                                                ],
                                                [
                                                    0.554,
                                                    -5.58
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.625,
                                                    -4.255
                                                ],
                                                [
                                                    0.625,
                                                    3.508
                                                ],
                                                [
                                                    -0.982,
                                                    3.508
                                                ],
                                                [
                                                    -0.982,
                                                    -4.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    0.216
                                                ],
                                                [
                                                    0.282,
                                                    0.375
                                                ],
                                                [
                                                    0.018,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.282,
                                                    -0.226
                                                ],
                                                [
                                                    -0.432,
                                                    0
                                                ],
                                                [
                                                    -0.244,
                                                    0.169
                                                ],
                                                [
                                                    0,
                                                    0.272
                                                ],
                                                [
                                                    0.282,
                                                    0.141
                                                ],
                                                [
                                                    0.601,
                                                    0.169
                                                ],
                                                [
                                                    0.366,
                                                    0.15
                                                ],
                                                [
                                                    0.272,
                                                    0.31
                                                ],
                                                [
                                                    0,
                                                    0.507
                                                ],
                                                [
                                                    -0.245,
                                                    0.338
                                                ],
                                                [
                                                    -0.451,
                                                    0.197
                                                ],
                                                [
                                                    -0.592,
                                                    0
                                                ],
                                                [
                                                    -0.536,
                                                    -0.451
                                                ],
                                                [
                                                    -0.038,
                                                    -0.771
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.254,
                                                    0.207
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.225,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.263
                                                ],
                                                [
                                                    -0.15,
                                                    -0.141
                                                ],
                                                [
                                                    -0.216,
                                                    -0.084
                                                ],
                                                [
                                                    -0.422,
                                                    -0.122
                                                ],
                                                [
                                                    -0.357,
                                                    -0.16
                                                ],
                                                [
                                                    -0.263,
                                                    -0.3
                                                ],
                                                [
                                                    -0.01,
                                                    -0.498
                                                ],
                                                [
                                                    0.245,
                                                    -0.347
                                                ],
                                                [
                                                    0.451,
                                                    -0.198
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.611,
                                                    0
                                                ],
                                                [
                                                    -0.479,
                                                    -0.225
                                                ],
                                                [
                                                    -0.281,
                                                    -0.385
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.328
                                                ],
                                                [
                                                    0.291,
                                                    0.216
                                                ],
                                                [
                                                    0.451,
                                                    0
                                                ],
                                                [
                                                    0.254,
                                                    -0.178
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    -0.272,
                                                    -0.141
                                                ],
                                                [
                                                    -0.583,
                                                    -0.16
                                                ],
                                                [
                                                    -0.366,
                                                    -0.15
                                                ],
                                                [
                                                    -0.263,
                                                    -0.31
                                                ],
                                                [
                                                    0,
                                                    -0.413
                                                ],
                                                [
                                                    0.244,
                                                    -0.348
                                                ],
                                                [
                                                    0.46,
                                                    -0.197
                                                ],
                                                [
                                                    0.883,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.442
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.348
                                                ],
                                                [
                                                    -0.253,
                                                    -0.206
                                                ],
                                                [
                                                    -0.423,
                                                    0
                                                ],
                                                [
                                                    -0.226,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.207
                                                ],
                                                [
                                                    0.15,
                                                    0.141
                                                ],
                                                [
                                                    0.216,
                                                    0.076
                                                ],
                                                [
                                                    0.564,
                                                    0.151
                                                ],
                                                [
                                                    0.366,
                                                    0.15
                                                ],
                                                [
                                                    0.263,
                                                    0.301
                                                ],
                                                [
                                                    0,
                                                    0.441
                                                ],
                                                [
                                                    -0.244,
                                                    0.348
                                                ],
                                                [
                                                    -0.442,
                                                    0.197
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.551,
                                                    3.634
                                                ],
                                                [
                                                    3.903,
                                                    3.31
                                                ],
                                                [
                                                    2.761,
                                                    2.409
                                                ],
                                                [
                                                    2.311,
                                                    1.127
                                                ],
                                                [
                                                    3.973,
                                                    1.127
                                                ],
                                                [
                                                    4.438,
                                                    1.958
                                                ],
                                                [
                                                    5.523,
                                                    2.282
                                                ],
                                                [
                                                    6.565,
                                                    2.028
                                                ],
                                                [
                                                    6.946,
                                                    1.352
                                                ],
                                                [
                                                    6.523,
                                                    0.704
                                                ],
                                                [
                                                    5.213,
                                                    0.239
                                                ],
                                                [
                                                    3.79,
                                                    -0.226
                                                ],
                                                [
                                                    2.832,
                                                    -0.916
                                                ],
                                                [
                                                    2.437,
                                                    -2.142
                                                ],
                                                [
                                                    2.804,
                                                    -3.269
                                                ],
                                                [
                                                    3.846,
                                                    -4.086
                                                ],
                                                [
                                                    5.424,
                                                    -4.382
                                                ],
                                                [
                                                    7.552,
                                                    -3.706
                                                ],
                                                [
                                                    8.425,
                                                    -1.888
                                                ],
                                                [
                                                    6.819,
                                                    -1.888
                                                ],
                                                [
                                                    6.396,
                                                    -2.72
                                                ],
                                                [
                                                    5.368,
                                                    -3.03
                                                ],
                                                [
                                                    4.396,
                                                    -2.79
                                                ],
                                                [
                                                    4.058,
                                                    -2.156
                                                ],
                                                [
                                                    4.283,
                                                    -1.635
                                                ],
                                                [
                                                    4.832,
                                                    -1.297
                                                ],
                                                [
                                                    5.79,
                                                    -1.001
                                                ],
                                                [
                                                    7.171,
                                                    -0.536
                                                ],
                                                [
                                                    8.115,
                                                    0.14
                                                ],
                                                [
                                                    8.524,
                                                    1.338
                                                ],
                                                [
                                                    8.157,
                                                    2.521
                                                ],
                                                [
                                                    7.115,
                                                    3.339
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.131,
                                                    -0.131
                                                ],
                                                [
                                                    -0.329,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.385,
                                                    0.339
                                                ],
                                                [
                                                    0,
                                                    0.761
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0.141,
                                                    0.122
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.723,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    -0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.133,
                                                    -2.945
                                                ],
                                                [
                                                    12.133,
                                                    1.352
                                                ],
                                                [
                                                    12.33,
                                                    1.986
                                                ],
                                                [
                                                    13.035,
                                                    2.169
                                                ],
                                                [
                                                    14.021,
                                                    2.169
                                                ],
                                                [
                                                    14.021,
                                                    3.508
                                                ],
                                                [
                                                    12.753,
                                                    3.508
                                                ],
                                                [
                                                    11.09,
                                                    3
                                                ],
                                                [
                                                    10.513,
                                                    1.352
                                                ],
                                                [
                                                    10.513,
                                                    -2.945
                                                ],
                                                [
                                                    9.597,
                                                    -2.945
                                                ],
                                                [
                                                    9.597,
                                                    -4.255
                                                ],
                                                [
                                                    10.513,
                                                    -4.255
                                                ],
                                                [
                                                    10.513,
                                                    -6.185
                                                ],
                                                [
                                                    12.133,
                                                    -6.185
                                                ],
                                                [
                                                    12.133,
                                                    -4.255
                                                ],
                                                [
                                                    14.021,
                                                    -4.255
                                                ],
                                                [
                                                    14.021,
                                                    -2.945
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.751
                                                ],
                                                [
                                                    0.037,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.414,
                                                    -0.375
                                                ],
                                                [
                                                    -0.601,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.723
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.619,
                                                    -0.46
                                                ],
                                                [
                                                    0.911,
                                                    0
                                                ],
                                                [
                                                    0.591,
                                                    0.329
                                                ],
                                                [
                                                    0.338,
                                                    0.602
                                                ],
                                                [
                                                    0,
                                                    0.799
                                                ],
                                                [
                                                    -0.32,
                                                    0.601
                                                ],
                                                [
                                                    -0.582,
                                                    0.329
                                                ],
                                                [
                                                    -0.761,
                                                    0
                                                ],
                                                [
                                                    -0.572,
                                                    -0.319
                                                ],
                                                [
                                                    -0.319,
                                                    -0.582
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.62
                                                ],
                                                [
                                                    0.413,
                                                    0.376
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.714
                                                ],
                                                [
                                                    -0.611,
                                                    0.451
                                                ],
                                                [
                                                    -0.742,
                                                    0
                                                ],
                                                [
                                                    -0.583,
                                                    -0.338
                                                ],
                                                [
                                                    -0.329,
                                                    -0.61
                                                ],
                                                [
                                                    0,
                                                    -0.798
                                                ],
                                                [
                                                    0.329,
                                                    -0.611
                                                ],
                                                [
                                                    0.592,
                                                    -0.329
                                                ],
                                                [
                                                    0.733,
                                                    0
                                                ],
                                                [
                                                    0.573,
                                                    0.319
                                                ],
                                                [
                                                    0.319,
                                                    0.573
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    22.616,
                                                    -0.564
                                                ],
                                                [
                                                    22.56,
                                                    0.225
                                                ],
                                                [
                                                    16.628,
                                                    0.225
                                                ],
                                                [
                                                    17.319,
                                                    1.718
                                                ],
                                                [
                                                    18.84,
                                                    2.282
                                                ],
                                                [
                                                    20.672,
                                                    1.197
                                                ],
                                                [
                                                    22.405,
                                                    1.197
                                                ],
                                                [
                                                    21.123,
                                                    2.958
                                                ],
                                                [
                                                    18.84,
                                                    3.634
                                                ],
                                                [
                                                    16.84,
                                                    3.141
                                                ],
                                                [
                                                    15.459,
                                                    1.732
                                                ],
                                                [
                                                    14.966,
                                                    -0.381
                                                ],
                                                [
                                                    15.445,
                                                    -2.48
                                                ],
                                                [
                                                    16.811,
                                                    -3.889
                                                ],
                                                [
                                                    18.84,
                                                    -4.382
                                                ],
                                                [
                                                    20.798,
                                                    -3.903
                                                ],
                                                [
                                                    22.137,
                                                    -2.551
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.414,
                                                    0.357
                                                ],
                                                [
                                                    0.61,
                                                    0
                                                ],
                                                [
                                                    0.394,
                                                    -0.357
                                                ],
                                                [
                                                    0.075,
                                                    -0.601
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.009,
                                                    -0.592
                                                ],
                                                [
                                                    -0.413,
                                                    -0.357
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.347
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.939,
                                                    -1.071
                                                ],
                                                [
                                                    20.305,
                                                    -2.494
                                                ],
                                                [
                                                    18.77,
                                                    -3.03
                                                ],
                                                [
                                                    17.347,
                                                    -2.494
                                                ],
                                                [
                                                    16.642,
                                                    -1.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    0.216
                                                ],
                                                [
                                                    -0.535,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.328,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.234,
                                                    -0.395
                                                ],
                                                [
                                                    0.395,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.803,
                                                    -3.128
                                                ],
                                                [
                                                    26.732,
                                                    -4.044
                                                ],
                                                [
                                                    28.127,
                                                    -4.382
                                                ],
                                                [
                                                    28.127,
                                                    -2.72
                                                ],
                                                [
                                                    27.719,
                                                    -2.72
                                                ],
                                                [
                                                    26.282,
                                                    -2.241
                                                ],
                                                [
                                                    25.803,
                                                    -0.578
                                                ],
                                                [
                                                    25.803,
                                                    3.508
                                                ],
                                                [
                                                    24.197,
                                                    3.508
                                                ],
                                                [
                                                    24.197,
                                                    -4.255
                                                ],
                                                [
                                                    25.803,
                                                    -4.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9804,
                                            0.9804,
                                            0.9804
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.379,
                                            279.966
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.593
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -18.785
                                                ],
                                                [
                                                    108.014,
                                                    -18.785
                                                ],
                                                [
                                                    112.71,
                                                    -14.089
                                                ],
                                                [
                                                    112.71,
                                                    14.089
                                                ],
                                                [
                                                    108.014,
                                                    18.785
                                                ],
                                                [
                                                    -108.014,
                                                    18.785
                                                ],
                                                [
                                                    -112.71,
                                                    14.089
                                                ],
                                                [
                                                    -112.71,
                                                    -14.089
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.2392,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.942,
                                            279.04
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.161,
                                                    -0.001
                                                ],
                                                [
                                                    0.104,
                                                    1.365
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.188,
                                                    -0.367
                                                ],
                                                [
                                                    0,
                                                    -0.093
                                                ],
                                                [
                                                    -0.043,
                                                    -0.083
                                                ],
                                                [
                                                    -2.254,
                                                    0
                                                ],
                                                [
                                                    -0.459,
                                                    0.118
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.39,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.253,
                                                    0.318
                                                ],
                                                [
                                                    -0.043,
                                                    0.083
                                                ],
                                                [
                                                    0,
                                                    0.093
                                                ],
                                                [
                                                    0.994,
                                                    1.942
                                                ],
                                                [
                                                    0.494,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.157,
                                                    0.031
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.001,
                                                    2.642
                                                ],
                                                [
                                                    -2.622,
                                                    0.2
                                                ],
                                                [
                                                    -4.546,
                                                    -1.287
                                                ],
                                                [
                                                    -5.219,
                                                    -0.267
                                                ],
                                                [
                                                    -5.283,
                                                    0.001
                                                ],
                                                [
                                                    -5.219,
                                                    0.268
                                                ],
                                                [
                                                    -0.001,
                                                    3.523
                                                ],
                                                [
                                                    1.428,
                                                    3.331
                                                ],
                                                [
                                                    0.477,
                                                    2.594
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.061,
                                                    0.048
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.367,
                                                    0.717
                                                ],
                                                [
                                                    0,
                                                    0.093
                                                ],
                                                [
                                                    0.043,
                                                    0.083
                                                ],
                                                [
                                                    2.256,
                                                    0
                                                ],
                                                [
                                                    0.828,
                                                    -0.453
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    0.01
                                                ],
                                                [
                                                    0.038,
                                                    -0.005
                                                ],
                                                [
                                                    0.035,
                                                    -0.019
                                                ],
                                                [
                                                    0.025,
                                                    -0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.01,
                                                    -0.077
                                                ],
                                                [
                                                    -0.061,
                                                    -0.048
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.037,
                                                    -0.01
                                                ],
                                                [
                                                    -0.038,
                                                    0.004
                                                ],
                                                [
                                                    -0.032,
                                                    0.019
                                                ],
                                                [
                                                    -0.025,
                                                    0.03
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.01,
                                                    0.078
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.615,
                                                    -0.519
                                                ],
                                                [
                                                    0.043,
                                                    -0.083
                                                ],
                                                [
                                                    0,
                                                    -0.093
                                                ],
                                                [
                                                    -0.994,
                                                    -1.941
                                                ],
                                                [
                                                    -0.944,
                                                    0.002
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.032,
                                                    -0.023
                                                ],
                                                [
                                                    -0.037,
                                                    -0.01
                                                ],
                                                [
                                                    -0.039,
                                                    0.004
                                                ],
                                                [
                                                    -0.032,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.047,
                                                    0.062
                                                ],
                                                [
                                                    0.009,
                                                    0.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.03,
                                                    0.024
                                                ],
                                                [
                                                    0.037,
                                                    0.011
                                                ],
                                                [
                                                    0.039,
                                                    -0.005
                                                ],
                                                [
                                                    0.035,
                                                    -0.02
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    -0.062
                                                ],
                                                [
                                                    -0.009,
                                                    -0.077
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.757,
                                                    3.708
                                                ],
                                                [
                                                    3.729,
                                                    2.141
                                                ],
                                                [
                                                    5.219,
                                                    0.268
                                                ],
                                                [
                                                    5.284,
                                                    0.001
                                                ],
                                                [
                                                    5.219,
                                                    -0.267
                                                ],
                                                [
                                                    -0.001,
                                                    -3.522
                                                ],
                                                [
                                                    -2.702,
                                                    -2.83
                                                ],
                                                [
                                                    -5.036,
                                                    -4.634
                                                ],
                                                [
                                                    -5.139,
                                                    -4.685
                                                ],
                                                [
                                                    -5.253,
                                                    -4.693
                                                ],
                                                [
                                                    -5.363,
                                                    -4.657
                                                ],
                                                [
                                                    -5.449,
                                                    -4.582
                                                ],
                                                [
                                                    -5.809,
                                                    -4.119
                                                ],
                                                [
                                                    -5.868,
                                                    -3.902
                                                ],
                                                [
                                                    -5.757,
                                                    -3.707
                                                ],
                                                [
                                                    5.036,
                                                    4.635
                                                ],
                                                [
                                                    5.139,
                                                    4.686
                                                ],
                                                [
                                                    5.253,
                                                    4.695
                                                ],
                                                [
                                                    5.361,
                                                    4.659
                                                ],
                                                [
                                                    5.449,
                                                    4.584
                                                ],
                                                [
                                                    5.809,
                                                    4.12
                                                ],
                                                [
                                                    5.868,
                                                    3.903
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.002,
                                                    0.185
                                                ],
                                                [
                                                    0.119,
                                                    0.244
                                                ],
                                                [
                                                    0.217,
                                                    0.164
                                                ],
                                                [
                                                    0.268,
                                                    0.05
                                                ],
                                                [
                                                    0.261,
                                                    -0.076
                                                ],
                                                [
                                                    0,
                                                    -0.187
                                                ],
                                                [
                                                    0.017,
                                                    -0.06
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.61,
                                                    0
                                                ],
                                                [
                                                    -0.319,
                                                    -0.133
                                                ],
                                                [
                                                    -0.246,
                                                    -0.245
                                                ],
                                                [
                                                    -0.132,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.347
                                                ],
                                                [
                                                    0.157,
                                                    -0.336
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.062,
                                                    -0.176
                                                ],
                                                [
                                                    0.004,
                                                    -0.272
                                                ],
                                                [
                                                    -0.12,
                                                    -0.245
                                                ],
                                                [
                                                    -0.216,
                                                    -0.165
                                                ],
                                                [
                                                    -0.267,
                                                    -0.049
                                                ],
                                                [
                                                    0.11,
                                                    0.15
                                                ],
                                                [
                                                    -0.002,
                                                    0.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    -0.392
                                                ],
                                                [
                                                    0.347,
                                                    0
                                                ],
                                                [
                                                    0.321,
                                                    0.132
                                                ],
                                                [
                                                    0.245,
                                                    0.246
                                                ],
                                                [
                                                    0.133,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.387,
                                                    1.103
                                                ],
                                                [
                                                    1.665,
                                                    0.546
                                                ],
                                                [
                                                    1.76,
                                                    0.001
                                                ],
                                                [
                                                    1.585,
                                                    -0.784
                                                ],
                                                [
                                                    1.075,
                                                    -1.406
                                                ],
                                                [
                                                    0.339,
                                                    -1.732
                                                ],
                                                [
                                                    -0.464,
                                                    -1.691
                                                ],
                                                [
                                                    -0.294,
                                                    -1.173
                                                ],
                                                [
                                                    -0.322,
                                                    -0.99
                                                ],
                                                [
                                                    -1.673,
                                                    -2.034
                                                ],
                                                [
                                                    -0.001,
                                                    -2.641
                                                ],
                                                [
                                                    1.01,
                                                    -2.44
                                                ],
                                                [
                                                    1.868,
                                                    -1.868
                                                ],
                                                [
                                                    2.441,
                                                    -1.011
                                                ],
                                                [
                                                    2.641,
                                                    0.001
                                                ],
                                                [
                                                    2.387,
                                                    1.103
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8353,
                                            0.8275,
                                            0.8275
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            231.329,
                                            208.828
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.676
                                                ],
                                                [
                                                    0.451,
                                                    -0.436
                                                ],
                                                [
                                                    0.917,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.458,
                                                    -0.428
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.654
                                                ],
                                                [
                                                    -0.443,
                                                    0.428
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.886,
                                                    0
                                                ],
                                                [
                                                    0.466,
                                                    0.429
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -20.98,
                                                    -1.437
                                                ],
                                                [
                                                    -21.656,
                                                    0.198
                                                ],
                                                [
                                                    -23.696,
                                                    0.84
                                                ],
                                                [
                                                    -25.207,
                                                    0.84
                                                ],
                                                [
                                                    -25.207,
                                                    4.12
                                                ],
                                                [
                                                    -26.232,
                                                    4.12
                                                ],
                                                [
                                                    -26.232,
                                                    -3.736
                                                ],
                                                [
                                                    -23.696,
                                                    -3.736
                                                ],
                                                [
                                                    -21.679,
                                                    -3.094
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.27,
                                                    0.248
                                                ],
                                                [
                                                    0,
                                                    0.459
                                                ],
                                                [
                                                    1.112,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.571,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    -0.969
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.696,
                                                    -0.005
                                                ],
                                                [
                                                    -22.434,
                                                    -0.377
                                                ],
                                                [
                                                    -22.028,
                                                    -1.437
                                                ],
                                                [
                                                    -23.696,
                                                    -2.891
                                                ],
                                                [
                                                    -25.207,
                                                    -2.891
                                                ],
                                                [
                                                    -25.207,
                                                    -0.005
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    -0.256,
                                                    0.474
                                                ],
                                                [
                                                    -0.443,
                                                    0.263
                                                ],
                                                [
                                                    -0.548,
                                                    0
                                                ],
                                                [
                                                    -0.398,
                                                    -0.233
                                                ],
                                                [
                                                    -0.195,
                                                    -0.353
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.241
                                                ],
                                                [
                                                    0.533,
                                                    0
                                                ],
                                                [
                                                    0.443,
                                                    0.27
                                                ],
                                                [
                                                    0.255,
                                                    0.489
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.255,
                                                    -0.481
                                                ],
                                                [
                                                    0.451,
                                                    -0.263
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.202,
                                                    0.361
                                                ],
                                                [
                                                    -0.398,
                                                    0.233
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    -0.271
                                                ],
                                                [
                                                    -0.256,
                                                    -0.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -20.088,
                                                    1.009
                                                ],
                                                [
                                                    -19.705,
                                                    -0.648
                                                ],
                                                [
                                                    -18.657,
                                                    -1.764
                                                ],
                                                [
                                                    -17.158,
                                                    -2.158
                                                ],
                                                [
                                                    -15.749,
                                                    -1.809
                                                ],
                                                [
                                                    -14.859,
                                                    -0.93
                                                ],
                                                [
                                                    -14.859,
                                                    -2.057
                                                ],
                                                [
                                                    -13.822,
                                                    -2.057
                                                ],
                                                [
                                                    -13.822,
                                                    4.12
                                                ],
                                                [
                                                    -14.859,
                                                    4.12
                                                ],
                                                [
                                                    -14.859,
                                                    2.97
                                                ],
                                                [
                                                    -15.772,
                                                    3.872
                                                ],
                                                [
                                                    -17.169,
                                                    4.221
                                                ],
                                                [
                                                    -18.657,
                                                    3.816
                                                ],
                                                [
                                                    -19.705,
                                                    2.677
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.466
                                                ],
                                                [
                                                    0.187,
                                                    0.346
                                                ],
                                                [
                                                    0.323,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.18
                                                ],
                                                [
                                                    0.188,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.188,
                                                    -0.353
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.315,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.346
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.465
                                                ],
                                                [
                                                    -0.188,
                                                    -0.346
                                                ],
                                                [
                                                    -0.315,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.473
                                                ],
                                                [
                                                    0.188,
                                                    0.346
                                                ],
                                                [
                                                    0.315,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.188
                                                ],
                                                [
                                                    0.187,
                                                    -0.353
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.859,
                                                    1.02
                                                ],
                                                [
                                                    -15.14,
                                                    -0.197
                                                ],
                                                [
                                                    -15.907,
                                                    -0.986
                                                ],
                                                [
                                                    -16.955,
                                                    -1.268
                                                ],
                                                [
                                                    -18.003,
                                                    -0.997
                                                ],
                                                [
                                                    -18.758,
                                                    -0.208
                                                ],
                                                [
                                                    -19.04,
                                                    1.009
                                                ],
                                                [
                                                    -18.758,
                                                    2.249
                                                ],
                                                [
                                                    -18.003,
                                                    3.049
                                                ],
                                                [
                                                    -16.955,
                                                    3.32
                                                ],
                                                [
                                                    -15.907,
                                                    3.049
                                                ],
                                                [
                                                    -15.14,
                                                    2.249
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.444,
                                                    0
                                                ],
                                                [
                                                    0.375,
                                                    0.157
                                                ],
                                                [
                                                    0.218,
                                                    0.286
                                                ],
                                                [
                                                    0.023,
                                                    0.376
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.255,
                                                    -0.195
                                                ],
                                                [
                                                    -0.421,
                                                    0
                                                ],
                                                [
                                                    -0.225,
                                                    0.173
                                                ],
                                                [
                                                    0,
                                                    0.263
                                                ],
                                                [
                                                    0.24,
                                                    0.128
                                                ],
                                                [
                                                    0.503,
                                                    0.127
                                                ],
                                                [
                                                    0.293,
                                                    0.12
                                                ],
                                                [
                                                    0.21,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0.399
                                                ],
                                                [
                                                    -0.188,
                                                    0.263
                                                ],
                                                [
                                                    -0.345,
                                                    0.15
                                                ],
                                                [
                                                    -0.443,
                                                    0
                                                ],
                                                [
                                                    -0.421,
                                                    -0.345
                                                ],
                                                [
                                                    -0.03,
                                                    -0.602
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    0.195
                                                ],
                                                [
                                                    0.398,
                                                    0
                                                ],
                                                [
                                                    0.218,
                                                    -0.158
                                                ],
                                                [
                                                    0,
                                                    -0.255
                                                ],
                                                [
                                                    -0.128,
                                                    -0.136
                                                ],
                                                [
                                                    -0.196,
                                                    -0.082
                                                ],
                                                [
                                                    -0.353,
                                                    -0.097
                                                ],
                                                [
                                                    -0.278,
                                                    -0.12
                                                ],
                                                [
                                                    -0.196,
                                                    -0.233
                                                ],
                                                [
                                                    -0.007,
                                                    -0.376
                                                ],
                                                [
                                                    0.187,
                                                    -0.27
                                                ],
                                                [
                                                    0.346,
                                                    -0.158
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.473,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    -0.166
                                                ],
                                                [
                                                    -0.218,
                                                    -0.293
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.03,
                                                    0.308
                                                ],
                                                [
                                                    0.263,
                                                    0.196
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.226,
                                                    -0.173
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    -0.241,
                                                    -0.135
                                                ],
                                                [
                                                    -0.459,
                                                    -0.121
                                                ],
                                                [
                                                    -0.286,
                                                    -0.128
                                                ],
                                                [
                                                    -0.203,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    -0.315
                                                ],
                                                [
                                                    0.188,
                                                    -0.263
                                                ],
                                                [
                                                    0.346,
                                                    -0.158
                                                ],
                                                [
                                                    0.684,
                                                    0
                                                ],
                                                [
                                                    0.421,
                                                    0.346
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.022,
                                                    -0.324
                                                ],
                                                [
                                                    -0.233,
                                                    -0.195
                                                ],
                                                [
                                                    -0.368,
                                                    0
                                                ],
                                                [
                                                    -0.218,
                                                    0.157
                                                ],
                                                [
                                                    0,
                                                    0.203
                                                ],
                                                [
                                                    0.135,
                                                    0.127
                                                ],
                                                [
                                                    0.203,
                                                    0.075
                                                ],
                                                [
                                                    0.443,
                                                    0.121
                                                ],
                                                [
                                                    0.278,
                                                    0.113
                                                ],
                                                [
                                                    0.203,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0.338
                                                ],
                                                [
                                                    -0.188,
                                                    0.271
                                                ],
                                                [
                                                    -0.338,
                                                    0.15
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.902,
                                                    4.221
                                                ],
                                                [
                                                    -11.175,
                                                    3.985
                                                ],
                                                [
                                                    -12.066,
                                                    3.308
                                                ],
                                                [
                                                    -12.427,
                                                    2.305
                                                ],
                                                [
                                                    -11.367,
                                                    2.305
                                                ],
                                                [
                                                    -10.939,
                                                    3.06
                                                ],
                                                [
                                                    -9.913,
                                                    3.353
                                                ],
                                                [
                                                    -8.989,
                                                    3.094
                                                ],
                                                [
                                                    -8.651,
                                                    2.441
                                                ],
                                                [
                                                    -9.011,
                                                    1.843
                                                ],
                                                [
                                                    -10.127,
                                                    1.449
                                                ],
                                                [
                                                    -11.254,
                                                    1.088
                                                ],
                                                [
                                                    -11.998,
                                                    0.536
                                                ],
                                                [
                                                    -12.303,
                                                    -0.434
                                                ],
                                                [
                                                    -12.021,
                                                    -1.301
                                                ],
                                                [
                                                    -11.221,
                                                    -1.921
                                                ],
                                                [
                                                    -10.037,
                                                    -2.158
                                                ],
                                                [
                                                    -8.38,
                                                    -1.64
                                                ],
                                                [
                                                    -7.704,
                                                    -0.219
                                                ],
                                                [
                                                    -8.73,
                                                    -0.219
                                                ],
                                                [
                                                    -9.124,
                                                    -0.997
                                                ],
                                                [
                                                    -10.071,
                                                    -1.29
                                                ],
                                                [
                                                    -10.95,
                                                    -1.053
                                                ],
                                                [
                                                    -11.277,
                                                    -0.434
                                                ],
                                                [
                                                    -11.085,
                                                    0.074
                                                ],
                                                [
                                                    -10.589,
                                                    0.389
                                                ],
                                                [
                                                    -9.755,
                                                    0.648
                                                ],
                                                [
                                                    -8.673,
                                                    1.009
                                                ],
                                                [
                                                    -7.963,
                                                    1.528
                                                ],
                                                [
                                                    -7.648,
                                                    2.441
                                                ],
                                                [
                                                    -7.929,
                                                    3.353
                                                ],
                                                [
                                                    -8.73,
                                                    3.996
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.443,
                                                    0
                                                ],
                                                [
                                                    0.376,
                                                    0.157
                                                ],
                                                [
                                                    0.218,
                                                    0.286
                                                ],
                                                [
                                                    0.023,
                                                    0.376
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    -0.195
                                                ],
                                                [
                                                    -0.421,
                                                    0
                                                ],
                                                [
                                                    -0.226,
                                                    0.173
                                                ],
                                                [
                                                    0,
                                                    0.263
                                                ],
                                                [
                                                    0.241,
                                                    0.128
                                                ],
                                                [
                                                    0.504,
                                                    0.127
                                                ],
                                                [
                                                    0.293,
                                                    0.12
                                                ],
                                                [
                                                    0.211,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0.399
                                                ],
                                                [
                                                    -0.188,
                                                    0.263
                                                ],
                                                [
                                                    -0.346,
                                                    0.15
                                                ],
                                                [
                                                    -0.444,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    -0.345
                                                ],
                                                [
                                                    -0.03,
                                                    -0.602
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    0.195
                                                ],
                                                [
                                                    0.398,
                                                    0
                                                ],
                                                [
                                                    0.218,
                                                    -0.158
                                                ],
                                                [
                                                    0,
                                                    -0.255
                                                ],
                                                [
                                                    -0.127,
                                                    -0.136
                                                ],
                                                [
                                                    -0.195,
                                                    -0.082
                                                ],
                                                [
                                                    -0.353,
                                                    -0.097
                                                ],
                                                [
                                                    -0.278,
                                                    -0.12
                                                ],
                                                [
                                                    -0.195,
                                                    -0.233
                                                ],
                                                [
                                                    -0.007,
                                                    -0.376
                                                ],
                                                [
                                                    0.188,
                                                    -0.27
                                                ],
                                                [
                                                    0.346,
                                                    -0.158
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.474,
                                                    0
                                                ],
                                                [
                                                    -0.375,
                                                    -0.166
                                                ],
                                                [
                                                    -0.218,
                                                    -0.293
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.03,
                                                    0.308
                                                ],
                                                [
                                                    0.263,
                                                    0.196
                                                ],
                                                [
                                                    0.39,
                                                    0
                                                ],
                                                [
                                                    0.225,
                                                    -0.173
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    -0.24,
                                                    -0.135
                                                ],
                                                [
                                                    -0.458,
                                                    -0.121
                                                ],
                                                [
                                                    -0.285,
                                                    -0.128
                                                ],
                                                [
                                                    -0.202,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    -0.315
                                                ],
                                                [
                                                    0.188,
                                                    -0.263
                                                ],
                                                [
                                                    0.346,
                                                    -0.158
                                                ],
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.421,
                                                    0.346
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.023,
                                                    -0.324
                                                ],
                                                [
                                                    -0.233,
                                                    -0.195
                                                ],
                                                [
                                                    -0.368,
                                                    0
                                                ],
                                                [
                                                    -0.218,
                                                    0.157
                                                ],
                                                [
                                                    0,
                                                    0.203
                                                ],
                                                [
                                                    0.136,
                                                    0.127
                                                ],
                                                [
                                                    0.203,
                                                    0.075
                                                ],
                                                [
                                                    0.444,
                                                    0.121
                                                ],
                                                [
                                                    0.278,
                                                    0.113
                                                ],
                                                [
                                                    0.203,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0.338
                                                ],
                                                [
                                                    -0.188,
                                                    0.271
                                                ],
                                                [
                                                    -0.338,
                                                    0.15
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.013,
                                                    4.221
                                                ],
                                                [
                                                    -5.287,
                                                    3.985
                                                ],
                                                [
                                                    -6.177,
                                                    3.308
                                                ],
                                                [
                                                    -6.538,
                                                    2.305
                                                ],
                                                [
                                                    -5.478,
                                                    2.305
                                                ],
                                                [
                                                    -5.05,
                                                    3.06
                                                ],
                                                [
                                                    -4.024,
                                                    3.353
                                                ],
                                                [
                                                    -3.1,
                                                    3.094
                                                ],
                                                [
                                                    -2.762,
                                                    2.441
                                                ],
                                                [
                                                    -3.123,
                                                    1.843
                                                ],
                                                [
                                                    -4.239,
                                                    1.449
                                                ],
                                                [
                                                    -5.366,
                                                    1.088
                                                ],
                                                [
                                                    -6.11,
                                                    0.536
                                                ],
                                                [
                                                    -6.414,
                                                    -0.434
                                                ],
                                                [
                                                    -6.132,
                                                    -1.301
                                                ],
                                                [
                                                    -5.332,
                                                    -1.921
                                                ],
                                                [
                                                    -4.148,
                                                    -2.158
                                                ],
                                                [
                                                    -2.492,
                                                    -1.64
                                                ],
                                                [
                                                    -1.815,
                                                    -0.219
                                                ],
                                                [
                                                    -2.841,
                                                    -0.219
                                                ],
                                                [
                                                    -3.235,
                                                    -0.997
                                                ],
                                                [
                                                    -4.182,
                                                    -1.29
                                                ],
                                                [
                                                    -5.061,
                                                    -1.053
                                                ],
                                                [
                                                    -5.388,
                                                    -0.434
                                                ],
                                                [
                                                    -5.197,
                                                    0.074
                                                ],
                                                [
                                                    -4.701,
                                                    0.389
                                                ],
                                                [
                                                    -3.867,
                                                    0.648
                                                ],
                                                [
                                                    -2.785,
                                                    1.009
                                                ],
                                                [
                                                    -2.075,
                                                    1.528
                                                ],
                                                [
                                                    -1.759,
                                                    2.441
                                                ],
                                                [
                                                    -2.041,
                                                    3.353
                                                ],
                                                [
                                                    -2.841,
                                                    3.996
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.917,
                                                    -2.057
                                                ],
                                                [
                                                    5.989,
                                                    4.12
                                                ],
                                                [
                                                    4.93,
                                                    4.12
                                                ],
                                                [
                                                    3.442,
                                                    -0.783
                                                ],
                                                [
                                                    1.954,
                                                    4.12
                                                ],
                                                [
                                                    0.895,
                                                    4.12
                                                ],
                                                [
                                                    -1.044,
                                                    -2.057
                                                ],
                                                [
                                                    0.005,
                                                    -2.057
                                                ],
                                                [
                                                    1.425,
                                                    3.128
                                                ],
                                                [
                                                    2.958,
                                                    -2.057
                                                ],
                                                [
                                                    4.006,
                                                    -2.057
                                                ],
                                                [
                                                    5.505,
                                                    3.139
                                                ],
                                                [
                                                    6.902,
                                                    -2.057
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.587,
                                                    0
                                                ],
                                                [
                                                    0.473,
                                                    0.263
                                                ],
                                                [
                                                    0.27,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.27,
                                                    0.481
                                                ],
                                                [
                                                    -0.473,
                                                    0.256
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.474,
                                                    -0.263
                                                ],
                                                [
                                                    -0.271,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -0.638
                                                ],
                                                [
                                                    0.286,
                                                    -0.488
                                                ],
                                                [
                                                    0.481,
                                                    -0.263
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.578,
                                                    0
                                                ],
                                                [
                                                    -0.466,
                                                    -0.263
                                                ],
                                                [
                                                    -0.263,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.278,
                                                    -0.488
                                                ],
                                                [
                                                    0.474,
                                                    -0.263
                                                ],
                                                [
                                                    0.586,
                                                    0
                                                ],
                                                [
                                                    0.473,
                                                    0.256
                                                ],
                                                [
                                                    0.278,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.278,
                                                    0.481
                                                ],
                                                [
                                                    -0.481,
                                                    0.263
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.628,
                                                    4.221
                                                ],
                                                [
                                                    10.051,
                                                    3.827
                                                ],
                                                [
                                                    8.946,
                                                    2.711
                                                ],
                                                [
                                                    8.551,
                                                    1.02
                                                ],
                                                [
                                                    8.957,
                                                    -0.648
                                                ],
                                                [
                                                    10.084,
                                                    -1.764
                                                ],
                                                [
                                                    11.674,
                                                    -2.158
                                                ],
                                                [
                                                    13.263,
                                                    -1.764
                                                ],
                                                [
                                                    14.379,
                                                    -0.659
                                                ],
                                                [
                                                    14.796,
                                                    1.02
                                                ],
                                                [
                                                    14.367,
                                                    2.711
                                                ],
                                                [
                                                    13.229,
                                                    3.827
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.368,
                                                    0
                                                ],
                                                [
                                                    -0.323,
                                                    0.173
                                                ],
                                                [
                                                    -0.195,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.496
                                                ],
                                                [
                                                    0.196,
                                                    0.346
                                                ],
                                                [
                                                    0.316,
                                                    0.165
                                                ],
                                                [
                                                    0.368,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.173
                                                ],
                                                [
                                                    0.188,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.496
                                                ],
                                                [
                                                    -0.18,
                                                    -0.346
                                                ],
                                                [
                                                    -0.308,
                                                    -0.173
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.369,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.172
                                                ],
                                                [
                                                    0.203,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.496
                                                ],
                                                [
                                                    -0.195,
                                                    -0.346
                                                ],
                                                [
                                                    -0.316,
                                                    -0.173
                                                ],
                                                [
                                                    -0.375,
                                                    0
                                                ],
                                                [
                                                    -0.308,
                                                    0.165
                                                ],
                                                [
                                                    -0.187,
                                                    0.346
                                                ],
                                                [
                                                    0,
                                                    0.504
                                                ],
                                                [
                                                    0.188,
                                                    0.346
                                                ],
                                                [
                                                    0.308,
                                                    0.165
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.628,
                                                    3.32
                                                ],
                                                [
                                                    12.665,
                                                    3.06
                                                ],
                                                [
                                                    13.443,
                                                    2.283
                                                ],
                                                [
                                                    13.747,
                                                    1.02
                                                ],
                                                [
                                                    13.454,
                                                    -0.242
                                                ],
                                                [
                                                    12.688,
                                                    -1.008
                                                ],
                                                [
                                                    11.662,
                                                    -1.268
                                                ],
                                                [
                                                    10.625,
                                                    -1.008
                                                ],
                                                [
                                                    9.881,
                                                    -0.242
                                                ],
                                                [
                                                    9.6,
                                                    1.02
                                                ],
                                                [
                                                    9.87,
                                                    2.294
                                                ],
                                                [
                                                    10.614,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.33,
                                                    0.195
                                                ],
                                                [
                                                    -0.481,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.247
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.18,
                                                    -0.354
                                                ],
                                                [
                                                    0.338,
                                                    -0.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.149,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.17,
                                                    -1.053
                                                ],
                                                [
                                                    17.936,
                                                    -1.876
                                                ],
                                                [
                                                    19.165,
                                                    -2.169
                                                ],
                                                [
                                                    19.165,
                                                    -1.11
                                                ],
                                                [
                                                    18.894,
                                                    -1.11
                                                ],
                                                [
                                                    17.17,
                                                    0.761
                                                ],
                                                [
                                                    17.17,
                                                    4.12
                                                ],
                                                [
                                                    16.144,
                                                    4.12
                                                ],
                                                [
                                                    16.144,
                                                    -2.057
                                                ],
                                                [
                                                    17.17,
                                                    -2.057
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    -0.256,
                                                    0.474
                                                ],
                                                [
                                                    -0.443,
                                                    0.263
                                                ],
                                                [
                                                    -0.556,
                                                    0
                                                ],
                                                [
                                                    -0.414,
                                                    -0.225
                                                ],
                                                [
                                                    -0.218,
                                                    -0.361
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    -0.241
                                                ],
                                                [
                                                    0.533,
                                                    0
                                                ],
                                                [
                                                    0.451,
                                                    0.27
                                                ],
                                                [
                                                    0.255,
                                                    0.489
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.255,
                                                    -0.481
                                                ],
                                                [
                                                    0.451,
                                                    -0.263
                                                ],
                                                [
                                                    0.481,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.368
                                                ],
                                                [
                                                    -0.399,
                                                    0.233
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    -0.271
                                                ],
                                                [
                                                    -0.256,
                                                    -0.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    19.965,
                                                    1.009
                                                ],
                                                [
                                                    20.349,
                                                    -0.648
                                                ],
                                                [
                                                    21.397,
                                                    -1.764
                                                ],
                                                [
                                                    22.907,
                                                    -2.158
                                                ],
                                                [
                                                    24.249,
                                                    -1.82
                                                ],
                                                [
                                                    25.195,
                                                    -0.952
                                                ],
                                                [
                                                    25.195,
                                                    -4.221
                                                ],
                                                [
                                                    26.232,
                                                    -4.221
                                                ],
                                                [
                                                    26.232,
                                                    4.12
                                                ],
                                                [
                                                    25.195,
                                                    4.12
                                                ],
                                                [
                                                    25.195,
                                                    2.959
                                                ],
                                                [
                                                    24.294,
                                                    3.872
                                                ],
                                                [
                                                    22.896,
                                                    4.221
                                                ],
                                                [
                                                    21.397,
                                                    3.816
                                                ],
                                                [
                                                    20.349,
                                                    2.677
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.466
                                                ],
                                                [
                                                    0.187,
                                                    0.346
                                                ],
                                                [
                                                    0.323,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.18
                                                ],
                                                [
                                                    0.187,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.188,
                                                    -0.353
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.346
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.465
                                                ],
                                                [
                                                    -0.188,
                                                    -0.346
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.473
                                                ],
                                                [
                                                    0.187,
                                                    0.346
                                                ],
                                                [
                                                    0.315,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.188
                                                ],
                                                [
                                                    0.187,
                                                    -0.353
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.195,
                                                    1.02
                                                ],
                                                [
                                                    24.914,
                                                    -0.197
                                                ],
                                                [
                                                    24.147,
                                                    -0.986
                                                ],
                                                [
                                                    23.099,
                                                    -1.268
                                                ],
                                                [
                                                    22.051,
                                                    -0.997
                                                ],
                                                [
                                                    21.296,
                                                    -0.208
                                                ],
                                                [
                                                    21.014,
                                                    1.009
                                                ],
                                                [
                                                    21.296,
                                                    2.249
                                                ],
                                                [
                                                    22.051,
                                                    3.049
                                                ],
                                                [
                                                    23.099,
                                                    3.32
                                                ],
                                                [
                                                    24.147,
                                                    3.049
                                                ],
                                                [
                                                    24.914,
                                                    2.249
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            47.332,
                                            182.426
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -15.85
                                                ],
                                                [
                                                    108.014,
                                                    -15.85
                                                ],
                                                [
                                                    112.123,
                                                    -11.741
                                                ],
                                                [
                                                    112.123,
                                                    11.741
                                                ],
                                                [
                                                    108.014,
                                                    15.85
                                                ],
                                                [
                                                    -108.014,
                                                    15.85
                                                ],
                                                [
                                                    -112.123,
                                                    11.741
                                                ],
                                                [
                                                    -112.123,
                                                    -11.741
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.174
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8235,
                                            0.8235,
                                            0.8235
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.943,
                                            208.829
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.88,
                                                    -2.784
                                                ],
                                                [
                                                    -14.88,
                                                    -0.158
                                                ],
                                                [
                                                    -12.017,
                                                    -0.158
                                                ],
                                                [
                                                    -12.017,
                                                    0.687
                                                ],
                                                [
                                                    -14.88,
                                                    0.687
                                                ],
                                                [
                                                    -14.88,
                                                    3.392
                                                ],
                                                [
                                                    -11.679,
                                                    3.392
                                                ],
                                                [
                                                    -11.679,
                                                    4.238
                                                ],
                                                [
                                                    -15.906,
                                                    4.238
                                                ],
                                                [
                                                    -15.906,
                                                    -3.629
                                                ],
                                                [
                                                    -11.679,
                                                    -3.629
                                                ],
                                                [
                                                    -11.679,
                                                    -2.784
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.488,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    -0.203
                                                ],
                                                [
                                                    -0.218,
                                                    -0.398
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.308,
                                                    0.323
                                                ],
                                                [
                                                    0.519,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.345
                                                ],
                                                [
                                                    0,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.308,
                                                    0.323
                                                ],
                                                [
                                                    0.519,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.345
                                                ],
                                                [
                                                    0,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.338,
                                                    0.173
                                                ],
                                                [
                                                    -0.413,
                                                    0
                                                ],
                                                [
                                                    -0.398,
                                                    -0.233
                                                ],
                                                [
                                                    -0.196,
                                                    -0.451
                                                ],
                                                [
                                                    -0.398,
                                                    0.241
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.481,
                                                    0
                                                ],
                                                [
                                                    0.376,
                                                    0.195
                                                ],
                                                [
                                                    0.218,
                                                    0.399
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.616
                                                ],
                                                [
                                                    -0.301,
                                                    -0.331
                                                ],
                                                [
                                                    -0.533,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.339
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.616
                                                ],
                                                [
                                                    -0.301,
                                                    -0.331
                                                ],
                                                [
                                                    -0.533,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.339
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.203,
                                                    -0.323
                                                ],
                                                [
                                                    0.345,
                                                    -0.173
                                                ],
                                                [
                                                    0.519,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    0.233
                                                ],
                                                [
                                                    0.172,
                                                    -0.436
                                                ],
                                                [
                                                    0.398,
                                                    -0.24
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.305,
                                                    -2.051
                                                ],
                                                [
                                                    1.59,
                                                    -1.747
                                                ],
                                                [
                                                    2.48,
                                                    -0.857
                                                ],
                                                [
                                                    2.807,
                                                    0.597
                                                ],
                                                [
                                                    2.807,
                                                    4.238
                                                ],
                                                [
                                                    1.793,
                                                    4.238
                                                ],
                                                [
                                                    1.793,
                                                    0.744
                                                ],
                                                [
                                                    1.331,
                                                    -0.665
                                                ],
                                                [
                                                    0.102,
                                                    -1.161
                                                ],
                                                [
                                                    -1.171,
                                                    -0.643
                                                ],
                                                [
                                                    -1.645,
                                                    0.834
                                                ],
                                                [
                                                    -1.645,
                                                    4.238
                                                ],
                                                [
                                                    -2.659,
                                                    4.238
                                                ],
                                                [
                                                    -2.659,
                                                    0.744
                                                ],
                                                [
                                                    -3.121,
                                                    -0.665
                                                ],
                                                [
                                                    -4.35,
                                                    -1.161
                                                ],
                                                [
                                                    -5.623,
                                                    -0.643
                                                ],
                                                [
                                                    -6.097,
                                                    0.834
                                                ],
                                                [
                                                    -6.097,
                                                    4.238
                                                ],
                                                [
                                                    -7.123,
                                                    4.238
                                                ],
                                                [
                                                    -7.123,
                                                    -1.939
                                                ],
                                                [
                                                    -6.097,
                                                    -1.939
                                                ],
                                                [
                                                    -6.097,
                                                    -1.048
                                                ],
                                                [
                                                    -5.285,
                                                    -1.792
                                                ],
                                                [
                                                    -4.147,
                                                    -2.051
                                                ],
                                                [
                                                    -2.772,
                                                    -1.702
                                                ],
                                                [
                                                    -1.881,
                                                    -0.676
                                                ],
                                                [
                                                    -1.025,
                                                    -1.691
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    -0.256,
                                                    0.474
                                                ],
                                                [
                                                    -0.443,
                                                    0.263
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.398,
                                                    -0.233
                                                ],
                                                [
                                                    -0.195,
                                                    -0.353
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.241
                                                ],
                                                [
                                                    0.533,
                                                    0
                                                ],
                                                [
                                                    0.443,
                                                    0.271
                                                ],
                                                [
                                                    0.255,
                                                    0.488
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.255,
                                                    -0.481
                                                ],
                                                [
                                                    0.451,
                                                    -0.263
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.361
                                                ],
                                                [
                                                    -0.398,
                                                    0.233
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    -0.27
                                                ],
                                                [
                                                    -0.256,
                                                    -0.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.106,
                                                    1.127
                                                ],
                                                [
                                                    4.49,
                                                    -0.53
                                                ],
                                                [
                                                    5.538,
                                                    -1.646
                                                ],
                                                [
                                                    7.037,
                                                    -2.04
                                                ],
                                                [
                                                    8.446,
                                                    -1.691
                                                ],
                                                [
                                                    9.336,
                                                    -0.812
                                                ],
                                                [
                                                    9.336,
                                                    -1.939
                                                ],
                                                [
                                                    10.373,
                                                    -1.939
                                                ],
                                                [
                                                    10.373,
                                                    4.238
                                                ],
                                                [
                                                    9.336,
                                                    4.238
                                                ],
                                                [
                                                    9.336,
                                                    3.088
                                                ],
                                                [
                                                    8.423,
                                                    3.99
                                                ],
                                                [
                                                    7.026,
                                                    4.339
                                                ],
                                                [
                                                    5.538,
                                                    3.933
                                                ],
                                                [
                                                    4.49,
                                                    2.795
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.466
                                                ],
                                                [
                                                    0.188,
                                                    0.346
                                                ],
                                                [
                                                    0.323,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.181
                                                ],
                                                [
                                                    0.188,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.187,
                                                    -0.353
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.187,
                                                    0.345
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.187,
                                                    -0.346
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.187,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.473
                                                ],
                                                [
                                                    0.188,
                                                    0.345
                                                ],
                                                [
                                                    0.315,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.188
                                                ],
                                                [
                                                    0.188,
                                                    -0.353
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.336,
                                                    1.138
                                                ],
                                                [
                                                    9.054,
                                                    -0.079
                                                ],
                                                [
                                                    8.288,
                                                    -0.868
                                                ],
                                                [
                                                    7.24,
                                                    -1.15
                                                ],
                                                [
                                                    6.192,
                                                    -0.879
                                                ],
                                                [
                                                    5.436,
                                                    -0.09
                                                ],
                                                [
                                                    5.155,
                                                    1.127
                                                ],
                                                [
                                                    5.436,
                                                    2.367
                                                ],
                                                [
                                                    6.192,
                                                    3.167
                                                ],
                                                [
                                                    7.24,
                                                    3.438
                                                ],
                                                [
                                                    8.288,
                                                    3.167
                                                ],
                                                [
                                                    9.054,
                                                    2.367
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.188,
                                                    0
                                                ],
                                                [
                                                    0.135,
                                                    0.136
                                                ],
                                                [
                                                    0,
                                                    0.196
                                                ],
                                                [
                                                    -0.135,
                                                    0.136
                                                ],
                                                [
                                                    -0.195,
                                                    0
                                                ],
                                                [
                                                    -0.128,
                                                    -0.135
                                                ],
                                                [
                                                    0,
                                                    -0.195
                                                ],
                                                [
                                                    0.135,
                                                    -0.135
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.195,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    -0.135
                                                ],
                                                [
                                                    0,
                                                    -0.195
                                                ],
                                                [
                                                    0.135,
                                                    -0.135
                                                ],
                                                [
                                                    0.188,
                                                    0
                                                ],
                                                [
                                                    0.135,
                                                    0.136
                                                ],
                                                [
                                                    0,
                                                    0.196
                                                ],
                                                [
                                                    -0.128,
                                                    0.136
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.636,
                                                    -2.942
                                                ],
                                                [
                                                    12.14,
                                                    -3.145
                                                ],
                                                [
                                                    11.937,
                                                    -3.641
                                                ],
                                                [
                                                    12.14,
                                                    -4.137
                                                ],
                                                [
                                                    12.636,
                                                    -4.339
                                                ],
                                                [
                                                    13.11,
                                                    -4.137
                                                ],
                                                [
                                                    13.312,
                                                    -3.641
                                                ],
                                                [
                                                    13.11,
                                                    -3.145
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.132,
                                                    -1.939
                                                ],
                                                [
                                                    13.132,
                                                    4.238
                                                ],
                                                [
                                                    12.106,
                                                    4.238
                                                ],
                                                [
                                                    12.106,
                                                    -1.939
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.906,
                                                    -4.103
                                                ],
                                                [
                                                    15.906,
                                                    4.238
                                                ],
                                                [
                                                    14.88,
                                                    4.238
                                                ],
                                                [
                                                    14.88,
                                                    -4.103
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            37.006,
                                            125.48
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -15.85
                                                ],
                                                [
                                                    108.014,
                                                    -15.85
                                                ],
                                                [
                                                    112.123,
                                                    -11.741
                                                ],
                                                [
                                                    112.123,
                                                    11.741
                                                ],
                                                [
                                                    108.014,
                                                    15.85
                                                ],
                                                [
                                                    -108.014,
                                                    15.85
                                                ],
                                                [
                                                    -112.123,
                                                    11.741
                                                ],
                                                [
                                                    -112.123,
                                                    -11.741
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.174
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8235,
                                            0.8235,
                                            0.8235
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.943,
                                            152.001
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -10.218,
                                                    3.883
                                                ],
                                                [
                                                    -11.244,
                                                    3.883
                                                ],
                                                [
                                                    -15.369,
                                                    -2.373
                                                ],
                                                [
                                                    -15.369,
                                                    3.883
                                                ],
                                                [
                                                    -16.395,
                                                    3.883
                                                ],
                                                [
                                                    -16.395,
                                                    -3.984
                                                ],
                                                [
                                                    -15.369,
                                                    -3.984
                                                ],
                                                [
                                                    -11.244,
                                                    2.26
                                                ],
                                                [
                                                    -11.244,
                                                    -3.984
                                                ],
                                                [
                                                    -10.218,
                                                    -3.984
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    -0.255,
                                                    0.474
                                                ],
                                                [
                                                    -0.443,
                                                    0.263
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.398,
                                                    -0.233
                                                ],
                                                [
                                                    -0.196,
                                                    -0.353
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.241
                                                ],
                                                [
                                                    0.534,
                                                    0
                                                ],
                                                [
                                                    0.444,
                                                    0.271
                                                ],
                                                [
                                                    0.256,
                                                    0.488
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.256,
                                                    -0.481
                                                ],
                                                [
                                                    0.451,
                                                    -0.263
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.399,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.361
                                                ],
                                                [
                                                    -0.398,
                                                    0.233
                                                ],
                                                [
                                                    -0.548,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    -0.27
                                                ],
                                                [
                                                    -0.255,
                                                    -0.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -8.853,
                                                    0.772
                                                ],
                                                [
                                                    -8.47,
                                                    -0.885
                                                ],
                                                [
                                                    -7.422,
                                                    -2.001
                                                ],
                                                [
                                                    -5.922,
                                                    -2.395
                                                ],
                                                [
                                                    -4.514,
                                                    -2.046
                                                ],
                                                [
                                                    -3.623,
                                                    -1.167
                                                ],
                                                [
                                                    -3.623,
                                                    -2.294
                                                ],
                                                [
                                                    -2.586,
                                                    -2.294
                                                ],
                                                [
                                                    -2.586,
                                                    3.883
                                                ],
                                                [
                                                    -3.623,
                                                    3.883
                                                ],
                                                [
                                                    -3.623,
                                                    2.733
                                                ],
                                                [
                                                    -4.536,
                                                    3.635
                                                ],
                                                [
                                                    -5.934,
                                                    3.984
                                                ],
                                                [
                                                    -7.422,
                                                    3.578
                                                ],
                                                [
                                                    -8.47,
                                                    2.44
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.466
                                                ],
                                                [
                                                    0.188,
                                                    0.346
                                                ],
                                                [
                                                    0.323,
                                                    0.18
                                                ],
                                                [
                                                    0.384,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.181
                                                ],
                                                [
                                                    0.188,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.188,
                                                    -0.353
                                                ],
                                                [
                                                    -0.315,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.345
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.188,
                                                    -0.346
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.315,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.473
                                                ],
                                                [
                                                    0.188,
                                                    0.345
                                                ],
                                                [
                                                    0.316,
                                                    0.18
                                                ],
                                                [
                                                    0.384,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.188
                                                ],
                                                [
                                                    0.188,
                                                    -0.353
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.623,
                                                    0.783
                                                ],
                                                [
                                                    -3.905,
                                                    -0.434
                                                ],
                                                [
                                                    -4.671,
                                                    -1.223
                                                ],
                                                [
                                                    -5.72,
                                                    -1.505
                                                ],
                                                [
                                                    -6.768,
                                                    -1.234
                                                ],
                                                [
                                                    -7.523,
                                                    -0.445
                                                ],
                                                [
                                                    -7.805,
                                                    0.772
                                                ],
                                                [
                                                    -7.523,
                                                    2.012
                                                ],
                                                [
                                                    -6.768,
                                                    2.812
                                                ],
                                                [
                                                    -5.72,
                                                    3.083
                                                ],
                                                [
                                                    -4.671,
                                                    2.812
                                                ],
                                                [
                                                    -3.905,
                                                    2.012
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.489,
                                                    0
                                                ],
                                                [
                                                    -0.375,
                                                    -0.203
                                                ],
                                                [
                                                    -0.218,
                                                    -0.398
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.308,
                                                    0.323
                                                ],
                                                [
                                                    0.518,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.308,
                                                    0.323
                                                ],
                                                [
                                                    0.518,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.338,
                                                    0.173
                                                ],
                                                [
                                                    -0.414,
                                                    0
                                                ],
                                                [
                                                    -0.399,
                                                    -0.233
                                                ],
                                                [
                                                    -0.195,
                                                    -0.451
                                                ],
                                                [
                                                    -0.399,
                                                    0.241
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.376,
                                                    0.195
                                                ],
                                                [
                                                    0.218,
                                                    0.399
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.616
                                                ],
                                                [
                                                    -0.3,
                                                    -0.331
                                                ],
                                                [
                                                    -0.534,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.616
                                                ],
                                                [
                                                    -0.3,
                                                    -0.331
                                                ],
                                                [
                                                    -0.534,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.203,
                                                    -0.323
                                                ],
                                                [
                                                    0.346,
                                                    -0.173
                                                ],
                                                [
                                                    0.518,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    0.233
                                                ],
                                                [
                                                    0.173,
                                                    -0.436
                                                ],
                                                [
                                                    0.398,
                                                    -0.24
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.575,
                                                    -2.406
                                                ],
                                                [
                                                    7.859,
                                                    -2.102
                                                ],
                                                [
                                                    8.75,
                                                    -1.212
                                                ],
                                                [
                                                    9.077,
                                                    0.242
                                                ],
                                                [
                                                    9.077,
                                                    3.883
                                                ],
                                                [
                                                    8.062,
                                                    3.883
                                                ],
                                                [
                                                    8.062,
                                                    0.389
                                                ],
                                                [
                                                    7.6,
                                                    -1.02
                                                ],
                                                [
                                                    6.372,
                                                    -1.516
                                                ],
                                                [
                                                    5.098,
                                                    -0.997
                                                ],
                                                [
                                                    4.625,
                                                    0.479
                                                ],
                                                [
                                                    4.625,
                                                    3.883
                                                ],
                                                [
                                                    3.61,
                                                    3.883
                                                ],
                                                [
                                                    3.61,
                                                    0.389
                                                ],
                                                [
                                                    3.148,
                                                    -1.02
                                                ],
                                                [
                                                    1.92,
                                                    -1.516
                                                ],
                                                [
                                                    0.646,
                                                    -0.997
                                                ],
                                                [
                                                    0.173,
                                                    0.479
                                                ],
                                                [
                                                    0.173,
                                                    3.883
                                                ],
                                                [
                                                    -0.853,
                                                    3.883
                                                ],
                                                [
                                                    -0.853,
                                                    -2.294
                                                ],
                                                [
                                                    0.173,
                                                    -2.294
                                                ],
                                                [
                                                    0.173,
                                                    -1.403
                                                ],
                                                [
                                                    0.984,
                                                    -2.147
                                                ],
                                                [
                                                    2.123,
                                                    -2.406
                                                ],
                                                [
                                                    3.498,
                                                    -2.057
                                                ],
                                                [
                                                    4.388,
                                                    -1.031
                                                ],
                                                [
                                                    5.245,
                                                    -2.046
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.564
                                                ],
                                                [
                                                    0.022,
                                                    -0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    -0.345
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.293,
                                                    0.203
                                                ],
                                                [
                                                    -0.12,
                                                    0.346
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.496,
                                                    -0.376
                                                ],
                                                [
                                                    0.737,
                                                    0
                                                ],
                                                [
                                                    0.466,
                                                    0.263
                                                ],
                                                [
                                                    0.263,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.255,
                                                    0.481
                                                ],
                                                [
                                                    -0.458,
                                                    0.256
                                                ],
                                                [
                                                    -0.601,
                                                    0
                                                ],
                                                [
                                                    -0.451,
                                                    -0.255
                                                ],
                                                [
                                                    -0.241,
                                                    -0.451
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.038,
                                                    0.608
                                                ],
                                                [
                                                    0.383,
                                                    0.338
                                                ],
                                                [
                                                    0.444,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.166,
                                                    0.594
                                                ],
                                                [
                                                    -0.496,
                                                    0.368
                                                ],
                                                [
                                                    -0.586,
                                                    0
                                                ],
                                                [
                                                    -0.458,
                                                    -0.263
                                                ],
                                                [
                                                    -0.263,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    -0.638
                                                ],
                                                [
                                                    0.256,
                                                    -0.481
                                                ],
                                                [
                                                    0.466,
                                                    -0.263
                                                ],
                                                [
                                                    0.587,
                                                    0
                                                ],
                                                [
                                                    0.451,
                                                    0.256
                                                ],
                                                [
                                                    0.248,
                                                    0.443
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.395,
                                                    0.558
                                                ],
                                                [
                                                    16.361,
                                                    1.178
                                                ],
                                                [
                                                    11.424,
                                                    1.178
                                                ],
                                                [
                                                    12.044,
                                                    2.609
                                                ],
                                                [
                                                    13.43,
                                                    3.116
                                                ],
                                                [
                                                    14.535,
                                                    2.812
                                                ],
                                                [
                                                    15.166,
                                                    1.978
                                                ],
                                                [
                                                    16.271,
                                                    1.978
                                                ],
                                                [
                                                    15.279,
                                                    3.432
                                                ],
                                                [
                                                    13.43,
                                                    3.984
                                                ],
                                                [
                                                    11.852,
                                                    3.59
                                                ],
                                                [
                                                    10.77,
                                                    2.474
                                                ],
                                                [
                                                    10.376,
                                                    0.783
                                                ],
                                                [
                                                    10.759,
                                                    -0.896
                                                ],
                                                [
                                                    11.83,
                                                    -2.001
                                                ],
                                                [
                                                    13.43,
                                                    -2.395
                                                ],
                                                [
                                                    14.986,
                                                    -2.012
                                                ],
                                                [
                                                    16.023,
                                                    -0.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.173,
                                                    0.278
                                                ],
                                                [
                                                    0.3,
                                                    0.143
                                                ],
                                                [
                                                    0.361,
                                                    0
                                                ],
                                                [
                                                    0.369,
                                                    -0.331
                                                ],
                                                [
                                                    0.053,
                                                    -0.586
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.391
                                                ],
                                                [
                                                    -0.173,
                                                    -0.286
                                                ],
                                                [
                                                    -0.293,
                                                    -0.15
                                                ],
                                                [
                                                    -0.518,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    0.33
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.335,
                                                    0.344
                                                ],
                                                [
                                                    15.076,
                                                    -0.659
                                                ],
                                                [
                                                    14.366,
                                                    -1.302
                                                ],
                                                [
                                                    13.385,
                                                    -1.527
                                                ],
                                                [
                                                    12.055,
                                                    -1.031
                                                ],
                                                [
                                                    11.435,
                                                    0.344
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            37.495,
                                            69.019
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -15.85
                                                ],
                                                [
                                                    108.014,
                                                    -15.85
                                                ],
                                                [
                                                    112.123,
                                                    -11.741
                                                ],
                                                [
                                                    112.123,
                                                    11.741
                                                ],
                                                [
                                                    108.014,
                                                    15.85
                                                ],
                                                [
                                                    -108.014,
                                                    15.85
                                                ],
                                                [
                                                    -112.123,
                                                    11.741
                                                ],
                                                [
                                                    -112.123,
                                                    -11.741
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.174
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8235,
                                            0.8235,
                                            0.8235
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.943,
                                            95.184
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.601,
                                                    0.325
                                                ],
                                                [
                                                    0.789,
                                                    0
                                                ],
                                                [
                                                    0.676,
                                                    -0.388
                                                ],
                                                [
                                                    0.388,
                                                    -0.714
                                                ],
                                                [
                                                    0,
                                                    -0.94
                                                ],
                                                [
                                                    -0.376,
                                                    -0.726
                                                ],
                                                [
                                                    -0.676,
                                                    -0.388
                                                ],
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.726,
                                                    0.651
                                                ],
                                                [
                                                    -0.163,
                                                    1.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.588,
                                                    -0.851
                                                ],
                                                [
                                                    0.939,
                                                    -0.514
                                                ],
                                                [
                                                    1.14,
                                                    0
                                                ],
                                                [
                                                    1.014,
                                                    0.563
                                                ],
                                                [
                                                    0.601,
                                                    1.015
                                                ],
                                                [
                                                    0,
                                                    1.277
                                                ],
                                                [
                                                    -0.589,
                                                    1.014
                                                ],
                                                [
                                                    -1.015,
                                                    0.564
                                                ],
                                                [
                                                    -1.214,
                                                    0
                                                ],
                                                [
                                                    -1.077,
                                                    -0.689
                                                ],
                                                [
                                                    -0.488,
                                                    -1.252
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.338,
                                                    -0.651
                                                ],
                                                [
                                                    -0.602,
                                                    -0.338
                                                ],
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.676,
                                                    0.388
                                                ],
                                                [
                                                    -0.376,
                                                    0.714
                                                ],
                                                [
                                                    0,
                                                    0.939
                                                ],
                                                [
                                                    0.388,
                                                    0.714
                                                ],
                                                [
                                                    0.676,
                                                    0.388
                                                ],
                                                [
                                                    1.165,
                                                    0
                                                ],
                                                [
                                                    0.726,
                                                    -0.652
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.137,
                                                    1.015
                                                ],
                                                [
                                                    -0.576,
                                                    0.852
                                                ],
                                                [
                                                    -0.927,
                                                    0.501
                                                ],
                                                [
                                                    -1.227,
                                                    0
                                                ],
                                                [
                                                    -1.015,
                                                    -0.576
                                                ],
                                                [
                                                    -0.589,
                                                    -1.014
                                                ],
                                                [
                                                    0,
                                                    -1.278
                                                ],
                                                [
                                                    0.601,
                                                    -1.015
                                                ],
                                                [
                                                    1.027,
                                                    -0.576
                                                ],
                                                [
                                                    1.39,
                                                    0
                                                ],
                                                [
                                                    1.09,
                                                    0.676
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -81.375,
                                                    -2.132
                                                ],
                                                [
                                                    -82.783,
                                                    -3.597
                                                ],
                                                [
                                                    -84.869,
                                                    -4.105
                                                ],
                                                [
                                                    -87.179,
                                                    -3.522
                                                ],
                                                [
                                                    -88.776,
                                                    -1.869
                                                ],
                                                [
                                                    -89.339,
                                                    0.611
                                                ],
                                                [
                                                    -88.776,
                                                    3.109
                                                ],
                                                [
                                                    -87.179,
                                                    4.762
                                                ],
                                                [
                                                    -84.869,
                                                    5.344
                                                ],
                                                [
                                                    -82.032,
                                                    4.368
                                                ],
                                                [
                                                    -80.698,
                                                    1.719
                                                ],
                                                [
                                                    -85.601,
                                                    1.719
                                                ],
                                                [
                                                    -85.601,
                                                    0.009
                                                ],
                                                [
                                                    -78.407,
                                                    0.009
                                                ],
                                                [
                                                    -78.407,
                                                    1.681
                                                ],
                                                [
                                                    -79.496,
                                                    4.48
                                                ],
                                                [
                                                    -81.769,
                                                    6.528
                                                ],
                                                [
                                                    -84.869,
                                                    7.279
                                                ],
                                                [
                                                    -88.231,
                                                    6.434
                                                ],
                                                [
                                                    -90.654,
                                                    4.048
                                                ],
                                                [
                                                    -91.537,
                                                    0.611
                                                ],
                                                [
                                                    -90.654,
                                                    -2.827
                                                ],
                                                [
                                                    -88.231,
                                                    -5.194
                                                ],
                                                [
                                                    -84.869,
                                                    -6.058
                                                ],
                                                [
                                                    -81.168,
                                                    -5.025
                                                ],
                                                [
                                                    -78.801,
                                                    -2.132
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -1.002
                                                ],
                                                [
                                                    0.05,
                                                    -0.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.501
                                                ],
                                                [
                                                    -0.802,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.826,
                                                    -0.614
                                                ],
                                                [
                                                    1.214,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.425,
                                                    0.801
                                                ],
                                                [
                                                    -0.777,
                                                    0.439
                                                ],
                                                [
                                                    -1.015,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -0.426
                                                ],
                                                [
                                                    -0.425,
                                                    -0.777
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.826
                                                ],
                                                [
                                                    0.551,
                                                    0.501
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.952
                                                ],
                                                [
                                                    -0.814,
                                                    0.601
                                                ],
                                                [
                                                    -0.99,
                                                    0
                                                ],
                                                [
                                                    -0.776,
                                                    -0.451
                                                ],
                                                [
                                                    -0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.065
                                                ],
                                                [
                                                    0.439,
                                                    -0.814
                                                ],
                                                [
                                                    0.789,
                                                    -0.438
                                                ],
                                                [
                                                    0.976,
                                                    0
                                                ],
                                                [
                                                    0.764,
                                                    0.425
                                                ],
                                                [
                                                    0.426,
                                                    0.764
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -66.808,
                                                    1.738
                                                ],
                                                [
                                                    -66.883,
                                                    2.79
                                                ],
                                                [
                                                    -74.792,
                                                    2.79
                                                ],
                                                [
                                                    -73.871,
                                                    4.781
                                                ],
                                                [
                                                    -71.842,
                                                    5.532
                                                ],
                                                [
                                                    -69.4,
                                                    4.086
                                                ],
                                                [
                                                    -67.09,
                                                    4.086
                                                ],
                                                [
                                                    -68.799,
                                                    6.434
                                                ],
                                                [
                                                    -71.842,
                                                    7.336
                                                ],
                                                [
                                                    -74.51,
                                                    6.678
                                                ],
                                                [
                                                    -76.351,
                                                    4.8
                                                ],
                                                [
                                                    -77.008,
                                                    1.982
                                                ],
                                                [
                                                    -76.37,
                                                    -0.817
                                                ],
                                                [
                                                    -74.547,
                                                    -2.696
                                                ],
                                                [
                                                    -71.842,
                                                    -3.353
                                                ],
                                                [
                                                    -69.231,
                                                    -2.714
                                                ],
                                                [
                                                    -67.447,
                                                    -0.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.476
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    -0.476
                                                ],
                                                [
                                                    0.1,
                                                    -0.801
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.013,
                                                    -0.789
                                                ],
                                                [
                                                    -0.551,
                                                    -0.476
                                                ],
                                                [
                                                    -0.739,
                                                    0
                                                ],
                                                [
                                                    -0.526,
                                                    0.463
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -69.043,
                                                    1.061
                                                ],
                                                [
                                                    -69.889,
                                                    -0.836
                                                ],
                                                [
                                                    -71.936,
                                                    -1.55
                                                ],
                                                [
                                                    -73.834,
                                                    -0.836
                                                ],
                                                [
                                                    -74.773,
                                                    1.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.176,
                                                    -0.176
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    0.451
                                                ],
                                                [
                                                    0,
                                                    1.015
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.389
                                                ],
                                                [
                                                    0.188,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.964,
                                                    0
                                                ],
                                                [
                                                    -0.514,
                                                    -0.451
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -62.202,
                                                    -1.437
                                                ],
                                                [
                                                    -62.202,
                                                    4.292
                                                ],
                                                [
                                                    -61.939,
                                                    5.138
                                                ],
                                                [
                                                    -61,
                                                    5.382
                                                ],
                                                [
                                                    -59.685,
                                                    5.382
                                                ],
                                                [
                                                    -59.685,
                                                    7.166
                                                ],
                                                [
                                                    -61.376,
                                                    7.166
                                                ],
                                                [
                                                    -63.592,
                                                    6.49
                                                ],
                                                [
                                                    -64.362,
                                                    4.292
                                                ],
                                                [
                                                    -64.362,
                                                    -1.437
                                                ],
                                                [
                                                    -65.583,
                                                    -1.437
                                                ],
                                                [
                                                    -65.583,
                                                    -3.184
                                                ],
                                                [
                                                    -64.362,
                                                    -3.184
                                                ],
                                                [
                                                    -64.362,
                                                    -5.758
                                                ],
                                                [
                                                    -62.202,
                                                    -5.758
                                                ],
                                                [
                                                    -62.202,
                                                    -3.184
                                                ],
                                                [
                                                    -59.685,
                                                    -3.184
                                                ],
                                                [
                                                    -59.685,
                                                    -1.437
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.927,
                                                    0
                                                ],
                                                [
                                                    0.702,
                                                    0.301
                                                ],
                                                [
                                                    0.401,
                                                    0.564
                                                ],
                                                [
                                                    0,
                                                    0.751
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.388,
                                                    -0.363
                                                ],
                                                [
                                                    -0.714,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    0.35
                                                ],
                                                [
                                                    0,
                                                    0.563
                                                ],
                                                [
                                                    0.263,
                                                    0.275
                                                ],
                                                [
                                                    0.388,
                                                    0.15
                                                ],
                                                [
                                                    0.676,
                                                    0.175
                                                ],
                                                [
                                                    0.538,
                                                    0.226
                                                ],
                                                [
                                                    0.376,
                                                    0.488
                                                ],
                                                [
                                                    0,
                                                    0.814
                                                ],
                                                [
                                                    -0.375,
                                                    0.563
                                                ],
                                                [
                                                    -0.676,
                                                    0.3
                                                ],
                                                [
                                                    -0.889,
                                                    0
                                                ],
                                                [
                                                    -0.802,
                                                    -0.639
                                                ],
                                                [
                                                    -0.087,
                                                    -1.102
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.338
                                                ],
                                                [
                                                    0.676,
                                                    0
                                                ],
                                                [
                                                    0.388,
                                                    -0.313
                                                ],
                                                [
                                                    0,
                                                    -0.588
                                                ],
                                                [
                                                    -0.238,
                                                    -0.263
                                                ],
                                                [
                                                    -0.376,
                                                    -0.15
                                                ],
                                                [
                                                    -0.651,
                                                    -0.175
                                                ],
                                                [
                                                    -0.538,
                                                    -0.238
                                                ],
                                                [
                                                    -0.375,
                                                    -0.501
                                                ],
                                                [
                                                    0,
                                                    -0.827
                                                ],
                                                [
                                                    0.363,
                                                    -0.588
                                                ],
                                                [
                                                    0.688,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.701,
                                                    -0.313
                                                ],
                                                [
                                                    -0.401,
                                                    -0.563
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.05,
                                                    0.563
                                                ],
                                                [
                                                    0.401,
                                                    0.363
                                                ],
                                                [
                                                    0.739,
                                                    0
                                                ],
                                                [
                                                    0.414,
                                                    -0.364
                                                ],
                                                [
                                                    0,
                                                    -0.439
                                                ],
                                                [
                                                    -0.251,
                                                    -0.276
                                                ],
                                                [
                                                    -0.376,
                                                    -0.15
                                                ],
                                                [
                                                    -0.852,
                                                    -0.226
                                                ],
                                                [
                                                    -0.526,
                                                    -0.237
                                                ],
                                                [
                                                    -0.375,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    -0.751
                                                ],
                                                [
                                                    0.376,
                                                    -0.564
                                                ],
                                                [
                                                    0.676,
                                                    -0.301
                                                ],
                                                [
                                                    1.265,
                                                    0
                                                ],
                                                [
                                                    0.814,
                                                    0.626
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.037,
                                                    -0.476
                                                ],
                                                [
                                                    -0.413,
                                                    -0.338
                                                ],
                                                [
                                                    -0.614,
                                                    0
                                                ],
                                                [
                                                    -0.388,
                                                    0.313
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.25,
                                                    0.25
                                                ],
                                                [
                                                    0.376,
                                                    0.15
                                                ],
                                                [
                                                    0.864,
                                                    0.238
                                                ],
                                                [
                                                    0.551,
                                                    0.238
                                                ],
                                                [
                                                    0.389,
                                                    0.489
                                                ],
                                                [
                                                    0,
                                                    0.664
                                                ],
                                                [
                                                    -0.351,
                                                    0.589
                                                ],
                                                [
                                                    -0.677,
                                                    0.351
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -48.53,
                                                    7.298
                                                ],
                                                [
                                                    -50.897,
                                                    6.847
                                                ],
                                                [
                                                    -52.55,
                                                    5.532
                                                ],
                                                [
                                                    -53.151,
                                                    3.56
                                                ],
                                                [
                                                    -50.859,
                                                    3.56
                                                ],
                                                [
                                                    -50.202,
                                                    4.95
                                                ],
                                                [
                                                    -48.53,
                                                    5.495
                                                ],
                                                [
                                                    -46.802,
                                                    4.969
                                                ],
                                                [
                                                    -46.182,
                                                    3.579
                                                ],
                                                [
                                                    -46.576,
                                                    2.508
                                                ],
                                                [
                                                    -47.534,
                                                    1.869
                                                ],
                                                [
                                                    -49.112,
                                                    1.381
                                                ],
                                                [
                                                    -51.197,
                                                    0.704
                                                ],
                                                [
                                                    -52.55,
                                                    -0.385
                                                ],
                                                [
                                                    -53.113,
                                                    -2.339
                                                ],
                                                [
                                                    -52.55,
                                                    -4.311
                                                ],
                                                [
                                                    -50.972,
                                                    -5.607
                                                ],
                                                [
                                                    -48.624,
                                                    -6.058
                                                ],
                                                [
                                                    -45.524,
                                                    -5.1
                                                ],
                                                [
                                                    -44.172,
                                                    -2.508
                                                ],
                                                [
                                                    -46.539,
                                                    -2.508
                                                ],
                                                [
                                                    -47.215,
                                                    -3.729
                                                ],
                                                [
                                                    -48.849,
                                                    -4.236
                                                ],
                                                [
                                                    -50.352,
                                                    -3.766
                                                ],
                                                [
                                                    -50.934,
                                                    -2.414
                                                ],
                                                [
                                                    -50.577,
                                                    -1.418
                                                ],
                                                [
                                                    -49.638,
                                                    -0.817
                                                ],
                                                [
                                                    -48.098,
                                                    -0.329
                                                ],
                                                [
                                                    -45.994,
                                                    0.385
                                                ],
                                                [
                                                    -44.604,
                                                    1.493
                                                ],
                                                [
                                                    -44.021,
                                                    3.466
                                                ],
                                                [
                                                    -44.566,
                                                    5.344
                                                ],
                                                [
                                                    -46.125,
                                                    6.772
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.175,
                                                    -0.176
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    0.451
                                                ],
                                                [
                                                    0,
                                                    1.015
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.389
                                                ],
                                                [
                                                    0.188,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.964,
                                                    0
                                                ],
                                                [
                                                    -0.514,
                                                    -0.451
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.996,
                                                    -1.437
                                                ],
                                                [
                                                    -38.996,
                                                    4.292
                                                ],
                                                [
                                                    -38.733,
                                                    5.138
                                                ],
                                                [
                                                    -37.794,
                                                    5.382
                                                ],
                                                [
                                                    -36.479,
                                                    5.382
                                                ],
                                                [
                                                    -36.479,
                                                    7.166
                                                ],
                                                [
                                                    -38.17,
                                                    7.166
                                                ],
                                                [
                                                    -40.386,
                                                    6.49
                                                ],
                                                [
                                                    -41.156,
                                                    4.292
                                                ],
                                                [
                                                    -41.156,
                                                    -1.437
                                                ],
                                                [
                                                    -42.377,
                                                    -1.437
                                                ],
                                                [
                                                    -42.377,
                                                    -3.184
                                                ],
                                                [
                                                    -41.156,
                                                    -3.184
                                                ],
                                                [
                                                    -41.156,
                                                    -5.758
                                                ],
                                                [
                                                    -38.996,
                                                    -5.758
                                                ],
                                                [
                                                    -38.996,
                                                    -3.184
                                                ],
                                                [
                                                    -36.479,
                                                    -3.184
                                                ],
                                                [
                                                    -36.479,
                                                    -1.437
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    1.04
                                                ],
                                                [
                                                    -0.426,
                                                    0.801
                                                ],
                                                [
                                                    -0.738,
                                                    0.438
                                                ],
                                                [
                                                    -0.902,
                                                    0
                                                ],
                                                [
                                                    -0.601,
                                                    -0.325
                                                ],
                                                [
                                                    -0.363,
                                                    -0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.626,
                                                    -0.325
                                                ],
                                                [
                                                    0.801,
                                                    0
                                                ],
                                                [
                                                    0.739,
                                                    0.451
                                                ],
                                                [
                                                    0.438,
                                                    0.814
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -1.039
                                                ],
                                                [
                                                    0.438,
                                                    -0.802
                                                ],
                                                [
                                                    0.752,
                                                    -0.451
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.613,
                                                    0.313
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    0.489
                                                ],
                                                [
                                                    -0.626,
                                                    0.326
                                                ],
                                                [
                                                    -0.89,
                                                    0
                                                ],
                                                [
                                                    -0.738,
                                                    -0.463
                                                ],
                                                [
                                                    -0.426,
                                                    -0.826
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -35.219,
                                                    1.944
                                                ],
                                                [
                                                    -34.58,
                                                    -0.817
                                                ],
                                                [
                                                    -32.815,
                                                    -2.677
                                                ],
                                                [
                                                    -30.335,
                                                    -3.353
                                                ],
                                                [
                                                    -28.212,
                                                    -2.865
                                                ],
                                                [
                                                    -26.747,
                                                    -1.681
                                                ],
                                                [
                                                    -26.747,
                                                    -3.184
                                                ],
                                                [
                                                    -24.587,
                                                    -3.184
                                                ],
                                                [
                                                    -24.587,
                                                    7.166
                                                ],
                                                [
                                                    -26.747,
                                                    7.166
                                                ],
                                                [
                                                    -26.747,
                                                    5.626
                                                ],
                                                [
                                                    -28.231,
                                                    6.847
                                                ],
                                                [
                                                    -30.372,
                                                    7.336
                                                ],
                                                [
                                                    -32.815,
                                                    6.659
                                                ],
                                                [
                                                    -34.58,
                                                    4.743
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    0.301,
                                                    0.526
                                                ],
                                                [
                                                    0.476,
                                                    0.275
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.475,
                                                    -0.276
                                                ],
                                                [
                                                    0.3,
                                                    -0.526
                                                ],
                                                [
                                                    0,
                                                    -0.714
                                                ],
                                                [
                                                    -0.288,
                                                    -0.539
                                                ],
                                                [
                                                    -0.476,
                                                    -0.288
                                                ],
                                                [
                                                    -0.539,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.275
                                                ],
                                                [
                                                    -0.288,
                                                    0.526
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.714
                                                ],
                                                [
                                                    -0.288,
                                                    -0.526
                                                ],
                                                [
                                                    -0.476,
                                                    -0.276
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.263
                                                ],
                                                [
                                                    -0.288,
                                                    0.514
                                                ],
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    0.3,
                                                    0.538
                                                ],
                                                [
                                                    0.488,
                                                    0.275
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.276
                                                ],
                                                [
                                                    0.301,
                                                    -0.538
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.747,
                                                    1.982
                                                ],
                                                [
                                                    -27.198,
                                                    0.122
                                                ],
                                                [
                                                    -28.344,
                                                    -1.08
                                                ],
                                                [
                                                    -29.884,
                                                    -1.493
                                                ],
                                                [
                                                    -31.424,
                                                    -1.08
                                                ],
                                                [
                                                    -32.589,
                                                    0.103
                                                ],
                                                [
                                                    -33.021,
                                                    1.944
                                                ],
                                                [
                                                    -32.589,
                                                    3.823
                                                ],
                                                [
                                                    -31.424,
                                                    5.063
                                                ],
                                                [
                                                    -29.884,
                                                    5.476
                                                ],
                                                [
                                                    -28.344,
                                                    5.063
                                                ],
                                                [
                                                    -27.198,
                                                    3.86
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.288
                                                ],
                                                [
                                                    -0.714,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    -0.426
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.313,
                                                    -0.526
                                                ],
                                                [
                                                    0.526,
                                                    -0.301
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.839,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    0.426
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -19.632,
                                                    -1.681
                                                ],
                                                [
                                                    -18.393,
                                                    -2.902
                                                ],
                                                [
                                                    -16.533,
                                                    -3.353
                                                ],
                                                [
                                                    -16.533,
                                                    -1.136
                                                ],
                                                [
                                                    -17.078,
                                                    -1.136
                                                ],
                                                [
                                                    -18.994,
                                                    -0.498
                                                ],
                                                [
                                                    -19.632,
                                                    1.719
                                                ],
                                                [
                                                    -19.632,
                                                    7.166
                                                ],
                                                [
                                                    -21.774,
                                                    7.166
                                                ],
                                                [
                                                    -21.774,
                                                    -3.184
                                                ],
                                                [
                                                    -19.632,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.176,
                                                    -0.176
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    0.451
                                                ],
                                                [
                                                    0,
                                                    1.015
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.389
                                                ],
                                                [
                                                    0.188,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.964,
                                                    0
                                                ],
                                                [
                                                    -0.514,
                                                    -0.451
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.066,
                                                    -1.437
                                                ],
                                                [
                                                    -12.066,
                                                    4.292
                                                ],
                                                [
                                                    -11.803,
                                                    5.138
                                                ],
                                                [
                                                    -10.864,
                                                    5.382
                                                ],
                                                [
                                                    -9.549,
                                                    5.382
                                                ],
                                                [
                                                    -9.549,
                                                    7.166
                                                ],
                                                [
                                                    -11.24,
                                                    7.166
                                                ],
                                                [
                                                    -13.456,
                                                    6.49
                                                ],
                                                [
                                                    -14.226,
                                                    4.292
                                                ],
                                                [
                                                    -14.226,
                                                    -1.437
                                                ],
                                                [
                                                    -15.447,
                                                    -1.437
                                                ],
                                                [
                                                    -15.447,
                                                    -3.184
                                                ],
                                                [
                                                    -14.226,
                                                    -3.184
                                                ],
                                                [
                                                    -14.226,
                                                    -5.758
                                                ],
                                                [
                                                    -12.066,
                                                    -5.758
                                                ],
                                                [
                                                    -12.066,
                                                    -3.184
                                                ],
                                                [
                                                    -9.549,
                                                    -3.184
                                                ],
                                                [
                                                    -9.549,
                                                    -1.437
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -1.002
                                                ],
                                                [
                                                    0.05,
                                                    -0.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.501
                                                ],
                                                [
                                                    -0.802,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.826,
                                                    -0.614
                                                ],
                                                [
                                                    1.214,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.426,
                                                    0.801
                                                ],
                                                [
                                                    -0.777,
                                                    0.439
                                                ],
                                                [
                                                    -1.015,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -0.426
                                                ],
                                                [
                                                    -0.425,
                                                    -0.777
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.826
                                                ],
                                                [
                                                    0.551,
                                                    0.501
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.952
                                                ],
                                                [
                                                    -0.814,
                                                    0.601
                                                ],
                                                [
                                                    -0.99,
                                                    0
                                                ],
                                                [
                                                    -0.776,
                                                    -0.451
                                                ],
                                                [
                                                    -0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.065
                                                ],
                                                [
                                                    0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0.789,
                                                    -0.438
                                                ],
                                                [
                                                    0.977,
                                                    0
                                                ],
                                                [
                                                    0.764,
                                                    0.425
                                                ],
                                                [
                                                    0.426,
                                                    0.764
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.911,
                                                    1.738
                                                ],
                                                [
                                                    1.836,
                                                    2.79
                                                ],
                                                [
                                                    -6.073,
                                                    2.79
                                                ],
                                                [
                                                    -5.152,
                                                    4.781
                                                ],
                                                [
                                                    -3.123,
                                                    5.532
                                                ],
                                                [
                                                    -0.681,
                                                    4.086
                                                ],
                                                [
                                                    1.629,
                                                    4.086
                                                ],
                                                [
                                                    -0.08,
                                                    6.434
                                                ],
                                                [
                                                    -3.123,
                                                    7.336
                                                ],
                                                [
                                                    -5.791,
                                                    6.678
                                                ],
                                                [
                                                    -7.632,
                                                    4.8
                                                ],
                                                [
                                                    -8.289,
                                                    1.982
                                                ],
                                                [
                                                    -7.65,
                                                    -0.817
                                                ],
                                                [
                                                    -5.828,
                                                    -2.696
                                                ],
                                                [
                                                    -3.123,
                                                    -3.353
                                                ],
                                                [
                                                    -0.512,
                                                    -2.714
                                                ],
                                                [
                                                    1.272,
                                                    -0.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.476
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    -0.476
                                                ],
                                                [
                                                    0.1,
                                                    -0.801
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.013,
                                                    -0.789
                                                ],
                                                [
                                                    -0.551,
                                                    -0.476
                                                ],
                                                [
                                                    -0.739,
                                                    0
                                                ],
                                                [
                                                    -0.525,
                                                    0.463
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.324,
                                                    1.061
                                                ],
                                                [
                                                    -1.17,
                                                    -0.836
                                                ],
                                                [
                                                    -3.217,
                                                    -1.55
                                                ],
                                                [
                                                    -5.115,
                                                    -0.836
                                                ],
                                                [
                                                    -6.054,
                                                    1.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    1.04
                                                ],
                                                [
                                                    -0.425,
                                                    0.801
                                                ],
                                                [
                                                    -0.739,
                                                    0.438
                                                ],
                                                [
                                                    -0.915,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    -0.301
                                                ],
                                                [
                                                    -0.389,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.627,
                                                    -0.325
                                                ],
                                                [
                                                    0.801,
                                                    0
                                                ],
                                                [
                                                    0.752,
                                                    0.451
                                                ],
                                                [
                                                    0.439,
                                                    0.814
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -1.039
                                                ],
                                                [
                                                    0.439,
                                                    -0.802
                                                ],
                                                [
                                                    0.752,
                                                    -0.451
                                                ],
                                                [
                                                    0.676,
                                                    0
                                                ],
                                                [
                                                    0.664,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0.501
                                                ],
                                                [
                                                    -0.613,
                                                    0.326
                                                ],
                                                [
                                                    -0.902,
                                                    0
                                                ],
                                                [
                                                    -0.739,
                                                    -0.463
                                                ],
                                                [
                                                    -0.425,
                                                    -0.826
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.305,
                                                    1.944
                                                ],
                                                [
                                                    3.943,
                                                    -0.817
                                                ],
                                                [
                                                    5.709,
                                                    -2.677
                                                ],
                                                [
                                                    8.208,
                                                    -3.353
                                                ],
                                                [
                                                    10.199,
                                                    -2.902
                                                ],
                                                [
                                                    11.777,
                                                    -1.738
                                                ],
                                                [
                                                    11.777,
                                                    -6.734
                                                ],
                                                [
                                                    13.937,
                                                    -6.734
                                                ],
                                                [
                                                    13.937,
                                                    7.166
                                                ],
                                                [
                                                    11.777,
                                                    7.166
                                                ],
                                                [
                                                    11.777,
                                                    5.607
                                                ],
                                                [
                                                    10.311,
                                                    6.847
                                                ],
                                                [
                                                    8.189,
                                                    7.336
                                                ],
                                                [
                                                    5.709,
                                                    6.659
                                                ],
                                                [
                                                    3.943,
                                                    4.743
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    0.3,
                                                    0.526
                                                ],
                                                [
                                                    0.476,
                                                    0.275
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.276
                                                ],
                                                [
                                                    0.3,
                                                    -0.526
                                                ],
                                                [
                                                    0,
                                                    -0.714
                                                ],
                                                [
                                                    -0.288,
                                                    -0.539
                                                ],
                                                [
                                                    -0.476,
                                                    -0.288
                                                ],
                                                [
                                                    -0.539,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.275
                                                ],
                                                [
                                                    -0.288,
                                                    0.526
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.714
                                                ],
                                                [
                                                    -0.288,
                                                    -0.526
                                                ],
                                                [
                                                    -0.476,
                                                    -0.276
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.263
                                                ],
                                                [
                                                    -0.288,
                                                    0.514
                                                ],
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    0.3,
                                                    0.538
                                                ],
                                                [
                                                    0.489,
                                                    0.275
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.276
                                                ],
                                                [
                                                    0.3,
                                                    -0.538
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.777,
                                                    1.982
                                                ],
                                                [
                                                    11.326,
                                                    0.122
                                                ],
                                                [
                                                    10.18,
                                                    -1.08
                                                ],
                                                [
                                                    8.64,
                                                    -1.493
                                                ],
                                                [
                                                    7.099,
                                                    -1.08
                                                ],
                                                [
                                                    5.935,
                                                    0.103
                                                ],
                                                [
                                                    5.503,
                                                    1.944
                                                ],
                                                [
                                                    5.935,
                                                    3.823
                                                ],
                                                [
                                                    7.099,
                                                    5.063
                                                ],
                                                [
                                                    8.64,
                                                    5.476
                                                ],
                                                [
                                                    10.18,
                                                    5.063
                                                ],
                                                [
                                                    11.326,
                                                    3.86
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.626,
                                                    0.539
                                                ],
                                                [
                                                    -1.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.263,
                                                    -0.251
                                                ],
                                                [
                                                    0,
                                                    -0.601
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.189
                                                ],
                                                [
                                                    0.638,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    0.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.969,
                                                    -1.437
                                                ],
                                                [
                                                    24.053,
                                                    -1.437
                                                ],
                                                [
                                                    24.053,
                                                    7.166
                                                ],
                                                [
                                                    21.892,
                                                    7.166
                                                ],
                                                [
                                                    21.892,
                                                    -1.437
                                                ],
                                                [
                                                    20.671,
                                                    -1.437
                                                ],
                                                [
                                                    20.671,
                                                    -3.184
                                                ],
                                                [
                                                    21.892,
                                                    -3.184
                                                ],
                                                [
                                                    21.892,
                                                    -3.917
                                                ],
                                                [
                                                    22.832,
                                                    -6.509
                                                ],
                                                [
                                                    25.818,
                                                    -7.336
                                                ],
                                                [
                                                    25.818,
                                                    -5.551
                                                ],
                                                [
                                                    24.447,
                                                    -5.175
                                                ],
                                                [
                                                    24.053,
                                                    -3.917
                                                ],
                                                [
                                                    24.053,
                                                    -3.184
                                                ],
                                                [
                                                    25.969,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.99,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.464,
                                                    0.814
                                                ],
                                                [
                                                    -0.802,
                                                    0.439
                                                ],
                                                [
                                                    -0.989,
                                                    0
                                                ],
                                                [
                                                    -0.801,
                                                    -0.438
                                                ],
                                                [
                                                    -0.464,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0.476,
                                                    -0.814
                                                ],
                                                [
                                                    0.827,
                                                    -0.451
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.977,
                                                    0
                                                ],
                                                [
                                                    -0.789,
                                                    -0.451
                                                ],
                                                [
                                                    -0.451,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0.463,
                                                    -0.814
                                                ],
                                                [
                                                    0.801,
                                                    -0.438
                                                ],
                                                [
                                                    0.99,
                                                    0
                                                ],
                                                [
                                                    0.802,
                                                    0.439
                                                ],
                                                [
                                                    0.463,
                                                    0.814
                                                ],
                                                [
                                                    0,
                                                    1.052
                                                ],
                                                [
                                                    -0.476,
                                                    0.814
                                                ],
                                                [
                                                    -0.814,
                                                    0.438
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    32.356,
                                                    7.336
                                                ],
                                                [
                                                    29.708,
                                                    6.678
                                                ],
                                                [
                                                    27.848,
                                                    4.8
                                                ],
                                                [
                                                    27.172,
                                                    1.982
                                                ],
                                                [
                                                    27.867,
                                                    -0.817
                                                ],
                                                [
                                                    29.764,
                                                    -2.696
                                                ],
                                                [
                                                    32.45,
                                                    -3.353
                                                ],
                                                [
                                                    35.136,
                                                    -2.696
                                                ],
                                                [
                                                    37.034,
                                                    -0.817
                                                ],
                                                [
                                                    37.729,
                                                    1.982
                                                ],
                                                [
                                                    37.015,
                                                    4.781
                                                ],
                                                [
                                                    35.061,
                                                    6.678
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.263
                                                ],
                                                [
                                                    -0.3,
                                                    0.526
                                                ],
                                                [
                                                    0,
                                                    0.751
                                                ],
                                                [
                                                    0.288,
                                                    0.513
                                                ],
                                                [
                                                    0.476,
                                                    0.263
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.263
                                                ],
                                                [
                                                    0.275,
                                                    -0.526
                                                ],
                                                [
                                                    0,
                                                    -0.752
                                                ],
                                                [
                                                    -0.564,
                                                    -0.613
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.263
                                                ],
                                                [
                                                    0.301,
                                                    -0.526
                                                ],
                                                [
                                                    0,
                                                    -0.752
                                                ],
                                                [
                                                    -0.288,
                                                    -0.526
                                                ],
                                                [
                                                    -0.476,
                                                    -0.263
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.463,
                                                    0.263
                                                ],
                                                [
                                                    -0.276,
                                                    0.513
                                                ],
                                                [
                                                    0,
                                                    1.114
                                                ],
                                                [
                                                    0.576,
                                                    0.601
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    32.356,
                                                    5.476
                                                ],
                                                [
                                                    33.897,
                                                    5.081
                                                ],
                                                [
                                                    35.08,
                                                    3.898
                                                ],
                                                [
                                                    35.531,
                                                    1.982
                                                ],
                                                [
                                                    35.099,
                                                    0.085
                                                ],
                                                [
                                                    33.953,
                                                    -1.099
                                                ],
                                                [
                                                    32.413,
                                                    -1.493
                                                ],
                                                [
                                                    30.872,
                                                    -1.099
                                                ],
                                                [
                                                    29.764,
                                                    0.085
                                                ],
                                                [
                                                    29.351,
                                                    1.982
                                                ],
                                                [
                                                    30.196,
                                                    4.574
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.288
                                                ],
                                                [
                                                    -0.714,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.438,
                                                    -0.426
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.313,
                                                    -0.526
                                                ],
                                                [
                                                    0.526,
                                                    -0.301
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.839,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    0.426
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    41.987,
                                                    -1.681
                                                ],
                                                [
                                                    43.227,
                                                    -2.902
                                                ],
                                                [
                                                    45.087,
                                                    -3.353
                                                ],
                                                [
                                                    45.087,
                                                    -1.136
                                                ],
                                                [
                                                    44.542,
                                                    -1.136
                                                ],
                                                [
                                                    42.626,
                                                    -0.498
                                                ],
                                                [
                                                    41.987,
                                                    1.719
                                                ],
                                                [
                                                    41.987,
                                                    7.166
                                                ],
                                                [
                                                    39.846,
                                                    7.166
                                                ],
                                                [
                                                    39.846,
                                                    -3.184
                                                ],
                                                [
                                                    41.987,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.626,
                                                    0.539
                                                ],
                                                [
                                                    -1.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.263,
                                                    -0.251
                                                ],
                                                [
                                                    0,
                                                    -0.601
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.189
                                                ],
                                                [
                                                    0.639,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    0.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    56.274,
                                                    -1.437
                                                ],
                                                [
                                                    54.358,
                                                    -1.437
                                                ],
                                                [
                                                    54.358,
                                                    7.166
                                                ],
                                                [
                                                    52.198,
                                                    7.166
                                                ],
                                                [
                                                    52.198,
                                                    -1.437
                                                ],
                                                [
                                                    50.977,
                                                    -1.437
                                                ],
                                                [
                                                    50.977,
                                                    -3.184
                                                ],
                                                [
                                                    52.198,
                                                    -3.184
                                                ],
                                                [
                                                    52.198,
                                                    -3.917
                                                ],
                                                [
                                                    53.137,
                                                    -6.509
                                                ],
                                                [
                                                    56.124,
                                                    -7.336
                                                ],
                                                [
                                                    56.124,
                                                    -5.551
                                                ],
                                                [
                                                    54.753,
                                                    -5.175
                                                ],
                                                [
                                                    54.358,
                                                    -3.917
                                                ],
                                                [
                                                    54.358,
                                                    -3.184
                                                ],
                                                [
                                                    56.274,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.288
                                                ],
                                                [
                                                    -0.714,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    -0.426
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.313,
                                                    -0.526
                                                ],
                                                [
                                                    0.526,
                                                    -0.301
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.839,
                                                    0
                                                ],
                                                [
                                                    -0.425,
                                                    0.426
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    60.314,
                                                    -1.681
                                                ],
                                                [
                                                    61.553,
                                                    -2.902
                                                ],
                                                [
                                                    63.413,
                                                    -3.353
                                                ],
                                                [
                                                    63.413,
                                                    -1.136
                                                ],
                                                [
                                                    62.868,
                                                    -1.136
                                                ],
                                                [
                                                    60.952,
                                                    -0.498
                                                ],
                                                [
                                                    60.314,
                                                    1.719
                                                ],
                                                [
                                                    60.314,
                                                    7.166
                                                ],
                                                [
                                                    58.172,
                                                    7.166
                                                ],
                                                [
                                                    58.172,
                                                    -3.184
                                                ],
                                                [
                                                    60.314,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -1.002
                                                ],
                                                [
                                                    0.05,
                                                    -0.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.501
                                                ],
                                                [
                                                    -0.802,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.826,
                                                    -0.614
                                                ],
                                                [
                                                    1.214,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.425,
                                                    0.801
                                                ],
                                                [
                                                    -0.777,
                                                    0.439
                                                ],
                                                [
                                                    -1.015,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -0.426
                                                ],
                                                [
                                                    -0.425,
                                                    -0.777
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.826
                                                ],
                                                [
                                                    0.551,
                                                    0.501
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.952
                                                ],
                                                [
                                                    -0.814,
                                                    0.601
                                                ],
                                                [
                                                    -0.99,
                                                    0
                                                ],
                                                [
                                                    -0.776,
                                                    -0.451
                                                ],
                                                [
                                                    -0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.065
                                                ],
                                                [
                                                    0.439,
                                                    -0.814
                                                ],
                                                [
                                                    0.789,
                                                    -0.438
                                                ],
                                                [
                                                    0.976,
                                                    0
                                                ],
                                                [
                                                    0.764,
                                                    0.425
                                                ],
                                                [
                                                    0.426,
                                                    0.764
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    74.868,
                                                    1.738
                                                ],
                                                [
                                                    74.793,
                                                    2.79
                                                ],
                                                [
                                                    66.884,
                                                    2.79
                                                ],
                                                [
                                                    67.805,
                                                    4.781
                                                ],
                                                [
                                                    69.834,
                                                    5.532
                                                ],
                                                [
                                                    72.276,
                                                    4.086
                                                ],
                                                [
                                                    74.586,
                                                    4.086
                                                ],
                                                [
                                                    72.877,
                                                    6.434
                                                ],
                                                [
                                                    69.834,
                                                    7.336
                                                ],
                                                [
                                                    67.166,
                                                    6.678
                                                ],
                                                [
                                                    65.325,
                                                    4.8
                                                ],
                                                [
                                                    64.668,
                                                    1.982
                                                ],
                                                [
                                                    65.306,
                                                    -0.817
                                                ],
                                                [
                                                    67.129,
                                                    -2.696
                                                ],
                                                [
                                                    69.834,
                                                    -3.353
                                                ],
                                                [
                                                    72.445,
                                                    -2.714
                                                ],
                                                [
                                                    74.229,
                                                    -0.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.476
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    -0.476
                                                ],
                                                [
                                                    0.1,
                                                    -0.801
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.013,
                                                    -0.789
                                                ],
                                                [
                                                    -0.551,
                                                    -0.476
                                                ],
                                                [
                                                    -0.739,
                                                    0
                                                ],
                                                [
                                                    -0.526,
                                                    0.463
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    72.633,
                                                    1.061
                                                ],
                                                [
                                                    71.787,
                                                    -0.836
                                                ],
                                                [
                                                    69.74,
                                                    -1.55
                                                ],
                                                [
                                                    67.842,
                                                    -0.836
                                                ],
                                                [
                                                    66.903,
                                                    1.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -1.002
                                                ],
                                                [
                                                    0.05,
                                                    -0.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.501
                                                ],
                                                [
                                                    -0.802,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.826,
                                                    -0.614
                                                ],
                                                [
                                                    1.214,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.425,
                                                    0.801
                                                ],
                                                [
                                                    -0.776,
                                                    0.439
                                                ],
                                                [
                                                    -1.015,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -0.426
                                                ],
                                                [
                                                    -0.426,
                                                    -0.777
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.826
                                                ],
                                                [
                                                    0.551,
                                                    0.501
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.952
                                                ],
                                                [
                                                    -0.814,
                                                    0.601
                                                ],
                                                [
                                                    -0.99,
                                                    0
                                                ],
                                                [
                                                    -0.776,
                                                    -0.451
                                                ],
                                                [
                                                    -0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.065
                                                ],
                                                [
                                                    0.439,
                                                    -0.814
                                                ],
                                                [
                                                    0.789,
                                                    -0.438
                                                ],
                                                [
                                                    0.976,
                                                    0
                                                ],
                                                [
                                                    0.764,
                                                    0.425
                                                ],
                                                [
                                                    0.426,
                                                    0.764
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    86.462,
                                                    1.738
                                                ],
                                                [
                                                    86.387,
                                                    2.79
                                                ],
                                                [
                                                    78.478,
                                                    2.79
                                                ],
                                                [
                                                    79.399,
                                                    4.781
                                                ],
                                                [
                                                    81.428,
                                                    5.532
                                                ],
                                                [
                                                    83.87,
                                                    4.086
                                                ],
                                                [
                                                    86.18,
                                                    4.086
                                                ],
                                                [
                                                    84.471,
                                                    6.434
                                                ],
                                                [
                                                    81.428,
                                                    7.336
                                                ],
                                                [
                                                    78.76,
                                                    6.678
                                                ],
                                                [
                                                    76.919,
                                                    4.8
                                                ],
                                                [
                                                    76.262,
                                                    1.982
                                                ],
                                                [
                                                    76.9,
                                                    -0.817
                                                ],
                                                [
                                                    78.722,
                                                    -2.696
                                                ],
                                                [
                                                    81.428,
                                                    -3.353
                                                ],
                                                [
                                                    84.039,
                                                    -2.714
                                                ],
                                                [
                                                    85.823,
                                                    -0.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.476
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    -0.476
                                                ],
                                                [
                                                    0.1,
                                                    -0.801
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.012,
                                                    -0.789
                                                ],
                                                [
                                                    -0.551,
                                                    -0.476
                                                ],
                                                [
                                                    -0.739,
                                                    0
                                                ],
                                                [
                                                    -0.526,
                                                    0.463
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    84.226,
                                                    1.061
                                                ],
                                                [
                                                    83.381,
                                                    -0.836
                                                ],
                                                [
                                                    81.334,
                                                    -1.55
                                                ],
                                                [
                                                    79.436,
                                                    -0.836
                                                ],
                                                [
                                                    78.497,
                                                    1.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    91.256,
                                                    -5.889
                                                ],
                                                [
                                                    91.011,
                                                    3.222
                                                ],
                                                [
                                                    89.227,
                                                    3.222
                                                ],
                                                [
                                                    88.983,
                                                    -5.889
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.376,
                                                    0
                                                ],
                                                [
                                                    0.263,
                                                    0.263
                                                ],
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    -0.263,
                                                    0.263
                                                ],
                                                [
                                                    -0.388,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    -0.263
                                                ],
                                                [
                                                    0,
                                                    -0.389
                                                ],
                                                [
                                                    0.263,
                                                    -0.262
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.388,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    -0.262
                                                ],
                                                [
                                                    0,
                                                    -0.389
                                                ],
                                                [
                                                    0.263,
                                                    -0.263
                                                ],
                                                [
                                                    0.376,
                                                    0
                                                ],
                                                [
                                                    0.263,
                                                    0.263
                                                ],
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    -0.263,
                                                    0.263
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    90.185,
                                                    7.298
                                                ],
                                                [
                                                    89.208,
                                                    6.903
                                                ],
                                                [
                                                    88.814,
                                                    5.927
                                                ],
                                                [
                                                    89.208,
                                                    4.95
                                                ],
                                                [
                                                    90.185,
                                                    4.555
                                                ],
                                                [
                                                    91.143,
                                                    4.95
                                                ],
                                                [
                                                    91.537,
                                                    5.927
                                                ],
                                                [
                                                    91.143,
                                                    6.903
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            112.465,
                                            32.465
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -8.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -8.509
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    8.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    8.509
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    8.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    8.509
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -8.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -8.509
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -117.731,
                                                    -158.072
                                                ],
                                                [
                                                    117.731,
                                                    -158.072
                                                ],
                                                [
                                                    133.137,
                                                    -142.666
                                                ],
                                                [
                                                    133.137,
                                                    142.666
                                                ],
                                                [
                                                    117.731,
                                                    158.072
                                                ],
                                                [
                                                    -117.731,
                                                    158.072
                                                ],
                                                [
                                                    -133.137,
                                                    142.666
                                                ],
                                                [
                                                    -133.137,
                                                    -142.666
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9608,
                                            0.9608,
                                            0.9608
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            133.137,
                                            158.072
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                }
            ]
        },
        {
            "nm": "Button .svg",
            "id": "14",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Button .svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "497",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                113,
                                19
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                113,
                                19
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.517,
                                                    -0.263
                                                ],
                                                [
                                                    -0.253,
                                                    -0.442
                                                ],
                                                [
                                                    0,
                                                    -0.545
                                                ],
                                                [
                                                    0.376,
                                                    -0.526
                                                ],
                                                [
                                                    0.77,
                                                    -0.188
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.751,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    0.263
                                                ],
                                                [
                                                    0.263,
                                                    0.441
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.366,
                                                    0.516
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.041,
                                                    3.508
                                                ],
                                                [
                                                    -25.296,
                                                    -0.409
                                                ],
                                                [
                                                    -26.521,
                                                    -0.409
                                                ],
                                                [
                                                    -26.521,
                                                    3.508
                                                ],
                                                [
                                                    -28.127,
                                                    3.508
                                                ],
                                                [
                                                    -28.127,
                                                    -6.284
                                                ],
                                                [
                                                    -24.746,
                                                    -6.284
                                                ],
                                                [
                                                    -22.844,
                                                    -5.889
                                                ],
                                                [
                                                    -21.675,
                                                    -4.832
                                                ],
                                                [
                                                    -21.28,
                                                    -3.353
                                                ],
                                                [
                                                    -21.844,
                                                    -1.606
                                                ],
                                                [
                                                    -23.548,
                                                    -0.549
                                                ],
                                                [
                                                    -21.125,
                                                    3.508
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    0.301
                                                ],
                                                [
                                                    0,
                                                    0.507
                                                ],
                                                [
                                                    0.3,
                                                    0.282
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    -0.507
                                                ],
                                                [
                                                    -0.301,
                                                    -0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.521,
                                                    -1.691
                                                ],
                                                [
                                                    -24.746,
                                                    -1.691
                                                ],
                                                [
                                                    -23.394,
                                                    -2.142
                                                ],
                                                [
                                                    -22.929,
                                                    -3.353
                                                ],
                                                [
                                                    -23.379,
                                                    -4.537
                                                ],
                                                [
                                                    -24.746,
                                                    -4.973
                                                ],
                                                [
                                                    -26.521,
                                                    -4.973
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.752
                                                ],
                                                [
                                                    0.037,
                                                    -0.234
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    -0.376
                                                ],
                                                [
                                                    -0.602,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.723
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.62,
                                                    -0.461
                                                ],
                                                [
                                                    0.911,
                                                    0
                                                ],
                                                [
                                                    0.592,
                                                    0.329
                                                ],
                                                [
                                                    0.338,
                                                    0.601
                                                ],
                                                [
                                                    0,
                                                    0.798
                                                ],
                                                [
                                                    -0.319,
                                                    0.601
                                                ],
                                                [
                                                    -0.583,
                                                    0.329
                                                ],
                                                [
                                                    -0.761,
                                                    0
                                                ],
                                                [
                                                    -0.573,
                                                    -0.319
                                                ],
                                                [
                                                    -0.319,
                                                    -0.582
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.62
                                                ],
                                                [
                                                    0.413,
                                                    0.375
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.713
                                                ],
                                                [
                                                    -0.611,
                                                    0.451
                                                ],
                                                [
                                                    -0.742,
                                                    0
                                                ],
                                                [
                                                    -0.582,
                                                    -0.338
                                                ],
                                                [
                                                    -0.329,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.799
                                                ],
                                                [
                                                    0.329,
                                                    -0.61
                                                ],
                                                [
                                                    0.591,
                                                    -0.328
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.573,
                                                    0.32
                                                ],
                                                [
                                                    0.32,
                                                    0.573
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.111,
                                                    -0.563
                                                ],
                                                [
                                                    -12.167,
                                                    0.225
                                                ],
                                                [
                                                    -18.098,
                                                    0.225
                                                ],
                                                [
                                                    -17.408,
                                                    1.719
                                                ],
                                                [
                                                    -15.886,
                                                    2.282
                                                ],
                                                [
                                                    -14.055,
                                                    1.198
                                                ],
                                                [
                                                    -12.322,
                                                    1.198
                                                ],
                                                [
                                                    -13.604,
                                                    2.959
                                                ],
                                                [
                                                    -15.886,
                                                    3.635
                                                ],
                                                [
                                                    -17.887,
                                                    3.142
                                                ],
                                                [
                                                    -19.268,
                                                    1.733
                                                ],
                                                [
                                                    -19.761,
                                                    -0.38
                                                ],
                                                [
                                                    -19.282,
                                                    -2.48
                                                ],
                                                [
                                                    -17.915,
                                                    -3.889
                                                ],
                                                [
                                                    -15.886,
                                                    -4.382
                                                ],
                                                [
                                                    -13.928,
                                                    -3.903
                                                ],
                                                [
                                                    -12.59,
                                                    -2.55
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.357
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.357
                                                ],
                                                [
                                                    0.075,
                                                    -0.601
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.01,
                                                    -0.592
                                                ],
                                                [
                                                    -0.414,
                                                    -0.357
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.787,
                                                    -1.071
                                                ],
                                                [
                                                    -14.421,
                                                    -2.494
                                                ],
                                                [
                                                    -15.957,
                                                    -3.029
                                                ],
                                                [
                                                    -17.38,
                                                    -2.494
                                                ],
                                                [
                                                    -18.084,
                                                    -1.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.676,
                                                    0
                                                ],
                                                [
                                                    -0.46,
                                                    -0.244
                                                ],
                                                [
                                                    -0.263,
                                                    -0.357
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    -0.554
                                                ],
                                                [
                                                    0.573,
                                                    -0.319
                                                ],
                                                [
                                                    0.788,
                                                    0
                                                ],
                                                [
                                                    0.695,
                                                    0.498
                                                ],
                                                [
                                                    0.093,
                                                    0.845
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    -0.244
                                                ],
                                                [
                                                    -0.555,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.394
                                                ],
                                                [
                                                    0,
                                                    0.751
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    -0.254
                                                ],
                                                [
                                                    0.592,
                                                    0
                                                ],
                                                [
                                                    0.563,
                                                    0.338
                                                ],
                                                [
                                                    0.329,
                                                    0.61
                                                ],
                                                [
                                                    0,
                                                    0.78
                                                ],
                                                [
                                                    -0.319,
                                                    0.601
                                                ],
                                                [
                                                    -0.555,
                                                    0.328
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    -0.301,
                                                    0.563
                                                ],
                                                [
                                                    -0.563,
                                                    0.32
                                                ],
                                                [
                                                    -1.052,
                                                    0
                                                ],
                                                [
                                                    -0.695,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.122,
                                                    0.404
                                                ],
                                                [
                                                    0.404,
                                                    0.254
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.404,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.272,
                                                    0.366
                                                ],
                                                [
                                                    -0.46,
                                                    0.244
                                                ],
                                                [
                                                    -0.676,
                                                    0
                                                ],
                                                [
                                                    -0.555,
                                                    -0.348
                                                ],
                                                [
                                                    -0.319,
                                                    -0.62
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    0.329,
                                                    -0.601
                                                ],
                                                [
                                                    0.563,
                                                    -0.338
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.403,
                                                    -4.382
                                                ],
                                                [
                                                    -5.811,
                                                    -4.015
                                                ],
                                                [
                                                    -4.712,
                                                    -3.128
                                                ],
                                                [
                                                    -4.712,
                                                    -4.255
                                                ],
                                                [
                                                    -3.092,
                                                    -4.255
                                                ],
                                                [
                                                    -3.092,
                                                    3.635
                                                ],
                                                [
                                                    -3.542,
                                                    5.537
                                                ],
                                                [
                                                    -4.853,
                                                    6.861
                                                ],
                                                [
                                                    -6.881,
                                                    7.34
                                                ],
                                                [
                                                    -9.502,
                                                    6.593
                                                ],
                                                [
                                                    -10.685,
                                                    4.593
                                                ],
                                                [
                                                    -9.093,
                                                    4.593
                                                ],
                                                [
                                                    -8.319,
                                                    5.565
                                                ],
                                                [
                                                    -6.881,
                                                    5.945
                                                ],
                                                [
                                                    -5.318,
                                                    5.354
                                                ],
                                                [
                                                    -4.712,
                                                    3.635
                                                ],
                                                [
                                                    -4.712,
                                                    2.339
                                                ],
                                                [
                                                    -5.825,
                                                    3.269
                                                ],
                                                [
                                                    -7.403,
                                                    3.635
                                                ],
                                                [
                                                    -9.262,
                                                    3.128
                                                ],
                                                [
                                                    -10.587,
                                                    1.691
                                                ],
                                                [
                                                    -11.066,
                                                    -0.409
                                                ],
                                                [
                                                    -10.587,
                                                    -2.48
                                                ],
                                                [
                                                    -9.262,
                                                    -3.874
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.535
                                                ],
                                                [
                                                    0.225,
                                                    0.394
                                                ],
                                                [
                                                    0.357,
                                                    0.207
                                                ],
                                                [
                                                    0.414,
                                                    0
                                                ],
                                                [
                                                    0.357,
                                                    -0.206
                                                ],
                                                [
                                                    0.225,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    -0.535
                                                ],
                                                [
                                                    -0.216,
                                                    -0.404
                                                ],
                                                [
                                                    -0.357,
                                                    -0.216
                                                ],
                                                [
                                                    -0.404,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.207
                                                ],
                                                [
                                                    -0.216,
                                                    0.395
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.536
                                                ],
                                                [
                                                    -0.216,
                                                    -0.395
                                                ],
                                                [
                                                    -0.357,
                                                    -0.206
                                                ],
                                                [
                                                    -0.413,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.197
                                                ],
                                                [
                                                    -0.216,
                                                    0.385
                                                ],
                                                [
                                                    0,
                                                    0.536
                                                ],
                                                [
                                                    0.225,
                                                    0.404
                                                ],
                                                [
                                                    0.366,
                                                    0.207
                                                ],
                                                [
                                                    0.414,
                                                    0
                                                ],
                                                [
                                                    0.357,
                                                    -0.206
                                                ],
                                                [
                                                    0.225,
                                                    -0.403
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.712,
                                                    -0.38
                                                ],
                                                [
                                                    -5.05,
                                                    -1.775
                                                ],
                                                [
                                                    -5.909,
                                                    -2.677
                                                ],
                                                [
                                                    -7.065,
                                                    -2.987
                                                ],
                                                [
                                                    -8.22,
                                                    -2.677
                                                ],
                                                [
                                                    -9.093,
                                                    -1.789
                                                ],
                                                [
                                                    -9.417,
                                                    -0.409
                                                ],
                                                [
                                                    -9.093,
                                                    1
                                                ],
                                                [
                                                    -8.22,
                                                    1.93
                                                ],
                                                [
                                                    -7.065,
                                                    2.24
                                                ],
                                                [
                                                    -5.909,
                                                    1.93
                                                ],
                                                [
                                                    -5.05,
                                                    1.028
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.282,
                                                    0
                                                ],
                                                [
                                                    0.198,
                                                    0.197
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    -0.197,
                                                    0.197
                                                ],
                                                [
                                                    -0.291,
                                                    0
                                                ],
                                                [
                                                    -0.198,
                                                    -0.198
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    0.197,
                                                    -0.197
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.291,
                                                    0
                                                ],
                                                [
                                                    -0.197,
                                                    -0.197
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    0.198,
                                                    -0.198
                                                ],
                                                [
                                                    0.282,
                                                    0
                                                ],
                                                [
                                                    0.197,
                                                    0.197
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    -0.198,
                                                    0.197
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.165,
                                                    -5.283
                                                ],
                                                [
                                                    -0.898,
                                                    -5.579
                                                ],
                                                [
                                                    -1.193,
                                                    -6.312
                                                ],
                                                [
                                                    -0.898,
                                                    -7.044
                                                ],
                                                [
                                                    -0.165,
                                                    -7.34
                                                ],
                                                [
                                                    0.554,
                                                    -7.044
                                                ],
                                                [
                                                    0.85,
                                                    -6.312
                                                ],
                                                [
                                                    0.554,
                                                    -5.579
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.624,
                                                    -4.255
                                                ],
                                                [
                                                    0.624,
                                                    3.508
                                                ],
                                                [
                                                    -0.982,
                                                    3.508
                                                ],
                                                [
                                                    -0.982,
                                                    -4.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.489,
                                                    0.216
                                                ],
                                                [
                                                    0.282,
                                                    0.376
                                                ],
                                                [
                                                    0.019,
                                                    0.47
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.282,
                                                    -0.225
                                                ],
                                                [
                                                    -0.432,
                                                    0
                                                ],
                                                [
                                                    -0.244,
                                                    0.169
                                                ],
                                                [
                                                    0,
                                                    0.272
                                                ],
                                                [
                                                    0.281,
                                                    0.141
                                                ],
                                                [
                                                    0.602,
                                                    0.169
                                                ],
                                                [
                                                    0.367,
                                                    0.15
                                                ],
                                                [
                                                    0.273,
                                                    0.31
                                                ],
                                                [
                                                    0,
                                                    0.508
                                                ],
                                                [
                                                    -0.244,
                                                    0.338
                                                ],
                                                [
                                                    -0.451,
                                                    0.197
                                                ],
                                                [
                                                    -0.592,
                                                    0
                                                ],
                                                [
                                                    -0.535,
                                                    -0.451
                                                ],
                                                [
                                                    -0.038,
                                                    -0.77
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.253,
                                                    0.207
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.226,
                                                    -0.159
                                                ],
                                                [
                                                    0,
                                                    -0.263
                                                ],
                                                [
                                                    -0.151,
                                                    -0.141
                                                ],
                                                [
                                                    -0.216,
                                                    -0.085
                                                ],
                                                [
                                                    -0.423,
                                                    -0.122
                                                ],
                                                [
                                                    -0.357,
                                                    -0.16
                                                ],
                                                [
                                                    -0.263,
                                                    -0.301
                                                ],
                                                [
                                                    -0.009,
                                                    -0.497
                                                ],
                                                [
                                                    0.244,
                                                    -0.348
                                                ],
                                                [
                                                    0.451,
                                                    -0.197
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.611,
                                                    0
                                                ],
                                                [
                                                    -0.479,
                                                    -0.226
                                                ],
                                                [
                                                    -0.282,
                                                    -0.385
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.329
                                                ],
                                                [
                                                    0.291,
                                                    0.216
                                                ],
                                                [
                                                    0.451,
                                                    0
                                                ],
                                                [
                                                    0.254,
                                                    -0.179
                                                ],
                                                [
                                                    0,
                                                    -0.292
                                                ],
                                                [
                                                    -0.273,
                                                    -0.14
                                                ],
                                                [
                                                    -0.582,
                                                    -0.16
                                                ],
                                                [
                                                    -0.366,
                                                    -0.151
                                                ],
                                                [
                                                    -0.263,
                                                    -0.31
                                                ],
                                                [
                                                    0,
                                                    -0.413
                                                ],
                                                [
                                                    0.244,
                                                    -0.347
                                                ],
                                                [
                                                    0.46,
                                                    -0.197
                                                ],
                                                [
                                                    0.883,
                                                    0
                                                ],
                                                [
                                                    0.545,
                                                    0.441
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.029,
                                                    -0.347
                                                ],
                                                [
                                                    -0.254,
                                                    -0.207
                                                ],
                                                [
                                                    -0.422,
                                                    0
                                                ],
                                                [
                                                    -0.225,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.207
                                                ],
                                                [
                                                    0.15,
                                                    0.141
                                                ],
                                                [
                                                    0.216,
                                                    0.075
                                                ],
                                                [
                                                    0.564,
                                                    0.15
                                                ],
                                                [
                                                    0.366,
                                                    0.15
                                                ],
                                                [
                                                    0.263,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0.442
                                                ],
                                                [
                                                    -0.244,
                                                    0.347
                                                ],
                                                [
                                                    -0.441,
                                                    0.197
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.551,
                                                    3.635
                                                ],
                                                [
                                                    3.902,
                                                    3.311
                                                ],
                                                [
                                                    2.761,
                                                    2.409
                                                ],
                                                [
                                                    2.31,
                                                    1.127
                                                ],
                                                [
                                                    3.973,
                                                    1.127
                                                ],
                                                [
                                                    4.438,
                                                    1.958
                                                ],
                                                [
                                                    5.522,
                                                    2.282
                                                ],
                                                [
                                                    6.565,
                                                    2.029
                                                ],
                                                [
                                                    6.945,
                                                    1.353
                                                ],
                                                [
                                                    6.523,
                                                    0.704
                                                ],
                                                [
                                                    5.212,
                                                    0.24
                                                ],
                                                [
                                                    3.789,
                                                    -0.225
                                                ],
                                                [
                                                    2.831,
                                                    -0.916
                                                ],
                                                [
                                                    2.437,
                                                    -2.142
                                                ],
                                                [
                                                    2.803,
                                                    -3.269
                                                ],
                                                [
                                                    3.846,
                                                    -4.086
                                                ],
                                                [
                                                    5.424,
                                                    -4.382
                                                ],
                                                [
                                                    7.551,
                                                    -3.705
                                                ],
                                                [
                                                    8.425,
                                                    -1.888
                                                ],
                                                [
                                                    6.819,
                                                    -1.888
                                                ],
                                                [
                                                    6.396,
                                                    -2.719
                                                ],
                                                [
                                                    5.367,
                                                    -3.029
                                                ],
                                                [
                                                    4.395,
                                                    -2.79
                                                ],
                                                [
                                                    4.057,
                                                    -2.156
                                                ],
                                                [
                                                    4.283,
                                                    -1.634
                                                ],
                                                [
                                                    4.832,
                                                    -1.296
                                                ],
                                                [
                                                    5.79,
                                                    -1
                                                ],
                                                [
                                                    7.171,
                                                    -0.535
                                                ],
                                                [
                                                    8.115,
                                                    0.141
                                                ],
                                                [
                                                    8.523,
                                                    1.338
                                                ],
                                                [
                                                    8.157,
                                                    2.522
                                                ],
                                                [
                                                    7.114,
                                                    3.339
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.132,
                                                    -0.131
                                                ],
                                                [
                                                    -0.329,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.385,
                                                    0.338
                                                ],
                                                [
                                                    0,
                                                    0.76
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0.141,
                                                    0.123
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.723,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    -0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.132,
                                                    -2.944
                                                ],
                                                [
                                                    12.132,
                                                    1.353
                                                ],
                                                [
                                                    12.33,
                                                    1.986
                                                ],
                                                [
                                                    13.034,
                                                    2.17
                                                ],
                                                [
                                                    14.02,
                                                    2.17
                                                ],
                                                [
                                                    14.02,
                                                    3.508
                                                ],
                                                [
                                                    12.752,
                                                    3.508
                                                ],
                                                [
                                                    11.09,
                                                    3.001
                                                ],
                                                [
                                                    10.512,
                                                    1.353
                                                ],
                                                [
                                                    10.512,
                                                    -2.944
                                                ],
                                                [
                                                    9.597,
                                                    -2.944
                                                ],
                                                [
                                                    9.597,
                                                    -4.255
                                                ],
                                                [
                                                    10.512,
                                                    -4.255
                                                ],
                                                [
                                                    10.512,
                                                    -6.185
                                                ],
                                                [
                                                    12.132,
                                                    -6.185
                                                ],
                                                [
                                                    12.132,
                                                    -4.255
                                                ],
                                                [
                                                    14.02,
                                                    -4.255
                                                ],
                                                [
                                                    14.02,
                                                    -2.944
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.752
                                                ],
                                                [
                                                    0.038,
                                                    -0.234
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    -0.376
                                                ],
                                                [
                                                    -0.601,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.723
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.62,
                                                    -0.461
                                                ],
                                                [
                                                    0.911,
                                                    0
                                                ],
                                                [
                                                    0.592,
                                                    0.329
                                                ],
                                                [
                                                    0.339,
                                                    0.601
                                                ],
                                                [
                                                    0,
                                                    0.798
                                                ],
                                                [
                                                    -0.319,
                                                    0.601
                                                ],
                                                [
                                                    -0.582,
                                                    0.329
                                                ],
                                                [
                                                    -0.761,
                                                    0
                                                ],
                                                [
                                                    -0.573,
                                                    -0.319
                                                ],
                                                [
                                                    -0.319,
                                                    -0.582
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.62
                                                ],
                                                [
                                                    0.413,
                                                    0.375
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.713
                                                ],
                                                [
                                                    -0.61,
                                                    0.451
                                                ],
                                                [
                                                    -0.742,
                                                    0
                                                ],
                                                [
                                                    -0.582,
                                                    -0.338
                                                ],
                                                [
                                                    -0.328,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.799
                                                ],
                                                [
                                                    0.329,
                                                    -0.61
                                                ],
                                                [
                                                    0.592,
                                                    -0.328
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.573,
                                                    0.32
                                                ],
                                                [
                                                    0.32,
                                                    0.573
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    22.616,
                                                    -0.563
                                                ],
                                                [
                                                    22.559,
                                                    0.225
                                                ],
                                                [
                                                    16.628,
                                                    0.225
                                                ],
                                                [
                                                    17.318,
                                                    1.719
                                                ],
                                                [
                                                    18.84,
                                                    2.282
                                                ],
                                                [
                                                    20.671,
                                                    1.198
                                                ],
                                                [
                                                    22.404,
                                                    1.198
                                                ],
                                                [
                                                    21.122,
                                                    2.959
                                                ],
                                                [
                                                    18.84,
                                                    3.635
                                                ],
                                                [
                                                    16.839,
                                                    3.142
                                                ],
                                                [
                                                    15.458,
                                                    1.733
                                                ],
                                                [
                                                    14.965,
                                                    -0.38
                                                ],
                                                [
                                                    15.444,
                                                    -2.48
                                                ],
                                                [
                                                    16.811,
                                                    -3.889
                                                ],
                                                [
                                                    18.84,
                                                    -4.382
                                                ],
                                                [
                                                    20.798,
                                                    -3.903
                                                ],
                                                [
                                                    22.136,
                                                    -2.55
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.357
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.357
                                                ],
                                                [
                                                    0.075,
                                                    -0.601
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.009,
                                                    -0.592
                                                ],
                                                [
                                                    -0.413,
                                                    -0.357
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.939,
                                                    -1.071
                                                ],
                                                [
                                                    20.305,
                                                    -2.494
                                                ],
                                                [
                                                    18.769,
                                                    -3.029
                                                ],
                                                [
                                                    17.346,
                                                    -2.494
                                                ],
                                                [
                                                    16.642,
                                                    -1.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    0.216
                                                ],
                                                [
                                                    -0.536,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.329,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.235,
                                                    -0.394
                                                ],
                                                [
                                                    0.395,
                                                    -0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.629,
                                                    0
                                                ],
                                                [
                                                    -0.319,
                                                    0.319
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.802,
                                                    -3.128
                                                ],
                                                [
                                                    26.732,
                                                    -4.043
                                                ],
                                                [
                                                    28.127,
                                                    -4.382
                                                ],
                                                [
                                                    28.127,
                                                    -2.719
                                                ],
                                                [
                                                    27.718,
                                                    -2.719
                                                ],
                                                [
                                                    26.281,
                                                    -2.24
                                                ],
                                                [
                                                    25.802,
                                                    -0.578
                                                ],
                                                [
                                                    25.802,
                                                    3.508
                                                ],
                                                [
                                                    24.196,
                                                    3.508
                                                ],
                                                [
                                                    24.196,
                                                    -4.255
                                                ],
                                                [
                                                    25.802,
                                                    -4.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.3804,
                                            0.3804,
                                            0.3804
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            112.147,
                                            19.71
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.593
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -18.785
                                                ],
                                                [
                                                    108.014,
                                                    -18.785
                                                ],
                                                [
                                                    112.71,
                                                    -14.089
                                                ],
                                                [
                                                    112.71,
                                                    14.089
                                                ],
                                                [
                                                    108.014,
                                                    18.785
                                                ],
                                                [
                                                    -108.014,
                                                    18.785
                                                ],
                                                [
                                                    -112.71,
                                                    14.089
                                                ],
                                                [
                                                    -112.71,
                                                    -14.089
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.7529,
                                            0.7529,
                                            0.7529
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            112.71,
                                            18.785
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "isometric",
            "id": "15",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Pre-comp 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "550",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                380,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "16",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "Box 1 Outlines Comp 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "567",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                106,
                                106
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                374.333,
                                351
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "18",
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Box11 Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "571",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                38,
                                43
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                475,
                                679
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            38.011,
                                            10.924
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            47.126,
                                            27.238
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.82,
                                            27.179
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.183,
                                                    -0.109
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    -0.081
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.045
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.12,
                                                    0.063
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.356,
                                                    1.406
                                                ],
                                                [
                                                    17.299,
                                                    1.424
                                                ],
                                                [
                                                    16.794,
                                                    1.716
                                                ],
                                                [
                                                    16.696,
                                                    1.768
                                                ],
                                                [
                                                    16.69,
                                                    1.768
                                                ],
                                                [
                                                    16.306,
                                                    1.975
                                                ],
                                                [
                                                    1.386,
                                                    10.596
                                                ],
                                                [
                                                    1.346,
                                                    10.619
                                                ],
                                                [
                                                    1.358,
                                                    10.619
                                                ],
                                                [
                                                    1.335,
                                                    10.642
                                                ],
                                                [
                                                    1.237,
                                                    10.585
                                                ],
                                                [
                                                    1.18,
                                                    10.556
                                                ],
                                                [
                                                    -14.262,
                                                    1.871
                                                ],
                                                [
                                                    -16.484,
                                                    0.586
                                                ],
                                                [
                                                    -16.627,
                                                    0.499
                                                ],
                                                [
                                                    -17.356,
                                                    0.08
                                                ],
                                                [
                                                    1.323,
                                                    -10.642
                                                ],
                                                [
                                                    1.323,
                                                    -7.772
                                                ],
                                                [
                                                    13.734,
                                                    -0.672
                                                ],
                                                [
                                                    13.757,
                                                    -0.66
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            18.324,
                                            40.833
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.348,
                                                    -6.07
                                                ],
                                                [
                                                    9.325,
                                                    16.609
                                                ],
                                                [
                                                    9.291,
                                                    16.591
                                                ],
                                                [
                                                    -9.348,
                                                    5.938
                                                ],
                                                [
                                                    -9.331,
                                                    -16.609
                                                ],
                                                [
                                                    -8.516,
                                                    -16.155
                                                ],
                                                [
                                                    -8.372,
                                                    -16.069
                                                ],
                                                [
                                                    -6.151,
                                                    -14.783
                                                ],
                                                [
                                                    9.291,
                                                    -6.099
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            10.213,
                                            57.484
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.31,
                                                    0.077
                                                ],
                                                [
                                                    -1.249,
                                                    10.599
                                                ],
                                                [
                                                    -1.289,
                                                    10.622
                                                ],
                                                [
                                                    -1.3,
                                                    10.616
                                                ],
                                                [
                                                    -1.335,
                                                    10.593
                                                ],
                                                [
                                                    -1.358,
                                                    10.582
                                                ],
                                                [
                                                    -17.299,
                                                    1.317
                                                ],
                                                [
                                                    -17.31,
                                                    1.312
                                                ],
                                                [
                                                    -12.833,
                                                    -1.266
                                                ],
                                                [
                                                    -12.041,
                                                    -1.719
                                                ],
                                                [
                                                    -1.398,
                                                    -7.792
                                                ],
                                                [
                                                    -1.398,
                                                    -10.622
                                                ],
                                                [
                                                    17.276,
                                                    0.055
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            57.657,
                                            40.93
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.325,
                                                    5.915
                                                ],
                                                [
                                                    -9.262,
                                                    16.62
                                                ],
                                                [
                                                    -9.291,
                                                    16.637
                                                ],
                                                [
                                                    -9.325,
                                                    -6.041
                                                ],
                                                [
                                                    -9.314,
                                                    -6.036
                                                ],
                                                [
                                                    -9.274,
                                                    -6.059
                                                ],
                                                [
                                                    9.285,
                                                    -16.58
                                                ],
                                                [
                                                    9.251,
                                                    -16.603
                                                ],
                                                [
                                                    9.314,
                                                    -16.637
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            65.683,
                                            57.591
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.144,
                                                    -0.063
                                                ],
                                                [
                                                    0.081,
                                                    -0.052
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.121,
                                                    0.057
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    -0.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.184,
                                                    -0.109
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.306,
                                                    -0.563
                                                ],
                                                [
                                                    0.591,
                                                    9.586
                                                ],
                                                [
                                                    0.321,
                                                    9.695
                                                ],
                                                [
                                                    0.017,
                                                    9.85
                                                ],
                                                [
                                                    -0.264,
                                                    9.689
                                                ],
                                                [
                                                    -18.289,
                                                    -0.654
                                                ],
                                                [
                                                    -18.306,
                                                    -0.654
                                                ],
                                                [
                                                    -3.387,
                                                    -9.282
                                                ],
                                                [
                                                    -3.002,
                                                    -9.482
                                                ],
                                                [
                                                    -2.997,
                                                    -9.482
                                                ],
                                                [
                                                    -2.899,
                                                    -9.54
                                                ],
                                                [
                                                    -2.394,
                                                    -9.833
                                                ],
                                                [
                                                    -2.336,
                                                    -9.85
                                                ],
                                                [
                                                    -2.158,
                                                    -9.752
                                                ],
                                                [
                                                    -2.044,
                                                    -9.689
                                                ],
                                                [
                                                    -0.023,
                                                    -8.535
                                                ],
                                                [
                                                    -0.023,
                                                    -8.639
                                                ],
                                                [
                                                    -0.011,
                                                    -8.639
                                                ],
                                                [
                                                    -0.011,
                                                    -8.524
                                                ],
                                                [
                                                    1.774,
                                                    -9.546
                                                ],
                                                [
                                                    1.831,
                                                    -9.58
                                                ],
                                                [
                                                    2.342,
                                                    -9.838
                                                ],
                                                [
                                                    18.283,
                                                    -0.574
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            38.017,
                                            52.083
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.211,
                                                    6.104
                                                ],
                                                [
                                                    9.211,
                                                    6.133
                                                ],
                                                [
                                                    9.067,
                                                    6.219
                                                ],
                                                [
                                                    -9.205,
                                                    16.58
                                                ],
                                                [
                                                    -9.211,
                                                    12.843
                                                ],
                                                [
                                                    -9.211,
                                                    12.08
                                                ],
                                                [
                                                    -9.176,
                                                    -6.001
                                                ],
                                                [
                                                    -9.176,
                                                    -6.15
                                                ],
                                                [
                                                    -8.659,
                                                    -6.443
                                                ],
                                                [
                                                    -8.602,
                                                    -6.432
                                                ],
                                                [
                                                    9.113,
                                                    -16.58
                                                ],
                                                [
                                                    9.147,
                                                    -16.557
                                                ],
                                                [
                                                    9.182,
                                                    6.122
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            47.21,
                                            68.104
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.265,
                                                    -6.133
                                                ],
                                                [
                                                    9.265,
                                                    -5.967
                                                ],
                                                [
                                                    9.231,
                                                    12.114
                                                ],
                                                [
                                                    9.231,
                                                    12.878
                                                ],
                                                [
                                                    9.225,
                                                    16.655
                                                ],
                                                [
                                                    -9.265,
                                                    6.076
                                                ],
                                                [
                                                    -9.265,
                                                    6.007
                                                ],
                                                [
                                                    -9.231,
                                                    6.024
                                                ],
                                                [
                                                    -9.208,
                                                    -16.655
                                                ],
                                                [
                                                    -9.11,
                                                    -16.597
                                                ],
                                                [
                                                    -9.087,
                                                    -16.614
                                                ],
                                                [
                                                    -9.081,
                                                    -16.614
                                                ],
                                                [
                                                    -9.041,
                                                    -16.637
                                                ],
                                                [
                                                    8.984,
                                                    -6.294
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.767,
                                            68.07
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.321,
                                                    -4.451
                                                ],
                                                [
                                                    5.321,
                                                    -1.622
                                                ],
                                                [
                                                    -5.321,
                                                    4.451
                                                ],
                                                [
                                                    5.195,
                                                    -1.593
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            50.938,
                                            16.18
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.208,
                                                    4.988
                                                ],
                                                [
                                                    -6.208,
                                                    -2.112
                                                ],
                                                [
                                                    -6.202,
                                                    -4.982
                                                ],
                                                [
                                                    -6.197,
                                                    -4.988
                                                ],
                                                [
                                                    -6.145,
                                                    -2.118
                                                ],
                                                [
                                                    5.479,
                                                    4.558
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            25.849,
                                            16.589
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.195,
                                                    -1.593
                                                ],
                                                [
                                                    -5.321,
                                                    4.451
                                                ],
                                                [
                                                    5.321,
                                                    -1.622
                                                ],
                                                [
                                                    5.321,
                                                    -4.451
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            50.938,
                                            16.18
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 14",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.046
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.183,
                                                    -0.109
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.281,
                                                    -0.155
                                                ],
                                                [
                                                    -0.281,
                                                    0.155
                                                ],
                                                [
                                                    0.224,
                                                    -0.138
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.398,
                                            23.809
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 15",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.145,
                                                    10.608
                                                ],
                                                [
                                                    -6.185,
                                                    10.631
                                                ],
                                                [
                                                    -6.174,
                                                    10.631
                                                ],
                                                [
                                                    -6.168,
                                                    10.636
                                                ],
                                                [
                                                    -6.128,
                                                    10.613
                                                ],
                                                [
                                                    -6.145,
                                                    10.613
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.474,
                                                    -1.091
                                                ],
                                                [
                                                    -6.151,
                                                    -7.766
                                                ],
                                                [
                                                    -6.203,
                                                    -10.636
                                                ],
                                                [
                                                    -6.208,
                                                    -7.76
                                                ],
                                                [
                                                    6.208,
                                                    -0.66
                                                ],
                                                [
                                                    5.479,
                                                    -1.091
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            25.855,
                                            22.237
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 16",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.011,
                                                    -0.014
                                                ],
                                                [
                                                    -0.028,
                                                    0.009
                                                ],
                                                [
                                                    -0.017,
                                                    0.009
                                                ],
                                                [
                                                    -0.011,
                                                    0.014
                                                ],
                                                [
                                                    0.028,
                                                    -0.009
                                                ],
                                                [
                                                    0.011,
                                                    -0.009
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 2",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 2",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            19.698,
                                            32.861
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Crane Body Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "570",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                110,
                                90
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                374.033,
                                608.369
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.363
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.198,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            86.927,
                                            31.546
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.93
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.082,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            96.043,
                                            47.86
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            77.737,
                                            47.801
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.363
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.198,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            104.602,
                                            21.234
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            113.717,
                                            37.548
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.152,
                                                    15.217
                                                ],
                                                [
                                                    7.037,
                                                    15.154
                                                ],
                                                [
                                                    6.859,
                                                    15.056
                                                ],
                                                [
                                                    3.26,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.508,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.144,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            95.411,
                                            37.492
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.363
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            68.517,
                                            21.234
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            77.633,
                                            37.548
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.167,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            59.327,
                                            37.492
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.795,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            86.192,
                                            10.924
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.121,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            95.307,
                                            27.238
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.167,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            77,
                                            27.183
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.198,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            86.927,
                                            53.635
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 14",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.082,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            96.043,
                                            69.953
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 15",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            77.737,
                                            69.893
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 16",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.363
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.198,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            104.602,
                                            43.33
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 17",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            113.717,
                                            59.644
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 18",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.371
                                                ],
                                                [
                                                    7.152,
                                                    15.217
                                                ],
                                                [
                                                    7.037,
                                                    15.154
                                                ],
                                                [
                                                    6.859,
                                                    15.056
                                                ],
                                                [
                                                    3.26,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.508,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.371
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.144,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            95.411,
                                            59.584
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 19",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.363
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            68.517,
                                            43.33
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 20",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            77.633,
                                            59.644
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 21",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.371
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.167,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.371
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            59.327,
                                            59.584
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 22",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.363
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.795,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            86.192,
                                            33.017
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 23",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.121,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            95.307,
                                            49.331
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 24",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.371
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.167,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.371
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            77,
                                            49.275
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 25",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.322
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.299
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            55.999,
                                            145.689
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 26",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.07
                                                ],
                                                [
                                                    9.007,
                                                    5.93
                                                ],
                                                [
                                                    -1.51,
                                                    11.973
                                                ],
                                                [
                                                    -2.302,
                                                    12.428
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.324
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.301
                                                ],
                                                [
                                                    9.122,
                                                    -16.324
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            65.114,
                                            162.007
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 27",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            46.807,
                                            161.947
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 28",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            73.673,
                                            135.38
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 29",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.324
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.953
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            82.787,
                                            151.698
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 30",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.896
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.216
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.055
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.977
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.871
                                                ],
                                                [
                                                    -9.167,
                                                    3.001
                                                ],
                                                [
                                                    -9.173,
                                                    3.007
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.913
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            64.481,
                                            151.639
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 31",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.363
                                                ],
                                                [
                                                    -0.046,
                                                    10.346
                                                ],
                                                [
                                                    -18.209,
                                                    -0.032
                                                ],
                                                [
                                                    -3.795,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.014
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            90.61,
                                            125.804
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 32",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.07
                                                ],
                                                [
                                                    9.007,
                                                    5.93
                                                ],
                                                [
                                                    -1.51,
                                                    11.973
                                                ],
                                                [
                                                    -2.302,
                                                    12.426
                                                ],
                                                [
                                                    -7.279,
                                                    15.269
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.297
                                                ],
                                                [
                                                    9.081,
                                                    -16.301
                                                ],
                                                [
                                                    9.121,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            99.725,
                                            142.122
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 33",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.057
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.979
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.167,
                                                    3.003
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.289
                                                ],
                                                [
                                                    9.145,
                                                    -5.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            81.418,
                                            142.063
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 34",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.419,
                                                    -1.763
                                                ],
                                                [
                                                    0.516,
                                                    -0.316
                                                ],
                                                [
                                                    0.482,
                                                    0
                                                ],
                                                [
                                                    0.327,
                                                    0.161
                                                ],
                                                [
                                                    -0.264,
                                                    2.514
                                                ],
                                                [
                                                    -1.32,
                                                    0.23
                                                ],
                                                [
                                                    -0.97,
                                                    -1.033
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.19,
                                                    0.78
                                                ],
                                                [
                                                    -0.436,
                                                    0.27
                                                ],
                                                [
                                                    -0.368,
                                                    0
                                                ],
                                                [
                                                    -2.273,
                                                    -1.102
                                                ],
                                                [
                                                    0.121,
                                                    -1.142
                                                ],
                                                [
                                                    1.073,
                                                    -0.183
                                                ],
                                                [
                                                    1.407,
                                                    1.504
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.436,
                                                    2.414
                                                ],
                                                [
                                                    2.282,
                                                    4.222
                                                ],
                                                [
                                                    0.87,
                                                    4.629
                                                ],
                                                [
                                                    -0.181,
                                                    4.394
                                                ],
                                                [
                                                    -3.591,
                                                    -1.742
                                                ],
                                                [
                                                    -1.415,
                                                    -4.446
                                                ],
                                                [
                                                    1.759,
                                                    -3.131
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            168.641,
                                            20.725
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 35",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.808,
                                                    0.058
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.792,
                                                    -0.982
                                                ],
                                                [
                                                    0.074,
                                                    -1.991
                                                ],
                                                [
                                                    0,
                                                    -0.138
                                                ],
                                                [
                                                    0,
                                                    -0.126
                                                ],
                                                [
                                                    -0.746,
                                                    -1.641
                                                ],
                                                [
                                                    -0.063,
                                                    -0.121
                                                ],
                                                [
                                                    -0.098,
                                                    -0.172
                                                ],
                                                [
                                                    -0.057,
                                                    -0.098
                                                ],
                                                [
                                                    -0.115,
                                                    -0.178
                                                ],
                                                [
                                                    -3.324,
                                                    -0.339
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.425,
                                                    0.069
                                                ],
                                                [
                                                    -0.006,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.609,
                                                    0.735
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.04,
                                                    1.533
                                                ],
                                                [
                                                    3.525,
                                                    2.743
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.309,
                                                    -1.016
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.102,
                                                    0.132
                                                ],
                                                [
                                                    -1.016,
                                                    1.251
                                                ],
                                                [
                                                    0,
                                                    0.138
                                                ],
                                                [
                                                    0,
                                                    0.126
                                                ],
                                                [
                                                    0.086,
                                                    1.693
                                                ],
                                                [
                                                    0.057,
                                                    0.121
                                                ],
                                                [
                                                    0.08,
                                                    0.172
                                                ],
                                                [
                                                    0.051,
                                                    0.104
                                                ],
                                                [
                                                    0.109,
                                                    0.178
                                                ],
                                                [
                                                    1.728,
                                                    2.617
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.425,
                                                    0.005
                                                ],
                                                [
                                                    0.011,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.027,
                                                    -0.264
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.82,
                                                    -1.245
                                                ],
                                                [
                                                    0.11,
                                                    -4.403
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.011,
                                                    -7.878
                                                ],
                                                [
                                                    -2.616,
                                                    -9.474
                                                ],
                                                [
                                                    -3.041,
                                                    -9.485
                                                ],
                                                [
                                                    -5.957,
                                                    -7.872
                                                ],
                                                [
                                                    -7.575,
                                                    -3.057
                                                ],
                                                [
                                                    -7.575,
                                                    -2.649
                                                ],
                                                [
                                                    -7.575,
                                                    -2.27
                                                ],
                                                [
                                                    -6.324,
                                                    2.838
                                                ],
                                                [
                                                    -6.146,
                                                    3.206
                                                ],
                                                [
                                                    -5.876,
                                                    3.722
                                                ],
                                                [
                                                    -5.71,
                                                    4.021
                                                ],
                                                [
                                                    -5.377,
                                                    4.555
                                                ],
                                                [
                                                    2.344,
                                                    9.48
                                                ],
                                                [
                                                    2.361,
                                                    9.48
                                                ],
                                                [
                                                    3.607,
                                                    9.365
                                                ],
                                                [
                                                    3.63,
                                                    9.365
                                                ],
                                                [
                                                    3.636,
                                                    9.365
                                                ],
                                                [
                                                    6.07,
                                                    7.809
                                                ],
                                                [
                                                    6.075,
                                                    7.809
                                                ],
                                                [
                                                    6.202,
                                                    7.608
                                                ],
                                                [
                                                    7.464,
                                                    3.533
                                                ],
                                                [
                                                    2.011,
                                                    -7.872
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.419,
                                                    -1.762
                                                ],
                                                [
                                                    0.517,
                                                    -0.316
                                                ],
                                                [
                                                    0.482,
                                                    0
                                                ],
                                                [
                                                    0.327,
                                                    0.161
                                                ],
                                                [
                                                    -0.264,
                                                    2.514
                                                ],
                                                [
                                                    -1.32,
                                                    0.229
                                                ],
                                                [
                                                    -0.97,
                                                    -1.033
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.189,
                                                    0.781
                                                ],
                                                [
                                                    -0.436,
                                                    0.27
                                                ],
                                                [
                                                    -0.367,
                                                    0
                                                ],
                                                [
                                                    -2.274,
                                                    -1.102
                                                ],
                                                [
                                                    0.12,
                                                    -1.142
                                                ],
                                                [
                                                    1.074,
                                                    -0.184
                                                ],
                                                [
                                                    1.406,
                                                    1.504
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.314,
                                                    2.494
                                                ],
                                                [
                                                    2.16,
                                                    4.302
                                                ],
                                                [
                                                    0.748,
                                                    4.71
                                                ],
                                                [
                                                    -0.302,
                                                    4.474
                                                ],
                                                [
                                                    -3.712,
                                                    -1.662
                                                ],
                                                [
                                                    -1.537,
                                                    -4.365
                                                ],
                                                [
                                                    1.638,
                                                    -3.051
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            168.763,
                                            20.64
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 36",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    1.848
                                                ],
                                                [
                                                    3.288,
                                                    2.549
                                                ],
                                                [
                                                    1.711,
                                                    -0.212
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.31,
                                                    -1.016
                                                ],
                                                [
                                                    0.11,
                                                    -4.403
                                                ],
                                                [
                                                    0.821,
                                                    -1.245
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.086,
                                                    -1.321
                                                ],
                                                [
                                                    -0.184,
                                                    -4.184
                                                ],
                                                [
                                                    -1.488,
                                                    -1.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.808,
                                                    0.057
                                                ],
                                                [
                                                    3.524,
                                                    2.743
                                                ],
                                                [
                                                    -0.041,
                                                    1.533
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.055,
                                                    7.893
                                                ],
                                                [
                                                    7.508,
                                                    2.824
                                                ],
                                                [
                                                    2.038,
                                                    -7.772
                                                ],
                                                [
                                                    -3.061,
                                                    -9.391
                                                ],
                                                [
                                                    -2.635,
                                                    -9.379
                                                ],
                                                [
                                                    1.992,
                                                    -7.783
                                                ],
                                                [
                                                    7.445,
                                                    3.622
                                                ],
                                                [
                                                    6.182,
                                                    7.697
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.425,
                                                    0.006
                                                ],
                                                [
                                                    -0.104,
                                                    -0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    0.068
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.104,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.023
                                                ],
                                                [
                                                    -0.424,
                                                    0.068
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.341,
                                                    9.574
                                                ],
                                                [
                                                    2.652,
                                                    9.603
                                                ],
                                                [
                                                    2.691,
                                                    9.603
                                                ],
                                                [
                                                    3.587,
                                                    9.46
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.086,
                                                    1.693
                                                ],
                                                [
                                                    -0.763,
                                                    -1.619
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.05,
                                                    1.727
                                                ],
                                                [
                                                    -0.746,
                                                    -1.641
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.594,
                                                    -2.175
                                                ],
                                                [
                                                    -6.344,
                                                    2.933
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            168.783,
                                            20.55
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 37",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    2.239,
                                                    -2.669
                                                ],
                                                [
                                                    1.01,
                                                    0
                                                ],
                                                [
                                                    0.654,
                                                    0.396
                                                ],
                                                [
                                                    -0.379,
                                                    3.163
                                                ],
                                                [
                                                    -1.522,
                                                    0.322
                                                ],
                                                [
                                                    -1.096,
                                                    -0.987
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.66,
                                                    0.786
                                                ],
                                                [
                                                    -0.694,
                                                    0
                                                ],
                                                [
                                                    -2.698,
                                                    -1.647
                                                ],
                                                [
                                                    0.207,
                                                    -1.71
                                                ],
                                                [
                                                    1.268,
                                                    -0.275
                                                ],
                                                [
                                                    2.71,
                                                    2.44
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.361,
                                                    4.951
                                                ],
                                                [
                                                    0.726,
                                                    6.15
                                                ],
                                                [
                                                    -1.34,
                                                    5.559
                                                ],
                                                [
                                                    -5.221,
                                                    -2.477
                                                ],
                                                [
                                                    -2.339,
                                                    -5.875
                                                ],
                                                [
                                                    1.432,
                                                    -4.733
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            138.871,
                                            42.548
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 38",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.154,
                                                    0.058
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.671,
                                                    -0.516
                                                ],
                                                [
                                                    0.252,
                                                    -2.446
                                                ],
                                                [
                                                    -2.624,
                                                    -3.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.046,
                                                    0.529
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.092,
                                                    0.706
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.586,
                                                    2.738
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.004,
                                                    -0.494
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.844,
                                                    0.132
                                                ],
                                                [
                                                    -1.682,
                                                    1.281
                                                ],
                                                [
                                                    -0.397,
                                                    3.782
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.574
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    -0.706
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.896,
                                                    -6.705
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.149,
                                                    -34.067
                                                ],
                                                [
                                                    -3.1,
                                                    -34.676
                                                ],
                                                [
                                                    -3.616,
                                                    -34.704
                                                ],
                                                [
                                                    -3.622,
                                                    -34.704
                                                ],
                                                [
                                                    -5.918,
                                                    -33.729
                                                ],
                                                [
                                                    -8.88,
                                                    -28.034
                                                ],
                                                [
                                                    -5.103,
                                                    -16.382
                                                ],
                                                [
                                                    -5.103,
                                                    20.021
                                                ],
                                                [
                                                    -5.046,
                                                    27.54
                                                ],
                                                [
                                                    7.991,
                                                    34.704
                                                ],
                                                [
                                                    8.008,
                                                    34.692
                                                ],
                                                [
                                                    8.008,
                                                    34.663
                                                ],
                                                [
                                                    7.991,
                                                    34.675
                                                ],
                                                [
                                                    7.951,
                                                    -0.729
                                                ],
                                                [
                                                    7.951,
                                                    -13.116
                                                ],
                                                [
                                                    8.037,
                                                    -14.764
                                                ],
                                                [
                                                    8.037,
                                                    -14.775
                                                ],
                                                [
                                                    8.289,
                                                    -16.864
                                                ],
                                                [
                                                    8.381,
                                                    -17.501
                                                ],
                                                [
                                                    0.149,
                                                    -34.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    2.239,
                                                    -2.669
                                                ],
                                                [
                                                    1.01,
                                                    0
                                                ],
                                                [
                                                    0.655,
                                                    0.396
                                                ],
                                                [
                                                    -0.379,
                                                    3.163
                                                ],
                                                [
                                                    -1.522,
                                                    0.321
                                                ],
                                                [
                                                    -1.096,
                                                    -0.987
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.66,
                                                    0.786
                                                ],
                                                [
                                                    -0.695,
                                                    0
                                                ],
                                                [
                                                    -2.698,
                                                    -1.647
                                                ],
                                                [
                                                    0.207,
                                                    -1.71
                                                ],
                                                [
                                                    1.268,
                                                    -0.276
                                                ],
                                                [
                                                    2.71,
                                                    2.44
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.588,
                                                    -18.454
                                                ],
                                                [
                                                    0.953,
                                                    -17.255
                                                ],
                                                [
                                                    -1.114,
                                                    -17.846
                                                ],
                                                [
                                                    -4.994,
                                                    -25.882
                                                ],
                                                [
                                                    -2.112,
                                                    -29.28
                                                ],
                                                [
                                                    1.659,
                                                    -28.138
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            138.644,
                                            65.95
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 39",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.904,
                                                    34.765
                                                ],
                                                [
                                                    -7.133,
                                                    27.601
                                                ],
                                                [
                                                    -7.19,
                                                    20.082
                                                ],
                                                [
                                                    -7.19,
                                                    27.635
                                                ],
                                                [
                                                    5.927,
                                                    34.793
                                                ],
                                                [
                                                    5.927,
                                                    34.753
                                                ],
                                                [
                                                    5.91,
                                                    34.765
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.574
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.046,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.95,
                                                    -14.703
                                                ],
                                                [
                                                    5.87,
                                                    -13.056
                                                ],
                                                [
                                                    5.87,
                                                    -0.669
                                                ],
                                                [
                                                    5.904,
                                                    34.736
                                                ],
                                                [
                                                    5.921,
                                                    34.724
                                                ],
                                                [
                                                    6.002,
                                                    14.887
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    3.278,
                                                    3.553
                                                ],
                                                [
                                                    1.59,
                                                    0.592
                                                ],
                                                [
                                                    1.016,
                                                    -0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.005,
                                                    -0.493
                                                ],
                                                [
                                                    0.896,
                                                    -6.704
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    -0.706
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.498,
                                                    -1.63
                                                ],
                                                [
                                                    -1.108,
                                                    -0.419
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.154,
                                                    0.057
                                                ],
                                                [
                                                    5.585,
                                                    2.738
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.092,
                                                    0.706
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.511,
                                                    -4.982
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.058,
                                                    -30.993
                                                ],
                                                [
                                                    -2.471,
                                                    -34.248
                                                ],
                                                [
                                                    -5.703,
                                                    -34.638
                                                ],
                                                [
                                                    -5.187,
                                                    -34.609
                                                ],
                                                [
                                                    -1.937,
                                                    -34.001
                                                ],
                                                [
                                                    6.294,
                                                    -17.441
                                                ],
                                                [
                                                    6.203,
                                                    -16.804
                                                ],
                                                [
                                                    5.95,
                                                    -14.714
                                                ],
                                                [
                                                    6.409,
                                                    -17.556
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            140.73,
                                            65.887
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 40",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.149,
                                                    -0.305
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.727,
                                                    -0.447
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.022,
                                                    -0.397
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.607,
                                                    -0.734
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.295,
                                                    -0.436
                                                ],
                                                [
                                                    1.177,
                                                    1.027
                                                ],
                                                [
                                                    0.729,
                                                    0.85
                                                ],
                                                [
                                                    -2.704,
                                                    0.362
                                                ],
                                                [
                                                    -3.295,
                                                    0.339
                                                ],
                                                [
                                                    -2.198,
                                                    -0.161
                                                ],
                                                [
                                                    2.761,
                                                    -0.58
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            144.494,
                                            26.971
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 41",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.229,
                                                    -0.029
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.194,
                                                    0.046
                                                ],
                                                [
                                                    -1.022,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.228,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.189,
                                                    -0.092
                                                ],
                                                [
                                                    1.149,
                                                    -0.304
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.042,
                                                    -0.657
                                                ],
                                                [
                                                    0.672,
                                                    1.679
                                                ],
                                                [
                                                    0.695,
                                                    1.696
                                                ],
                                                [
                                                    0.626,
                                                    1.742
                                                ],
                                                [
                                                    -3.128,
                                                    0.824
                                                ],
                                                [
                                                    -3.139,
                                                    0.824
                                                ],
                                                [
                                                    -4.207,
                                                    0.772
                                                ],
                                                [
                                                    -0.246,
                                                    -1.225
                                                ],
                                                [
                                                    0.327,
                                                    -1.438
                                                ],
                                                [
                                                    3.761,
                                                    -0.95
                                                ],
                                                [
                                                    4.208,
                                                    -0.772
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            141.462,
                                            28.771
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 42",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.111,
                                                    -0.809
                                                ],
                                                [
                                                    -1.008,
                                                    0.654
                                                ],
                                                [
                                                    -1.174,
                                                    0.769
                                                ],
                                                [
                                                    -1.128,
                                                    0.792
                                                ],
                                                [
                                                    -1.094,
                                                    0.809
                                                ],
                                                [
                                                    1.174,
                                                    -0.792
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.68,
                                            27.342
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 43",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.712,
                                                    -0.511
                                                ],
                                                [
                                                    0.005,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    -0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.138,
                                                    0.402
                                                ],
                                                [
                                                    -0.023,
                                                    0.063
                                                ],
                                                [
                                                    -0.04,
                                                    0.471
                                                ],
                                                [
                                                    -0.006,
                                                    0.086
                                                ],
                                                [
                                                    0.017,
                                                    0.447
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.505,
                                                    0.413
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.735,
                                                    -1.084
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.666,
                                                    0.695
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.058,
                                                    0.023
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.396
                                                ],
                                                [
                                                    0.029,
                                                    -0.069
                                                ],
                                                [
                                                    0.149,
                                                    -0.442
                                                ],
                                                [
                                                    0.011,
                                                    -0.086
                                                ],
                                                [
                                                    0.034,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.58,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.155,
                                                    1.371
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.096,
                                                    0.898
                                                ],
                                                [
                                                    0.741,
                                                    1.271
                                                ],
                                                [
                                                    -1.303,
                                                    3.062
                                                ],
                                                [
                                                    -1.32,
                                                    3.062
                                                ],
                                                [
                                                    -1.493,
                                                    3.12
                                                ],
                                                [
                                                    -2.153,
                                                    3.303
                                                ],
                                                [
                                                    -1.82,
                                                    2.701
                                                ],
                                                [
                                                    -1.28,
                                                    1.507
                                                ],
                                                [
                                                    -1.211,
                                                    1.312
                                                ],
                                                [
                                                    -0.924,
                                                    -0.055
                                                ],
                                                [
                                                    -0.901,
                                                    -0.319
                                                ],
                                                [
                                                    -0.878,
                                                    -1.581
                                                ],
                                                [
                                                    -0.878,
                                                    -1.759
                                                ],
                                                [
                                                    0.224,
                                                    -2.368
                                                ],
                                                [
                                                    0.27,
                                                    -2.391
                                                ],
                                                [
                                                    1.946,
                                                    -3.303
                                                ],
                                                [
                                                    1.998,
                                                    -2.884
                                                ],
                                                [
                                                    1.096,
                                                    0.892
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            156.056,
                                            46.772
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 44",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.505,
                                                    0.413
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.58,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.051,
                                                    -2.267
                                                ],
                                                [
                                                    1.625,
                                                    -3.18
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.712,
                                                    -0.511
                                                ],
                                                [
                                                    -0.361,
                                                    0.361
                                                ],
                                                [
                                                    -0.092,
                                                    0.092
                                                ],
                                                [
                                                    -0.224,
                                                    0.344
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.666,
                                                    0.695
                                                ],
                                                [
                                                    0.585,
                                                    -0.207
                                                ],
                                                [
                                                    0.092,
                                                    -0.092
                                                ],
                                                [
                                                    0.31,
                                                    -0.287
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.42,
                                                    1.389
                                                ],
                                                [
                                                    -1.624,
                                                    3.18
                                                ],
                                                [
                                                    -0.304,
                                                    2.239
                                                ],
                                                [
                                                    -0.028,
                                                    1.963
                                                ],
                                                [
                                                    0.775,
                                                    1.016
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.138,
                                                    -0.436
                                                ],
                                                [
                                                    -0.04,
                                                    0.471
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.15,
                                                    -0.442
                                                ],
                                                [
                                                    -0.053,
                                                    0.482
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -1.533,
                                                    1.435
                                                ],
                                                [
                                                    -1.245,
                                                    0.069
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            156.376,
                                            46.66
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 45",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.642,
                                                    -1.269
                                                ],
                                                [
                                                    3.476,
                                                    -1.154
                                                ],
                                                [
                                                    0.106,
                                                    1.182
                                                ],
                                                [
                                                    0.129,
                                                    1.2
                                                ],
                                                [
                                                    3.522,
                                                    -1.131
                                                ],
                                                [
                                                    3.694,
                                                    -1.246
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.228,
                                                    -0.029
                                                ],
                                                [
                                                    -1.252,
                                                    -0.545
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.251,
                                                    0.069
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.228,
                                                    -0.597
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.694,
                                                    0.327
                                                ],
                                                [
                                                    -0.123,
                                                    1.205
                                                ],
                                                [
                                                    0.026,
                                                    1.269
                                                ],
                                                [
                                                    0.06,
                                                    1.246
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            142.028,
                                            29.269
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 46",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.023,
                                                    -0.333
                                                ],
                                                [
                                                    0.011,
                                                    -0.086
                                                ],
                                                [
                                                    0.138,
                                                    -0.436
                                                ],
                                                [
                                                    0.029,
                                                    -0.069
                                                ],
                                                [
                                                    1.027,
                                                    -0.746
                                                ],
                                                [
                                                    0.012,
                                                    -0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.183,
                                                    1.9
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.373,
                                                    0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.006,
                                                    0.086
                                                ],
                                                [
                                                    -0.052,
                                                    0.482
                                                ],
                                                [
                                                    -0.023,
                                                    0.064
                                                ],
                                                [
                                                    -0.419,
                                                    1.119
                                                ],
                                                [
                                                    -0.012,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.465,
                                                    -1.762
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    -0.183
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.034,
                                                    0.339
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.919,
                                                    -2.543
                                                ],
                                                [
                                                    2.896,
                                                    -2.279
                                                ],
                                                [
                                                    2.609,
                                                    -0.913
                                                ],
                                                [
                                                    2.54,
                                                    -0.717
                                                ],
                                                [
                                                    0.342,
                                                    2.141
                                                ],
                                                [
                                                    0.301,
                                                    2.17
                                                ],
                                                [
                                                    -2.942,
                                                    3.972
                                                ],
                                                [
                                                    -1.846,
                                                    -1.498
                                                ],
                                                [
                                                    0.232,
                                                    -2.594
                                                ],
                                                [
                                                    0.307,
                                                    -2.635
                                                ],
                                                [
                                                    1.484,
                                                    -3.249
                                                ],
                                                [
                                                    1.518,
                                                    -3.272
                                                ],
                                                [
                                                    2.85,
                                                    -3.972
                                                ],
                                                [
                                                    2.896,
                                                    -3.553
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            152.235,
                                            49.006
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 47",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.183,
                                                    1.899
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.597,
                                                    -1.796
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.464,
                                                    -1.762
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.12,
                                                    1.538
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.801,
                                                    3.516
                                                ],
                                                [
                                                    -1.706,
                                                    -1.954
                                                ],
                                                [
                                                    -1.757,
                                                    -1.926
                                                ],
                                                [
                                                    -1.769,
                                                    -1.765
                                                ],
                                                [
                                                    -2.796,
                                                    2.993
                                                ],
                                                [
                                                    -3.036,
                                                    3.705
                                                ],
                                                [
                                                    0.441,
                                                    1.713
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.373,
                                                    0.218
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.413,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.447,
                                                    -3.091
                                                ],
                                                [
                                                    1.624,
                                                    -3.705
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.138,
                                                    -0.436
                                                ],
                                                [
                                                    -0.04,
                                                    0.471
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.149,
                                                    -0.442
                                                ],
                                                [
                                                    -0.052,
                                                    0.482
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.749,
                                                    -1.369
                                                ],
                                                [
                                                    3.036,
                                                    -2.735
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            152.094,
                                            49.466
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 48",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.683,
                                                    -0.419
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.855,
                                                    0
                                                ],
                                                [
                                                    0.706,
                                                    0.425
                                                ],
                                                [
                                                    0.012,
                                                    0.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.104,
                                                    0
                                                ],
                                                [
                                                    -0.27,
                                                    0.08
                                                ],
                                                [
                                                    -0.316,
                                                    0.167
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.011,
                                                    0.603
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.678,
                                                    0.338
                                                ],
                                                [
                                                    -0.97,
                                                    0
                                                ],
                                                [
                                                    -0.62,
                                                    -0.379
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.012
                                                ],
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.551,
                                                    1.814
                                                ],
                                                [
                                                    2.535,
                                                    3.352
                                                ],
                                                [
                                                    2.512,
                                                    3.364
                                                ],
                                                [
                                                    0.124,
                                                    3.869
                                                ],
                                                [
                                                    -2.528,
                                                    3.226
                                                ],
                                                [
                                                    -3.499,
                                                    1.791
                                                ],
                                                [
                                                    -3.499,
                                                    1.762
                                                ],
                                                [
                                                    -3.562,
                                                    -0.89
                                                ],
                                                [
                                                    -3.544,
                                                    -0.89
                                                ],
                                                [
                                                    -3.234,
                                                    -0.872
                                                ],
                                                [
                                                    -2.402,
                                                    -0.987
                                                ],
                                                [
                                                    -1.386,
                                                    -1.286
                                                ],
                                                [
                                                    -0.76,
                                                    -1.619
                                                ],
                                                [
                                                    -0.823,
                                                    -1.487
                                                ],
                                                [
                                                    2.782,
                                                    -3.496
                                                ],
                                                [
                                                    3.482,
                                                    -3.869
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            211.006,
                                            57.795
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 49",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.379,
                                                    0.565
                                                ],
                                                [
                                                    -0.442,
                                                    0.697
                                                ],
                                                [
                                                    3.163,
                                                    -1.312
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.316,
                                                    -0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    0
                                                ],
                                                [
                                                    -0.269,
                                                    0.08
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.012
                                                ],
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    0.04
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.905,
                                                    1.277
                                                ],
                                                [
                                                    -3.163,
                                                    1.294
                                                ],
                                                [
                                                    -2.853,
                                                    1.312
                                                ],
                                                [
                                                    -2.021,
                                                    1.197
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            210.623,
                                            55.614
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 50",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.023,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.293,
                                                    -0.149
                                                ],
                                                [
                                                    0.431,
                                                    -0.258
                                                ],
                                                [
                                                    0.098,
                                                    -0.057
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.345,
                                                    -0.097
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.005,
                                                    0.023
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.212,
                                                    -0.005
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.104,
                                                    -0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.281,
                                                    0.069
                                                ],
                                                [
                                                    -0.007,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.195,
                                                    0.035
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.287,
                                                    0.121
                                                ],
                                                [
                                                    -0.477,
                                                    0.23
                                                ],
                                                [
                                                    -0.098,
                                                    0.057
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.143
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.235,
                                                    0.034
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.023
                                                ],
                                                [
                                                    0.012,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.185,
                                                    -0.029
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.799,
                                                    -8.69
                                                ],
                                                [
                                                    2.437,
                                                    -0.672
                                                ],
                                                [
                                                    -4.147,
                                                    5.028
                                                ],
                                                [
                                                    -4.222,
                                                    5.086
                                                ],
                                                [
                                                    -5.898,
                                                    6.004
                                                ],
                                                [
                                                    -5.944,
                                                    6.027
                                                ],
                                                [
                                                    -6.822,
                                                    6.423
                                                ],
                                                [
                                                    -8.177,
                                                    7.175
                                                ],
                                                [
                                                    -8.47,
                                                    7.347
                                                ],
                                                [
                                                    -8.505,
                                                    7.37
                                                ],
                                                [
                                                    -9.681,
                                                    7.984
                                                ],
                                                [
                                                    -9.757,
                                                    8.025
                                                ],
                                                [
                                                    -10.727,
                                                    8.386
                                                ],
                                                [
                                                    -11.799,
                                                    8.69
                                                ],
                                                [
                                                    -11.799,
                                                    8.622
                                                ],
                                                [
                                                    -11.794,
                                                    8.622
                                                ],
                                                [
                                                    -7.408,
                                                    4.822
                                                ],
                                                [
                                                    8.069,
                                                    -8.329
                                                ],
                                                [
                                                    8.086,
                                                    -8.346
                                                ],
                                                [
                                                    8.212,
                                                    -8.323
                                                ],
                                                [
                                                    8.883,
                                                    -8.266
                                                ],
                                                [
                                                    8.9,
                                                    -8.266
                                                ],
                                                [
                                                    9.211,
                                                    -8.237
                                                ],
                                                [
                                                    9.251,
                                                    -8.237
                                                ],
                                                [
                                                    10.146,
                                                    -8.38
                                                ],
                                                [
                                                    10.17,
                                                    -8.38
                                                ],
                                                [
                                                    10.174,
                                                    -8.38
                                                ],
                                                [
                                                    10.743,
                                                    -8.484
                                                ],
                                                [
                                                    11.799,
                                                    -8.685
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            162.223,
                                            38.389
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 51",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.373,
                                                    0.218
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.413,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -8.763,
                                                    7.804
                                                ],
                                                [
                                                    -7.586,
                                                    7.189
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.505,
                                                    0.413
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.58,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.98,
                                                    5.823
                                                ],
                                                [
                                                    -3.304,
                                                    4.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.006,
                                                    0.023
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.913,
                                                    1.547
                                                ],
                                                [
                                                    -10.875,
                                                    8.401
                                                ],
                                                [
                                                    -10.915,
                                                    8.429
                                                ],
                                                [
                                                    -11.065,
                                                    8.561
                                                ],
                                                [
                                                    -10.881,
                                                    8.51
                                                ],
                                                [
                                                    -10.881,
                                                    8.441
                                                ],
                                                [
                                                    -10.875,
                                                    8.441
                                                ],
                                                [
                                                    -6.49,
                                                    4.641
                                                ],
                                                [
                                                    8.987,
                                                    -8.51
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.425,
                                                    0.005
                                                ],
                                                [
                                                    -0.103,
                                                    -0.005
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.282,
                                                    0.069
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.103,
                                                    0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.023
                                                ],
                                                [
                                                    -0.425,
                                                    0.069
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.819,
                                                    -8.446
                                                ],
                                                [
                                                    10.129,
                                                    -8.418
                                                ],
                                                [
                                                    10.169,
                                                    -8.418
                                                ],
                                                [
                                                    11.065,
                                                    -8.561
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            161.304,
                                            38.572
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 52",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    0.024,
                                                    -0.144
                                                ],
                                                [
                                                    0.039,
                                                    -0.178
                                                ],
                                                [
                                                    0,
                                                    -0.011
                                                ],
                                                [
                                                    0.013,
                                                    -0.017
                                                ],
                                                [
                                                    0.659,
                                                    -0.764
                                                ],
                                                [
                                                    0.786,
                                                    -0.356
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    1.849
                                                ],
                                                [
                                                    3.29,
                                                    2.549
                                                ],
                                                [
                                                    1.711,
                                                    -0.213
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.245,
                                                    -0.189
                                                ],
                                                [
                                                    -0.569,
                                                    -0.241
                                                ],
                                                [
                                                    -0.016,
                                                    -0.011
                                                ],
                                                [
                                                    -1.319,
                                                    -1.774
                                                ],
                                                [
                                                    -0.177,
                                                    -0.276
                                                ],
                                                [
                                                    -0.074,
                                                    -0.126
                                                ],
                                                [
                                                    -0.218,
                                                    -0.454
                                                ],
                                                [
                                                    0.264,
                                                    -2.336
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    0.144
                                                ],
                                                [
                                                    -0.034,
                                                    0.178
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    0,
                                                    0.017
                                                ],
                                                [
                                                    -0.246,
                                                    0.999
                                                ],
                                                [
                                                    -0.477,
                                                    0.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.084,
                                                    -1.326
                                                ],
                                                [
                                                    -0.184,
                                                    -4.184
                                                ],
                                                [
                                                    -1.487,
                                                    -1.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.925,
                                                    -0.769
                                                ],
                                                [
                                                    0.586,
                                                    0.115
                                                ],
                                                [
                                                    0.017,
                                                    0.006
                                                ],
                                                [
                                                    1.827,
                                                    0.827
                                                ],
                                                [
                                                    0.19,
                                                    0.258
                                                ],
                                                [
                                                    0.08,
                                                    0.12
                                                ],
                                                [
                                                    0.254,
                                                    0.419
                                                ],
                                                [
                                                    1.096,
                                                    2.009
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.527,
                                                    4.339
                                                ],
                                                [
                                                    6.527,
                                                    4.368
                                                ],
                                                [
                                                    6.469,
                                                    4.793
                                                ],
                                                [
                                                    6.361,
                                                    5.327
                                                ],
                                                [
                                                    6.355,
                                                    5.361
                                                ],
                                                [
                                                    6.342,
                                                    5.407
                                                ],
                                                [
                                                    5.006,
                                                    8.088
                                                ],
                                                [
                                                    3.135,
                                                    9.328
                                                ],
                                                [
                                                    2.238,
                                                    9.735
                                                ],
                                                [
                                                    2.646,
                                                    9.109
                                                ],
                                                [
                                                    2.652,
                                                    9.109
                                                ],
                                                [
                                                    4.105,
                                                    4.035
                                                ],
                                                [
                                                    -1.367,
                                                    -6.561
                                                ],
                                                [
                                                    -6.464,
                                                    -8.179
                                                ],
                                                [
                                                    -6.796,
                                                    -8.191
                                                ],
                                                [
                                                    -6.212,
                                                    -8.673
                                                ],
                                                [
                                                    -2.917,
                                                    -9.546
                                                ],
                                                [
                                                    -1.182,
                                                    -9.012
                                                ],
                                                [
                                                    -1.132,
                                                    -8.989
                                                ],
                                                [
                                                    3.598,
                                                    -5.074
                                                ],
                                                [
                                                    4.15,
                                                    -4.276
                                                ],
                                                [
                                                    4.385,
                                                    -3.903
                                                ],
                                                [
                                                    5.092,
                                                    -2.594
                                                ],
                                                [
                                                    6.533,
                                                    4.339
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            172.191,
                                            19.341
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 53",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.063,
                                                    0.023
                                                ],
                                                [
                                                    0.5,
                                                    0.075
                                                ],
                                                [
                                                    -0.567,
                                                    -0.241
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.534,
                                                    -0.23
                                                ],
                                                [
                                                    0.586,
                                                    0.115
                                                ],
                                                [
                                                    -0.058,
                                                    -0.028
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -1.538,
                                                    -8.871
                                                ],
                                                [
                                                    -3.094,
                                                    -9.325
                                                ],
                                                [
                                                    -1.361,
                                                    -8.791
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    1.849
                                                ],
                                                [
                                                    3.288,
                                                    2.549
                                                ],
                                                [
                                                    1.709,
                                                    -0.213
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.31,
                                                    -1.016
                                                ],
                                                [
                                                    0.11,
                                                    -4.402
                                                ],
                                                [
                                                    0.821,
                                                    -1.246
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.084,
                                                    -1.321
                                                ],
                                                [
                                                    -0.184,
                                                    -4.184
                                                ],
                                                [
                                                    -1.488,
                                                    -1.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.808,
                                                    0.057
                                                ],
                                                [
                                                    3.524,
                                                    2.743
                                                ],
                                                [
                                                    -0.039,
                                                    1.533
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.475,
                                                    9.325
                                                ],
                                                [
                                                    3.926,
                                                    4.256
                                                ],
                                                [
                                                    -1.544,
                                                    -6.34
                                                ],
                                                [
                                                    -6.641,
                                                    -7.958
                                                ],
                                                [
                                                    -6.217,
                                                    -7.947
                                                ],
                                                [
                                                    -1.59,
                                                    -6.351
                                                ],
                                                [
                                                    3.863,
                                                    5.054
                                                ],
                                                [
                                                    2.6,
                                                    9.13
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.661,
                                                    -0.764
                                                ],
                                                [
                                                    -0.276,
                                                    1.165
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.661,
                                                    -0.666
                                                ],
                                                [
                                                    -0.246,
                                                    0.999
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.827,
                                                    8.309
                                                ],
                                                [
                                                    6.165,
                                                    5.628
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.217,
                                                    2.405
                                                ],
                                                [
                                                    0.269,
                                                    0.43
                                                ],
                                                [
                                                    -0.218,
                                                    -0.454
                                                ],
                                                [
                                                    0.264,
                                                    -2.336
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.24,
                                                    -0.471
                                                ],
                                                [
                                                    0.252,
                                                    0.419
                                                ],
                                                [
                                                    1.097,
                                                    2.009
                                                ],
                                                [
                                                    0.287,
                                                    -2.227
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.965,
                                                    -2.333
                                                ],
                                                [
                                                    4.208,
                                                    -3.682
                                                ],
                                                [
                                                    4.913,
                                                    -2.373
                                                ],
                                                [
                                                    6.354,
                                                    4.56
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            172.365,
                                            19.117
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 54",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.041,
                                                    -0.345
                                                ],
                                                [
                                                    0.081,
                                                    0.345
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.041,
                                                    -0.345
                                                ],
                                                [
                                                    0.086,
                                                    0.345
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.095,
                                                    0.52
                                                ],
                                                [
                                                    -0.095,
                                                    -0.52
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            211.126,
                                            50.794
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 55",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.086,
                                                    0.345
                                                ],
                                                [
                                                    -0.041,
                                                    -0.345
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.081,
                                                    0.345
                                                ],
                                                [
                                                    -0.041,
                                                    -0.345
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.095,
                                                    -0.52
                                                ],
                                                [
                                                    0.095,
                                                    0.52
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            211.126,
                                            50.794
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 56",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.012,
                                                    -0.087
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.006,
                                                    -0.058
                                                ],
                                                [
                                                    0.155,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.765,
                                                    -0.333
                                                ],
                                                [
                                                    0.172,
                                                    -0.035
                                                ],
                                                [
                                                    0.316,
                                                    -0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.401,
                                                    0.178
                                                ],
                                                [
                                                    1.022,
                                                    1.665
                                                ],
                                                [
                                                    0.109,
                                                    1.24
                                                ],
                                                [
                                                    -0.212,
                                                    0.815
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    -0.051,
                                                    0.161
                                                ],
                                                [
                                                    -0.053,
                                                    0.115
                                                ],
                                                [
                                                    -0.075,
                                                    0.121
                                                ],
                                                [
                                                    -0.661,
                                                    0.298
                                                ],
                                                [
                                                    -0.063,
                                                    0.023
                                                ],
                                                [
                                                    -0.494,
                                                    -0.034
                                                ],
                                                [
                                                    -0.763,
                                                    -0.516
                                                ],
                                                [
                                                    -0.104,
                                                    -0.081
                                                ],
                                                [
                                                    -0.08,
                                                    -0.069
                                                ],
                                                [
                                                    -0.126,
                                                    -0.12
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.029,
                                                    -0.035
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.126,
                                                    -0.161
                                                ],
                                                [
                                                    -0.064,
                                                    -0.087
                                                ],
                                                [
                                                    -0.138,
                                                    -0.218
                                                ],
                                                [
                                                    -0.069,
                                                    -0.115
                                                ],
                                                [
                                                    -0.039,
                                                    -0.075
                                                ],
                                                [
                                                    -0.034,
                                                    -0.069
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    -0.006,
                                                    -0.023
                                                ],
                                                [
                                                    -0.097,
                                                    -0.252
                                                ],
                                                [
                                                    -0.046,
                                                    -0.126
                                                ],
                                                [
                                                    -0.053,
                                                    -0.218
                                                ],
                                                [
                                                    -0.023,
                                                    -0.086
                                                ],
                                                [
                                                    -0.039,
                                                    -0.344
                                                ],
                                                [
                                                    0.029,
                                                    -0.505
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.007,
                                                    0.086
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.005,
                                                    0.063
                                                ],
                                                [
                                                    -0.063,
                                                    0.499
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.367,
                                                    0.803
                                                ],
                                                [
                                                    -0.159,
                                                    0.069
                                                ],
                                                [
                                                    -0.276,
                                                    0.04
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.407,
                                                    -0.034
                                                ],
                                                [
                                                    -1.493,
                                                    -0.66
                                                ],
                                                [
                                                    -0.735,
                                                    -1.194
                                                ],
                                                [
                                                    -0.08,
                                                    -0.826
                                                ],
                                                [
                                                    0,
                                                    -0.012
                                                ],
                                                [
                                                    0.041,
                                                    -0.161
                                                ],
                                                [
                                                    0.04,
                                                    -0.12
                                                ],
                                                [
                                                    0.063,
                                                    -0.132
                                                ],
                                                [
                                                    0.378,
                                                    -0.637
                                                ],
                                                [
                                                    0.063,
                                                    -0.029
                                                ],
                                                [
                                                    0.459,
                                                    -0.183
                                                ],
                                                [
                                                    0.884,
                                                    0.161
                                                ],
                                                [
                                                    0.109,
                                                    0.075
                                                ],
                                                [
                                                    0.086,
                                                    0.069
                                                ],
                                                [
                                                    0.132,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.041,
                                                    0.034
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    0.149
                                                ],
                                                [
                                                    0.069,
                                                    0.08
                                                ],
                                                [
                                                    0.155,
                                                    0.195
                                                ],
                                                [
                                                    0.069,
                                                    0.11
                                                ],
                                                [
                                                    0.04,
                                                    0.069
                                                ],
                                                [
                                                    0.035,
                                                    0.068
                                                ],
                                                [
                                                    0,
                                                    0.006
                                                ],
                                                [
                                                    0.011,
                                                    0.023
                                                ],
                                                [
                                                    0.127,
                                                    0.246
                                                ],
                                                [
                                                    0.045,
                                                    0.127
                                                ],
                                                [
                                                    0.08,
                                                    0.213
                                                ],
                                                [
                                                    0.023,
                                                    0.086
                                                ],
                                                [
                                                    0.08,
                                                    0.345
                                                ],
                                                [
                                                    0.065,
                                                    0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.058,
                                                    2.422
                                                ],
                                                [
                                                    5.034,
                                                    2.681
                                                ],
                                                [
                                                    5.034,
                                                    2.698
                                                ],
                                                [
                                                    5.012,
                                                    2.876
                                                ],
                                                [
                                                    4.685,
                                                    4.311
                                                ],
                                                [
                                                    4.633,
                                                    4.443
                                                ],
                                                [
                                                    2.898,
                                                    6.199
                                                ],
                                                [
                                                    2.394,
                                                    6.366
                                                ],
                                                [
                                                    1.51,
                                                    6.446
                                                ],
                                                [
                                                    1.252,
                                                    6.463
                                                ],
                                                [
                                                    1.234,
                                                    6.463
                                                ],
                                                [
                                                    0.012,
                                                    6.142
                                                ],
                                                [
                                                    -3.725,
                                                    2.686
                                                ],
                                                [
                                                    -4.994,
                                                    -0.982
                                                ],
                                                [
                                                    -4.799,
                                                    -3.444
                                                ],
                                                [
                                                    -4.799,
                                                    -3.478
                                                ],
                                                [
                                                    -4.661,
                                                    -3.955
                                                ],
                                                [
                                                    -4.523,
                                                    -4.311
                                                ],
                                                [
                                                    -4.316,
                                                    -4.69
                                                ],
                                                [
                                                    -2.743,
                                                    -6.136
                                                ],
                                                [
                                                    -2.554,
                                                    -6.211
                                                ],
                                                [
                                                    -1.113,
                                                    -6.429
                                                ],
                                                [
                                                    1.378,
                                                    -5.396
                                                ],
                                                [
                                                    1.7,
                                                    -5.16
                                                ],
                                                [
                                                    1.952,
                                                    -4.954
                                                ],
                                                [
                                                    2.337,
                                                    -4.604
                                                ],
                                                [
                                                    2.337,
                                                    -4.598
                                                ],
                                                [
                                                    2.439,
                                                    -4.494
                                                ],
                                                [
                                                    2.544,
                                                    -4.391
                                                ],
                                                [
                                                    2.572,
                                                    -4.362
                                                ],
                                                [
                                                    2.974,
                                                    -3.903
                                                ],
                                                [
                                                    3.169,
                                                    -3.656
                                                ],
                                                [
                                                    3.605,
                                                    -3.037
                                                ],
                                                [
                                                    3.812,
                                                    -2.698
                                                ],
                                                [
                                                    3.926,
                                                    -2.485
                                                ],
                                                [
                                                    4.036,
                                                    -2.279
                                                ],
                                                [
                                                    4.042,
                                                    -2.267
                                                ],
                                                [
                                                    4.07,
                                                    -2.198
                                                ],
                                                [
                                                    4.409,
                                                    -1.447
                                                ],
                                                [
                                                    4.547,
                                                    -1.068
                                                ],
                                                [
                                                    4.742,
                                                    -0.425
                                                ],
                                                [
                                                    4.811,
                                                    -0.167
                                                ],
                                                [
                                                    4.999,
                                                    0.872
                                                ],
                                                [
                                                    5.046,
                                                    2.422
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            206.208,
                                            50.444
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 57",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.316,
                                                    -0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    0
                                                ],
                                                [
                                                    -0.269,
                                                    0.08
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.012
                                                ],
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    0.04
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.313,
                                                    0.023
                                                ],
                                                [
                                                    -0.571,
                                                    0.04
                                                ],
                                                [
                                                    -0.261,
                                                    0.057
                                                ],
                                                [
                                                    0.571,
                                                    -0.057
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            208.031,
                                            56.863
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 58",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.51,
                                                    0.849
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.608,
                                                    -0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.017,
                                                    -0.005
                                                ],
                                                [
                                                    -0.763,
                                                    -0.517
                                                ],
                                                [
                                                    -0.103,
                                                    -0.08
                                                ],
                                                [
                                                    -0.08,
                                                    -0.069
                                                ],
                                                [
                                                    -0.127,
                                                    -0.121
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.03,
                                                    -0.034
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.125,
                                                    -0.161
                                                ],
                                                [
                                                    -0.058,
                                                    -0.086
                                                ],
                                                [
                                                    -0.138,
                                                    -0.218
                                                ],
                                                [
                                                    -0.069,
                                                    -0.114
                                                ],
                                                [
                                                    -0.039,
                                                    -0.075
                                                ],
                                                [
                                                    -0.035,
                                                    -0.068
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    -0.006,
                                                    -0.023
                                                ],
                                                [
                                                    -0.097,
                                                    -0.253
                                                ],
                                                [
                                                    -0.045,
                                                    -0.127
                                                ],
                                                [
                                                    -0.051,
                                                    -0.219
                                                ],
                                                [
                                                    -0.023,
                                                    -0.086
                                                ],
                                                [
                                                    -0.041,
                                                    -0.345
                                                ],
                                                [
                                                    0.028,
                                                    -0.506
                                                ],
                                                [
                                                    0.012,
                                                    -0.086
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.004,
                                                    -0.057
                                                ],
                                                [
                                                    0.155,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.091,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.16,
                                                    2.911
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.009,
                                                    -2.525
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.638,
                                                    -0.041
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.006
                                                ],
                                                [
                                                    0.883,
                                                    0.161
                                                ],
                                                [
                                                    0.108,
                                                    0.074
                                                ],
                                                [
                                                    0.087,
                                                    0.069
                                                ],
                                                [
                                                    0.131,
                                                    0.109
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.041,
                                                    0.034
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    0.149
                                                ],
                                                [
                                                    0.076,
                                                    0.08
                                                ],
                                                [
                                                    0.155,
                                                    0.195
                                                ],
                                                [
                                                    0.07,
                                                    0.109
                                                ],
                                                [
                                                    0.041,
                                                    0.069
                                                ],
                                                [
                                                    0.036,
                                                    0.069
                                                ],
                                                [
                                                    0,
                                                    0.006
                                                ],
                                                [
                                                    0.011,
                                                    0.023
                                                ],
                                                [
                                                    0.127,
                                                    0.247
                                                ],
                                                [
                                                    0.046,
                                                    0.126
                                                ],
                                                [
                                                    0.08,
                                                    0.212
                                                ],
                                                [
                                                    0.022,
                                                    0.086
                                                ],
                                                [
                                                    0.086,
                                                    0.344
                                                ],
                                                [
                                                    0.063,
                                                    0.522
                                                ],
                                                [
                                                    -0.006,
                                                    0.086
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.005,
                                                    0.063
                                                ],
                                                [
                                                    -0.065,
                                                    0.499
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.076,
                                                    0.207
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.032,
                                                    -1.688
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.426,
                                                    -2.925
                                                ],
                                                [
                                                    0.967,
                                                    -8.165
                                                ],
                                                [
                                                    0.887,
                                                    -8.182
                                                ],
                                                [
                                                    -0.984,
                                                    -7.907
                                                ],
                                                [
                                                    -6.523,
                                                    -4.629
                                                ],
                                                [
                                                    -6.542,
                                                    -4.647
                                                ],
                                                [
                                                    -6.581,
                                                    -4.681
                                                ],
                                                [
                                                    -7.581,
                                                    -4.084
                                                ],
                                                [
                                                    -7.557,
                                                    -4.084
                                                ],
                                                [
                                                    -6.811,
                                                    -3.952
                                                ],
                                                [
                                                    -6.753,
                                                    -3.941
                                                ],
                                                [
                                                    -4.262,
                                                    -2.907
                                                ],
                                                [
                                                    -3.941,
                                                    -2.672
                                                ],
                                                [
                                                    -3.688,
                                                    -2.465
                                                ],
                                                [
                                                    -3.303,
                                                    -2.115
                                                ],
                                                [
                                                    -3.303,
                                                    -2.109
                                                ],
                                                [
                                                    -3.201,
                                                    -2.006
                                                ],
                                                [
                                                    -3.096,
                                                    -1.903
                                                ],
                                                [
                                                    -3.068,
                                                    -1.874
                                                ],
                                                [
                                                    -2.667,
                                                    -1.415
                                                ],
                                                [
                                                    -2.471,
                                                    -1.168
                                                ],
                                                [
                                                    -2.035,
                                                    -0.548
                                                ],
                                                [
                                                    -1.829,
                                                    -0.21
                                                ],
                                                [
                                                    -1.714,
                                                    0.003
                                                ],
                                                [
                                                    -1.604,
                                                    0.209
                                                ],
                                                [
                                                    -1.598,
                                                    0.221
                                                ],
                                                [
                                                    -1.57,
                                                    0.29
                                                ],
                                                [
                                                    -1.232,
                                                    1.042
                                                ],
                                                [
                                                    -1.094,
                                                    1.421
                                                ],
                                                [
                                                    -0.898,
                                                    2.064
                                                ],
                                                [
                                                    -0.829,
                                                    2.322
                                                ],
                                                [
                                                    -0.639,
                                                    3.361
                                                ],
                                                [
                                                    -0.594,
                                                    4.911
                                                ],
                                                [
                                                    -0.617,
                                                    5.169
                                                ],
                                                [
                                                    -0.617,
                                                    5.186
                                                ],
                                                [
                                                    -0.639,
                                                    5.364
                                                ],
                                                [
                                                    -0.967,
                                                    6.799
                                                ],
                                                [
                                                    -1.018,
                                                    6.931
                                                ],
                                                [
                                                    -1.271,
                                                    7.528
                                                ],
                                                [
                                                    -1.615,
                                                    8.223
                                                ],
                                                [
                                                    1.926,
                                                    6.346
                                                ],
                                                [
                                                    4.98,
                                                    4.641
                                                ],
                                                [
                                                    6.421,
                                                    -2.925
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.149,
                                                    0.338
                                                ],
                                                [
                                                    -0.104,
                                                    -0.35
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.16,
                                                    0.333
                                                ],
                                                [
                                                    -0.11,
                                                    -0.35
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -1.346,
                                                    0.715
                                                ],
                                                [
                                                    -0.949,
                                                    1.742
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            211.855,
                                            47.956
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 59",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.041,
                                                    0.167
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.148,
                                                    -0.161
                                                ],
                                                [
                                                    -0.453,
                                                    -0.276
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.161
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.177,
                                                    0.161
                                                ],
                                                [
                                                    0.317,
                                                    0.332
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.798,
                                                    10.576
                                                ],
                                                [
                                                    15.471,
                                                    10.771
                                                ],
                                                [
                                                    9.93,
                                                    14.049
                                                ],
                                                [
                                                    9.913,
                                                    14.031
                                                ],
                                                [
                                                    9.874,
                                                    13.997
                                                ],
                                                [
                                                    2.469,
                                                    7.04
                                                ],
                                                [
                                                    -4.822,
                                                    0.198
                                                ],
                                                [
                                                    -5.092,
                                                    -0.055
                                                ],
                                                [
                                                    -5.723,
                                                    -0.652
                                                ],
                                                [
                                                    -12.393,
                                                    -6.983
                                                ],
                                                [
                                                    -15.695,
                                                    -10.203
                                                ],
                                                [
                                                    -15.798,
                                                    -10.691
                                                ],
                                                [
                                                    -13.283,
                                                    -12.189
                                                ],
                                                [
                                                    -10.051,
                                                    -14.049
                                                ],
                                                [
                                                    -9.57,
                                                    -13.566
                                                ],
                                                [
                                                    -8.473,
                                                    -12.619
                                                ],
                                                [
                                                    7.249,
                                                    2.253
                                                ],
                                                [
                                                    11.969,
                                                    6.77
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            195.4,
                                            29.277
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 60",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -1.74,
                                                    0.873
                                                ],
                                                [
                                                    -1.803,
                                                    1.004
                                                ],
                                                [
                                                    1.802,
                                                    -1.004
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            211.987,
                                            55.307
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 61",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.04,
                                                    0.166
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.029,
                                                    -0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.539,
                                                    1.467
                                                ],
                                                [
                                                    -3.786,
                                                    1.61
                                                ],
                                                [
                                                    -3.435,
                                                    1.954
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.15,
                                                    -0.161
                                                ],
                                                [
                                                    -0.453,
                                                    -0.276
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.178,
                                                    0.16
                                                ],
                                                [
                                                    0.315,
                                                    0.333
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.207,
                                                    -1.954
                                                ],
                                                [
                                                    -1.024,
                                                    -0.032
                                                ],
                                                [
                                                    2.207,
                                                    -1.891
                                                ],
                                                [
                                                    2.69,
                                                    -1.409
                                                ],
                                                [
                                                    3.786,
                                                    -0.462
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            183.142,
                                            17.118
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 62",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.597
                                                ],
                                                [
                                                    0.017,
                                                    0.23
                                                ],
                                                [
                                                    0.022,
                                                    0.224
                                                ],
                                                [
                                                    0.069,
                                                    0.43
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    0.029,
                                                    0.138
                                                ],
                                                [
                                                    0.103,
                                                    0.396
                                                ],
                                                [
                                                    0.058,
                                                    0.195
                                                ],
                                                [
                                                    0.057,
                                                    0.183
                                                ],
                                                [
                                                    0.023,
                                                    0.069
                                                ],
                                                [
                                                    0.068,
                                                    0.178
                                                ],
                                                [
                                                    0.08,
                                                    0.189
                                                ],
                                                [
                                                    0.017,
                                                    0.035
                                                ],
                                                [
                                                    0.092,
                                                    0.189
                                                ],
                                                [
                                                    0.069,
                                                    0.132
                                                ],
                                                [
                                                    0.051,
                                                    0.092
                                                ],
                                                [
                                                    0.08,
                                                    0.138
                                                ],
                                                [
                                                    0.051,
                                                    0.087
                                                ],
                                                [
                                                    0.086,
                                                    0.132
                                                ],
                                                [
                                                    0.121,
                                                    0.178
                                                ],
                                                [
                                                    0.138,
                                                    0.189
                                                ],
                                                [
                                                    0.132,
                                                    0.166
                                                ],
                                                [
                                                    0.5,
                                                    0.477
                                                ],
                                                [
                                                    0.017,
                                                    0.018
                                                ],
                                                [
                                                    0.011,
                                                    0
                                                ],
                                                [
                                                    0.052,
                                                    0.051
                                                ],
                                                [
                                                    0.552,
                                                    0.367
                                                ],
                                                [
                                                    0.339,
                                                    0.206
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.012,
                                                    -0.04
                                                ],
                                                [
                                                    0,
                                                    -0.126
                                                ],
                                                [
                                                    -0.763,
                                                    -1.619
                                                ],
                                                [
                                                    -0.063,
                                                    -0.121
                                                ],
                                                [
                                                    -0.098,
                                                    -0.173
                                                ],
                                                [
                                                    -0.057,
                                                    -0.098
                                                ],
                                                [
                                                    -0.12,
                                                    -0.172
                                                ],
                                                [
                                                    -2.796,
                                                    -0.695
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.046,
                                                    -0.58
                                                ],
                                                [
                                                    0,
                                                    -0.23
                                                ],
                                                [
                                                    -0.011,
                                                    -0.23
                                                ],
                                                [
                                                    -0.041,
                                                    -0.442
                                                ],
                                                [
                                                    0,
                                                    -0.017
                                                ],
                                                [
                                                    -0.023,
                                                    -0.138
                                                ],
                                                [
                                                    -0.074,
                                                    -0.413
                                                ],
                                                [
                                                    -0.046,
                                                    -0.201
                                                ],
                                                [
                                                    -0.052,
                                                    -0.184
                                                ],
                                                [
                                                    -0.023,
                                                    -0.069
                                                ],
                                                [
                                                    -0.063,
                                                    -0.183
                                                ],
                                                [
                                                    -0.069,
                                                    -0.19
                                                ],
                                                [
                                                    -0.012,
                                                    -0.035
                                                ],
                                                [
                                                    -0.081,
                                                    -0.195
                                                ],
                                                [
                                                    -0.063,
                                                    -0.138
                                                ],
                                                [
                                                    -0.046,
                                                    -0.098
                                                ],
                                                [
                                                    -0.069,
                                                    -0.138
                                                ],
                                                [
                                                    -0.046,
                                                    -0.086
                                                ],
                                                [
                                                    -0.075,
                                                    -0.132
                                                ],
                                                [
                                                    -0.11,
                                                    -0.183
                                                ],
                                                [
                                                    -0.126,
                                                    -0.189
                                                ],
                                                [
                                                    -0.126,
                                                    -0.172
                                                ],
                                                [
                                                    -0.425,
                                                    -0.54
                                                ],
                                                [
                                                    -0.017,
                                                    -0.023
                                                ],
                                                [
                                                    -0.012,
                                                    -0.017
                                                ],
                                                [
                                                    -0.052,
                                                    -0.058
                                                ],
                                                [
                                                    -0.482,
                                                    -0.454
                                                ],
                                                [
                                                    -0.315,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.04
                                                ],
                                                [
                                                    0,
                                                    0.126
                                                ],
                                                [
                                                    0.051,
                                                    1.728
                                                ],
                                                [
                                                    0.058,
                                                    0.12
                                                ],
                                                [
                                                    0.081,
                                                    0.172
                                                ],
                                                [
                                                    0.052,
                                                    0.103
                                                ],
                                                [
                                                    0.104,
                                                    0.178
                                                ],
                                                [
                                                    1.436,
                                                    2.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    14.058,
                                                    -2.095
                                                ],
                                                [
                                                    2.158,
                                                    7.961
                                                ],
                                                [
                                                    -5.804,
                                                    14.815
                                                ],
                                                [
                                                    -5.763,
                                                    13.053
                                                ],
                                                [
                                                    -5.798,
                                                    12.364
                                                ],
                                                [
                                                    -5.849,
                                                    11.687
                                                ],
                                                [
                                                    -6.01,
                                                    10.378
                                                ],
                                                [
                                                    -6.01,
                                                    10.338
                                                ],
                                                [
                                                    -6.085,
                                                    9.93
                                                ],
                                                [
                                                    -6.349,
                                                    8.719
                                                ],
                                                [
                                                    -6.504,
                                                    8.128
                                                ],
                                                [
                                                    -6.67,
                                                    7.577
                                                ],
                                                [
                                                    -6.739,
                                                    7.364
                                                ],
                                                [
                                                    -6.934,
                                                    6.825
                                                ],
                                                [
                                                    -7.158,
                                                    6.257
                                                ],
                                                [
                                                    -7.198,
                                                    6.153
                                                ],
                                                [
                                                    -7.457,
                                                    5.574
                                                ],
                                                [
                                                    -7.652,
                                                    5.166
                                                ],
                                                [
                                                    -7.801,
                                                    4.879
                                                ],
                                                [
                                                    -8.025,
                                                    4.466
                                                ],
                                                [
                                                    -8.174,
                                                    4.207
                                                ],
                                                [
                                                    -8.415,
                                                    3.811
                                                ],
                                                [
                                                    -8.766,
                                                    3.266
                                                ],
                                                [
                                                    -9.162,
                                                    2.698
                                                ],
                                                [
                                                    -9.546,
                                                    2.193
                                                ],
                                                [
                                                    -10.936,
                                                    0.66
                                                ],
                                                [
                                                    -10.981,
                                                    0.608
                                                ],
                                                [
                                                    -11.01,
                                                    0.58
                                                ],
                                                [
                                                    -11.165,
                                                    0.425
                                                ],
                                                [
                                                    -12.727,
                                                    -0.821
                                                ],
                                                [
                                                    -13.708,
                                                    -1.469
                                                ],
                                                [
                                                    -14.064,
                                                    -1.682
                                                ],
                                                [
                                                    -10.671,
                                                    -4.012
                                                ],
                                                [
                                                    -10.637,
                                                    -3.995
                                                ],
                                                [
                                                    -8.37,
                                                    -5.596
                                                ],
                                                [
                                                    -8.433,
                                                    -5.614
                                                ],
                                                [
                                                    1.561,
                                                    -12.53
                                                ],
                                                [
                                                    4.948,
                                                    -14.815
                                                ],
                                                [
                                                    4.948,
                                                    -14.281
                                                ],
                                                [
                                                    4.96,
                                                    -14.155
                                                ],
                                                [
                                                    4.96,
                                                    -13.776
                                                ],
                                                [
                                                    6.211,
                                                    -8.667
                                                ],
                                                [
                                                    6.389,
                                                    -8.3
                                                ],
                                                [
                                                    6.659,
                                                    -7.783
                                                ],
                                                [
                                                    6.825,
                                                    -7.485
                                                ],
                                                [
                                                    7.158,
                                                    -6.951
                                                ],
                                                [
                                                    13.525,
                                                    -2.227
                                                ],
                                                [
                                                    14.064,
                                                    -2.089
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            156.233,
                                            32.155
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 63",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.597
                                                ],
                                                [
                                                    0.018,
                                                    0.23
                                                ],
                                                [
                                                    0.023,
                                                    0.224
                                                ],
                                                [
                                                    0.063,
                                                    0.431
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    0.029,
                                                    0.138
                                                ],
                                                [
                                                    0.104,
                                                    0.396
                                                ],
                                                [
                                                    0.058,
                                                    0.195
                                                ],
                                                [
                                                    0.057,
                                                    0.184
                                                ],
                                                [
                                                    0.023,
                                                    0.068
                                                ],
                                                [
                                                    0.069,
                                                    0.178
                                                ],
                                                [
                                                    0.08,
                                                    0.189
                                                ],
                                                [
                                                    0.017,
                                                    0.035
                                                ],
                                                [
                                                    0.092,
                                                    0.189
                                                ],
                                                [
                                                    0.069,
                                                    0.132
                                                ],
                                                [
                                                    0.052,
                                                    0.092
                                                ],
                                                [
                                                    0.081,
                                                    0.138
                                                ],
                                                [
                                                    0.052,
                                                    0.086
                                                ],
                                                [
                                                    0.086,
                                                    0.127
                                                ],
                                                [
                                                    -0.103,
                                                    -0.189
                                                ],
                                                [
                                                    -0.097,
                                                    -0.195
                                                ],
                                                [
                                                    -0.092,
                                                    -0.206
                                                ],
                                                [
                                                    -0.075,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    -0.068,
                                                    -0.207
                                                ],
                                                [
                                                    -0.058,
                                                    -0.189
                                                ],
                                                [
                                                    -0.017,
                                                    -0.058
                                                ],
                                                [
                                                    -0.046,
                                                    -0.184
                                                ],
                                                [
                                                    -0.051,
                                                    -0.224
                                                ],
                                                [
                                                    -0.075,
                                                    -0.46
                                                ],
                                                [
                                                    -0.029,
                                                    -0.229
                                                ],
                                                [
                                                    0.034,
                                                    -1.2
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.046,
                                                    -0.58
                                                ],
                                                [
                                                    0,
                                                    -0.23
                                                ],
                                                [
                                                    -0.011,
                                                    -0.23
                                                ],
                                                [
                                                    -0.04,
                                                    -0.442
                                                ],
                                                [
                                                    0,
                                                    -0.017
                                                ],
                                                [
                                                    -0.023,
                                                    -0.138
                                                ],
                                                [
                                                    -0.074,
                                                    -0.413
                                                ],
                                                [
                                                    -0.046,
                                                    -0.201
                                                ],
                                                [
                                                    -0.051,
                                                    -0.184
                                                ],
                                                [
                                                    -0.023,
                                                    -0.069
                                                ],
                                                [
                                                    -0.063,
                                                    -0.184
                                                ],
                                                [
                                                    -0.069,
                                                    -0.189
                                                ],
                                                [
                                                    -0.012,
                                                    -0.035
                                                ],
                                                [
                                                    -0.081,
                                                    -0.195
                                                ],
                                                [
                                                    -0.063,
                                                    -0.138
                                                ],
                                                [
                                                    -0.046,
                                                    -0.097
                                                ],
                                                [
                                                    -0.069,
                                                    -0.138
                                                ],
                                                [
                                                    -0.046,
                                                    -0.086
                                                ],
                                                [
                                                    -0.075,
                                                    -0.138
                                                ],
                                                [
                                                    0.115,
                                                    0.184
                                                ],
                                                [
                                                    0.109,
                                                    0.189
                                                ],
                                                [
                                                    0.104,
                                                    0.195
                                                ],
                                                [
                                                    0.092,
                                                    0.196
                                                ],
                                                [
                                                    0.011,
                                                    0.006
                                                ],
                                                [
                                                    0.086,
                                                    0.201
                                                ],
                                                [
                                                    0.075,
                                                    0.183
                                                ],
                                                [
                                                    0.023,
                                                    0.058
                                                ],
                                                [
                                                    0.063,
                                                    0.183
                                                ],
                                                [
                                                    0.068,
                                                    0.212
                                                ],
                                                [
                                                    0.115,
                                                    0.442
                                                ],
                                                [
                                                    0.046,
                                                    0.229
                                                ],
                                                [
                                                    0.155,
                                                    1.125
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.176,
                                                    7.407
                                                ],
                                                [
                                                    -5.786,
                                                    14.261
                                                ],
                                                [
                                                    -5.746,
                                                    12.499
                                                ],
                                                [
                                                    -5.781,
                                                    11.81
                                                ],
                                                [
                                                    -5.832,
                                                    11.133
                                                ],
                                                [
                                                    -5.993,
                                                    9.824
                                                ],
                                                [
                                                    -5.993,
                                                    9.784
                                                ],
                                                [
                                                    -6.068,
                                                    9.376
                                                ],
                                                [
                                                    -6.332,
                                                    8.165
                                                ],
                                                [
                                                    -6.487,
                                                    7.574
                                                ],
                                                [
                                                    -6.653,
                                                    7.023
                                                ],
                                                [
                                                    -6.722,
                                                    6.811
                                                ],
                                                [
                                                    -6.917,
                                                    6.271
                                                ],
                                                [
                                                    -7.141,
                                                    5.703
                                                ],
                                                [
                                                    -7.181,
                                                    5.599
                                                ],
                                                [
                                                    -7.44,
                                                    5.02
                                                ],
                                                [
                                                    -7.635,
                                                    4.612
                                                ],
                                                [
                                                    -7.784,
                                                    4.325
                                                ],
                                                [
                                                    -8.008,
                                                    3.912
                                                ],
                                                [
                                                    -8.157,
                                                    3.654
                                                ],
                                                [
                                                    -8.398,
                                                    3.257
                                                ],
                                                [
                                                    -8.071,
                                                    3.82
                                                ],
                                                [
                                                    -7.767,
                                                    4.4
                                                ],
                                                [
                                                    -7.474,
                                                    5.002
                                                ],
                                                [
                                                    -7.221,
                                                    5.588
                                                ],
                                                [
                                                    -7.21,
                                                    5.605
                                                ],
                                                [
                                                    -6.975,
                                                    6.214
                                                ],
                                                [
                                                    -6.779,
                                                    6.77
                                                ],
                                                [
                                                    -6.722,
                                                    6.943
                                                ],
                                                [
                                                    -6.555,
                                                    7.494
                                                ],
                                                [
                                                    -6.378,
                                                    8.148
                                                ],
                                                [
                                                    -6.096,
                                                    9.503
                                                ],
                                                [
                                                    -5.987,
                                                    10.191
                                                ],
                                                [
                                                    -5.803,
                                                    13.687
                                                ],
                                                [
                                                    -5.821,
                                                    14.29
                                                ],
                                                [
                                                    -5.821,
                                                    14.336
                                                ],
                                                [
                                                    -5.786,
                                                    14.301
                                                ],
                                                [
                                                    -5.781,
                                                    14.301
                                                ],
                                                [
                                                    -1.395,
                                                    10.501
                                                ],
                                                [
                                                    14.081,
                                                    -2.649
                                                ],
                                                [
                                                    2.181,
                                                    7.407
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.086,
                                                    1.694
                                                ],
                                                [
                                                    -0.764,
                                                    -1.619
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.052,
                                                    1.728
                                                ],
                                                [
                                                    -0.747,
                                                    -1.642
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.971,
                                                    -14.336
                                                ],
                                                [
                                                    6.223,
                                                    -9.227
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -8.427,
                                                    -6.173
                                                ],
                                                [
                                                    -10.545,
                                                    -4.71
                                                ],
                                                [
                                                    -10.712,
                                                    -4.595
                                                ],
                                                [
                                                    -14.081,
                                                    -2.259
                                                ],
                                                [
                                                    -14.058,
                                                    -2.241
                                                ],
                                                [
                                                    -10.666,
                                                    -4.572
                                                ],
                                                [
                                                    -10.631,
                                                    -4.555
                                                ],
                                                [
                                                    -8.364,
                                                    -6.156
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.132,
                                                    0.166
                                                ],
                                                [
                                                    0.138,
                                                    0.161
                                                ],
                                                [
                                                    -0.253,
                                                    -0.344
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.138,
                                                    -0.167
                                                ],
                                                [
                                                    0.281,
                                                    0.322
                                                ],
                                                [
                                                    -0.126,
                                                    -0.172
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.535,
                                                    1.639
                                                ],
                                                [
                                                    -9.948,
                                                    1.145
                                                ],
                                                [
                                                    -9.15,
                                                    2.144
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.011,
                                                    0.017
                                                ],
                                                [
                                                    0.017,
                                                    0.017
                                                ],
                                                [
                                                    0.012,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.368
                                                ],
                                                [
                                                    -0.562,
                                                    -0.545
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.482,
                                                    -0.454
                                                ],
                                                [
                                                    0.654,
                                                    0.471
                                                ],
                                                [
                                                    -0.011,
                                                    -0.017
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -10.924,
                                                    0.106
                                                ],
                                                [
                                                    -10.97,
                                                    0.055
                                                ],
                                                [
                                                    -10.999,
                                                    0.026
                                                ],
                                                [
                                                    -11.154,
                                                    -0.129
                                                ],
                                                [
                                                    -12.715,
                                                    -1.375
                                                ],
                                                [
                                                    -10.884,
                                                    0.152
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            156.216,
                                            32.711
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 64",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    -0.04
                                                ],
                                                [
                                                    0.063,
                                                    -0.029
                                                ],
                                                [
                                                    0.379,
                                                    -0.637
                                                ],
                                                [
                                                    0.057,
                                                    -0.132
                                                ],
                                                [
                                                    0.041,
                                                    -0.126
                                                ],
                                                [
                                                    0.041,
                                                    -0.172
                                                ],
                                                [
                                                    0,
                                                    -0.012
                                                ],
                                                [
                                                    -0.08,
                                                    -0.826
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.109,
                                                    0.127
                                                ],
                                                [
                                                    -0.247,
                                                    0.998
                                                ],
                                                [
                                                    -0.006,
                                                    0.017
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    -0.029,
                                                    0.178
                                                ],
                                                [
                                                    -0.012,
                                                    0.137
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    1.097,
                                                    2.009
                                                ],
                                                [
                                                    0.253,
                                                    0.419
                                                ],
                                                [
                                                    0.079,
                                                    0.121
                                                ],
                                                [
                                                    2.026,
                                                    0.866
                                                ],
                                                [
                                                    0.017,
                                                    0.005
                                                ],
                                                [
                                                    0.586,
                                                    0.115
                                                ],
                                                [
                                                    0.126,
                                                    0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.704,
                                                    -2.394
                                                ],
                                                [
                                                    -0.173,
                                                    -3.547
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.04
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.006,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.04,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.068,
                                                    0.04
                                                ],
                                                [
                                                    -0.065,
                                                    0.023
                                                ],
                                                [
                                                    -0.66,
                                                    0.298
                                                ],
                                                [
                                                    -0.069,
                                                    0.126
                                                ],
                                                [
                                                    -0.052,
                                                    0.115
                                                ],
                                                [
                                                    -0.057,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    -0.211,
                                                    0.815
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.12,
                                                    -0.121
                                                ],
                                                [
                                                    0.66,
                                                    -0.763
                                                ],
                                                [
                                                    0.005,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    -0.012
                                                ],
                                                [
                                                    0.046,
                                                    -0.172
                                                ],
                                                [
                                                    0.023,
                                                    -0.143
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    0.264,
                                                    -2.336
                                                ],
                                                [
                                                    -0.218,
                                                    -0.453
                                                ],
                                                [
                                                    -0.074,
                                                    -0.126
                                                ],
                                                [
                                                    -1.412,
                                                    -2.204
                                                ],
                                                [
                                                    -0.017,
                                                    -0.012
                                                ],
                                                [
                                                    -0.568,
                                                    -0.241
                                                ],
                                                [
                                                    -0.126,
                                                    -0.023
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.44,
                                                    -1.355
                                                ],
                                                [
                                                    2.697,
                                                    2.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.069,
                                                    -0.035
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.051,
                                                    0.241
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.618,
                                                    16.617
                                                ],
                                                [
                                                    17.641,
                                                    16.617
                                                ],
                                                [
                                                    17.204,
                                                    16.864
                                                ],
                                                [
                                                    17.004,
                                                    16.979
                                                ],
                                                [
                                                    16.814,
                                                    17.054
                                                ],
                                                [
                                                    15.241,
                                                    18.5
                                                ],
                                                [
                                                    15.035,
                                                    18.879
                                                ],
                                                [
                                                    14.896,
                                                    19.235
                                                ],
                                                [
                                                    14.758,
                                                    19.711
                                                ],
                                                [
                                                    14.758,
                                                    19.746
                                                ],
                                                [
                                                    14.564,
                                                    22.208
                                                ],
                                                [
                                                    14.564,
                                                    22.92
                                                ],
                                                [
                                                    2.153,
                                                    11.71
                                                ],
                                                [
                                                    -10.028,
                                                    0.752
                                                ],
                                                [
                                                    -9.804,
                                                    0.54
                                                ],
                                                [
                                                    -9.46,
                                                    0.172
                                                ],
                                                [
                                                    -8.122,
                                                    -2.508
                                                ],
                                                [
                                                    -8.111,
                                                    -2.554
                                                ],
                                                [
                                                    -8.105,
                                                    -2.589
                                                ],
                                                [
                                                    -7.996,
                                                    -3.123
                                                ],
                                                [
                                                    -7.939,
                                                    -3.547
                                                ],
                                                [
                                                    -7.939,
                                                    -3.576
                                                ],
                                                [
                                                    -9.38,
                                                    -10.51
                                                ],
                                                [
                                                    -10.086,
                                                    -11.819
                                                ],
                                                [
                                                    -10.321,
                                                    -12.192
                                                ],
                                                [
                                                    -15.602,
                                                    -16.904
                                                ],
                                                [
                                                    -15.654,
                                                    -16.927
                                                ],
                                                [
                                                    -17.388,
                                                    -17.461
                                                ],
                                                [
                                                    -17.772,
                                                    -17.524
                                                ],
                                                [
                                                    -18.617,
                                                    -17.645
                                                ],
                                                [
                                                    -11.544,
                                                    -21.565
                                                ],
                                                [
                                                    -3.564,
                                                    -19.952
                                                ],
                                                [
                                                    0.89,
                                                    -10.751
                                                ],
                                                [
                                                    0.919,
                                                    -10.246
                                                ],
                                                [
                                                    0.471,
                                                    -10.481
                                                ],
                                                [
                                                    0.27,
                                                    -10.596
                                                ],
                                                [
                                                    -1.308,
                                                    -12.088
                                                ],
                                                [
                                                    -4.54,
                                                    -10.166
                                                ],
                                                [
                                                    -7.066,
                                                    -8.713
                                                ],
                                                [
                                                    -7.055,
                                                    -8.667
                                                ],
                                                [
                                                    -7.302,
                                                    -8.524
                                                ],
                                                [
                                                    -6.951,
                                                    -8.179
                                                ],
                                                [
                                                    -6.814,
                                                    -7.462
                                                ],
                                                [
                                                    -6.779,
                                                    -7.898
                                                ],
                                                [
                                                    3.02,
                                                    1.372
                                                ],
                                                [
                                                    3.651,
                                                    1.969
                                                ],
                                                [
                                                    3.921,
                                                    2.221
                                                ],
                                                [
                                                    7.859,
                                                    5.947
                                                ],
                                                [
                                                    11.211,
                                                    9.064
                                                ],
                                                [
                                                    18.617,
                                                    16.02
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            186.656,
                                            27.254
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 65",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.15,
                                                    -0.161
                                                ],
                                                [
                                                    -0.453,
                                                    -0.276
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.178,
                                                    0.16
                                                ],
                                                [
                                                    0.315,
                                                    0.333
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.207,
                                                    -1.954
                                                ],
                                                [
                                                    -1.024,
                                                    -0.032
                                                ],
                                                [
                                                    2.207,
                                                    -1.891
                                                ],
                                                [
                                                    2.69,
                                                    -1.409
                                                ],
                                                [
                                                    3.786,
                                                    -0.462
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.04,
                                                    0.166
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.029,
                                                    -0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.539,
                                                    1.467
                                                ],
                                                [
                                                    -3.786,
                                                    1.61
                                                ],
                                                [
                                                    -3.435,
                                                    1.954
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            183.142,
                                            17.118
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 66",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.278,
                                                    3.553
                                                ],
                                                [
                                                    1.59,
                                                    0.591
                                                ],
                                                [
                                                    1.016,
                                                    -0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.165,
                                                    0.023
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.251,
                                                    -0.546
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.453,
                                                    -0.31
                                                ],
                                                [
                                                    -0.562,
                                                    -0.546
                                                ],
                                                [
                                                    -0.029,
                                                    -0.028
                                                ],
                                                [
                                                    -0.012,
                                                    -0.012
                                                ],
                                                [
                                                    -0.258,
                                                    -0.299
                                                ],
                                                [
                                                    -0.253,
                                                    -0.344
                                                ],
                                                [
                                                    -0.126,
                                                    -0.19
                                                ],
                                                [
                                                    -0.115,
                                                    -0.184
                                                ],
                                                [
                                                    -0.103,
                                                    -0.19
                                                ],
                                                [
                                                    -0.098,
                                                    -0.195
                                                ],
                                                [
                                                    -0.092,
                                                    -0.207
                                                ],
                                                [
                                                    -0.075,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    -0.075,
                                                    -0.201
                                                ],
                                                [
                                                    -0.057,
                                                    -0.19
                                                ],
                                                [
                                                    -0.017,
                                                    -0.057
                                                ],
                                                [
                                                    -0.052,
                                                    -0.184
                                                ],
                                                [
                                                    -0.058,
                                                    -0.218
                                                ],
                                                [
                                                    -0.08,
                                                    -0.459
                                                ],
                                                [
                                                    -0.034,
                                                    -0.23
                                                ],
                                                [
                                                    0.034,
                                                    -1.2
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.597,
                                                    -1.797
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.012,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.402,
                                                    0.293
                                                ],
                                                [
                                                    -0.005,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    0.362
                                                ],
                                                [
                                                    -0.092,
                                                    0.092
                                                ],
                                                [
                                                    -0.224,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.511,
                                                    -4.983
                                                ],
                                                [
                                                    -1.498,
                                                    -1.63
                                                ],
                                                [
                                                    -1.108,
                                                    -0.419
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.924,
                                                    -0.787
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.252,
                                                    0.069
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.482,
                                                    0.235
                                                ],
                                                [
                                                    0.654,
                                                    0.47
                                                ],
                                                [
                                                    0.035,
                                                    0.034
                                                ],
                                                [
                                                    0.012,
                                                    0.012
                                                ],
                                                [
                                                    0.281,
                                                    0.281
                                                ],
                                                [
                                                    0.281,
                                                    0.321
                                                ],
                                                [
                                                    0.138,
                                                    0.19
                                                ],
                                                [
                                                    0.12,
                                                    0.178
                                                ],
                                                [
                                                    0.115,
                                                    0.184
                                                ],
                                                [
                                                    0.104,
                                                    0.189
                                                ],
                                                [
                                                    0.103,
                                                    0.195
                                                ],
                                                [
                                                    0.092,
                                                    0.195
                                                ],
                                                [
                                                    0.011,
                                                    0.006
                                                ],
                                                [
                                                    0.081,
                                                    0.201
                                                ],
                                                [
                                                    0.074,
                                                    0.184
                                                ],
                                                [
                                                    0.023,
                                                    0.057
                                                ],
                                                [
                                                    0.058,
                                                    0.184
                                                ],
                                                [
                                                    0.063,
                                                    0.218
                                                ],
                                                [
                                                    0.109,
                                                    0.442
                                                ],
                                                [
                                                    0.04,
                                                    0.23
                                                ],
                                                [
                                                    0.155,
                                                    1.125
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.12,
                                                    1.538
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.436,
                                                    -0.247
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    -0.206
                                                ],
                                                [
                                                    0.091,
                                                    -0.092
                                                ],
                                                [
                                                    0.31,
                                                    -0.287
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.389,
                                                    29.308
                                                ],
                                                [
                                                    11.32,
                                                    29.349
                                                ],
                                                [
                                                    0.683,
                                                    35.508
                                                ],
                                                [
                                                    0.764,
                                                    15.67
                                                ],
                                                [
                                                    0.712,
                                                    -13.92
                                                ],
                                                [
                                                    0.712,
                                                    -13.931
                                                ],
                                                [
                                                    1.171,
                                                    -16.772
                                                ],
                                                [
                                                    -3.18,
                                                    -30.21
                                                ],
                                                [
                                                    -7.709,
                                                    -33.464
                                                ],
                                                [
                                                    -10.941,
                                                    -33.855
                                                ],
                                                [
                                                    -10.947,
                                                    -33.855
                                                ],
                                                [
                                                    -11.389,
                                                    -33.878
                                                ],
                                                [
                                                    -10.838,
                                                    -34.342
                                                ],
                                                [
                                                    -7.646,
                                                    -35.508
                                                ],
                                                [
                                                    -7.635,
                                                    -35.508
                                                ],
                                                [
                                                    -4.064,
                                                    -34.629
                                                ],
                                                [
                                                    -3.915,
                                                    -34.566
                                                ],
                                                [
                                                    -3.88,
                                                    -34.589
                                                ],
                                                [
                                                    -2.474,
                                                    -33.774
                                                ],
                                                [
                                                    -0.643,
                                                    -32.247
                                                ],
                                                [
                                                    -0.551,
                                                    -32.156
                                                ],
                                                [
                                                    -0.516,
                                                    -32.121
                                                ],
                                                [
                                                    0.293,
                                                    -31.254
                                                ],
                                                [
                                                    1.091,
                                                    -30.256
                                                ],
                                                [
                                                    1.487,
                                                    -29.687
                                                ],
                                                [
                                                    1.837,
                                                    -29.142
                                                ],
                                                [
                                                    2.164,
                                                    -28.579
                                                ],
                                                [
                                                    2.469,
                                                    -28
                                                ],
                                                [
                                                    2.761,
                                                    -27.397
                                                ],
                                                [
                                                    3.014,
                                                    -26.812
                                                ],
                                                [
                                                    3.025,
                                                    -26.794
                                                ],
                                                [
                                                    3.261,
                                                    -26.186
                                                ],
                                                [
                                                    3.456,
                                                    -25.629
                                                ],
                                                [
                                                    3.513,
                                                    -25.457
                                                ],
                                                [
                                                    3.68,
                                                    -24.906
                                                ],
                                                [
                                                    3.858,
                                                    -24.252
                                                ],
                                                [
                                                    4.139,
                                                    -22.897
                                                ],
                                                [
                                                    4.248,
                                                    -22.208
                                                ],
                                                [
                                                    4.432,
                                                    -18.712
                                                ],
                                                [
                                                    4.415,
                                                    -18.11
                                                ],
                                                [
                                                    4.265,
                                                    -17.978
                                                ],
                                                [
                                                    4.449,
                                                    -18.029
                                                ],
                                                [
                                                    4.415,
                                                    -17.599
                                                ],
                                                [
                                                    4.363,
                                                    -17.57
                                                ],
                                                [
                                                    4.351,
                                                    -17.409
                                                ],
                                                [
                                                    3.324,
                                                    -12.651
                                                ],
                                                [
                                                    3.083,
                                                    -11.939
                                                ],
                                                [
                                                    6.562,
                                                    -13.931
                                                ],
                                                [
                                                    6.602,
                                                    -13.96
                                                ],
                                                [
                                                    7.503,
                                                    -14.459
                                                ],
                                                [
                                                    8.76,
                                                    -15.263
                                                ],
                                                [
                                                    8.777,
                                                    -15.263
                                                ],
                                                [
                                                    10.098,
                                                    -16.204
                                                ],
                                                [
                                                    10.373,
                                                    -16.48
                                                ],
                                                [
                                                    11.177,
                                                    -17.427
                                                ],
                                                [
                                                    11.315,
                                                    -17.57
                                                ],
                                                [
                                                    11.332,
                                                    10.659
                                                ],
                                                [
                                                    11.361,
                                                    20.033
                                                ],
                                                [
                                                    11.383,
                                                    29.308
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            145.968,
                                            65.104
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 67",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.228,
                                                    -0.029
                                                ],
                                                [
                                                    -1.251,
                                                    -0.545
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.251,
                                                    0.069
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.228,
                                                    -0.596
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.755,
                                                    -35.499
                                                ],
                                                [
                                                    -4.185,
                                                    -34.621
                                                ],
                                                [
                                                    -4.035,
                                                    -34.558
                                                ],
                                                [
                                                    -4.001,
                                                    -34.581
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.012,
                                                    0.017
                                                ],
                                                [
                                                    0.018,
                                                    0.017
                                                ],
                                                [
                                                    0.011,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.368
                                                ],
                                                [
                                                    -0.562,
                                                    -0.545
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.483,
                                                    -0.454
                                                ],
                                                [
                                                    0.655,
                                                    0.471
                                                ],
                                                [
                                                    -0.011,
                                                    -0.017
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.798,
                                                    -32.279
                                                ],
                                                [
                                                    -0.844,
                                                    -32.33
                                                ],
                                                [
                                                    -0.872,
                                                    -32.359
                                                ],
                                                [
                                                    -1.027,
                                                    -32.514
                                                ],
                                                [
                                                    -2.589,
                                                    -33.76
                                                ],
                                                [
                                                    -0.758,
                                                    -32.233
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.574
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.045,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.591,
                                                    -13.911
                                                ],
                                                [
                                                    0.511,
                                                    -12.263
                                                ],
                                                [
                                                    0.511,
                                                    0.124
                                                ],
                                                [
                                                    0.546,
                                                    35.528
                                                ],
                                                [
                                                    0.563,
                                                    35.517
                                                ],
                                                [
                                                    0.643,
                                                    15.679
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    3.278,
                                                    3.553
                                                ],
                                                [
                                                    1.59,
                                                    0.591
                                                ],
                                                [
                                                    1.016,
                                                    -0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.004,
                                                    -0.493
                                                ],
                                                [
                                                    0.895,
                                                    -6.704
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.064,
                                                    -0.706
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.498,
                                                    -1.63
                                                ],
                                                [
                                                    -1.108,
                                                    -0.42
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.154,
                                                    0.057
                                                ],
                                                [
                                                    5.586,
                                                    2.738
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.092,
                                                    0.706
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.511,
                                                    -4.982
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.301,
                                                    -30.201
                                                ],
                                                [
                                                    -7.83,
                                                    -33.455
                                                ],
                                                [
                                                    -11.062,
                                                    -33.846
                                                ],
                                                [
                                                    -10.545,
                                                    -33.817
                                                ],
                                                [
                                                    -7.296,
                                                    -33.209
                                                ],
                                                [
                                                    0.936,
                                                    -16.649
                                                ],
                                                [
                                                    0.844,
                                                    -16.012
                                                ],
                                                [
                                                    0.591,
                                                    -13.922
                                                ],
                                                [
                                                    1.051,
                                                    -16.764
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.23
                                                ],
                                                [
                                                    0.023,
                                                    0.224
                                                ],
                                                [
                                                    0.063,
                                                    0.431
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    0.028,
                                                    0.138
                                                ],
                                                [
                                                    0.103,
                                                    0.396
                                                ],
                                                [
                                                    0.057,
                                                    0.195
                                                ],
                                                [
                                                    0.058,
                                                    0.184
                                                ],
                                                [
                                                    0.023,
                                                    0.068
                                                ],
                                                [
                                                    0.069,
                                                    0.178
                                                ],
                                                [
                                                    0.081,
                                                    0.189
                                                ],
                                                [
                                                    0.017,
                                                    0.035
                                                ],
                                                [
                                                    0.092,
                                                    0.189
                                                ],
                                                [
                                                    0.068,
                                                    0.132
                                                ],
                                                [
                                                    0.052,
                                                    0.092
                                                ],
                                                [
                                                    0.081,
                                                    0.138
                                                ],
                                                [
                                                    0.052,
                                                    0.086
                                                ],
                                                [
                                                    0.086,
                                                    0.127
                                                ],
                                                [
                                                    -0.103,
                                                    -0.189
                                                ],
                                                [
                                                    -0.098,
                                                    -0.195
                                                ],
                                                [
                                                    -0.092,
                                                    -0.206
                                                ],
                                                [
                                                    -0.075,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    -0.075,
                                                    -0.201
                                                ],
                                                [
                                                    -0.058,
                                                    -0.189
                                                ],
                                                [
                                                    -0.017,
                                                    -0.058
                                                ],
                                                [
                                                    -0.052,
                                                    -0.184
                                                ],
                                                [
                                                    -0.058,
                                                    -0.218
                                                ],
                                                [
                                                    -0.08,
                                                    -0.46
                                                ],
                                                [
                                                    -0.034,
                                                    -0.229
                                                ],
                                                [
                                                    0.034,
                                                    -1.2
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.006,
                                                    0.023
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.597
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.23
                                                ],
                                                [
                                                    -0.012,
                                                    -0.23
                                                ],
                                                [
                                                    -0.04,
                                                    -0.442
                                                ],
                                                [
                                                    0,
                                                    -0.017
                                                ],
                                                [
                                                    -0.023,
                                                    -0.138
                                                ],
                                                [
                                                    -0.075,
                                                    -0.413
                                                ],
                                                [
                                                    -0.046,
                                                    -0.201
                                                ],
                                                [
                                                    -0.052,
                                                    -0.184
                                                ],
                                                [
                                                    -0.023,
                                                    -0.069
                                                ],
                                                [
                                                    -0.063,
                                                    -0.184
                                                ],
                                                [
                                                    -0.069,
                                                    -0.189
                                                ],
                                                [
                                                    -0.011,
                                                    -0.035
                                                ],
                                                [
                                                    -0.08,
                                                    -0.195
                                                ],
                                                [
                                                    -0.063,
                                                    -0.138
                                                ],
                                                [
                                                    -0.046,
                                                    -0.097
                                                ],
                                                [
                                                    -0.069,
                                                    -0.138
                                                ],
                                                [
                                                    -0.045,
                                                    -0.086
                                                ],
                                                [
                                                    -0.074,
                                                    -0.138
                                                ],
                                                [
                                                    0.115,
                                                    0.184
                                                ],
                                                [
                                                    0.104,
                                                    0.189
                                                ],
                                                [
                                                    0.103,
                                                    0.195
                                                ],
                                                [
                                                    0.092,
                                                    0.196
                                                ],
                                                [
                                                    0.011,
                                                    0.006
                                                ],
                                                [
                                                    0.081,
                                                    0.201
                                                ],
                                                [
                                                    0.074,
                                                    0.183
                                                ],
                                                [
                                                    0.023,
                                                    0.058
                                                ],
                                                [
                                                    0.058,
                                                    0.183
                                                ],
                                                [
                                                    0.063,
                                                    0.218
                                                ],
                                                [
                                                    0.109,
                                                    0.442
                                                ],
                                                [
                                                    0.04,
                                                    0.229
                                                ],
                                                [
                                                    0.155,
                                                    1.125
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.046,
                                                    -0.58
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.38,
                                                    -19.886
                                                ],
                                                [
                                                    4.346,
                                                    -20.575
                                                ],
                                                [
                                                    4.294,
                                                    -21.252
                                                ],
                                                [
                                                    4.133,
                                                    -22.561
                                                ],
                                                [
                                                    4.133,
                                                    -22.601
                                                ],
                                                [
                                                    4.059,
                                                    -23.009
                                                ],
                                                [
                                                    3.795,
                                                    -24.22
                                                ],
                                                [
                                                    3.64,
                                                    -24.811
                                                ],
                                                [
                                                    3.473,
                                                    -25.362
                                                ],
                                                [
                                                    3.404,
                                                    -25.574
                                                ],
                                                [
                                                    3.209,
                                                    -26.114
                                                ],
                                                [
                                                    2.985,
                                                    -26.682
                                                ],
                                                [
                                                    2.945,
                                                    -26.786
                                                ],
                                                [
                                                    2.687,
                                                    -27.365
                                                ],
                                                [
                                                    2.492,
                                                    -27.773
                                                ],
                                                [
                                                    2.342,
                                                    -28.06
                                                ],
                                                [
                                                    2.118,
                                                    -28.473
                                                ],
                                                [
                                                    1.969,
                                                    -28.731
                                                ],
                                                [
                                                    1.728,
                                                    -29.128
                                                ],
                                                [
                                                    2.055,
                                                    -28.565
                                                ],
                                                [
                                                    2.36,
                                                    -27.985
                                                ],
                                                [
                                                    2.652,
                                                    -27.383
                                                ],
                                                [
                                                    2.905,
                                                    -26.797
                                                ],
                                                [
                                                    2.916,
                                                    -26.78
                                                ],
                                                [
                                                    3.152,
                                                    -26.171
                                                ],
                                                [
                                                    3.347,
                                                    -25.615
                                                ],
                                                [
                                                    3.404,
                                                    -25.442
                                                ],
                                                [
                                                    3.571,
                                                    -24.891
                                                ],
                                                [
                                                    3.749,
                                                    -24.237
                                                ],
                                                [
                                                    4.03,
                                                    -22.882
                                                ],
                                                [
                                                    4.139,
                                                    -22.194
                                                ],
                                                [
                                                    4.323,
                                                    -18.698
                                                ],
                                                [
                                                    4.306,
                                                    -18.095
                                                ],
                                                [
                                                    4.156,
                                                    -17.963
                                                ],
                                                [
                                                    4.34,
                                                    -18.015
                                                ],
                                                [
                                                    4.34,
                                                    -18.084
                                                ],
                                                [
                                                    4.346,
                                                    -18.084
                                                ],
                                                [
                                                    4.346,
                                                    -18.124
                                                ],
                                                [
                                                    4.386,
                                                    -19.886
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.184,
                                                    1.9
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.597,
                                                    -1.797
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.465,
                                                    -1.762
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.121,
                                                    1.538
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.203,
                                                    -12.114
                                                ],
                                                [
                                                    4.3,
                                                    -17.584
                                                ],
                                                [
                                                    4.248,
                                                    -17.556
                                                ],
                                                [
                                                    4.237,
                                                    -17.395
                                                ],
                                                [
                                                    3.209,
                                                    -12.636
                                                ],
                                                [
                                                    2.968,
                                                    -11.925
                                                ],
                                                [
                                                    6.447,
                                                    -13.917
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.711,
                                                    -0.511
                                                ],
                                                [
                                                    -0.362,
                                                    0.361
                                                ],
                                                [
                                                    -0.091,
                                                    0.092
                                                ],
                                                [
                                                    -0.224,
                                                    0.344
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.666,
                                                    0.695
                                                ],
                                                [
                                                    0.585,
                                                    -0.207
                                                ],
                                                [
                                                    0.092,
                                                    -0.092
                                                ],
                                                [
                                                    0.31,
                                                    -0.287
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    10.706,
                                                    -17.045
                                                ],
                                                [
                                                    8.663,
                                                    -15.254
                                                ],
                                                [
                                                    9.983,
                                                    -16.195
                                                ],
                                                [
                                                    10.258,
                                                    -16.471
                                                ],
                                                [
                                                    11.062,
                                                    -17.418
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.089,
                                            65.093
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 68",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.155,
                                                    -0.54
                                                ],
                                                [
                                                    0.729,
                                                    -0.333
                                                ],
                                                [
                                                    1.188,
                                                    0
                                                ],
                                                [
                                                    1.004,
                                                    0.465
                                                ],
                                                [
                                                    0.149,
                                                    0.453
                                                ],
                                                [
                                                    -0.213,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.62,
                                                    -0.379
                                                ],
                                                [
                                                    -0.97,
                                                    0
                                                ],
                                                [
                                                    -0.677,
                                                    0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.011,
                                                    0.597
                                                ],
                                                [
                                                    0,
                                                    0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.132,
                                                    0.465
                                                ],
                                                [
                                                    -0.798,
                                                    0.367
                                                ],
                                                [
                                                    -1.039,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.252
                                                ],
                                                [
                                                    -0.127,
                                                    -0.373
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.011,
                                                    0.563
                                                ],
                                                [
                                                    0.706,
                                                    0.425
                                                ],
                                                [
                                                    0.855,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.683,
                                                    -0.419
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    0.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.314,
                                                    -0.086
                                                ],
                                                [
                                                    3,
                                                    1.137
                                                ],
                                                [
                                                    -0.1,
                                                    1.751
                                                ],
                                                [
                                                    -3.24,
                                                    1.096
                                                ],
                                                [
                                                    -4.342,
                                                    -0.017
                                                ],
                                                [
                                                    -4.21,
                                                    -1.182
                                                ],
                                                [
                                                    -3.906,
                                                    -1.751
                                                ],
                                                [
                                                    -3.699,
                                                    -1.177
                                                ],
                                                [
                                                    -3.699,
                                                    -1.148
                                                ],
                                                [
                                                    -2.729,
                                                    0.287
                                                ],
                                                [
                                                    -0.077,
                                                    0.93
                                                ],
                                                [
                                                    2.311,
                                                    0.425
                                                ],
                                                [
                                                    2.334,
                                                    0.413
                                                ],
                                                [
                                                    3.35,
                                                    -1.119
                                                ],
                                                [
                                                    3.361,
                                                    -1.205
                                                ],
                                                [
                                                    3.407,
                                                    -1.665
                                                ],
                                                [
                                                    3.798,
                                                    -1.429
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            211.206,
                                            60.736
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 69",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.006,
                                                    -0.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.144,
                                                    -0.39
                                                ],
                                                [
                                                    0.046,
                                                    -0.092
                                                ],
                                                [
                                                    0.006,
                                                    -0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.142,
                                                    -1.234
                                                ],
                                                [
                                                    5.361,
                                                    11.368
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.006,
                                                    0.017
                                                ],
                                                [
                                                    0.052,
                                                    0.407
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.104
                                                ],
                                                [
                                                    -0.058,
                                                    0.298
                                                ],
                                                [
                                                    -0.838,
                                                    0.959
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.017,
                                                    -0.063
                                                ],
                                                [
                                                    0,
                                                    -0.005
                                                ],
                                                [
                                                    -0.287,
                                                    -0.511
                                                ],
                                                [
                                                    -0.023,
                                                    -0.04
                                                ],
                                                [
                                                    -1.998,
                                                    -0.488
                                                ],
                                                [
                                                    -2.531,
                                                    0
                                                ],
                                                [
                                                    -3.267,
                                                    1.211
                                                ],
                                                [
                                                    -1.509,
                                                    1.608
                                                ],
                                                [
                                                    0,
                                                    1.526
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.16,
                                                    -1.492
                                                ],
                                                [
                                                    0,
                                                    -0.012
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.057,
                                                    0.413
                                                ],
                                                [
                                                    -0.034,
                                                    0.098
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.678,
                                                    1.268
                                                ],
                                                [
                                                    -9.148,
                                                    9.883
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.137,
                                                    -0.385
                                                ],
                                                [
                                                    0,
                                                    -0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.012,
                                                    -0.103
                                                ],
                                                [
                                                    0.011,
                                                    -0.292
                                                ],
                                                [
                                                    0.31,
                                                    -1.55
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.069
                                                ],
                                                [
                                                    0,
                                                    0.006
                                                ],
                                                [
                                                    0.081,
                                                    0.517
                                                ],
                                                [
                                                    0.017,
                                                    0.04
                                                ],
                                                [
                                                    2.13,
                                                    3.972
                                                ],
                                                [
                                                    2.543,
                                                    0.626
                                                ],
                                                [
                                                    3.531,
                                                    0
                                                ],
                                                [
                                                    2.566,
                                                    -0.947
                                                ],
                                                [
                                                    1.367,
                                                    -1.446
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.096,
                                                    1.366
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0.091
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.013,
                                                    -5.352
                                                ],
                                                [
                                                    20.978,
                                                    -5.329
                                                ],
                                                [
                                                    20.978,
                                                    -4.387
                                                ],
                                                [
                                                    20.68,
                                                    -3.182
                                                ],
                                                [
                                                    20.565,
                                                    -2.901
                                                ],
                                                [
                                                    20.548,
                                                    -2.861
                                                ],
                                                [
                                                    20.514,
                                                    -2.797
                                                ],
                                                [
                                                    18.151,
                                                    0.514
                                                ],
                                                [
                                                    -20.462,
                                                    -2.643
                                                ],
                                                [
                                                    -20.646,
                                                    -3.016
                                                ],
                                                [
                                                    -20.669,
                                                    -3.067
                                                ],
                                                [
                                                    -20.956,
                                                    -4.255
                                                ],
                                                [
                                                    -20.956,
                                                    -4.284
                                                ],
                                                [
                                                    -20.967,
                                                    -4.91
                                                ],
                                                [
                                                    -21.001,
                                                    -4.927
                                                ],
                                                [
                                                    -21.001,
                                                    -5.243
                                                ],
                                                [
                                                    -20.898,
                                                    -6.132
                                                ],
                                                [
                                                    -18.849,
                                                    -9.835
                                                ],
                                                [
                                                    -18.355,
                                                    -10.397
                                                ],
                                                [
                                                    -18.344,
                                                    -9.536
                                                ],
                                                [
                                                    -18.378,
                                                    -9.594
                                                ],
                                                [
                                                    -18.275,
                                                    -4.267
                                                ],
                                                [
                                                    -18.275,
                                                    -4.221
                                                ],
                                                [
                                                    -18.229,
                                                    -4.026
                                                ],
                                                [
                                                    -18.229,
                                                    -4.009
                                                ],
                                                [
                                                    -17.666,
                                                    -2.459
                                                ],
                                                [
                                                    -17.603,
                                                    -2.338
                                                ],
                                                [
                                                    -7.471,
                                                    3.901
                                                ],
                                                [
                                                    0.169,
                                                    4.837
                                                ],
                                                [
                                                    10.428,
                                                    3.023
                                                ],
                                                [
                                                    16.403,
                                                    -0.72
                                                ],
                                                [
                                                    18.458,
                                                    -5.202
                                                ],
                                                [
                                                    18.447,
                                                    -9.898
                                                ],
                                                [
                                                    18.447,
                                                    -10.363
                                                ],
                                                [
                                                    18.958,
                                                    -9.737
                                                ],
                                                [
                                                    20.984,
                                                    -5.662
                                                ],
                                                [
                                                    20.99,
                                                    -5.621
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.53,
                                            104.419
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 70",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.177
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.017,
                                                    -0.063
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.069
                                                ],
                                                [
                                                    -0.029,
                                                    -0.178
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -18.292,
                                                    -1.719
                                                ],
                                                [
                                                    -18.361,
                                                    -6.696
                                                ],
                                                [
                                                    -18.395,
                                                    -6.753
                                                ],
                                                [
                                                    -18.292,
                                                    -1.427
                                                ],
                                                [
                                                    -18.292,
                                                    -1.381
                                                ],
                                                [
                                                    -18.246,
                                                    -1.186
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.206
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -20.984,
                                                    -2.07
                                                ],
                                                [
                                                    -21.019,
                                                    -2.087
                                                ],
                                                [
                                                    -20.973,
                                                    -1.444
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.337,
                                                    2.76
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.842,
                                                    -1.292
                                                ],
                                                [
                                                    -0.701,
                                                    -0.247
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.993,
                                                    2.675
                                                ],
                                                [
                                                    0.665,
                                                    0.304
                                                ],
                                                [
                                                    -4.392,
                                                    -1.642
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -20.473,
                                                    0.198
                                                ],
                                                [
                                                    -20.657,
                                                    -0.176
                                                ],
                                                [
                                                    -20.657,
                                                    -0.164
                                                ],
                                                [
                                                    -14.009,
                                                    5.932
                                                ],
                                                [
                                                    -11.954,
                                                    6.753
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.017,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.04,
                                                    -0.31
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.002,
                                                    -2.506
                                                ],
                                                [
                                                    20.967,
                                                    -2.489
                                                ],
                                                [
                                                    20.967,
                                                    -1.547
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.542,
                                            101.581
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 71",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.418,
                                                    -0.161
                                                ],
                                                [
                                                    6.17,
                                                    2.795
                                                ],
                                                [
                                                    1.463,
                                                    2.244
                                                ],
                                                [
                                                    -1.304,
                                                    -0.608
                                                ],
                                                [
                                                    -4.202,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.26,
                                                    1.63
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -6.94,
                                                    2.692
                                                ],
                                                [
                                                    -3.145,
                                                    -1.418
                                                ],
                                                [
                                                    1.532,
                                                    2.68
                                                ],
                                                [
                                                    3.392,
                                                    1.579
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.565,
                                                    -0.011
                                                ],
                                                [
                                                    -0.39,
                                                    0.189
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.93,
                                                    2.092
                                                ],
                                                [
                                                    -7.66,
                                                    1.931
                                                ],
                                                [
                                                    -14.227,
                                                    -3.263
                                                ],
                                                [
                                                    -8.171,
                                                    1.747
                                                ],
                                                [
                                                    3.115,
                                                    4.095
                                                ],
                                                [
                                                    3.206,
                                                    4.095
                                                ],
                                                [
                                                    15.141,
                                                    1.564
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.177
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.017,
                                                    -0.063
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.016,
                                                    0.069
                                                ],
                                                [
                                                    -0.03,
                                                    -0.178
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.036,
                                                    0.25
                                                ],
                                                [
                                                    -15.105,
                                                    -4.727
                                                ],
                                                [
                                                    -15.141,
                                                    -4.784
                                                ],
                                                [
                                                    -15.036,
                                                    0.542
                                                ],
                                                [
                                                    -15.036,
                                                    0.588
                                                ],
                                                [
                                                    -14.99,
                                                    0.783
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            143.286,
                                            99.607
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 72",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.43,
                                                    -1.079
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.227,
                                                    -1.039
                                                ],
                                                [
                                                    0.15,
                                                    -0.114
                                                ],
                                                [
                                                    0.092,
                                                    -0.063
                                                ],
                                                [
                                                    0.11,
                                                    -0.074
                                                ],
                                                [
                                                    0.299,
                                                    -0.172
                                                ],
                                                [
                                                    0.155,
                                                    -0.086
                                                ],
                                                [
                                                    0.162,
                                                    -0.081
                                                ],
                                                [
                                                    0.127,
                                                    -0.063
                                                ],
                                                [
                                                    0.42,
                                                    -0.161
                                                ],
                                                [
                                                    6.171,
                                                    2.796
                                                ],
                                                [
                                                    1.464,
                                                    2.245
                                                ],
                                                [
                                                    0.011,
                                                    0.017
                                                ],
                                                [
                                                    0,
                                                    1.074
                                                ],
                                                [
                                                    -0.138,
                                                    0.522
                                                ],
                                                [
                                                    -0.883,
                                                    1.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.039,
                                                    -0.683
                                                ],
                                                [
                                                    -0.407,
                                                    -1.98
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.633,
                                                    1.286
                                                ],
                                                [
                                                    -0.138,
                                                    0.115
                                                ],
                                                [
                                                    -0.086,
                                                    0.069
                                                ],
                                                [
                                                    -0.104,
                                                    0.08
                                                ],
                                                [
                                                    -0.28,
                                                    0.201
                                                ],
                                                [
                                                    -0.149,
                                                    0.086
                                                ],
                                                [
                                                    -0.155,
                                                    0.086
                                                ],
                                                [
                                                    -0.119,
                                                    0.069
                                                ],
                                                [
                                                    -0.39,
                                                    0.189
                                                ],
                                                [
                                                    -6.94,
                                                    2.692
                                                ],
                                                [
                                                    -3.146,
                                                    -1.417
                                                ],
                                                [
                                                    -0.012,
                                                    -0.017
                                                ],
                                                [
                                                    -0.494,
                                                    -0.872
                                                ],
                                                [
                                                    0,
                                                    -0.482
                                                ],
                                                [
                                                    0.338,
                                                    -1.303
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.319,
                                                    0.551
                                                ],
                                                [
                                                    1.974,
                                                    1.418
                                                ],
                                                [
                                                    0.223,
                                                    1.091
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.839,
                                                    0.812
                                                ],
                                                [
                                                    17.822,
                                                    0.852
                                                ],
                                                [
                                                    14.992,
                                                    4.371
                                                ],
                                                [
                                                    14.566,
                                                    4.715
                                                ],
                                                [
                                                    14.303,
                                                    4.911
                                                ],
                                                [
                                                    13.98,
                                                    5.14
                                                ],
                                                [
                                                    13.114,
                                                    5.703
                                                ],
                                                [
                                                    12.661,
                                                    5.967
                                                ],
                                                [
                                                    12.189,
                                                    6.22
                                                ],
                                                [
                                                    11.816,
                                                    6.409
                                                ],
                                                [
                                                    10.605,
                                                    6.937
                                                ],
                                                [
                                                    -10.984,
                                                    6.776
                                                ],
                                                [
                                                    -17.551,
                                                    1.581
                                                ],
                                                [
                                                    -17.585,
                                                    1.524
                                                ],
                                                [
                                                    -18.383,
                                                    -1.398
                                                ],
                                                [
                                                    -18.182,
                                                    -2.907
                                                ],
                                                [
                                                    -16.197,
                                                    -6.277
                                                ],
                                                [
                                                    -16.156,
                                                    -6.323
                                                ],
                                                [
                                                    -13.074,
                                                    -8.791
                                                ],
                                                [
                                                    -13.074,
                                                    -1.243
                                                ],
                                                [
                                                    0.042,
                                                    5.915
                                                ],
                                                [
                                                    0.042,
                                                    5.875
                                                ],
                                                [
                                                    10.68,
                                                    -0.307
                                                ],
                                                [
                                                    10.749,
                                                    -0.353
                                                ],
                                                [
                                                    10.726,
                                                    -9.629
                                                ],
                                                [
                                                    11.111,
                                                    -9.468
                                                ],
                                                [
                                                    14.521,
                                                    -7.689
                                                ],
                                                [
                                                    18.16,
                                                    -2.494
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.609,
                                            94.765
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 73",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.366,
                                                    -1.447
                                                ],
                                                [
                                                    2.567,
                                                    -0.947
                                                ],
                                                [
                                                    3.53,
                                                    0
                                                ],
                                                [
                                                    2.543,
                                                    0.626
                                                ],
                                                [
                                                    2.13,
                                                    3.972
                                                ],
                                                [
                                                    0.017,
                                                    0.04
                                                ],
                                                [
                                                    0.116,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.006
                                                ],
                                                [
                                                    0,
                                                    0.177
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.108,
                                                    -0.167
                                                ],
                                                [
                                                    -0.013,
                                                    -0.017
                                                ],
                                                [
                                                    -1.304,
                                                    -0.609
                                                ],
                                                [
                                                    -4.201,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.261,
                                                    1.63
                                                ],
                                                [
                                                    -0.119,
                                                    0.069
                                                ],
                                                [
                                                    -0.155,
                                                    0.092
                                                ],
                                                [
                                                    -0.149,
                                                    0.097
                                                ],
                                                [
                                                    -0.281,
                                                    0.2
                                                ],
                                                [
                                                    -0.104,
                                                    0.081
                                                ],
                                                [
                                                    -0.086,
                                                    0.069
                                                ],
                                                [
                                                    -0.136,
                                                    0.114
                                                ],
                                                [
                                                    -0.633,
                                                    1.286
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.526
                                                ],
                                                [
                                                    -1.511,
                                                    1.607
                                                ],
                                                [
                                                    -3.267,
                                                    1.211
                                                ],
                                                [
                                                    -2.532,
                                                    0
                                                ],
                                                [
                                                    -1.998,
                                                    -0.488
                                                ],
                                                [
                                                    -0.023,
                                                    -0.04
                                                ],
                                                [
                                                    -0.253,
                                                    -0.482
                                                ],
                                                [
                                                    0,
                                                    -0.005
                                                ],
                                                [
                                                    -0.028,
                                                    -0.178
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.178
                                                ],
                                                [
                                                    0.013,
                                                    0.017
                                                ],
                                                [
                                                    1.533,
                                                    2.681
                                                ],
                                                [
                                                    3.393,
                                                    1.578
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.563,
                                                    -0.011
                                                ],
                                                [
                                                    0.127,
                                                    -0.063
                                                ],
                                                [
                                                    0.161,
                                                    -0.08
                                                ],
                                                [
                                                    0.156,
                                                    -0.08
                                                ],
                                                [
                                                    0.3,
                                                    -0.172
                                                ],
                                                [
                                                    0.109,
                                                    -0.069
                                                ],
                                                [
                                                    0.09,
                                                    -0.063
                                                ],
                                                [
                                                    0.15,
                                                    -0.115
                                                ],
                                                [
                                                    1.229,
                                                    -1.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.398,
                                                    -2.672
                                                ],
                                                [
                                                    16.344,
                                                    1.811
                                                ],
                                                [
                                                    10.367,
                                                    5.553
                                                ],
                                                [
                                                    0.109,
                                                    7.367
                                                ],
                                                [
                                                    -7.531,
                                                    6.431
                                                ],
                                                [
                                                    -17.663,
                                                    0.192
                                                ],
                                                [
                                                    -17.727,
                                                    0.071
                                                ],
                                                [
                                                    -18.29,
                                                    -1.479
                                                ],
                                                [
                                                    -18.29,
                                                    -1.496
                                                ],
                                                [
                                                    -18.335,
                                                    -2.029
                                                ],
                                                [
                                                    -18.404,
                                                    -7.006
                                                ],
                                                [
                                                    -17.882,
                                                    -6.116
                                                ],
                                                [
                                                    -17.561,
                                                    -5.599
                                                ],
                                                [
                                                    -17.525,
                                                    -5.542
                                                ],
                                                [
                                                    -11.469,
                                                    -0.531
                                                ],
                                                [
                                                    -0.184,
                                                    1.816
                                                ],
                                                [
                                                    -0.092,
                                                    1.816
                                                ],
                                                [
                                                    11.842,
                                                    -0.715
                                                ],
                                                [
                                                    12.215,
                                                    -0.905
                                                ],
                                                [
                                                    12.686,
                                                    -1.157
                                                ],
                                                [
                                                    13.139,
                                                    -1.421
                                                ],
                                                [
                                                    14.006,
                                                    -1.983
                                                ],
                                                [
                                                    14.329,
                                                    -2.213
                                                ],
                                                [
                                                    14.592,
                                                    -2.408
                                                ],
                                                [
                                                    15.016,
                                                    -2.752
                                                ],
                                                [
                                                    17.848,
                                                    -6.271
                                                ],
                                                [
                                                    17.865,
                                                    -6.311
                                                ],
                                                [
                                                    18.393,
                                                    -7.367
                                                ],
                                                [
                                                    18.404,
                                                    -2.672
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.59,
                                            101.889
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 74",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.419,
                                                    -0.161
                                                ],
                                                [
                                                    6.171,
                                                    2.796
                                                ],
                                                [
                                                    1.463,
                                                    2.245
                                                ],
                                                [
                                                    -1.303,
                                                    -0.608
                                                ],
                                                [
                                                    -4.202,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.261,
                                                    1.63
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -6.941,
                                                    2.692
                                                ],
                                                [
                                                    -3.146,
                                                    -1.418
                                                ],
                                                [
                                                    1.532,
                                                    2.681
                                                ],
                                                [
                                                    3.392,
                                                    1.579
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.564,
                                                    -0.011
                                                ],
                                                [
                                                    -0.391,
                                                    0.189
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.473,
                                                    6.521
                                                ],
                                                [
                                                    -8.117,
                                                    6.36
                                                ],
                                                [
                                                    -14.684,
                                                    1.165
                                                ],
                                                [
                                                    -8.628,
                                                    6.176
                                                ],
                                                [
                                                    2.657,
                                                    8.524
                                                ],
                                                [
                                                    2.749,
                                                    8.524
                                                ],
                                                [
                                                    14.684,
                                                    5.993
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.893,
                                                    5.47
                                                ],
                                                [
                                                    -10.144,
                                                    -1.693
                                                ],
                                                [
                                                    -10.201,
                                                    -9.213
                                                ],
                                                [
                                                    -10.201,
                                                    -1.659
                                                ],
                                                [
                                                    2.916,
                                                    5.499
                                                ],
                                                [
                                                    2.916,
                                                    5.459
                                                ],
                                                [
                                                    2.899,
                                                    5.47
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            143.744,
                                            95.181
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 75",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.169,
                                                    -1.486
                                                ],
                                                [
                                                    5.396,
                                                    0
                                                ],
                                                [
                                                    0.419,
                                                    0.017
                                                ],
                                                [
                                                    4.151,
                                                    3.708
                                                ],
                                                [
                                                    0.167,
                                                    0.166
                                                ],
                                                [
                                                    0.15,
                                                    0.167
                                                ],
                                                [
                                                    0.12,
                                                    0.143
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    0.115,
                                                    0.792
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.012,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.841,
                                                    -1.292
                                                ],
                                                [
                                                    -0.7,
                                                    -0.246
                                                ],
                                                [
                                                    -0.011,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    -0.023
                                                ],
                                                [
                                                    -0.126,
                                                    -0.046
                                                ],
                                                [
                                                    -0.005,
                                                    0
                                                ],
                                                [
                                                    -0.183,
                                                    -0.064
                                                ],
                                                [
                                                    -0.218,
                                                    -0.063
                                                ],
                                                [
                                                    -0.207,
                                                    -0.052
                                                ],
                                                [
                                                    -0.207,
                                                    -0.046
                                                ],
                                                [
                                                    -6.855,
                                                    5.757
                                                ],
                                                [
                                                    -0.678,
                                                    1.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.005,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    3.696
                                                ],
                                                [
                                                    -4.609,
                                                    2.158
                                                ],
                                                [
                                                    -0.414,
                                                    0
                                                ],
                                                [
                                                    -4.948,
                                                    -0.149
                                                ],
                                                [
                                                    -0.189,
                                                    -0.166
                                                ],
                                                [
                                                    -0.166,
                                                    -0.167
                                                ],
                                                [
                                                    -0.132,
                                                    -0.137
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.483,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.993,
                                                    2.675
                                                ],
                                                [
                                                    0.666,
                                                    0.304
                                                ],
                                                [
                                                    0.012,
                                                    0.006
                                                ],
                                                [
                                                    0.075,
                                                    0.029
                                                ],
                                                [
                                                    0.114,
                                                    0.046
                                                ],
                                                [
                                                    0.006,
                                                    0
                                                ],
                                                [
                                                    0.178,
                                                    0.069
                                                ],
                                                [
                                                    0.219,
                                                    0.068
                                                ],
                                                [
                                                    0.201,
                                                    0.057
                                                ],
                                                [
                                                    0.207,
                                                    0.058
                                                ],
                                                [
                                                    8.594,
                                                    2.049
                                                ],
                                                [
                                                    0.993,
                                                    -0.832
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.042,
                                                    -8.513
                                                ],
                                                [
                                                    21.042,
                                                    -2.962
                                                ],
                                                [
                                                    14.165,
                                                    5.263
                                                ],
                                                [
                                                    -0.903,
                                                    8.512
                                                ],
                                                [
                                                    -2.155,
                                                    8.489
                                                ],
                                                [
                                                    -18.016,
                                                    3.145
                                                ],
                                                [
                                                    -18.544,
                                                    2.646
                                                ],
                                                [
                                                    -19.015,
                                                    2.146
                                                ],
                                                [
                                                    -19.393,
                                                    1.722
                                                ],
                                                [
                                                    -20.025,
                                                    0.849
                                                ],
                                                [
                                                    -20.036,
                                                    0.838
                                                ],
                                                [
                                                    -20.926,
                                                    -1.504
                                                ],
                                                [
                                                    -21.041,
                                                    -8.513
                                                ],
                                                [
                                                    -20.955,
                                                    -8.335
                                                ],
                                                [
                                                    -20.679,
                                                    -7.772
                                                ],
                                                [
                                                    -20.656,
                                                    -7.726
                                                ],
                                                [
                                                    -20.656,
                                                    -7.709
                                                ],
                                                [
                                                    -14.009,
                                                    -1.613
                                                ],
                                                [
                                                    -11.954,
                                                    -0.793
                                                ],
                                                [
                                                    -11.914,
                                                    -0.781
                                                ],
                                                [
                                                    -11.695,
                                                    -0.701
                                                ],
                                                [
                                                    -11.34,
                                                    -0.569
                                                ],
                                                [
                                                    -11.317,
                                                    -0.563
                                                ],
                                                [
                                                    -10.766,
                                                    -0.373
                                                ],
                                                [
                                                    -10.111,
                                                    -0.178
                                                ],
                                                [
                                                    -9.497,
                                                    -0.012
                                                ],
                                                [
                                                    -8.877,
                                                    0.143
                                                ],
                                                [
                                                    18.052,
                                                    -4.426
                                                ],
                                                [
                                                    20.503,
                                                    -7.503
                                                ],
                                                [
                                                    20.537,
                                                    -7.566
                                                ],
                                                [
                                                    20.554,
                                                    -7.606
                                                ],
                                                [
                                                    20.669,
                                                    -7.813
                                                ],
                                                [
                                                    20.956,
                                                    -8.352
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.539,
                                            109.12
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 76",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.338,
                                                    2.761
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.841,
                                                    -1.291
                                                ],
                                                [
                                                    -0.7,
                                                    -0.247
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.993,
                                                    2.675
                                                ],
                                                [
                                                    0.666,
                                                    0.304
                                                ],
                                                [
                                                    -4.391,
                                                    -1.642
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.168,
                                                    -3.091
                                                ],
                                                [
                                                    -4.351,
                                                    -3.464
                                                ],
                                                [
                                                    -4.351,
                                                    -3.453
                                                ],
                                                [
                                                    2.296,
                                                    2.643
                                                ],
                                                [
                                                    4.351,
                                                    3.464
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            130.235,
                                            104.862
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 77",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.247,
                                                    -0.299
                                                ],
                                                [
                                                    0.052,
                                                    -0.057
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    -0.109
                                                ],
                                                [
                                                    0.018,
                                                    -0.011
                                                ],
                                                [
                                                    0.488,
                                                    -0.092
                                                ],
                                                [
                                                    0.029,
                                                    0
                                                ],
                                                [
                                                    0.195,
                                                    -0.012
                                                ],
                                                [
                                                    0.063,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.023,
                                                    0.006
                                                ],
                                                [
                                                    0.097,
                                                    0.017
                                                ],
                                                [
                                                    0.138,
                                                    0.035
                                                ],
                                                [
                                                    0.006,
                                                    0
                                                ],
                                                [
                                                    0.109,
                                                    0.017
                                                ],
                                                [
                                                    0.15,
                                                    0.057
                                                ],
                                                [
                                                    4.42,
                                                    2.503
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.022,
                                                    0.035
                                                ],
                                                [
                                                    0.04,
                                                    0.092
                                                ],
                                                [
                                                    0.023,
                                                    0.126
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.012,
                                                    -0.103
                                                ],
                                                [
                                                    -0.028,
                                                    -0.207
                                                ],
                                                [
                                                    0,
                                                    -0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.482,
                                                    -0.775
                                                ],
                                                [
                                                    -0.012,
                                                    -0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.069,
                                                    -0.069
                                                ],
                                                [
                                                    -0.241,
                                                    -0.236
                                                ],
                                                [
                                                    -0.189,
                                                    -0.166
                                                ],
                                                [
                                                    -4.948,
                                                    -0.149
                                                ],
                                                [
                                                    -0.413,
                                                    0
                                                ],
                                                [
                                                    -4.61,
                                                    2.158
                                                ],
                                                [
                                                    -0.006,
                                                    3.696
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.327
                                                ],
                                                [
                                                    0.006,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.634,
                                                    -2.135
                                                ],
                                                [
                                                    -0.017,
                                                    -0.344
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.017,
                                                    0.293
                                                ],
                                                [
                                                    -0.046,
                                                    0.057
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.121
                                                ],
                                                [
                                                    -0.017,
                                                    0.006
                                                ],
                                                [
                                                    -0.459,
                                                    0.247
                                                ],
                                                [
                                                    -0.029,
                                                    0.011
                                                ],
                                                [
                                                    -0.201,
                                                    0.052
                                                ],
                                                [
                                                    -0.063,
                                                    0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.097,
                                                    0
                                                ],
                                                [
                                                    -0.127,
                                                    -0.017
                                                ],
                                                [
                                                    -0.005,
                                                    -0.005
                                                ],
                                                [
                                                    -0.097,
                                                    -0.046
                                                ],
                                                [
                                                    -0.132,
                                                    -0.04
                                                ],
                                                [
                                                    -4.425,
                                                    -2.509
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.029,
                                                    -0.023
                                                ],
                                                [
                                                    -0.075,
                                                    -0.063
                                                ],
                                                [
                                                    -0.058,
                                                    -0.103
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.103
                                                ],
                                                [
                                                    0,
                                                    0.218
                                                ],
                                                [
                                                    0,
                                                    0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.114,
                                                    0.792
                                                ],
                                                [
                                                    0,
                                                    0.005
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    0.069
                                                ],
                                                [
                                                    0.201,
                                                    0.241
                                                ],
                                                [
                                                    0.166,
                                                    0.166
                                                ],
                                                [
                                                    4.15,
                                                    3.708
                                                ],
                                                [
                                                    0.419,
                                                    0.017
                                                ],
                                                [
                                                    5.396,
                                                    0
                                                ],
                                                [
                                                    3.169,
                                                    -1.487
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    -0.309
                                                ],
                                                [
                                                    -0.006,
                                                    -0.097
                                                ],
                                                [
                                                    0,
                                                    -0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.656,
                                                    2.043
                                                ],
                                                [
                                                    0.402,
                                                    0.35
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    33.504,
                                                    -6.53
                                                ],
                                                [
                                                    33.125,
                                                    -5.663
                                                ],
                                                [
                                                    32.975,
                                                    -5.491
                                                ],
                                                [
                                                    32.93,
                                                    -5.451
                                                ],
                                                [
                                                    32.901,
                                                    -5.434
                                                ],
                                                [
                                                    0.513,
                                                    12.877
                                                ],
                                                [
                                                    -0.101,
                                                    13.221
                                                ],
                                                [
                                                    -0.153,
                                                    13.25
                                                ],
                                                [
                                                    -1.536,
                                                    13.784
                                                ],
                                                [
                                                    -1.628,
                                                    13.801
                                                ],
                                                [
                                                    -2.219,
                                                    13.899
                                                ],
                                                [
                                                    -2.414,
                                                    13.905
                                                ],
                                                [
                                                    -2.506,
                                                    13.905
                                                ],
                                                [
                                                    -2.564,
                                                    13.899
                                                ],
                                                [
                                                    -2.856,
                                                    13.87
                                                ],
                                                [
                                                    -3.253,
                                                    13.795
                                                ],
                                                [
                                                    -3.27,
                                                    13.79
                                                ],
                                                [
                                                    -3.591,
                                                    13.698
                                                ],
                                                [
                                                    -4.005,
                                                    13.549
                                                ],
                                                [
                                                    -17.271,
                                                    6.029
                                                ],
                                                [
                                                    -18.39,
                                                    5.392
                                                ],
                                                [
                                                    -33.143,
                                                    -3.051
                                                ],
                                                [
                                                    -33.223,
                                                    -3.132
                                                ],
                                                [
                                                    -33.401,
                                                    -3.367
                                                ],
                                                [
                                                    -33.522,
                                                    -3.706
                                                ],
                                                [
                                                    -33.522,
                                                    -3.757
                                                ],
                                                [
                                                    -33.505,
                                                    -6.134
                                                ],
                                                [
                                                    -33.304,
                                                    -6.668
                                                ],
                                                [
                                                    -21.358,
                                                    -13.383
                                                ],
                                                [
                                                    -20.749,
                                                    -13.107
                                                ],
                                                [
                                                    -20.749,
                                                    -12.792
                                                ],
                                                [
                                                    -20.704,
                                                    -12.149
                                                ],
                                                [
                                                    -20.704,
                                                    -12.121
                                                ],
                                                [
                                                    -20.692,
                                                    -11.495
                                                ],
                                                [
                                                    -20.778,
                                                    -11.673
                                                ],
                                                [
                                                    -20.663,
                                                    -4.664
                                                ],
                                                [
                                                    -19.774,
                                                    -2.322
                                                ],
                                                [
                                                    -19.762,
                                                    -2.311
                                                ],
                                                [
                                                    -19.131,
                                                    -1.439
                                                ],
                                                [
                                                    -18.947,
                                                    -1.226
                                                ],
                                                [
                                                    -18.281,
                                                    -0.514
                                                ],
                                                [
                                                    -17.753,
                                                    -0.015
                                                ],
                                                [
                                                    -1.892,
                                                    5.329
                                                ],
                                                [
                                                    -0.641,
                                                    5.352
                                                ],
                                                [
                                                    14.428,
                                                    2.103
                                                ],
                                                [
                                                    21.3,
                                                    -6.122
                                                ],
                                                [
                                                    21.3,
                                                    -11.673
                                                ],
                                                [
                                                    21.219,
                                                    -11.512
                                                ],
                                                [
                                                    21.219,
                                                    -12.253
                                                ],
                                                [
                                                    21.265,
                                                    -13.211
                                                ],
                                                [
                                                    21.242,
                                                    -13.486
                                                ],
                                                [
                                                    21.236,
                                                    -13.527
                                                ],
                                                [
                                                    21.374,
                                                    -13.607
                                                ],
                                                [
                                                    21.65,
                                                    -13.905
                                                ],
                                                [
                                                    21.845,
                                                    -13.796
                                                ],
                                                [
                                                    32.832,
                                                    -7.506
                                                ],
                                                [
                                                    33.498,
                                                    -6.53
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.271,
                                            112.283
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 78",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.196,
                                                    -0.333
                                                ],
                                                [
                                                    0.086,
                                                    -0.109
                                                ],
                                                [
                                                    0.395,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.706,
                                                    -0.051
                                                ],
                                                [
                                                    0.063,
                                                    -0.012
                                                ],
                                                [
                                                    0.114,
                                                    -0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.051,
                                                    0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.005,
                                                    0.069
                                                ],
                                                [
                                                    0.036,
                                                    1.538
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    0.006
                                                ],
                                                [
                                                    -0.201,
                                                    0.051
                                                ],
                                                [
                                                    -0.029,
                                                    0.012
                                                ],
                                                [
                                                    -0.459,
                                                    0.246
                                                ],
                                                [
                                                    -0.017,
                                                    0.006
                                                ],
                                                [
                                                    -0.092,
                                                    0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.046,
                                                    0.058
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.006,
                                                    -0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.46
                                                ],
                                                [
                                                    -0.068,
                                                    0.126
                                                ],
                                                [
                                                    -0.356,
                                                    0.442
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.689,
                                                    0.396
                                                ],
                                                [
                                                    -0.063,
                                                    0
                                                ],
                                                [
                                                    -0.109,
                                                    0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.051,
                                                    0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.069
                                                ],
                                                [
                                                    -0.018,
                                                    -1.538
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.064,
                                                    0
                                                ],
                                                [
                                                    0.195,
                                                    -0.011
                                                ],
                                                [
                                                    0.029,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.091
                                                ],
                                                [
                                                    0.017,
                                                    -0.012
                                                ],
                                                [
                                                    0.086,
                                                    -0.04
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.052,
                                                    -0.058
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.264,
                                                    0.27
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.934,
                                                    -7.227
                                                ],
                                                [
                                                    17.612,
                                                    -6.044
                                                ],
                                                [
                                                    17.377,
                                                    -5.7
                                                ],
                                                [
                                                    16.154,
                                                    -4.718
                                                ],
                                                [
                                                    -14.959,
                                                    13.059
                                                ],
                                                [
                                                    -17.043,
                                                    13.615
                                                ],
                                                [
                                                    -17.232,
                                                    13.627
                                                ],
                                                [
                                                    -17.565,
                                                    13.644
                                                ],
                                                [
                                                    -17.703,
                                                    13.644
                                                ],
                                                [
                                                    -17.864,
                                                    13.644
                                                ],
                                                [
                                                    -17.864,
                                                    13.558
                                                ],
                                                [
                                                    -17.869,
                                                    13.357
                                                ],
                                                [
                                                    -17.951,
                                                    8.731
                                                ],
                                                [
                                                    -17.951,
                                                    5.918
                                                ],
                                                [
                                                    -17.864,
                                                    5.918
                                                ],
                                                [
                                                    -17.668,
                                                    5.912
                                                ],
                                                [
                                                    -17.077,
                                                    5.815
                                                ],
                                                [
                                                    -16.985,
                                                    5.797
                                                ],
                                                [
                                                    -15.602,
                                                    5.264
                                                ],
                                                [
                                                    -15.55,
                                                    5.235
                                                ],
                                                [
                                                    -15.286,
                                                    5.109
                                                ],
                                                [
                                                    17.452,
                                                    -13.42
                                                ],
                                                [
                                                    17.48,
                                                    -13.437
                                                ],
                                                [
                                                    17.526,
                                                    -13.477
                                                ],
                                                [
                                                    17.676,
                                                    -13.65
                                                ],
                                                [
                                                    17.687,
                                                    -13.638
                                                ],
                                                [
                                                    17.934,
                                                    -12.68
                                                ],
                                                [
                                                    17.934,
                                                    -12.496
                                                ],
                                                [
                                                    17.94,
                                                    -7.227
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            161.727,
                                            120.271
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 79",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.253,
                                                    0.046
                                                ],
                                                [
                                                    0.729,
                                                    0.31
                                                ],
                                                [
                                                    0.006,
                                                    0.006
                                                ],
                                                [
                                                    0.011,
                                                    0.006
                                                ],
                                                [
                                                    0.104,
                                                    0.057
                                                ],
                                                [
                                                    5.04,
                                                    2.893
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    -0.063
                                                ],
                                                [
                                                    -0.029,
                                                    -0.023
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.426,
                                                    -2.508
                                                ],
                                                [
                                                    -0.132,
                                                    -0.041
                                                ],
                                                [
                                                    -0.097,
                                                    -0.046
                                                ],
                                                [
                                                    -0.006,
                                                    -0.006
                                                ],
                                                [
                                                    -0.126,
                                                    -0.017
                                                ],
                                                [
                                                    -0.098,
                                                    0
                                                ],
                                                [
                                                    -0.018,
                                                    -0.947
                                                ],
                                                [
                                                    -0.017,
                                                    -1.538
                                                ],
                                                [
                                                    0,
                                                    -0.069
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.253,
                                                    -0.011
                                                ],
                                                [
                                                    -0.666,
                                                    -0.109
                                                ],
                                                [
                                                    0,
                                                    -0.006
                                                ],
                                                [
                                                    -0.017,
                                                    -0.005
                                                ],
                                                [
                                                    -0.109,
                                                    -0.051
                                                ],
                                                [
                                                    -5.04,
                                                    -2.91
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.04,
                                                    0.092
                                                ],
                                                [
                                                    0.022,
                                                    0.034
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.42,
                                                    2.503
                                                ],
                                                [
                                                    0.149,
                                                    0.058
                                                ],
                                                [
                                                    0.109,
                                                    0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.137,
                                                    0.035
                                                ],
                                                [
                                                    0.097,
                                                    0.017
                                                ],
                                                [
                                                    0.023,
                                                    0.93
                                                ],
                                                [
                                                    0.034,
                                                    1.538
                                                ],
                                                [
                                                    0.006,
                                                    0.069
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.554,
                                                    12.413
                                                ],
                                                [
                                                    15.554,
                                                    12.499
                                                ],
                                                [
                                                    15.479,
                                                    12.499
                                                ],
                                                [
                                                    14.721,
                                                    12.419
                                                ],
                                                [
                                                    12.649,
                                                    11.776
                                                ],
                                                [
                                                    12.626,
                                                    11.764
                                                ],
                                                [
                                                    12.58,
                                                    11.747
                                                ],
                                                [
                                                    12.264,
                                                    11.581
                                                ],
                                                [
                                                    -2.856,
                                                    2.873
                                                ],
                                                [
                                                    -3.413,
                                                    2.552
                                                ],
                                                [
                                                    -15.123,
                                                    -4.198
                                                ],
                                                [
                                                    -15.25,
                                                    -4.497
                                                ],
                                                [
                                                    -15.439,
                                                    -4.25
                                                ],
                                                [
                                                    -15.554,
                                                    -4.56
                                                ],
                                                [
                                                    -15.554,
                                                    -12.338
                                                ],
                                                [
                                                    -15.433,
                                                    -12.499
                                                ],
                                                [
                                                    -15.255,
                                                    -12.263
                                                ],
                                                [
                                                    -15.175,
                                                    -12.183
                                                ],
                                                [
                                                    -0.428,
                                                    -3.739
                                                ],
                                                [
                                                    0.692,
                                                    -3.102
                                                ],
                                                [
                                                    13.958,
                                                    4.417
                                                ],
                                                [
                                                    14.371,
                                                    4.567
                                                ],
                                                [
                                                    14.692,
                                                    4.658
                                                ],
                                                [
                                                    14.71,
                                                    4.664
                                                ],
                                                [
                                                    15.106,
                                                    4.739
                                                ],
                                                [
                                                    15.399,
                                                    4.767
                                                ],
                                                [
                                                    15.462,
                                                    7.586
                                                ],
                                                [
                                                    15.542,
                                                    12.212
                                                ],
                                                [
                                                    15.548,
                                                    12.413
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            128.303,
                                            121.416
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 80",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.051,
                                                    0.007
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.052,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -17.62,
                                                    13.523
                                                ],
                                                [
                                                    -17.695,
                                                    13.523
                                                ],
                                                [
                                                    -17.695,
                                                    13.541
                                                ],
                                                [
                                                    -17.62,
                                                    13.541
                                                ],
                                                [
                                                    -17.459,
                                                    13.53
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    -0.108
                                                ],
                                                [
                                                    -0.092,
                                                    0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.212,
                                                    0.12
                                                ],
                                                [
                                                    0.086,
                                                    -0.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.693,
                                                    4.77
                                                ],
                                                [
                                                    -15.307,
                                                    5.114
                                                ],
                                                [
                                                    -15.043,
                                                    4.988
                                                ],
                                                [
                                                    17.695,
                                                    -13.541
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            161.478,
                                            120.392
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 81",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    -0.039
                                                ],
                                                [
                                                    -0.212,
                                                    0.12
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.092,
                                                    0.046
                                                ],
                                                [
                                                    0.201,
                                                    -0.108
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.501,
                                                    -9.327
                                                ],
                                                [
                                                    -16.237,
                                                    9.201
                                                ],
                                                [
                                                    -16.501,
                                                    9.327
                                                ],
                                                [
                                                    -15.887,
                                                    8.983
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            162.672,
                                            116.178
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 82",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.53,
                                                    -0.333
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.993,
                                                    0
                                                ],
                                                [
                                                    1.52,
                                                    0.666
                                                ],
                                                [
                                                    9.046,
                                                    5.257
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.908,
                                                    -2.245
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.034,
                                                    -0.017
                                                ],
                                                [
                                                    -0.063,
                                                    -0.034
                                                ],
                                                [
                                                    -0.039,
                                                    -0.019
                                                ],
                                                [
                                                    -0.017,
                                                    -0.005
                                                ],
                                                [
                                                    -0.006,
                                                    -0.005
                                                ],
                                                [
                                                    -0.666,
                                                    -0.11
                                                ],
                                                [
                                                    -0.252,
                                                    -0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.007
                                                ],
                                                [
                                                    -0.064,
                                                    0
                                                ],
                                                [
                                                    -0.689,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.356,
                                                    0.436
                                                ],
                                                [
                                                    -0.068,
                                                    0.128
                                                ],
                                                [
                                                    -0.109,
                                                    -0.276
                                                ],
                                                [
                                                    0.28,
                                                    -0.58
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.386,
                                                    0.809
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.459,
                                                    0.66
                                                ],
                                                [
                                                    -1.067,
                                                    0
                                                ],
                                                [
                                                    -9.071,
                                                    -5.205
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.91,
                                                    2.239
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.035,
                                                    0.016
                                                ],
                                                [
                                                    0.063,
                                                    0.035
                                                ],
                                                [
                                                    0.039,
                                                    0.016
                                                ],
                                                [
                                                    0.011,
                                                    0.005
                                                ],
                                                [
                                                    0.005,
                                                    0.006
                                                ],
                                                [
                                                    0.73,
                                                    0.31
                                                ],
                                                [
                                                    0.252,
                                                    0.045
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.116,
                                                    -0.011
                                                ],
                                                [
                                                    0.062,
                                                    -0.004
                                                ],
                                                [
                                                    0.707,
                                                    -0.052
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.397,
                                                    -0.229
                                                ],
                                                [
                                                    0.086,
                                                    -0.115
                                                ],
                                                [
                                                    0.218,
                                                    0.018
                                                ],
                                                [
                                                    0.212,
                                                    0.505
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    33.195,
                                                    -7.927
                                                ],
                                                [
                                                    31.523,
                                                    -6.245
                                                ],
                                                [
                                                    1.008,
                                                    11.279
                                                ],
                                                [
                                                    -2.46,
                                                    12.249
                                                ],
                                                [
                                                    -6.081,
                                                    11.221
                                                ],
                                                [
                                                    -33.371,
                                                    -4.54
                                                ],
                                                [
                                                    -33.469,
                                                    -4.598
                                                ],
                                                [
                                                    -33.647,
                                                    -5.177
                                                ],
                                                [
                                                    -33.647,
                                                    -9.161
                                                ],
                                                [
                                                    -33.533,
                                                    -9.311
                                                ],
                                                [
                                                    -33.44,
                                                    -9.058
                                                ],
                                                [
                                                    -33.36,
                                                    -9.011
                                                ],
                                                [
                                                    -33.36,
                                                    -9.063
                                                ],
                                                [
                                                    -33.229,
                                                    -9.236
                                                ],
                                                [
                                                    -21.507,
                                                    -2.508
                                                ],
                                                [
                                                    -20.95,
                                                    -2.187
                                                ],
                                                [
                                                    -5.939,
                                                    6.464
                                                ],
                                                [
                                                    -5.829,
                                                    6.52
                                                ],
                                                [
                                                    -5.639,
                                                    6.63
                                                ],
                                                [
                                                    -5.514,
                                                    6.688
                                                ],
                                                [
                                                    -5.467,
                                                    6.704
                                                ],
                                                [
                                                    -5.445,
                                                    6.715
                                                ],
                                                [
                                                    -3.372,
                                                    7.359
                                                ],
                                                [
                                                    -2.615,
                                                    7.439
                                                ],
                                                [
                                                    -2.615,
                                                    7.456
                                                ],
                                                [
                                                    -2.54,
                                                    7.456
                                                ],
                                                [
                                                    -2.38,
                                                    7.445
                                                ],
                                                [
                                                    -2.242,
                                                    7.445
                                                ],
                                                [
                                                    -1.908,
                                                    7.421
                                                ],
                                                [
                                                    -1.719,
                                                    7.411
                                                ],
                                                [
                                                    0.365,
                                                    6.854
                                                ],
                                                [
                                                    31.477,
                                                    -10.924
                                                ],
                                                [
                                                    32.7,
                                                    -11.899
                                                ],
                                                [
                                                    32.936,
                                                    -12.25
                                                ],
                                                [
                                                    33.436,
                                                    -11.813
                                                ],
                                                [
                                                    33.189,
                                                    -7.927
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            146.396,
                                            126.479
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 83",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.103,
                                                    0.057
                                                ],
                                                [
                                                    -0.062,
                                                    -0.035
                                                ],
                                                [
                                                    -0.041,
                                                    -0.017
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.063,
                                                    0.034
                                                ],
                                                [
                                                    0.041,
                                                    0.017
                                                ],
                                                [
                                                    -0.11,
                                                    -0.051
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.208,
                                                    7.571
                                                ],
                                                [
                                                    12.396,
                                                    7.68
                                                ],
                                                [
                                                    12.523,
                                                    7.737
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -5.04,
                                                    -2.911
                                                ],
                                                [
                                                    0.034,
                                                    0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.035,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.04,
                                                    2.893
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.208,
                                                    7.571
                                                ],
                                                [
                                                    12.099,
                                                    7.513
                                                ],
                                                [
                                                    -2.913,
                                                    -1.137
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.422,
                                                    8.49
                                                ],
                                                [
                                                    15.422,
                                                    8.507
                                                ],
                                                [
                                                    15.497,
                                                    8.507
                                                ],
                                                [
                                                    15.497,
                                                    8.49
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.909,
                                                    -2.245
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.91,
                                                    2.239
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.18,
                                                    -8.209
                                                ],
                                                [
                                                    -15.306,
                                                    -8.507
                                                ],
                                                [
                                                    -15.496,
                                                    -8.26
                                                ],
                                                [
                                                    -15.404,
                                                    -8.008
                                                ],
                                                [
                                                    -15.324,
                                                    -7.962
                                                ],
                                                [
                                                    -15.324,
                                                    -8.013
                                                ],
                                                [
                                                    -15.192,
                                                    -8.186
                                                ],
                                                [
                                                    -3.47,
                                                    -1.458
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            128.361,
                                            125.428
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 84",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.422,
                                                    8.49
                                                ],
                                                [
                                                    15.422,
                                                    8.507
                                                ],
                                                [
                                                    15.497,
                                                    8.507
                                                ],
                                                [
                                                    15.497,
                                                    8.49
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.103,
                                                    0.057
                                                ],
                                                [
                                                    -0.062,
                                                    -0.035
                                                ],
                                                [
                                                    -0.041,
                                                    -0.017
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.063,
                                                    0.034
                                                ],
                                                [
                                                    0.041,
                                                    0.017
                                                ],
                                                [
                                                    -0.11,
                                                    -0.051
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.208,
                                                    7.571
                                                ],
                                                [
                                                    12.396,
                                                    7.68
                                                ],
                                                [
                                                    12.523,
                                                    7.737
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    5.04,
                                                    2.893
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.035,
                                                    -0.018
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.034,
                                                    0.017
                                                ],
                                                [
                                                    -5.04,
                                                    -2.911
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.913,
                                                    -1.137
                                                ],
                                                [
                                                    12.099,
                                                    7.513
                                                ],
                                                [
                                                    12.208,
                                                    7.571
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.909,
                                                    -2.245
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.91,
                                                    2.239
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.18,
                                                    -8.209
                                                ],
                                                [
                                                    -15.306,
                                                    -8.507
                                                ],
                                                [
                                                    -15.496,
                                                    -8.26
                                                ],
                                                [
                                                    -15.404,
                                                    -8.008
                                                ],
                                                [
                                                    -15.324,
                                                    -7.962
                                                ],
                                                [
                                                    -15.324,
                                                    -8.013
                                                ],
                                                [
                                                    -15.192,
                                                    -8.186
                                                ],
                                                [
                                                    -3.47,
                                                    -1.458
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            128.361,
                                            125.428
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 85",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -5.04,
                                                    -2.91
                                                ],
                                                [
                                                    0.034,
                                                    0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.035,
                                                    -0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.04,
                                                    2.893
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.561,
                                                    4.354
                                                ],
                                                [
                                                    7.452,
                                                    4.297
                                                ],
                                                [
                                                    -7.56,
                                                    -4.353
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            133.007,
                                            128.641
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 86",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.103,
                                                    0.057
                                                ],
                                                [
                                                    -0.063,
                                                    -0.034
                                                ],
                                                [
                                                    -0.04,
                                                    -0.017
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.063,
                                                    0.034
                                                ],
                                                [
                                                    0.04,
                                                    0.017
                                                ],
                                                [
                                                    -0.109,
                                                    -0.051
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.127,
                                                    7.571
                                                ],
                                                [
                                                    12.316,
                                                    7.68
                                                ],
                                                [
                                                    12.442,
                                                    7.737
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -5.04,
                                                    -2.91
                                                ],
                                                [
                                                    0.034,
                                                    0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.035,
                                                    -0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.04,
                                                    2.893
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.127,
                                                    7.571
                                                ],
                                                [
                                                    12.018,
                                                    7.514
                                                ],
                                                [
                                                    -2.994,
                                                    -1.137
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.052,
                                                    0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.052,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.416,
                                                    8.489
                                                ],
                                                [
                                                    15.341,
                                                    8.489
                                                ],
                                                [
                                                    15.341,
                                                    8.507
                                                ],
                                                [
                                                    15.416,
                                                    8.507
                                                ],
                                                [
                                                    15.577,
                                                    8.495
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.91,
                                                    -2.244
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.909,
                                                    2.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.261,
                                                    -8.208
                                                ],
                                                [
                                                    -15.387,
                                                    -8.507
                                                ],
                                                [
                                                    -15.577,
                                                    -8.26
                                                ],
                                                [
                                                    -15.485,
                                                    -8.007
                                                ],
                                                [
                                                    -15.405,
                                                    -7.962
                                                ],
                                                [
                                                    -15.405,
                                                    -8.013
                                                ],
                                                [
                                                    -15.272,
                                                    -8.185
                                                ],
                                                [
                                                    -3.55,
                                                    -1.458
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            128.441,
                                            125.428
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 87",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.052,
                                                    0.006
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.052,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.416,
                                                    8.489
                                                ],
                                                [
                                                    15.341,
                                                    8.489
                                                ],
                                                [
                                                    15.341,
                                                    8.507
                                                ],
                                                [
                                                    15.416,
                                                    8.507
                                                ],
                                                [
                                                    15.577,
                                                    8.495
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.103,
                                                    0.057
                                                ],
                                                [
                                                    -0.063,
                                                    -0.034
                                                ],
                                                [
                                                    -0.04,
                                                    -0.017
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.063,
                                                    0.034
                                                ],
                                                [
                                                    0.04,
                                                    0.017
                                                ],
                                                [
                                                    -0.109,
                                                    -0.051
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.127,
                                                    7.571
                                                ],
                                                [
                                                    12.316,
                                                    7.68
                                                ],
                                                [
                                                    12.442,
                                                    7.737
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    5.04,
                                                    2.893
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.035,
                                                    -0.017
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.034,
                                                    0.017
                                                ],
                                                [
                                                    -5.04,
                                                    -2.91
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.994,
                                                    -1.137
                                                ],
                                                [
                                                    12.018,
                                                    7.514
                                                ],
                                                [
                                                    12.127,
                                                    7.571
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.91,
                                                    -2.244
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.909,
                                                    2.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.261,
                                                    -8.208
                                                ],
                                                [
                                                    -15.387,
                                                    -8.507
                                                ],
                                                [
                                                    -15.577,
                                                    -8.26
                                                ],
                                                [
                                                    -15.485,
                                                    -8.007
                                                ],
                                                [
                                                    -15.405,
                                                    -7.962
                                                ],
                                                [
                                                    -15.405,
                                                    -8.013
                                                ],
                                                [
                                                    -15.272,
                                                    -8.185
                                                ],
                                                [
                                                    -3.55,
                                                    -1.458
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            128.441,
                                            125.428
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 88",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.052,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.052,
                                                    0.005
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.118,
                                                    -0.003
                                                ],
                                                [
                                                    -0.043,
                                                    -0.003
                                                ],
                                                [
                                                    -0.118,
                                                    0.008
                                                ],
                                                [
                                                    -0.118,
                                                    -0.008
                                                ],
                                                [
                                                    -0.043,
                                                    -0.008
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            143.899,
                                            133.923
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 89",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -5.041,
                                                    -2.911
                                                ],
                                                [
                                                    0.034,
                                                    0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.036,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.041,
                                                    2.893
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.561,
                                                    4.354
                                                ],
                                                [
                                                    7.452,
                                                    4.296
                                                ],
                                                [
                                                    -7.561,
                                                    -4.354
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            133.008,
                                            128.642
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 90",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    -0.109
                                                ],
                                                [
                                                    -0.093,
                                                    0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.212,
                                                    0.12
                                                ],
                                                [
                                                    0.086,
                                                    -0.04
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.562,
                                                    12.872
                                                ],
                                                [
                                                    -6.176,
                                                    13.216
                                                ],
                                                [
                                                    -5.912,
                                                    13.09
                                                ],
                                                [
                                                    26.826,
                                                    -5.439
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.052,
                                                    0.408
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.138,
                                                    -0.384
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.773,
                                                    -12.126
                                                ],
                                                [
                                                    -26.761,
                                                    -11.5
                                                ],
                                                [
                                                    -26.486,
                                                    -10.938
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.143,
                                                    -0.391
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.046,
                                                    0.413
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    14.863,
                                                    -11.052
                                                ],
                                                [
                                                    14.863,
                                                    -10.978
                                                ],
                                                [
                                                    15.15,
                                                    -11.517
                                                ],
                                                [
                                                    15.15,
                                                    -12.258
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.206
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.79,
                                                    -12.78
                                                ],
                                                [
                                                    -26.825,
                                                    -12.797
                                                ],
                                                [
                                                    -26.779,
                                                    -12.155
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.017,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.04,
                                                    -0.31
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.196,
                                                    -13.216
                                                ],
                                                [
                                                    15.161,
                                                    -13.199
                                                ],
                                                [
                                                    15.161,
                                                    -12.258
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            152.348,
                                            112.287
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 91",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.132,
                                                    -0.138
                                                ],
                                                [
                                                    0.063,
                                                    0.069
                                                ],
                                                [
                                                    0.057,
                                                    0.075
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.063,
                                                    -0.075
                                                ],
                                                [
                                                    -0.063,
                                                    -0.068
                                                ],
                                                [
                                                    0.12,
                                                    0.144
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.189,
                                                    0.212
                                                ],
                                                [
                                                    -0.006,
                                                    -0.001
                                                ],
                                                [
                                                    -0.189,
                                                    -0.213
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            127.337,
                                            111.055
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 92",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.04,
                                                    -0.31
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    0.327
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.028,
                                                    0.479
                                                ],
                                                [
                                                    -0.028,
                                                    -0.462
                                                ],
                                                [
                                                    0.012,
                                                    -0.479
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            167.531,
                                            99.55
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 93",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.028,
                                                    -0.206
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.023,
                                                    0.321
                                                ],
                                                [
                                                    -0.023,
                                                    -0.321
                                                ],
                                                [
                                                    0.012,
                                                    -0.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            125.546,
                                            99.81
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 94",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            37.588,
                                            135.382
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 95",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.072
                                                ],
                                                [
                                                    9.007,
                                                    5.93
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.428
                                                ],
                                                [
                                                    -7.279,
                                                    15.269
                                                ],
                                                [
                                                    -7.336,
                                                    15.304
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.205
                                                ],
                                                [
                                                    -9.133,
                                                    11.871
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.94
                                                ],
                                                [
                                                    9.093,
                                                    -16.295
                                                ],
                                                [
                                                    9.081,
                                                    -16.301
                                                ],
                                                [
                                                    9.122,
                                                    -16.324
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            46.702,
                                            151.699
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 96",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.896
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.216
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.055
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.977
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.871
                                                ],
                                                [
                                                    -9.168,
                                                    3.001
                                                ],
                                                [
                                                    -9.173,
                                                    3.007
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.913
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.396,
                                            151.641
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 97",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            55.261,
                                            125.073
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 98",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.973
                                                ],
                                                [
                                                    -2.302,
                                                    12.427
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.324
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.941
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            64.376,
                                            141.387
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 99",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.055
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.977
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.001
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.913
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            46.07,
                                            141.327
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 100",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.322
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.299
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            72.2,
                                            115.498
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 101",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.071
                                                ],
                                                [
                                                    9.007,
                                                    5.93
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.428
                                                ],
                                                [
                                                    -7.279,
                                                    15.269
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.205
                                                ],
                                                [
                                                    -9.133,
                                                    11.871
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.94
                                                ],
                                                [
                                                    9.093,
                                                    -16.295
                                                ],
                                                [
                                                    9.081,
                                                    -16.301
                                                ],
                                                [
                                                    9.122,
                                                    -16.324
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            81.315,
                                            131.815
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 102",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.371
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.978
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.371
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            63.008,
                                            131.756
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 103",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.322
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.299
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            19.177,
                                            125.071
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 104",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.072
                                                ],
                                                [
                                                    9.007,
                                                    5.93
                                                ],
                                                [
                                                    -1.51,
                                                    11.974
                                                ],
                                                [
                                                    -2.302,
                                                    12.428
                                                ],
                                                [
                                                    -7.279,
                                                    15.269
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.325
                                                ],
                                                [
                                                    -9.122,
                                                    16.205
                                                ],
                                                [
                                                    -9.133,
                                                    11.871
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.94
                                                ],
                                                [
                                                    9.093,
                                                    -16.295
                                                ],
                                                [
                                                    9.081,
                                                    -16.301
                                                ],
                                                [
                                                    9.122,
                                                    -16.324
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.292,
                                            141.384
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 105",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.896
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.055
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.977
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.168,
                                                    3.001
                                                ],
                                                [
                                                    -9.173,
                                                    3.007
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.913
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.986,
                                            141.326
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 106",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.362
                                                ],
                                                [
                                                    -0.046,
                                                    10.345
                                                ],
                                                [
                                                    -18.209,
                                                    -0.033
                                                ],
                                                [
                                                    -3.794,
                                                    -8.322
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.299
                                                ],
                                                [
                                                    18.197,
                                                    0.013
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            36.851,
                                            114.762
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 107",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.072
                                                ],
                                                [
                                                    9.007,
                                                    5.93
                                                ],
                                                [
                                                    -1.51,
                                                    11.973
                                                ],
                                                [
                                                    -2.302,
                                                    12.428
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.303
                                                ],
                                                [
                                                    -9.122,
                                                    16.324
                                                ],
                                                [
                                                    -9.122,
                                                    16.204
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.952
                                                ],
                                                [
                                                    -9.116,
                                                    -5.94
                                                ],
                                                [
                                                    9.093,
                                                    -16.296
                                                ],
                                                [
                                                    9.081,
                                                    -16.301
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            45.966,
                                            131.076
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 108",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.154
                                                ],
                                                [
                                                    6.86,
                                                    15.057
                                                ],
                                                [
                                                    3.261,
                                                    12.99
                                                ],
                                                [
                                                    3.238,
                                                    12.979
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.167,
                                                    3.003
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.37
                                                ],
                                                [
                                                    -9.018,
                                                    -16.289
                                                ],
                                                [
                                                    9.145,
                                                    -5.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            27.66,
                                            131.02
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 109",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.209,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    10.374
                                                ],
                                                [
                                                    -0.017,
                                                    10.363
                                                ],
                                                [
                                                    -0.046,
                                                    10.346
                                                ],
                                                [
                                                    -18.209,
                                                    -0.032
                                                ],
                                                [
                                                    -3.794,
                                                    -8.321
                                                ],
                                                [
                                                    0.006,
                                                    -10.374
                                                ],
                                                [
                                                    3.674,
                                                    -8.298
                                                ],
                                                [
                                                    18.197,
                                                    0.014
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            53.79,
                                            105.186
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 110",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.133,
                                                    3.07
                                                ],
                                                [
                                                    9.007,
                                                    5.929
                                                ],
                                                [
                                                    -1.51,
                                                    11.973
                                                ],
                                                [
                                                    -2.302,
                                                    12.426
                                                ],
                                                [
                                                    -7.279,
                                                    15.268
                                                ],
                                                [
                                                    -7.336,
                                                    15.302
                                                ],
                                                [
                                                    -9.122,
                                                    16.324
                                                ],
                                                [
                                                    -9.122,
                                                    16.203
                                                ],
                                                [
                                                    -9.133,
                                                    11.87
                                                ],
                                                [
                                                    -9.133,
                                                    -5.953
                                                ],
                                                [
                                                    -9.116,
                                                    -5.942
                                                ],
                                                [
                                                    9.093,
                                                    -16.297
                                                ],
                                                [
                                                    9.081,
                                                    -16.302
                                                ],
                                                [
                                                    9.122,
                                                    -16.325
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            62.905,
                                            121.501
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 111",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.173,
                                                    -5.895
                                                ],
                                                [
                                                    9.173,
                                                    16.37
                                                ],
                                                [
                                                    7.153,
                                                    15.217
                                                ],
                                                [
                                                    7.038,
                                                    15.153
                                                ],
                                                [
                                                    6.86,
                                                    15.056
                                                ],
                                                [
                                                    3.261,
                                                    12.989
                                                ],
                                                [
                                                    3.238,
                                                    12.979
                                                ],
                                                [
                                                    2.509,
                                                    12.548
                                                ],
                                                [
                                                    -9.116,
                                                    5.872
                                                ],
                                                [
                                                    -9.167,
                                                    3.002
                                                ],
                                                [
                                                    -9.173,
                                                    3.008
                                                ],
                                                [
                                                    -9.156,
                                                    -16.371
                                                ],
                                                [
                                                    -9.018,
                                                    -16.29
                                                ],
                                                [
                                                    9.145,
                                                    -5.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.964
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.598,
                                            121.441
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Pre-comp 1",
            "id": "16",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "539",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    94.931,
                                                    214.364
                                                ],
                                                [
                                                    94.868,
                                                    241.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            1
                                        ],
                                        "t": 0
                                    },
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            100
                                        ],
                                        "t": 86.999
                                    },
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            100
                                        ],
                                        "t": 127.999
                                    },
                                    {
                                        "s": [
                                            0
                                        ],
                                        "t": 151.999
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "crane lift",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "538",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        382,
                                        365.302
                                    ],
                                    "t": 0
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        382,
                                        390.181
                                    ],
                                    "t": 83.999
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        382,
                                        390.181
                                    ],
                                    "t": 129.999
                                },
                                {
                                    "s": [
                                        382,
                                        366.181
                                    ],
                                    "t": 151.999
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "17",
                    "ind": 2
                }
            ]
        },
        {
            "nm": "crane lift",
            "id": "17",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Crane base Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "521",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                10,
                                7
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                476.669,
                                589.068
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.656,
                                                    -0.669
                                                ],
                                                [
                                                    -2.591,
                                                    0
                                                ],
                                                [
                                                    -1.809,
                                                    0.598
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.031,
                                                    1.063
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.03,
                                                    0.993
                                                ],
                                                [
                                                    1.886,
                                                    0.75
                                                ],
                                                [
                                                    2.285,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.825,
                                                    -0.74
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.515,
                                                    -6.5
                                                ],
                                                [
                                                    -9.345,
                                                    2.781
                                                ],
                                                [
                                                    -9.345,
                                                    2.832
                                                ],
                                                [
                                                    -6.754,
                                                    5.365
                                                ],
                                                [
                                                    0.33,
                                                    6.5
                                                ],
                                                [
                                                    6.709,
                                                    5.608
                                                ],
                                                [
                                                    6.77,
                                                    5.588
                                                ],
                                                [
                                                    9.484,
                                                    2.873
                                                ],
                                                [
                                                    9.484,
                                                    -6.5
                                                ],
                                                [
                                                    7.43,
                                                    -6.5
                                                ],
                                                [
                                                    -1.401,
                                                    -6.5
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.515,
                                                    -6.5
                                                ],
                                                [
                                                    -9.468,
                                                    -1.9
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            10.02,
                                            7
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Crane 1 Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "519",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                10,
                                6.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                468.301,
                                591.652
                            ]
                        },
                        "r": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        10
                                    ],
                                    "t": 7
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        -10
                                    ],
                                    "t": 111.999
                                },
                                {
                                    "s": [
                                        10
                                    ],
                                    "t": 264.998
                                }
                            ]
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.056,
                                                    -0.017
                                                ],
                                                [
                                                    -0.095,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.686,
                                                    0.871
                                                ],
                                                [
                                                    0.163,
                                                    0.536
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.484,
                                                    -1.54
                                                ],
                                                [
                                                    -0.007,
                                                    -0.023
                                                ],
                                                [
                                                    -1.004,
                                                    -0.55
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.015,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.685,
                                                    -0.871
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    0.973
                                                ],
                                                [
                                                    0.485,
                                                    1.539
                                                ],
                                                [
                                                    0.442,
                                                    1.252
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.056,
                                                    0.025
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -1.752,
                                                    9.145
                                                ],
                                                [
                                                    -1.254,
                                                    9.315
                                                ],
                                                [
                                                    -1.228,
                                                    9.238
                                                ],
                                                [
                                                    -1.886,
                                                    5.642
                                                ],
                                                [
                                                    -1.805,
                                                    -2.032
                                                ],
                                                [
                                                    -1.284,
                                                    -2.399
                                                ],
                                                [
                                                    3.774,
                                                    -6.95
                                                ],
                                                [
                                                    2.943,
                                                    -7.797
                                                ],
                                                [
                                                    1.528,
                                                    -9.336
                                                ],
                                                [
                                                    1.282,
                                                    -9.491
                                                ],
                                                [
                                                    -4.629,
                                                    -4.744
                                                ],
                                                [
                                                    -4.506,
                                                    3.245
                                                ],
                                                [
                                                    -4.132,
                                                    6.303
                                                ],
                                                [
                                                    -4.11,
                                                    6.373
                                                ],
                                                [
                                                    -1.936,
                                                    9.077
                                                ],
                                                [
                                                    -1.92,
                                                    9.078
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.954
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            7.809,
                                            16.832
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.06,
                                                    -0.019
                                                ],
                                                [
                                                    -0.101,
                                                    0.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.323,
                                                    -1.11
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.075,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.017,
                                                    -0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.031,
                                                    1.082
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.472,
                                                    1.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.06,
                                                    0.028
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -1.436,
                                                    10.755
                                                ],
                                                [
                                                    -0.904,
                                                    10.943
                                                ],
                                                [
                                                    -0.875,
                                                    10.858
                                                ],
                                                [
                                                    -1.576,
                                                    6.859
                                                ],
                                                [
                                                    -1.48,
                                                    -1.675
                                                ],
                                                [
                                                    -0.922,
                                                    -2.084
                                                ],
                                                [
                                                    4.409,
                                                    -7.122
                                                ],
                                                [
                                                    4.064,
                                                    -11.139
                                                ],
                                                [
                                                    -4.067,
                                                    -4.852
                                                ],
                                                [
                                                    -4.378,
                                                    4.197
                                                ],
                                                [
                                                    -3.981,
                                                    7.597
                                                ],
                                                [
                                                    -3.957,
                                                    7.675
                                                ],
                                                [
                                                    -1.633,
                                                    10.68
                                                ],
                                                [
                                                    -1.616,
                                                    10.68
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.156
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            4.961,
                                            14.446
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Crane 2 Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "518",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                8.25,
                                7
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                485.648,
                                590.441
                            ]
                        },
                        "r": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        -10
                                    ],
                                    "t": 7
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        10
                                    ],
                                    "t": 111.999
                                },
                                {
                                    "s": [
                                        -10
                                    ],
                                    "t": 264.998
                                }
                            ]
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.056,
                                                    -0.017
                                                ],
                                                [
                                                    0.095,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.686,
                                                    0.871
                                                ],
                                                [
                                                    -0.163,
                                                    0.536
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.484,
                                                    -1.54
                                                ],
                                                [
                                                    0.007,
                                                    -0.023
                                                ],
                                                [
                                                    1.004,
                                                    -0.55
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.015,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.685,
                                                    -0.871
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.973
                                                ],
                                                [
                                                    -0.485,
                                                    1.539
                                                ],
                                                [
                                                    -0.442,
                                                    1.252
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.056,
                                                    0.025
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.752,
                                                    9.145
                                                ],
                                                [
                                                    1.254,
                                                    9.315
                                                ],
                                                [
                                                    1.228,
                                                    9.238
                                                ],
                                                [
                                                    1.886,
                                                    5.642
                                                ],
                                                [
                                                    1.805,
                                                    -2.032
                                                ],
                                                [
                                                    1.285,
                                                    -2.399
                                                ],
                                                [
                                                    -3.774,
                                                    -6.95
                                                ],
                                                [
                                                    -2.943,
                                                    -7.797
                                                ],
                                                [
                                                    -1.528,
                                                    -9.336
                                                ],
                                                [
                                                    -1.282,
                                                    -9.491
                                                ],
                                                [
                                                    4.629,
                                                    -4.744
                                                ],
                                                [
                                                    4.506,
                                                    3.245
                                                ],
                                                [
                                                    4.132,
                                                    6.303
                                                ],
                                                [
                                                    4.11,
                                                    6.373
                                                ],
                                                [
                                                    1.936,
                                                    9.077
                                                ],
                                                [
                                                    1.92,
                                                    9.078
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.954
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            10.325,
                                            16.832
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.06,
                                                    -0.019
                                                ],
                                                [
                                                    0.101,
                                                    0.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -1.11
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.075,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.017,
                                                    -0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.031,
                                                    1.082
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.472,
                                                    1.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.06,
                                                    0.028
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.436,
                                                    10.755
                                                ],
                                                [
                                                    0.904,
                                                    10.943
                                                ],
                                                [
                                                    0.875,
                                                    10.858
                                                ],
                                                [
                                                    1.576,
                                                    6.859
                                                ],
                                                [
                                                    1.48,
                                                    -1.675
                                                ],
                                                [
                                                    0.922,
                                                    -2.084
                                                ],
                                                [
                                                    -4.409,
                                                    -7.122
                                                ],
                                                [
                                                    -4.064,
                                                    -11.139
                                                ],
                                                [
                                                    4.067,
                                                    -4.852
                                                ],
                                                [
                                                    4.378,
                                                    4.197
                                                ],
                                                [
                                                    3.981,
                                                    7.597
                                                ],
                                                [
                                                    3.957,
                                                    7.675
                                                ],
                                                [
                                                    1.633,
                                                    10.68
                                                ],
                                                [
                                                    1.616,
                                                    10.68
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.156
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            13.173,
                                            14.446
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Box 1 Outlines Comp 1",
            "id": "18",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Box 1 Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "555",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                14,
                                16.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                80,
                                80
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        477.073,
                                        637.817
                                    ],
                                    "t": 131.999
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        477.073,
                                        614.817
                                    ],
                                    "t": 152.999
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        477.073,
                                        614.817
                                    ],
                                    "t": 164.999
                                },
                                {
                                    "s": [
                                        477.073,
                                        637.817
                                    ],
                                    "t": 188.998
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.768,
                                                    -4.46
                                                ],
                                                [
                                                    -6.764,
                                                    -4.46
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.764,
                                                    -4.46
                                                ],
                                                [
                                                    -6.723,
                                                    -4.487
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.059
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.051,
                                                    0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.764,
                                                    -4.46
                                                ],
                                                [
                                                    6.674,
                                                    -11.87
                                                ],
                                                [
                                                    6.764,
                                                    4.368
                                                ],
                                                [
                                                    -3.819,
                                                    10.39
                                                ],
                                                [
                                                    -6.464,
                                                    11.842
                                                ],
                                                [
                                                    -6.579,
                                                    11.775
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.751
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            20.611,
                                            20.493
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.051,
                                                    0.028
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.059
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.819,
                                                    10.39
                                                ],
                                                [
                                                    6.764,
                                                    4.368
                                                ],
                                                [
                                                    6.674,
                                                    -11.87
                                                ],
                                                [
                                                    -6.764,
                                                    -4.46
                                                ],
                                                [
                                                    -6.579,
                                                    11.775
                                                ],
                                                [
                                                    -6.464,
                                                    11.842
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            20.611,
                                            20.493
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.002,
                                                    0.152
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.051,
                                                    -0.03
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.002,
                                                    -0.152
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.051,
                                                    0.029
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.225,
                                                    7.795
                                                ],
                                                [
                                                    13.219,
                                                    0.39
                                                ],
                                                [
                                                    13.215,
                                                    0
                                                ],
                                                [
                                                    9.644,
                                                    -2.165
                                                ],
                                                [
                                                    7.025,
                                                    -3.676
                                                ],
                                                [
                                                    0.221,
                                                    -7.795
                                                ],
                                                [
                                                    -3.559,
                                                    -5.544
                                                ],
                                                [
                                                    -6.231,
                                                    -4.06
                                                ],
                                                [
                                                    -13.169,
                                                    -0.066
                                                ],
                                                [
                                                    -13.17,
                                                    0.068
                                                ],
                                                [
                                                    -0.225,
                                                    7.768
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.751
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            14.064,
                                            8.233
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.002
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.001,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.023,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.002,
                                                    -0.059
                                                ],
                                                [
                                                    0.156,
                                                    -6.261
                                                ],
                                                [
                                                    -0.025,
                                                    -0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    -0.001,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.027
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.051,
                                                    -0.031
                                                ],
                                                [
                                                    -0.156,
                                                    6.238
                                                ],
                                                [
                                                    -0.001,
                                                    0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.002,
                                                    0.002
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.752,
                                                    12.12
                                                ],
                                                [
                                                    6.752,
                                                    12.088
                                                ],
                                                [
                                                    6.75,
                                                    12.086
                                                ],
                                                [
                                                    6.748,
                                                    12.084
                                                ],
                                                [
                                                    6.716,
                                                    -4.318
                                                ],
                                                [
                                                    6.679,
                                                    -4.385
                                                ],
                                                [
                                                    -6.232,
                                                    -12.093
                                                ],
                                                [
                                                    -6.35,
                                                    -12.027
                                                ],
                                                [
                                                    -6.751,
                                                    4.397
                                                ],
                                                [
                                                    -6.712,
                                                    4.467
                                                ],
                                                [
                                                    3.844,
                                                    10.471
                                                ],
                                                [
                                                    6.747,
                                                    12.122
                                                ],
                                                [
                                                    6.748,
                                                    12.122
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.751
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            7.127,
                                            20.394
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        }
    ]
};

//# sourceMappingURL=qa-automation.9139826f.js.map
